//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AbpLanguagesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getDisplayNameLanguageTexts(): Observable<LanguagesDisplayNameDto[]> {
        let url_ = this.baseUrl + '/api/services/app/AbpLanguages/GetDisplayNameLanguageTexts';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetDisplayNameLanguageTexts(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetDisplayNameLanguageTexts(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<LanguagesDisplayNameDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<LanguagesDisplayNameDto[]>;
                })
            );
    }

    protected processGetDisplayNameLanguageTexts(response: HttpResponseBase): Observable<LanguagesDisplayNameDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(LanguagesDisplayNameDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<LanguagesDisplayNameDto[]>(null as any);
    }
}

@Injectable()
export class AbpLanguageTextsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param languageName (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getLanguageTexts(
        languageName: string | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/AbpLanguageTexts/GetLanguageTexts?';
        if (languageName === null) throw new Error("The parameter 'languageName' cannot be null.");
        else if (languageName !== undefined) url_ += 'LanguageName=' + encodeURIComponent('' + languageName) + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetLanguageTexts(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetLanguageTexts(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetLanguageTexts(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getLanguageTextsById(id: number | undefined): Observable<LanguageTextsDto> {
        let url_ = this.baseUrl + '/api/services/app/AbpLanguageTexts/GetLanguageTextsById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetLanguageTextsById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetLanguageTextsById(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<LanguageTextsDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<LanguageTextsDto>;
                })
            );
    }

    protected processGetLanguageTextsById(response: HttpResponseBase): Observable<LanguageTextsDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = LanguageTextsDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<LanguageTextsDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    insertLanguageTexts(body: CreateLanguageTextsDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/AbpLanguageTexts/InsertLanguageTexts';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processInsertLanguageTexts(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processInsertLanguageTexts(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processInsertLanguageTexts(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateLanguageTexts(body: UpdateLanguageTextsDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/AbpLanguageTexts/UpdateLanguageTexts';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateLanguageTexts(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateLanguageTexts(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdateLanguageTexts(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteLanguageTexts(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/AbpLanguageTexts/DeleteLanguageTexts?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteLanguageTexts(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteLanguageTexts(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDeleteLanguageTexts(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + '/api/services/app/Account/IsTenantAvailable';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processIsTenantAvailable(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processIsTenantAvailable(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                        }
                    } else return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
                })
            );
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IsTenantAvailableOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IsTenantAvailableOutput>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + '/api/services/app/Account/Register';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processRegister(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processRegister(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<RegisterOutput>;
                        }
                    } else return _observableThrow(response_) as any as Observable<RegisterOutput>;
                })
            );
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = RegisterOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<RegisterOutput>(null as any);
    }
}

@Injectable()
export class AdvanceSalaryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getById(id: number | undefined): Observable<InfoAdvanceSalaryDto> {
        let url_ = this.baseUrl + '/api/services/app/AdvanceSalary/GetById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetById(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<InfoAdvanceSalaryDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<InfoAdvanceSalaryDto>;
                })
            );
    }

    protected processGetById(response: HttpResponseBase): Observable<InfoAdvanceSalaryDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = InfoAdvanceSalaryDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<InfoAdvanceSalaryDto>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(
        fromDate: moment.Moment | undefined,
        toDate: moment.Moment | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/AdvanceSalary/GetList?';
        if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined) url_ += 'FromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
        if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined) url_ += 'ToDate=' + encodeURIComponent(toDate ? '' + toDate.toISOString() : '') + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    insert(body: InsertAdvanceSalaryDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/AdvanceSalary/Insert';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processInsert(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processInsert(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processInsert(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateAdvanceSalaryDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/AdvanceSalary/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/AdvanceSalary/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    action(body: ActionAdvanceSalaryDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/AdvanceSalary/Action';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processAction(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processAction(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processAction(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class AnnualLeaveServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getListAnnualLeave(
        fromDate: moment.Moment | undefined,
        toDate: moment.Moment | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/AnnualLeave/GetListAnnualLeave?';
        if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined) url_ += 'FromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
        if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined) url_ += 'ToDate=' + encodeURIComponent(toDate ? '' + toDate.toISOString() : '') + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetListAnnualLeave(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetListAnnualLeave(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetListAnnualLeave(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getAnnualLeaveById(id: number | undefined): Observable<AnnualLeaveDto> {
        let url_ = this.baseUrl + '/api/services/app/AnnualLeave/GetAnnualLeaveById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAnnualLeaveById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAnnualLeaveById(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<AnnualLeaveDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<AnnualLeaveDto>;
                })
            );
    }

    protected processGetAnnualLeaveById(response: HttpResponseBase): Observable<AnnualLeaveDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = AnnualLeaveDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AnnualLeaveDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    insertAnnualLeave(body: UpdateAnnualLeaveDto | undefined): Observable<string> {
        let url_ = this.baseUrl + '/api/services/app/AnnualLeave/InsertAnnualLeave';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processInsertAnnualLeave(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processInsertAnnualLeave(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<string>;
                        }
                    } else return _observableThrow(response_) as any as Observable<string>;
                })
            );
    }

    protected processInsertAnnualLeave(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAnnualLeave(body: UpdateAnnualLeaveDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/AnnualLeave/UpdateAnnualLeave';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateAnnualLeave(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateAnnualLeave(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdateAnnualLeave(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param employeeId (optional)
     * @return Success
     */
    deleteAnnualLeave(id: number | undefined, employeeId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/AnnualLeave/DeleteAnnualLeave?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (employeeId === null) throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined) url_ += 'EmployeeId=' + encodeURIComponent('' + employeeId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteAnnualLeave(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteAnnualLeave(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDeleteAnnualLeave(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    action(body: ActionDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/AnnualLeave/Action';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processAction(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processAction(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processAction(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param file (optional)
     * @return Success
     */
    importAnnualLeave(file: FileParameter | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/AnnualLeave/ImportAnnualLeave';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = new FormData();
        if (file === null || file === undefined) throw new Error("The parameter 'file' cannot be null.");
        else content_.append('File', file.data, file.fileName ? file.fileName : 'File');

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processImportAnnualLeave(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processImportAnnualLeave(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processImportAnnualLeave(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class AttendanceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(keyword: string | undefined, pageIndex: number | undefined, pageSize: number | undefined): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/Attendance/GetList?';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getInfo(id: number | undefined): Observable<AttendanceDto> {
        let url_ = this.baseUrl + '/api/services/app/Attendance/GetInfo?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInfo(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInfo(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<AttendanceDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<AttendanceDto>;
                })
            );
    }

    protected processGetInfo(response: HttpResponseBase): Observable<AttendanceDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = AttendanceDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AttendanceDto>(null as any);
    }

    /**
     * @param attendanceId (optional)
     * @param attendanceDate (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getListDetail(
        attendanceId: number | undefined,
        attendanceDate: moment.Moment | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/Attendance/GetListDetail?';
        if (attendanceId === null) throw new Error("The parameter 'attendanceId' cannot be null.");
        else if (attendanceId !== undefined) url_ += 'AttendanceId=' + encodeURIComponent('' + attendanceId) + '&';
        if (attendanceDate === null) throw new Error("The parameter 'attendanceDate' cannot be null.");
        else if (attendanceDate !== undefined) url_ += 'AttendanceDate=' + encodeURIComponent(attendanceDate ? '' + attendanceDate.toISOString() : '') + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetListDetail(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetListDetail(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetListDetail(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateAttendanceDto | undefined): Observable<string> {
        let url_ = this.baseUrl + '/api/services/app/Attendance/Create';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<string>;
                        }
                    } else return _observableThrow(response_) as any as Observable<string>;
                })
            );
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateAttendanceDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Attendance/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Attendance/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    action(body: ActionAttendanceDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Attendance/Action';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processAction(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processAction(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processAction(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param file (optional)
     * @param attendanceId (optional)
     * @param attendanceDate (optional)
     * @return Success
     */
    importTimeKeeper(file: FileParameter | undefined, attendanceId: number | undefined, attendanceDate: moment.Moment | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Attendance/ImportTimeKeeper';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = new FormData();
        if (file === null || file === undefined) throw new Error("The parameter 'file' cannot be null.");
        else content_.append('File', file.data, file.fileName ? file.fileName : 'File');
        if (attendanceId === null || attendanceId === undefined) throw new Error("The parameter 'attendanceId' cannot be null.");
        else content_.append('AttendanceId', attendanceId.toString());
        if (attendanceDate === null || attendanceDate === undefined) throw new Error("The parameter 'attendanceDate' cannot be null.");
        else content_.append('AttendanceDate', attendanceDate.toJSON());

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processImportTimeKeeper(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processImportTimeKeeper(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processImportTimeKeeper(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param employeeCode (optional)
     * @param attendanceId (optional)
     * @param attendanceDate (optional)
     * @return Success
     */
    getDetails(employeeCode: string | undefined, attendanceId: number | undefined, attendanceDate: moment.Moment | undefined): Observable<AttendanceDetailDto> {
        let url_ = this.baseUrl + '/api/services/app/Attendance/GetDetails?';
        if (employeeCode === null) throw new Error("The parameter 'employeeCode' cannot be null.");
        else if (employeeCode !== undefined) url_ += 'EmployeeCode=' + encodeURIComponent('' + employeeCode) + '&';
        if (attendanceId === null) throw new Error("The parameter 'attendanceId' cannot be null.");
        else if (attendanceId !== undefined) url_ += 'AttendanceId=' + encodeURIComponent('' + attendanceId) + '&';
        if (attendanceDate === null) throw new Error("The parameter 'attendanceDate' cannot be null.");
        else if (attendanceDate !== undefined) url_ += 'AttendanceDate=' + encodeURIComponent(attendanceDate ? '' + attendanceDate.toISOString() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetDetails(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetDetails(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<AttendanceDetailDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<AttendanceDetailDto>;
                })
            );
    }

    protected processGetDetails(response: HttpResponseBase): Observable<AttendanceDetailDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = AttendanceDetailDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AttendanceDetailDto>(null as any);
    }

    /**
     * @param employeeCode (optional)
     * @param attendanceId (optional)
     * @param attendanceDate (optional)
     * @return Success
     */
    getTimeWorking(employeeCode: string | undefined, attendanceId: number | undefined, attendanceDate: moment.Moment | undefined): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/Attendance/GetTimeWorking?';
        if (employeeCode === null) throw new Error("The parameter 'employeeCode' cannot be null.");
        else if (employeeCode !== undefined) url_ += 'EmployeeCode=' + encodeURIComponent('' + employeeCode) + '&';
        if (attendanceId === null) throw new Error("The parameter 'attendanceId' cannot be null.");
        else if (attendanceId !== undefined) url_ += 'AttendanceId=' + encodeURIComponent('' + attendanceId) + '&';
        if (attendanceDate === null) throw new Error("The parameter 'attendanceDate' cannot be null.");
        else if (attendanceDate !== undefined) url_ += 'AttendanceDate=' + encodeURIComponent(attendanceDate ? '' + attendanceDate.toISOString() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTimeWorking(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTimeWorking(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<number>;
                        }
                    } else return _observableThrow(response_) as any as Observable<number>;
                })
            );
    }

    protected processGetTimeWorking(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    insertOrUpdateAttendance(body: AttendanceDetailDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Attendance/InsertOrUpdateAttendance';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processInsertOrUpdateAttendance(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processInsertOrUpdateAttendance(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processInsertOrUpdateAttendance(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param employee (optional)
     * @param attendanceId (optional)
     * @param pDate (optional)
     * @return Success
     */
    export(employee: string | undefined, attendanceId: number | undefined, pDate: moment.Moment | undefined): Observable<string> {
        let url_ = this.baseUrl + '/api/services/app/Attendance/Export?';
        if (employee === null) throw new Error("The parameter 'employee' cannot be null.");
        else if (employee !== undefined) url_ += 'Employee=' + encodeURIComponent('' + employee) + '&';
        if (attendanceId === null) throw new Error("The parameter 'attendanceId' cannot be null.");
        else if (attendanceId !== undefined) url_ += 'AttendanceId=' + encodeURIComponent('' + attendanceId) + '&';
        if (pDate === null) throw new Error("The parameter 'pDate' cannot be null.");
        else if (pDate !== undefined) url_ += 'PDate=' + encodeURIComponent(pDate ? '' + pDate.toISOString() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processExport(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processExport(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<string>;
                        }
                    } else return _observableThrow(response_) as any as Observable<string>;
                })
            );
    }

    protected processExport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param employee (optional)
     * @param attendanceId (optional)
     * @param pDate (optional)
     * @return Success
     */
    exportTimeSheet(employee: string | undefined, attendanceId: number | undefined, pDate: moment.Moment | undefined): Observable<string> {
        let url_ = this.baseUrl + '/api/services/app/Attendance/ExportTimeSheet?';
        if (employee === null) throw new Error("The parameter 'employee' cannot be null.");
        else if (employee !== undefined) url_ += 'Employee=' + encodeURIComponent('' + employee) + '&';
        if (attendanceId === null) throw new Error("The parameter 'attendanceId' cannot be null.");
        else if (attendanceId !== undefined) url_ += 'AttendanceId=' + encodeURIComponent('' + attendanceId) + '&';
        if (pDate === null) throw new Error("The parameter 'pDate' cannot be null.");
        else if (pDate !== undefined) url_ += 'PDate=' + encodeURIComponent(pDate ? '' + pDate.toISOString() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processExportTimeSheet(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processExportTimeSheet(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<string>;
                        }
                    } else return _observableThrow(response_) as any as Observable<string>;
                })
            );
    }

    protected processExportTimeSheet(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    deleteAttendanceDetail(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Attendance/DeleteAttendanceDetail?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteAttendanceDetail(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteAttendanceDetail(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDeleteAttendanceDetail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class BonusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(
        fromDate: moment.Moment | undefined,
        toDate: moment.Moment | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/Bonus/GetList?';
        if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined) url_ += 'FromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
        if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined) url_ += 'ToDate=' + encodeURIComponent(toDate ? '' + toDate.toISOString() : '') + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getInfo(id: number | undefined): Observable<BonusDto> {
        let url_ = this.baseUrl + '/api/services/app/Bonus/GetInfo?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInfo(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInfo(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<BonusDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<BonusDto>;
                })
            );
    }

    protected processGetInfo(response: HttpResponseBase): Observable<BonusDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = BonusDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<BonusDto>(null as any);
    }

    /**
     * @param bonusId (optional)
     * @return Success
     */
    getListDetail(bonusId: number | undefined): Observable<BonusDetailModel[]> {
        let url_ = this.baseUrl + '/api/services/app/Bonus/GetListDetail?';
        if (bonusId === null) throw new Error("The parameter 'bonusId' cannot be null.");
        else if (bonusId !== undefined) url_ += 'BonusId=' + encodeURIComponent('' + bonusId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetListDetail(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetListDetail(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<BonusDetailModel[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<BonusDetailModel[]>;
                })
            );
    }

    protected processGetListDetail(response: HttpResponseBase): Observable<BonusDetailModel[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(BonusDetailModel.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<BonusDetailModel[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateBonusDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Bonus/Create';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateBonusDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Bonus/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Bonus/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    action(body: ActionBonusDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Bonus/Action';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processAction(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processAction(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processAction(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class CachingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getAllCaches(): Observable<CacheDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Caching/GetAllCaches';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAllCaches(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAllCaches(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<CacheDtoListResultDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<CacheDtoListResultDto>;
                })
            );
    }

    protected processGetAllCaches(response: HttpResponseBase): Observable<CacheDtoListResultDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CacheDtoListResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CacheDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    clearCache(body: StringEntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Caching/ClearCache';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processClearCache(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processClearCache(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<void>;
                        }
                    } else return _observableThrow(response_) as any as Observable<void>;
                })
            );
    }

    protected processClearCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(null as any);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    clearAllCaches(): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Caching/ClearAllCaches';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({})
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processClearAllCaches(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processClearAllCaches(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<void>;
                        }
                    } else return _observableThrow(response_) as any as Observable<void>;
                })
            );
    }

    protected processClearAllCaches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(null as any);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ClientAbpLanguageTextsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param langguageName (optional)
     * @return Success
     */
    getList(langguageName: string | undefined): Observable<ClientAbpLanguageTextsDto[]> {
        let url_ = this.baseUrl + '/api/services/app/ClientAbpLanguageTexts/GetList?';
        if (langguageName === null) throw new Error("The parameter 'langguageName' cannot be null.");
        else if (langguageName !== undefined) url_ += 'langguageName=' + encodeURIComponent('' + langguageName) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientAbpLanguageTextsDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientAbpLanguageTextsDto[]>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ClientAbpLanguageTextsDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ClientAbpLanguageTextsDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientAbpLanguageTextsDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getLanguage(): Observable<ClientAbpLanguageDto[]> {
        let url_ = this.baseUrl + '/api/services/app/ClientAbpLanguageTexts/GetLanguage';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetLanguage(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetLanguage(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientAbpLanguageDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientAbpLanguageDto[]>;
                })
            );
    }

    protected processGetLanguage(response: HttpResponseBase): Observable<ClientAbpLanguageDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ClientAbpLanguageDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientAbpLanguageDto[]>(null as any);
    }
}

@Injectable()
export class ClientAnnualLeaveServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(id: string | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/ClientAnnualLeave/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @return Success
     */
    getWorkingShift(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined): Observable<ClientAnnualLeaveWorkingShiftModel[]> {
        let url_ = this.baseUrl + '/api/services/app/ClientAnnualLeave/GetWorkingShift?';
        if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined) url_ += 'FromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
        if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined) url_ += 'ToDate=' + encodeURIComponent(toDate ? '' + toDate.toISOString() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetWorkingShift(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetWorkingShift(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientAnnualLeaveWorkingShiftModel[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientAnnualLeaveWorkingShiftModel[]>;
                })
            );
    }

    protected processGetWorkingShift(response: HttpResponseBase): Observable<ClientAnnualLeaveWorkingShiftModel[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ClientAnnualLeaveWorkingShiftModel.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientAnnualLeaveWorkingShiftModel[]>(null as any);
    }

    /**
     * @param id (optional)
     * @param isManager (optional)
     * @return Success
     */
    getById(id: number | undefined, isManager: boolean | undefined): Observable<ClientAnnualLeaveDetailsModel> {
        let url_ = this.baseUrl + '/api/services/app/ClientAnnualLeave/GetById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (isManager === null) throw new Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined) url_ += 'IsManager=' + encodeURIComponent('' + isManager) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetById(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientAnnualLeaveDetailsModel>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientAnnualLeaveDetailsModel>;
                })
            );
    }

    protected processGetById(response: HttpResponseBase): Observable<ClientAnnualLeaveDetailsModel> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ClientAnnualLeaveDetailsModel.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientAnnualLeaveDetailsModel>(null as any);
    }

    /**
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(pageIndex: number | undefined, pageSize: number | undefined): Observable<ClientAnnualLeavePageModel[]> {
        let url_ = this.baseUrl + '/api/services/app/ClientAnnualLeave/GetList?';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientAnnualLeavePageModel[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientAnnualLeavePageModel[]>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ClientAnnualLeavePageModel[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ClientAnnualLeavePageModel.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientAnnualLeavePageModel[]>(null as any);
    }

    /**
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getListByManagerId(pageIndex: number | undefined, pageSize: number | undefined): Observable<ClientAnnualLeaveByManagerPageModel[]> {
        let url_ = this.baseUrl + '/api/services/app/ClientAnnualLeave/GetListByManagerId?';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetListByManagerId(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetListByManagerId(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientAnnualLeaveByManagerPageModel[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientAnnualLeaveByManagerPageModel[]>;
                })
            );
    }

    protected processGetListByManagerId(response: HttpResponseBase): Observable<ClientAnnualLeaveByManagerPageModel[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ClientAnnualLeaveByManagerPageModel.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientAnnualLeaveByManagerPageModel[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    register(body: RegisterClientAnnualLeaveDto | undefined): Observable<string> {
        let url_ = this.baseUrl + '/api/services/app/ClientAnnualLeave/Register';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processRegister(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processRegister(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<string>;
                        }
                    } else return _observableThrow(response_) as any as Observable<string>;
                })
            );
    }

    protected processRegister(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateClientAnnualLeaveDto | undefined): Observable<string> {
        let url_ = this.baseUrl + '/api/services/app/ClientAnnualLeave/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<string>;
                        }
                    } else return _observableThrow(response_) as any as Observable<string>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class ClientAttendanceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @return Success
     */
    getInfo(month: number | undefined, year: number | undefined): Observable<ClientAttendanceTotalDto> {
        let url_ = this.baseUrl + '/api/services/app/ClientAttendance/GetInfo?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInfo(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInfo(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientAttendanceTotalDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientAttendanceTotalDto>;
                })
            );
    }

    protected processGetInfo(response: HttpResponseBase): Observable<ClientAttendanceTotalDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ClientAttendanceTotalDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientAttendanceTotalDto>(null as any);
    }

    /**
     * @return Success
     */
    checkIn(): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/ClientAttendance/CheckIn';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCheckIn(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCheckIn(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processCheckIn(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return Success
     */
    checkOut(): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/ClientAttendance/CheckOut';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCheckOut(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCheckOut(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processCheckOut(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(keyword: string | undefined, pageIndex: number | undefined, pageSize: number | undefined): Observable<ClientAttendancePageModel[]> {
        let url_ = this.baseUrl + '/api/services/app/ClientAttendance/GetList?';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientAttendancePageModel[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientAttendancePageModel[]>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ClientAttendancePageModel[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ClientAttendancePageModel.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientAttendancePageModel[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getAttendanceDetail(body: GetInfoAttendanceDto | undefined): Observable<ClientAttendanceInfoDto> {
        let url_ = this.baseUrl + '/api/services/app/ClientAttendance/GetAttendanceDetail';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAttendanceDetail(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAttendanceDetail(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientAttendanceInfoDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientAttendanceInfoDto>;
                })
            );
    }

    protected processGetAttendanceDetail(response: HttpResponseBase): Observable<ClientAttendanceInfoDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ClientAttendanceInfoDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientAttendanceInfoDto>(null as any);
    }
}

@Injectable()
export class ClientEmployeeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param device (optional)
     * @param tenantId (optional)
     * @return Success
     */
    checkDevice(device: string | undefined, tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/ClientEmployee/CheckDevice?';
        if (device === null) throw new Error("The parameter 'device' cannot be null.");
        else if (device !== undefined) url_ += 'device=' + encodeURIComponent('' + device) + '&';
        if (tenantId === null) throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined) url_ += 'tenantId=' + encodeURIComponent('' + tenantId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCheckDevice(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCheckDevice(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processCheckDevice(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    login(body: ClientLoginEmployeeDto | undefined): Observable<ClientEmployeeLoginDto> {
        let url_ = this.baseUrl + '/api/services/app/ClientEmployee/Login';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processLogin(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processLogin(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientEmployeeLoginDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientEmployeeLoginDto>;
                })
            );
    }

    protected processLogin(response: HttpResponseBase): Observable<ClientEmployeeLoginDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ClientEmployeeLoginDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientEmployeeLoginDto>(null as any);
    }

    /**
     * @return Success
     */
    getInfo(): Observable<ClientEmployeeDto> {
        let url_ = this.baseUrl + '/api/services/app/ClientEmployee/GetInfo';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInfo(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInfo(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientEmployeeDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientEmployeeDto>;
                })
            );
    }

    protected processGetInfo(response: HttpResponseBase): Observable<ClientEmployeeDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ClientEmployeeDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientEmployeeDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    changePassword(body: ClientChangePasswordEmployeeDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/ClientEmployee/ChangePassword';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processChangePassword(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processChangePassword(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getProfileById(): Observable<ClientProfileDto> {
        let url_ = this.baseUrl + '/api/services/app/ClientEmployee/GetProfileById';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProfileById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProfileById(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientProfileDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientProfileDto>;
                })
            );
    }

    protected processGetProfileById(response: HttpResponseBase): Observable<ClientProfileDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ClientProfileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientProfileDto>(null as any);
    }

    /**
     * @return Success
     */
    getStatWidgetById(): Observable<ClientEmployeeStatWidgetModel> {
        let url_ = this.baseUrl + '/api/services/app/ClientEmployee/GetStatWidgetById';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetStatWidgetById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetStatWidgetById(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientEmployeeStatWidgetModel>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientEmployeeStatWidgetModel>;
                })
            );
    }

    protected processGetStatWidgetById(response: HttpResponseBase): Observable<ClientEmployeeStatWidgetModel> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ClientEmployeeStatWidgetModel.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientEmployeeStatWidgetModel>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    resetPassword(body: ClientEmployeeResetPasswordDto | undefined): Observable<string> {
        let url_ = this.baseUrl + '/api/services/app/ClientEmployee/ResetPassword';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processResetPassword(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processResetPassword(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<string>;
                        }
                    } else return _observableThrow(response_) as any as Observable<string>;
                })
            );
    }

    protected processResetPassword(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    checkOtp(body: ClientEmployeeUpdatePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/ClientEmployee/CheckOtp';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCheckOtp(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCheckOtp(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processCheckOtp(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateImage(body: ClientEmployeeUpdateImageDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/ClientEmployee/UpdateImage';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateImage(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateImage(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdateImage(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class ClientEvaluationResultServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(
        fromDate: moment.Moment | undefined,
        toDate: moment.Moment | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ClientEvaluationResultModel[]> {
        let url_ = this.baseUrl + '/api/services/app/ClientEvaluationResult/GetList?';
        if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined) url_ += 'FromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
        if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined) url_ += 'ToDate=' + encodeURIComponent(toDate ? '' + toDate.toISOString() : '') + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientEvaluationResultModel[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientEvaluationResultModel[]>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ClientEvaluationResultModel[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ClientEvaluationResultModel.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientEvaluationResultModel[]>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getInfo(id: number | undefined): Observable<ClientEvaluationResultDto> {
        let url_ = this.baseUrl + '/api/services/app/ClientEvaluationResult/GetInfo?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInfo(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInfo(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientEvaluationResultDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientEvaluationResultDto>;
                })
            );
    }

    protected processGetInfo(response: HttpResponseBase): Observable<ClientEvaluationResultDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ClientEvaluationResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientEvaluationResultDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    action(body: ClientActionEvaluationResultDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/ClientEvaluationResult/Action';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processAction(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processAction(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processAction(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class ClientMasterDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param workflowCode (optional)
     * @param workflowDataCode (optional)
     * @return Success
     */
    getListWorkflowByUsrType(workflowCode: string | undefined, workflowDataCode: string | undefined): Observable<SysWorkflowDto[]> {
        let url_ = this.baseUrl + '/api/services/app/ClientMasterData/GetListWorkflowByUsrType?';
        if (workflowCode === null) throw new Error("The parameter 'workflowCode' cannot be null.");
        else if (workflowCode !== undefined) url_ += 'workflowCode=' + encodeURIComponent('' + workflowCode) + '&';
        if (workflowDataCode === null) throw new Error("The parameter 'workflowDataCode' cannot be null.");
        else if (workflowDataCode !== undefined) url_ += 'workflowDataCode=' + encodeURIComponent('' + workflowDataCode) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetListWorkflowByUsrType(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetListWorkflowByUsrType(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<SysWorkflowDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<SysWorkflowDto[]>;
                })
            );
    }

    protected processGetListWorkflowByUsrType(response: HttpResponseBase): Observable<SysWorkflowDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(SysWorkflowDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SysWorkflowDto[]>(null as any);
    }

    /**
     * @param workflowCode (optional)
     * @param workflowDataCode (optional)
     * @return Success
     */
    getLatestWorkflowStateOfWorkflowCode(workflowCode: string | undefined, workflowDataCode: string | undefined): Observable<SysWorkflowStateDto> {
        let url_ = this.baseUrl + '/api/services/app/ClientMasterData/GetLatestWorkflowStateOfWorkflowCode?';
        if (workflowCode === null) throw new Error("The parameter 'workflowCode' cannot be null.");
        else if (workflowCode !== undefined) url_ += 'workflowCode=' + encodeURIComponent('' + workflowCode) + '&';
        if (workflowDataCode === null) throw new Error("The parameter 'workflowDataCode' cannot be null.");
        else if (workflowDataCode !== undefined) url_ += 'workflowDataCode=' + encodeURIComponent('' + workflowDataCode) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetLatestWorkflowStateOfWorkflowCode(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetLatestWorkflowStateOfWorkflowCode(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<SysWorkflowStateDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<SysWorkflowStateDto>;
                })
            );
    }

    protected processGetLatestWorkflowStateOfWorkflowCode(response: HttpResponseBase): Observable<SysWorkflowStateDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = SysWorkflowStateDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SysWorkflowStateDto>(null as any);
    }
}

@Injectable()
export class ClientMasterListServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param masterListGroupCde (optional)
     * @return Success
     */
    getMasterData(masterListGroupCde: string | undefined): Observable<ClientMasterListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/ClientMasterList/GetMasterData?';
        if (masterListGroupCde === null) throw new Error("The parameter 'masterListGroupCde' cannot be null.");
        else if (masterListGroupCde !== undefined) url_ += 'masterListGroupCde=' + encodeURIComponent('' + masterListGroupCde) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetMasterData(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetMasterData(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientMasterListDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientMasterListDto[]>;
                })
            );
    }

    protected processGetMasterData(response: HttpResponseBase): Observable<ClientMasterListDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ClientMasterListDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientMasterListDto[]>(null as any);
    }
}

@Injectable()
export class ClientNotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getById(id: number | undefined): Observable<ClientInfoNotificationDto> {
        let url_ = this.baseUrl + '/api/services/app/ClientNotification/GetById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetById(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientInfoNotificationDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientInfoNotificationDto>;
                })
            );
    }

    protected processGetById(response: HttpResponseBase): Observable<ClientInfoNotificationDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ClientInfoNotificationDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientInfoNotificationDto>(null as any);
    }

    /**
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(pageIndex: number | undefined, pageSize: number | undefined): Observable<ClientNotificationDto[]> {
        let url_ = this.baseUrl + '/api/services/app/ClientNotification/GetList?';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientNotificationDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientNotificationDto[]>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ClientNotificationDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ClientNotificationDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientNotificationDto[]>(null as any);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    getNotReadNumber(model: ClientGetNotificationNotReadDto | undefined): Observable<ClientNotificationNotReadDto> {
        let url_ = this.baseUrl + '/api/services/app/ClientNotification/GetNotReadNumber?';
        if (model === null) throw new Error("The parameter 'model' cannot be null.");
        else if (model !== undefined) url_ += 'model=' + encodeURIComponent('' + model) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetNotReadNumber(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetNotReadNumber(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientNotificationNotReadDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientNotificationNotReadDto>;
                })
            );
    }

    protected processGetNotReadNumber(response: HttpResponseBase): Observable<ClientNotificationNotReadDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ClientNotificationNotReadDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientNotificationNotReadDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateRead(body: ClientGetNotificationReadDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/ClientNotification/UpdateRead';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateRead(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateRead(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdateRead(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateReadAll(body: ClientGetNotificationReadAllDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/ClientNotification/UpdateReadAll';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateReadAll(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateReadAll(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdateReadAll(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class ClientRegisterOvertimeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(pageIndex: number | undefined, pageSize: number | undefined): Observable<ClientRegisterOvertimeModel[]> {
        let url_ = this.baseUrl + '/api/services/app/ClientRegisterOvertime/GetList?';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientRegisterOvertimeModel[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientRegisterOvertimeModel[]>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ClientRegisterOvertimeModel[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ClientRegisterOvertimeModel.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientRegisterOvertimeModel[]>(null as any);
    }

    /**
     * @param id (optional)
     * @param isManager (optional)
     * @return Success
     */
    getById(id: number | undefined, isManager: boolean | undefined): Observable<ClientRegisterOvertimeDetailModel> {
        let url_ = this.baseUrl + '/api/services/app/ClientRegisterOvertime/GetById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (isManager === null) throw new Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined) url_ += 'IsManager=' + encodeURIComponent('' + isManager) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetById(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientRegisterOvertimeDetailModel>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientRegisterOvertimeDetailModel>;
                })
            );
    }

    protected processGetById(response: HttpResponseBase): Observable<ClientRegisterOvertimeDetailModel> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ClientRegisterOvertimeDetailModel.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientRegisterOvertimeDetailModel>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    register(body: ClientRegisterOvertimeDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/ClientRegisterOvertime/Register';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processRegister(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processRegister(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processRegister(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: ClientUpdateRegisterOvertimeDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/ClientRegisterOvertime/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/ClientRegisterOvertime/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getListByManagerId(pageIndex: number | undefined, pageSize: number | undefined): Observable<ClientRegisterOvertimeByManagerIdModel[]> {
        let url_ = this.baseUrl + '/api/services/app/ClientRegisterOvertime/GetListByManagerId?';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetListByManagerId(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetListByManagerId(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientRegisterOvertimeByManagerIdModel[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientRegisterOvertimeByManagerIdModel[]>;
                })
            );
    }

    protected processGetListByManagerId(response: HttpResponseBase): Observable<ClientRegisterOvertimeByManagerIdModel[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ClientRegisterOvertimeByManagerIdModel.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientRegisterOvertimeByManagerIdModel[]>(null as any);
    }
}

@Injectable()
export class ClientSalaryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    export(body: ExportClientSalaryDto | undefined): Observable<ClientSalaryExportDto> {
        let url_ = this.baseUrl + '/api/services/app/ClientSalary/Export';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processExport(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processExport(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientSalaryExportDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientSalaryExportDto>;
                })
            );
    }

    protected processExport(response: HttpResponseBase): Observable<ClientSalaryExportDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ClientSalaryExportDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientSalaryExportDto>(null as any);
    }

    /**
     * @return Success
     */
    payRollList(): Observable<ClientSalaryPayrollModel[]> {
        let url_ = this.baseUrl + '/api/services/app/ClientSalary/PayRollList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processPayRollList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processPayRollList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientSalaryPayrollModel[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientSalaryPayrollModel[]>;
                })
            );
    }

    protected processPayRollList(response: HttpResponseBase): Observable<ClientSalaryPayrollModel[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ClientSalaryPayrollModel.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientSalaryPayrollModel[]>(null as any);
    }
}

@Injectable()
export class ClientTenantsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param userName (optional)
     * @return Success
     */
    getInfo(userName: string | undefined): Observable<ClientInfoTenantsDto[]> {
        let url_ = this.baseUrl + '/api/services/app/ClientTenants/GetInfo?';
        if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined) url_ += 'UserName=' + encodeURIComponent('' + userName) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInfo(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInfo(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientInfoTenantsDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientInfoTenantsDto[]>;
                })
            );
    }

    protected processGetInfo(response: HttpResponseBase): Observable<ClientInfoTenantsDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ClientInfoTenantsDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientInfoTenantsDto[]>(null as any);
    }
}

@Injectable()
export class ClientTrackingLeaveServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(
        fromDate: moment.Moment | undefined,
        toDate: moment.Moment | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ClientTrackingLeaveModel[]> {
        let url_ = this.baseUrl + '/api/services/app/ClientTrackingLeave/GetList?';
        if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined) url_ += 'FromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
        if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined) url_ += 'ToDate=' + encodeURIComponent(toDate ? '' + toDate.toISOString() : '') + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ClientTrackingLeaveModel[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ClientTrackingLeaveModel[]>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ClientTrackingLeaveModel[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ClientTrackingLeaveModel.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ClientTrackingLeaveModel[]>(null as any);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Configuration/ChangeUiTheme';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processChangeUiTheme(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processChangeUiTheme(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<void>;
                        }
                    } else return _observableThrow(response_) as any as Observable<void>;
                })
            );
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(null as any);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ContractServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(
        fromDate: moment.Moment | undefined,
        toDate: moment.Moment | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/Contract/GetList?';
        if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined) url_ += 'FromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
        if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined) url_ += 'ToDate=' + encodeURIComponent(toDate ? '' + toDate.toISOString() : '') + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getById(id: number | undefined): Observable<ContractDto> {
        let url_ = this.baseUrl + '/api/services/app/Contract/GetById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetById(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ContractDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ContractDto>;
                })
            );
    }

    protected processGetById(response: HttpResponseBase): Observable<ContractDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ContractDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ContractDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    insert(body: CreateContractDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Contract/Insert';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processInsert(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processInsert(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processInsert(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateContractDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Contract/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param iD (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(iD: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Contract/Delete?';
        if (iD === null) throw new Error("The parameter 'iD' cannot be null.");
        else if (iD !== undefined) url_ += 'ID=' + encodeURIComponent('' + iD) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class EmployeeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param isInactivity (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(
        isInactivity: boolean | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/Employee/GetList?';
        if (isInactivity === null) throw new Error("The parameter 'isInactivity' cannot be null.");
        else if (isInactivity !== undefined) url_ += 'IsInactivity=' + encodeURIComponent('' + isInactivity) + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getById(id: number | undefined): Observable<EmployeeDto> {
        let url_ = this.baseUrl + '/api/services/app/Employee/GetById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetById(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<EmployeeDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<EmployeeDto>;
                })
            );
    }

    protected processGetById(response: HttpResponseBase): Observable<EmployeeDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = EmployeeDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<EmployeeDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    insert(body: CreateEmployeeDto | undefined): Observable<string> {
        let url_ = this.baseUrl + '/api/services/app/Employee/Insert';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processInsert(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processInsert(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<string>;
                        }
                    } else return _observableThrow(response_) as any as Observable<string>;
                })
            );
    }

    protected processInsert(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateEmployeeDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Employee/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Employee/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    resetPassword(body: ResetPasswordEmployeeDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Employee/ResetPassword';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processResetPassword(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processResetPassword(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param managerId (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getListAffiliated(managerId: number | undefined, pageIndex: number | undefined, pageSize: number | undefined): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/Employee/GetListAffiliated?';
        if (managerId === null) throw new Error("The parameter 'managerId' cannot be null.");
        else if (managerId !== undefined) url_ += 'ManagerId=' + encodeURIComponent('' + managerId) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetListAffiliated(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetListAffiliated(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetListAffiliated(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllManagerEmployee(): Observable<EmployeeGetAllManagerDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Employee/GetAllManagerEmployee';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAllManagerEmployee(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAllManagerEmployee(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<EmployeeGetAllManagerDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<EmployeeGetAllManagerDto[]>;
                })
            );
    }

    protected processGetAllManagerEmployee(response: HttpResponseBase): Observable<EmployeeGetAllManagerDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(EmployeeGetAllManagerDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<EmployeeGetAllManagerDto[]>(null as any);
    }
}

@Injectable()
export class EmployeeOverviewReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @return Success
     */
    getEmployeeMovementChart(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined): Observable<EmployeeOverviewReportDto[]> {
        let url_ = this.baseUrl + '/api/services/app/EmployeeOverviewReport/GetEmployeeMovementChart?';
        if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined) url_ += 'FromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
        if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined) url_ += 'ToDate=' + encodeURIComponent(toDate ? '' + toDate.toISOString() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetEmployeeMovementChart(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetEmployeeMovementChart(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<EmployeeOverviewReportDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<EmployeeOverviewReportDto[]>;
                })
            );
    }

    protected processGetEmployeeMovementChart(response: HttpResponseBase): Observable<EmployeeOverviewReportDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(EmployeeOverviewReportDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<EmployeeOverviewReportDto[]>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @return Success
     */
    getEmployeeHeadcountChart(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined): Observable<EmployeeOverviewReportDto[]> {
        let url_ = this.baseUrl + '/api/services/app/EmployeeOverviewReport/GetEmployeeHeadcountChart?';
        if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined) url_ += 'FromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
        if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined) url_ += 'ToDate=' + encodeURIComponent(toDate ? '' + toDate.toISOString() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetEmployeeHeadcountChart(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetEmployeeHeadcountChart(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<EmployeeOverviewReportDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<EmployeeOverviewReportDto[]>;
                })
            );
    }

    protected processGetEmployeeHeadcountChart(response: HttpResponseBase): Observable<EmployeeOverviewReportDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(EmployeeOverviewReportDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<EmployeeOverviewReportDto[]>(null as any);
    }

    /**
     * @param inputTime (optional)
     * @return Success
     */
    getEmployeeByDepartmentChart(inputTime: moment.Moment | undefined): Observable<EmployeeOverviewReportDto[]> {
        let url_ = this.baseUrl + '/api/services/app/EmployeeOverviewReport/GetEmployeeByDepartmentChart?';
        if (inputTime === null) throw new Error("The parameter 'inputTime' cannot be null.");
        else if (inputTime !== undefined) url_ += 'inputTime=' + encodeURIComponent(inputTime ? '' + inputTime.toISOString() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetEmployeeByDepartmentChart(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetEmployeeByDepartmentChart(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<EmployeeOverviewReportDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<EmployeeOverviewReportDto[]>;
                })
            );
    }

    protected processGetEmployeeByDepartmentChart(response: HttpResponseBase): Observable<EmployeeOverviewReportDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(EmployeeOverviewReportDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<EmployeeOverviewReportDto[]>(null as any);
    }

    /**
     * @param inputTime (optional)
     * @return Success
     */
    getEmployeeByContractTypeChart(inputTime: moment.Moment | undefined): Observable<EmployeeOverviewReportDto[]> {
        let url_ = this.baseUrl + '/api/services/app/EmployeeOverviewReport/GetEmployeeByContractTypeChart?';
        if (inputTime === null) throw new Error("The parameter 'inputTime' cannot be null.");
        else if (inputTime !== undefined) url_ += 'inputTime=' + encodeURIComponent(inputTime ? '' + inputTime.toISOString() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetEmployeeByContractTypeChart(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetEmployeeByContractTypeChart(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<EmployeeOverviewReportDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<EmployeeOverviewReportDto[]>;
                })
            );
    }

    protected processGetEmployeeByContractTypeChart(response: HttpResponseBase): Observable<EmployeeOverviewReportDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(EmployeeOverviewReportDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<EmployeeOverviewReportDto[]>(null as any);
    }
}

@Injectable()
export class EmployeePayrollDisbursementReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @return Success
     */
    getSalarySummaryReport(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined): Observable<EmployeePayrollDisbursementReportDto> {
        let url_ = this.baseUrl + '/api/services/app/EmployeePayrollDisbursementReport/GetSalarySummaryReport?';
        if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined) url_ += 'FromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
        if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined) url_ += 'ToDate=' + encodeURIComponent(toDate ? '' + toDate.toISOString() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSalarySummaryReport(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSalarySummaryReport(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<EmployeePayrollDisbursementReportDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<EmployeePayrollDisbursementReportDto>;
                })
            );
    }

    protected processGetSalarySummaryReport(response: HttpResponseBase): Observable<EmployeePayrollDisbursementReportDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = EmployeePayrollDisbursementReportDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<EmployeePayrollDisbursementReportDto>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @return Success
     */
    getSalarySummaryDetailReport(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined): Observable<EmployeePayrollDisbursementReportDto[]> {
        let url_ = this.baseUrl + '/api/services/app/EmployeePayrollDisbursementReport/GetSalarySummaryDetailReport?';
        if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined) url_ += 'FromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
        if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined) url_ += 'ToDate=' + encodeURIComponent(toDate ? '' + toDate.toISOString() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSalarySummaryDetailReport(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSalarySummaryDetailReport(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<EmployeePayrollDisbursementReportDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<EmployeePayrollDisbursementReportDto[]>;
                })
            );
    }

    protected processGetSalarySummaryDetailReport(response: HttpResponseBase): Observable<EmployeePayrollDisbursementReportDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(EmployeePayrollDisbursementReportDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<EmployeePayrollDisbursementReportDto[]>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @return Success
     */
    getEmployeeSalaryAnalysisChart(
        fromDate: moment.Moment | undefined,
        toDate: moment.Moment | undefined
    ): Observable<EmployeePayrollDisbursementReportChartDto[]> {
        let url_ = this.baseUrl + '/api/services/app/EmployeePayrollDisbursementReport/GetEmployeeSalaryAnalysisChart?';
        if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined) url_ += 'fromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
        if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined) url_ += 'toDate=' + encodeURIComponent(toDate ? '' + toDate.toISOString() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetEmployeeSalaryAnalysisChart(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetEmployeeSalaryAnalysisChart(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<EmployeePayrollDisbursementReportChartDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<EmployeePayrollDisbursementReportChartDto[]>;
                })
            );
    }

    protected processGetEmployeeSalaryAnalysisChart(response: HttpResponseBase): Observable<EmployeePayrollDisbursementReportChartDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(EmployeePayrollDisbursementReportChartDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<EmployeePayrollDisbursementReportChartDto[]>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @return Success
     */
    getEmployeeIncomeStructureChart(
        fromDate: moment.Moment | undefined,
        toDate: moment.Moment | undefined
    ): Observable<EmployeePayrollDisbursementReportChartDto[]> {
        let url_ = this.baseUrl + '/api/services/app/EmployeePayrollDisbursementReport/GetEmployeeIncomeStructureChart?';
        if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined) url_ += 'FromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
        if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined) url_ += 'ToDate=' + encodeURIComponent(toDate ? '' + toDate.toISOString() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetEmployeeIncomeStructureChart(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetEmployeeIncomeStructureChart(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<EmployeePayrollDisbursementReportChartDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<EmployeePayrollDisbursementReportChartDto[]>;
                })
            );
    }

    protected processGetEmployeeIncomeStructureChart(response: HttpResponseBase): Observable<EmployeePayrollDisbursementReportChartDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(EmployeePayrollDisbursementReportChartDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<EmployeePayrollDisbursementReportChartDto[]>(null as any);
    }
}

@Injectable()
export class EvaluationPeriodServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(
        fromDate: moment.Moment | undefined,
        toDate: moment.Moment | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/EvaluationPeriod/GetList?';
        if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined) url_ += 'FromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
        if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined) url_ += 'ToDate=' + encodeURIComponent(toDate ? '' + toDate.toISOString() : '') + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getInfo(id: number | undefined): Observable<EvaluationPeriodDto> {
        let url_ = this.baseUrl + '/api/services/app/EvaluationPeriod/GetInfo?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInfo(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInfo(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<EvaluationPeriodDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<EvaluationPeriodDto>;
                })
            );
    }

    protected processGetInfo(response: HttpResponseBase): Observable<EvaluationPeriodDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = EvaluationPeriodDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<EvaluationPeriodDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateEvaluationPeriodDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/EvaluationPeriod/Create';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateEvaluationPeriodDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/EvaluationPeriod/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/EvaluationPeriod/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class EvaluationResultServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(
        fromDate: moment.Moment | undefined,
        toDate: moment.Moment | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/EvaluationResult/GetList?';
        if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined) url_ += 'FromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
        if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined) url_ += 'ToDate=' + encodeURIComponent(toDate ? '' + toDate.toISOString() : '') + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getInfo(id: number | undefined): Observable<EvaluationResultDto> {
        let url_ = this.baseUrl + '/api/services/app/EvaluationResult/GetInfo?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInfo(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInfo(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<EvaluationResultDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<EvaluationResultDto>;
                })
            );
    }

    protected processGetInfo(response: HttpResponseBase): Observable<EvaluationResultDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = EvaluationResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<EvaluationResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getDropDownPeriod(): Observable<DropDownEvaluationPeriodDto[]> {
        let url_ = this.baseUrl + '/api/services/app/EvaluationResult/GetDropDownPeriod';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetDropDownPeriod(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetDropDownPeriod(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<DropDownEvaluationPeriodDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<DropDownEvaluationPeriodDto[]>;
                })
            );
    }

    protected processGetDropDownPeriod(response: HttpResponseBase): Observable<DropDownEvaluationPeriodDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DropDownEvaluationPeriodDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DropDownEvaluationPeriodDto[]>(null as any);
    }

    /**
     * @param notEvaluated (optional)
     * @return Success
     */
    getDropDownEmployee(notEvaluated: string | undefined): Observable<DropDownEmployeeDto[]> {
        let url_ = this.baseUrl + '/api/services/app/EvaluationResult/GetDropDownEmployee?';
        if (notEvaluated === null) throw new Error("The parameter 'notEvaluated' cannot be null.");
        else if (notEvaluated !== undefined) url_ += 'notEvaluated=' + encodeURIComponent('' + notEvaluated) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetDropDownEmployee(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetDropDownEmployee(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<DropDownEmployeeDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<DropDownEmployeeDto[]>;
                })
            );
    }

    protected processGetDropDownEmployee(response: HttpResponseBase): Observable<DropDownEmployeeDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DropDownEmployeeDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DropDownEmployeeDto[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateEvaluationResultDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/EvaluationResult/Create';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class ExpenditureIncomeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param type (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(
        type: string | undefined,
        fromDate: moment.Moment | undefined,
        toDate: moment.Moment | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/ExpenditureIncome/GetList?';
        if (type === null) throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined) url_ += 'Type=' + encodeURIComponent('' + type) + '&';
        if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined) url_ += 'FromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
        if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined) url_ += 'ToDate=' + encodeURIComponent(toDate ? '' + toDate.toISOString() : '') + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getById(id: number | undefined): Observable<ExpenditureIncomeDto> {
        let url_ = this.baseUrl + '/api/services/app/ExpenditureIncome/GetById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetById(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ExpenditureIncomeDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ExpenditureIncomeDto>;
                })
            );
    }

    protected processGetById(response: HttpResponseBase): Observable<ExpenditureIncomeDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ExpenditureIncomeDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ExpenditureIncomeDto>(null as any);
    }

    /**
     * @return Success
     */
    getEmployee(): Observable<ExpenditureIncomeEmployeeDto[]> {
        let url_ = this.baseUrl + '/api/services/app/ExpenditureIncome/GetEmployee';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetEmployee(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetEmployee(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ExpenditureIncomeEmployeeDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ExpenditureIncomeEmployeeDto[]>;
                })
            );
    }

    protected processGetEmployee(response: HttpResponseBase): Observable<ExpenditureIncomeEmployeeDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ExpenditureIncomeEmployeeDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ExpenditureIncomeEmployeeDto[]>(null as any);
    }

    /**
     * @param statusCde (optional)
     * @return Success
     */
    getContract(statusCde: string | undefined): Observable<ExpenditureIncomeContractDto[]> {
        let url_ = this.baseUrl + '/api/services/app/ExpenditureIncome/GetContract?';
        if (statusCde === null) throw new Error("The parameter 'statusCde' cannot be null.");
        else if (statusCde !== undefined) url_ += 'statusCde=' + encodeURIComponent('' + statusCde) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetContract(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetContract(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ExpenditureIncomeContractDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ExpenditureIncomeContractDto[]>;
                })
            );
    }

    protected processGetContract(response: HttpResponseBase): Observable<ExpenditureIncomeContractDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ExpenditureIncomeContractDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ExpenditureIncomeContractDto[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    insert(body: InsertExpenditureIncomeDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/ExpenditureIncome/Insert';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processInsert(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processInsert(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processInsert(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateExpenditureIncomeDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/ExpenditureIncome/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/ExpenditureIncome/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class FamilyExemptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param keyword (optional)
     * @param employeeId (optional)
     * @return Success
     */
    getList(keyword: string | undefined, employeeId: number | undefined): Observable<FamilyExemptionDto[]> {
        let url_ = this.baseUrl + '/api/services/app/FamilyExemption/GetList?';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (employeeId === null) throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined) url_ += 'EmployeeId=' + encodeURIComponent('' + employeeId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<FamilyExemptionDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<FamilyExemptionDto[]>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<FamilyExemptionDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(FamilyExemptionDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FamilyExemptionDto[]>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getById(id: number | undefined): Observable<FamilyExemptionDto> {
        let url_ = this.baseUrl + '/api/services/app/FamilyExemption/GetById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetById(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<FamilyExemptionDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<FamilyExemptionDto>;
                })
            );
    }

    protected processGetById(response: HttpResponseBase): Observable<FamilyExemptionDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FamilyExemptionDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FamilyExemptionDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    insert(body: CreateFamilyExemptionDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/FamilyExemption/Insert';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processInsert(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processInsert(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processInsert(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateFamilyExemptionDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/FamilyExemption/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateFEDate(body: UpdateDateFamilyExemptionDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/FamilyExemption/UpdateFEDate';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateFEDate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateFEDate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdateFEDate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/FamilyExemption/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class HolidayServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(keyword: string | undefined, pageIndex: number | undefined, pageSize: number | undefined): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/Holiday/GetList?';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getInfo(id: number | undefined): Observable<HolidayDto> {
        let url_ = this.baseUrl + '/api/services/app/Holiday/GetInfo?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInfo(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInfo(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<HolidayDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<HolidayDto>;
                })
            );
    }

    protected processGetInfo(response: HttpResponseBase): Observable<HolidayDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = HolidayDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<HolidayDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateHolidayDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Holiday/Create';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateHolidayDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Holiday/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Holiday/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    action(body: ActionHolidayDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Holiday/Action';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processAction(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processAction(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processAction(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class HomeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @return Success
     */
    getDashBoardListDataHome(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined): Observable<DashboardListDto> {
        let url_ = this.baseUrl + '/api/services/app/Home/GetDashBoardListDataHome?';
        if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined) url_ += 'FromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
        if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined) url_ += 'ToDate=' + encodeURIComponent(toDate ? '' + toDate.toISOString() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetDashBoardListDataHome(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetDashBoardListDataHome(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<DashboardListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<DashboardListDto>;
                })
            );
    }

    protected processGetDashBoardListDataHome(response: HttpResponseBase): Observable<DashboardListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = DashboardListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DashboardListDto>(null as any);
    }

    /**
     * @return Success
     */
    getExpiresPartnerContract(): Observable<HomeGetExpiresPartnerContractDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Home/GetExpiresPartnerContract';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetExpiresPartnerContract(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetExpiresPartnerContract(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<HomeGetExpiresPartnerContractDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<HomeGetExpiresPartnerContractDto[]>;
                })
            );
    }

    protected processGetExpiresPartnerContract(response: HttpResponseBase): Observable<HomeGetExpiresPartnerContractDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(HomeGetExpiresPartnerContractDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<HomeGetExpiresPartnerContractDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getListBirthday(): Observable<HomeListBirthdayDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Home/GetListBirthday';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetListBirthday(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetListBirthday(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<HomeListBirthdayDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<HomeListBirthdayDto[]>;
                })
            );
    }

    protected processGetListBirthday(response: HttpResponseBase): Observable<HomeListBirthdayDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(HomeListBirthdayDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<HomeListBirthdayDto[]>(null as any);
    }
}

@Injectable()
export class InsuranceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getById(id: number | undefined): Observable<InsuranceGetByIdDto> {
        let url_ = this.baseUrl + '/api/services/app/Insurance/GetById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetById(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<InsuranceGetByIdDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<InsuranceGetByIdDto>;
                })
            );
    }

    protected processGetById(response: HttpResponseBase): Observable<InsuranceGetByIdDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = InsuranceGetByIdDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<InsuranceGetByIdDto>(null as any);
    }

    /**
     * @param employeeId (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(
        employeeId: number | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/Insurance/GetList?';
        if (employeeId === null) throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined) url_ += 'EmployeeId=' + encodeURIComponent('' + employeeId) + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    insert(body: CreateInsuranceDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Insurance/Insert';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processInsert(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processInsert(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processInsert(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Insurance/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateInsuranceDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Insurance/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class ListNotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getById(id: number | undefined): Observable<GetInfoListNotificationDto> {
        let url_ = this.baseUrl + '/api/services/app/ListNotification/GetById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetById(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<GetInfoListNotificationDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<GetInfoListNotificationDto>;
                })
            );
    }

    protected processGetById(response: HttpResponseBase): Observable<GetInfoListNotificationDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetInfoListNotificationDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetInfoListNotificationDto>(null as any);
    }

    /**
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(keyword: string | undefined, pageIndex: number | undefined, pageSize: number | undefined): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/ListNotification/GetList?';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    send(body: SendListNotificationDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/ListNotification/Send';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processSend(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processSend(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processSend(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    insert(body: CreateListNotificationDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/ListNotification/Insert';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processInsert(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processInsert(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processInsert(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/ListNotification/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateListNotificationDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/ListNotification/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class LocationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getListProvince(): Observable<ProvinceModel[]> {
        let url_ = this.baseUrl + '/api/services/app/Location/GetListProvince';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetListProvince(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetListProvince(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ProvinceModel[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ProvinceModel[]>;
                })
            );
    }

    protected processGetListProvince(response: HttpResponseBase): Observable<ProvinceModel[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ProvinceModel.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProvinceModel[]>(null as any);
    }

    /**
     * @param provinceCde (optional)
     * @return Success
     */
    getListDistrict(provinceCde: string | undefined): Observable<DistrictModel[]> {
        let url_ = this.baseUrl + '/api/services/app/Location/GetListDistrict?';
        if (provinceCde === null) throw new Error("The parameter 'provinceCde' cannot be null.");
        else if (provinceCde !== undefined) url_ += 'provinceCde=' + encodeURIComponent('' + provinceCde) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetListDistrict(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetListDistrict(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<DistrictModel[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<DistrictModel[]>;
                })
            );
    }

    protected processGetListDistrict(response: HttpResponseBase): Observable<DistrictModel[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DistrictModel.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DistrictModel[]>(null as any);
    }

    /**
     * @param provinceCde (optional)
     * @param districtCde (optional)
     * @return Success
     */
    getListWard(provinceCde: string | undefined, districtCde: string | undefined): Observable<WardModel[]> {
        let url_ = this.baseUrl + '/api/services/app/Location/GetListWard?';
        if (provinceCde === null) throw new Error("The parameter 'provinceCde' cannot be null.");
        else if (provinceCde !== undefined) url_ += 'provinceCde=' + encodeURIComponent('' + provinceCde) + '&';
        if (districtCde === null) throw new Error("The parameter 'districtCde' cannot be null.");
        else if (districtCde !== undefined) url_ += 'districtCde=' + encodeURIComponent('' + districtCde) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetListWard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetListWard(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<WardModel[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<WardModel[]>;
                })
            );
    }

    protected processGetListWard(response: HttpResponseBase): Observable<WardModel[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(WardModel.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<WardModel[]>(null as any);
    }
}

@Injectable()
export class MasterDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param workflowCode (optional)
     * @param workflowDataCode (optional)
     * @return Success
     */
    getListWorkflowByUsrType(workflowCode: string | undefined, workflowDataCode: string | undefined): Observable<SysWorkflowDto[]> {
        let url_ = this.baseUrl + '/api/services/app/MasterData/GetListWorkflowByUsrType?';
        if (workflowCode === null) throw new Error("The parameter 'workflowCode' cannot be null.");
        else if (workflowCode !== undefined) url_ += 'workflowCode=' + encodeURIComponent('' + workflowCode) + '&';
        if (workflowDataCode === null) throw new Error("The parameter 'workflowDataCode' cannot be null.");
        else if (workflowDataCode !== undefined) url_ += 'workflowDataCode=' + encodeURIComponent('' + workflowDataCode) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetListWorkflowByUsrType(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetListWorkflowByUsrType(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<SysWorkflowDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<SysWorkflowDto[]>;
                })
            );
    }

    protected processGetListWorkflowByUsrType(response: HttpResponseBase): Observable<SysWorkflowDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(SysWorkflowDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SysWorkflowDto[]>(null as any);
    }

    /**
     * @param workflowCode (optional)
     * @param workflowDataCode (optional)
     * @return Success
     */
    getLatestWorkflowStateOfWorkflowCode(workflowCode: string | undefined, workflowDataCode: string | undefined): Observable<SysWorkflowStateDto> {
        let url_ = this.baseUrl + '/api/services/app/MasterData/GetLatestWorkflowStateOfWorkflowCode?';
        if (workflowCode === null) throw new Error("The parameter 'workflowCode' cannot be null.");
        else if (workflowCode !== undefined) url_ += 'workflowCode=' + encodeURIComponent('' + workflowCode) + '&';
        if (workflowDataCode === null) throw new Error("The parameter 'workflowDataCode' cannot be null.");
        else if (workflowDataCode !== undefined) url_ += 'workflowDataCode=' + encodeURIComponent('' + workflowDataCode) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetLatestWorkflowStateOfWorkflowCode(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetLatestWorkflowStateOfWorkflowCode(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<SysWorkflowStateDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<SysWorkflowStateDto>;
                })
            );
    }

    protected processGetLatestWorkflowStateOfWorkflowCode(response: HttpResponseBase): Observable<SysWorkflowStateDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = SysWorkflowStateDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SysWorkflowStateDto>(null as any);
    }

    /**
     * @param isActive (optional)
     * @return Success
     */
    getListUser(isActive: boolean | undefined): Observable<MasterUserModel[]> {
        let url_ = this.baseUrl + '/api/services/app/MasterData/GetListUser?';
        if (isActive === null) throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined) url_ += 'isActive=' + encodeURIComponent('' + isActive) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetListUser(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetListUser(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<MasterUserModel[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<MasterUserModel[]>;
                })
            );
    }

    protected processGetListUser(response: HttpResponseBase): Observable<MasterUserModel[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(MasterUserModel.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<MasterUserModel[]>(null as any);
    }

    /**
     * @param code (optional)
     * @return Success
     */
    getAllTable(code: string | undefined): Observable<SysMasterListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/MasterData/GetAllTable?';
        if (code === null) throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined) url_ += 'code=' + encodeURIComponent('' + code) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAllTable(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAllTable(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<SysMasterListDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<SysMasterListDto[]>;
                })
            );
    }

    protected processGetAllTable(response: HttpResponseBase): Observable<SysMasterListDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(SysMasterListDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SysMasterListDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getListEmployee(): Observable<MasterDataModel[]> {
        let url_ = this.baseUrl + '/api/services/app/MasterData/GetListEmployee';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetListEmployee(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetListEmployee(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<MasterDataModel[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<MasterDataModel[]>;
                })
            );
    }

    protected processGetListEmployee(response: HttpResponseBase): Observable<MasterDataModel[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(MasterDataModel.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<MasterDataModel[]>(null as any);
    }

    /**
     * @param code (optional)
     * @return Success
     */
    checkEmployeeCode(code: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/MasterData/CheckEmployeeCode?';
        if (code === null) throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined) url_ += 'code=' + encodeURIComponent('' + code) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCheckEmployeeCode(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCheckEmployeeCode(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processCheckEmployeeCode(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param code (optional)
     * @return Success
     */
    getListByCode(code: string | undefined): Observable<SysMasterListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/MasterData/GetListByCode?';
        if (code === null) throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined) url_ += 'code=' + encodeURIComponent('' + code) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetListByCode(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetListByCode(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<SysMasterListDto[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<SysMasterListDto[]>;
                })
            );
    }

    protected processGetListByCode(response: HttpResponseBase): Observable<SysMasterListDto[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(SysMasterListDto.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SysMasterListDto[]>(null as any);
    }

    /**
     * @param masterListGroupCde (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(
        masterListGroupCde: string | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/MasterData/GetList?';
        if (masterListGroupCde === null) throw new Error("The parameter 'masterListGroupCde' cannot be null.");
        else if (masterListGroupCde !== undefined) url_ += 'MasterListGroupCde=' + encodeURIComponent('' + masterListGroupCde) + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/MasterData/ChangePassword';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processChangePassword(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processChangePassword(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/MasterData/ChangeLanguage';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processChangeLanguage(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processChangeLanguage(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<void>;
                        }
                    } else return _observableThrow(response_) as any as Observable<void>;
                })
            );
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(null as any);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param requestId (optional)
     * @return Success
     */
    getListRECRequest(requestId: number | undefined): Observable<MasterDataModel[]> {
        let url_ = this.baseUrl + '/api/services/app/MasterData/GetListRECRequest?';
        if (requestId === null) throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined) url_ += 'requestId=' + encodeURIComponent('' + requestId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetListRECRequest(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetListRECRequest(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<MasterDataModel[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<MasterDataModel[]>;
                })
            );
    }

    protected processGetListRECRequest(response: HttpResponseBase): Observable<MasterDataModel[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(MasterDataModel.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<MasterDataModel[]>(null as any);
    }

    /**
     * @param planId (optional)
     * @return Success
     */
    getListRECPlans(planId: number | undefined): Observable<MasterDataModel[]> {
        let url_ = this.baseUrl + '/api/services/app/MasterData/GetListRECPlans?';
        if (planId === null) throw new Error("The parameter 'planId' cannot be null.");
        else if (planId !== undefined) url_ += 'planId=' + encodeURIComponent('' + planId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetListRECPlans(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetListRECPlans(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<MasterDataModel[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<MasterDataModel[]>;
                })
            );
    }

    protected processGetListRECPlans(response: HttpResponseBase): Observable<MasterDataModel[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(MasterDataModel.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<MasterDataModel[]>(null as any);
    }
}

@Injectable()
export class RecruitmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(
        fromDate: moment.Moment | undefined,
        toDate: moment.Moment | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/Recruitment/GetList?';
        if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined) url_ += 'FromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
        if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined) url_ += 'ToDate=' + encodeURIComponent(toDate ? '' + toDate.toISOString() : '') + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getInfo(id: number | undefined): Observable<RecruitmentDto> {
        let url_ = this.baseUrl + '/api/services/app/Recruitment/GetInfo?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInfo(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInfo(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<RecruitmentDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<RecruitmentDto>;
                })
            );
    }

    protected processGetInfo(response: HttpResponseBase): Observable<RecruitmentDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = RecruitmentDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<RecruitmentDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateRecruitmentDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Recruitment/Create';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateRecruitmentDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Recruitment/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Recruitment/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class RecruitmentCandidatesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(
        fromDate: moment.Moment | undefined,
        toDate: moment.Moment | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/RecruitmentCandidates/GetList?';
        if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined) url_ += 'FromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
        if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined) url_ += 'ToDate=' + encodeURIComponent(toDate ? '' + toDate.toISOString() : '') + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getInfo(id: number | undefined): Observable<RecruitmentCandidatesDto> {
        let url_ = this.baseUrl + '/api/services/app/RecruitmentCandidates/GetInfo?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInfo(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInfo(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<RecruitmentCandidatesDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<RecruitmentCandidatesDto>;
                })
            );
    }

    protected processGetInfo(response: HttpResponseBase): Observable<RecruitmentCandidatesDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = RecruitmentCandidatesDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<RecruitmentCandidatesDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateRecruitmentCandidatesDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/RecruitmentCandidates/Create';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateRecruitmentCandidatesDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/RecruitmentCandidates/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/RecruitmentCandidates/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class RecruitmentJobPostsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param publishDate (optional)
     * @param expireDate (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(
        publishDate: moment.Moment | undefined,
        expireDate: moment.Moment | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/RecruitmentJobPosts/GetList?';
        if (publishDate === null) throw new Error("The parameter 'publishDate' cannot be null.");
        else if (publishDate !== undefined) url_ += 'PublishDate=' + encodeURIComponent(publishDate ? '' + publishDate.toISOString() : '') + '&';
        if (expireDate === null) throw new Error("The parameter 'expireDate' cannot be null.");
        else if (expireDate !== undefined) url_ += 'ExpireDate=' + encodeURIComponent(expireDate ? '' + expireDate.toISOString() : '') + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getInfo(id: number | undefined): Observable<RecruitmentJobPostsDto> {
        let url_ = this.baseUrl + '/api/services/app/RecruitmentJobPosts/GetInfo?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInfo(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInfo(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<RecruitmentJobPostsDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<RecruitmentJobPostsDto>;
                })
            );
    }

    protected processGetInfo(response: HttpResponseBase): Observable<RecruitmentJobPostsDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = RecruitmentJobPostsDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<RecruitmentJobPostsDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateRecruitmentJobPostsDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/RecruitmentJobPosts/Create';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateRecruitmentJobPostsDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/RecruitmentJobPosts/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/RecruitmentJobPosts/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class RecruitmentPlansServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(
        fromDate: moment.Moment | undefined,
        toDate: moment.Moment | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/RecruitmentPlans/GetList?';
        if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined) url_ += 'FromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
        if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined) url_ += 'ToDate=' + encodeURIComponent(toDate ? '' + toDate.toISOString() : '') + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getInfo(id: number | undefined): Observable<RecruitmentPlansDto> {
        let url_ = this.baseUrl + '/api/services/app/RecruitmentPlans/GetInfo?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInfo(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInfo(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<RecruitmentPlansDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<RecruitmentPlansDto>;
                })
            );
    }

    protected processGetInfo(response: HttpResponseBase): Observable<RecruitmentPlansDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = RecruitmentPlansDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<RecruitmentPlansDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateRecruitmentPlansDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/RecruitmentPlans/Create';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateRecruitmentPlansDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/RecruitmentPlans/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/RecruitmentPlans/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class RecruitmentRequestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(keyword: string | undefined, pageIndex: number | undefined, pageSize: number | undefined): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/RecruitmentRequest/GetList?';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getInfo(id: number | undefined): Observable<RECRequestDto> {
        let url_ = this.baseUrl + '/api/services/app/RecruitmentRequest/GetInfo?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInfo(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInfo(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<RECRequestDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<RECRequestDto>;
                })
            );
    }

    protected processGetInfo(response: HttpResponseBase): Observable<RECRequestDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = RECRequestDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<RECRequestDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateRECRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/RecruitmentRequest/Create';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateRECRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/RecruitmentRequest/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/RecruitmentRequest/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class RegisterOvertimeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(
        fromDate: moment.Moment | undefined,
        toDate: moment.Moment | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/RegisterOvertime/GetList?';
        if (fromDate === null) throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined) url_ += 'FromDate=' + encodeURIComponent(fromDate ? '' + fromDate.toISOString() : '') + '&';
        if (toDate === null) throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined) url_ += 'ToDate=' + encodeURIComponent(toDate ? '' + toDate.toISOString() : '') + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getRegisterOvertimeById(id: number | undefined): Observable<RegisterOvertimeDto> {
        let url_ = this.baseUrl + '/api/services/app/RegisterOvertime/GetRegisterOvertimeById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetRegisterOvertimeById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetRegisterOvertimeById(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<RegisterOvertimeDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<RegisterOvertimeDto>;
                })
            );
    }

    protected processGetRegisterOvertimeById(response: HttpResponseBase): Observable<RegisterOvertimeDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = RegisterOvertimeDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<RegisterOvertimeDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    insertRegisterOvertime(body: CreateRegisterOvertimeDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/RegisterOvertime/InsertRegisterOvertime';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processInsertRegisterOvertime(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processInsertRegisterOvertime(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processInsertRegisterOvertime(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateRegisterOvertime(body: UpdateRegisterOvertimeDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/RegisterOvertime/UpdateRegisterOvertime';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateRegisterOvertime(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateRegisterOvertime(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdateRegisterOvertime(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    deleteRegisterOvertime(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/RegisterOvertime/DeleteRegisterOvertime?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteRegisterOvertime(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteRegisterOvertime(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDeleteRegisterOvertime(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    action(body: ActionRegisterOvertimeDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/RegisterOvertime/Action';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processAction(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processAction(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processAction(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class RemainingLeaveServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param leaveYear (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(
        leaveYear: number | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/RemainingLeave/GetList?';
        if (leaveYear === null) throw new Error("The parameter 'leaveYear' cannot be null.");
        else if (leaveYear !== undefined) url_ += 'LeaveYear=' + encodeURIComponent('' + leaveYear) + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getInfo(id: number | undefined): Observable<RemainingLeaveDto> {
        let url_ = this.baseUrl + '/api/services/app/RemainingLeave/GetInfo?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInfo(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInfo(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<RemainingLeaveDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<RemainingLeaveDto>;
                })
            );
    }

    protected processGetInfo(response: HttpResponseBase): Observable<RemainingLeaveDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = RemainingLeaveDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<RemainingLeaveDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateRemainingLeaveDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/RemainingLeave/Create';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param remainingLeaveId (optional)
     * @return Success
     */
    getListDetail(remainingLeaveId: number | undefined): Observable<RemainingLeaveDetailModel[]> {
        let url_ = this.baseUrl + '/api/services/app/RemainingLeave/GetListDetail?';
        if (remainingLeaveId === null) throw new Error("The parameter 'remainingLeaveId' cannot be null.");
        else if (remainingLeaveId !== undefined) url_ += 'remainingLeaveId=' + encodeURIComponent('' + remainingLeaveId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetListDetail(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetListDetail(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<RemainingLeaveDetailModel[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<RemainingLeaveDetailModel[]>;
                })
            );
    }

    protected processGetListDetail(response: HttpResponseBase): Observable<RemainingLeaveDetailModel[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(RemainingLeaveDetailModel.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<RemainingLeaveDetailModel[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateRemainingLeaveDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/RemainingLeave/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/RemainingLeave/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    action(body: ActionRemainingLeaveDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/RemainingLeave/Action';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processAction(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processAction(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processAction(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + '/api/services/app/Role/Create';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<RoleDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<RoleDto>;
                })
            );
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = RoleDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param permission (optional)
     * @return Success
     */
    getRoles(permission: string | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Role/GetRoles?';
        if (permission === null) throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined) url_ += 'Permission=' + encodeURIComponent('' + permission) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetRoles(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetRoles(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<RoleListDtoListResultDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<RoleListDtoListResultDto>;
                })
            );
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = RoleListDtoListResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<RoleListDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + '/api/services/app/Role/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<RoleDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<RoleDto>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = RoleDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Role/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({})
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<void>;
                        }
                    } else return _observableThrow(response_) as any as Observable<void>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(null as any);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Role/GetAllPermissions';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAllPermissions(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAllPermissions(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<PermissionDtoListResultDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<PermissionDtoListResultDto>;
                })
            );
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = PermissionDtoListResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PermissionDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + '/api/services/app/Role/GetRoleForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetRoleForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetRoleForEdit(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                        }
                    } else return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
                })
            );
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetRoleForEditOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetRoleForEditOutput>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + '/api/services/app/Role/Get?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGet(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGet(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<RoleDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<RoleDto>;
                })
            );
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = RoleDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param keyword (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Role/GetAll?';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAll(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAll(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<RoleDtoPagedResultDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<RoleDtoPagedResultDto>;
                })
            );
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = RoleDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<RoleDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class SalaryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(keyword: string | undefined, pageIndex: number | undefined, pageSize: number | undefined): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/Salary/GetList?';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getInfo(id: number | undefined): Observable<SalaryDto> {
        let url_ = this.baseUrl + '/api/services/app/Salary/GetInfo?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInfo(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInfo(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<SalaryDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<SalaryDto>;
                })
            );
    }

    protected processGetInfo(response: HttpResponseBase): Observable<SalaryDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = SalaryDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SalaryDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateSalaryDto | undefined): Observable<string> {
        let url_ = this.baseUrl + '/api/services/app/Salary/Create';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<string>;
                        }
                    } else return _observableThrow(response_) as any as Observable<string>;
                })
            );
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateSalaryDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Salary/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param salaryId (optional)
     * @param salaryDate (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getListDetail(
        salaryId: number | undefined,
        salaryDate: moment.Moment | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/Salary/GetListDetail?';
        if (salaryId === null) throw new Error("The parameter 'salaryId' cannot be null.");
        else if (salaryId !== undefined) url_ += 'SalaryId=' + encodeURIComponent('' + salaryId) + '&';
        if (salaryDate === null) throw new Error("The parameter 'salaryDate' cannot be null.");
        else if (salaryDate !== undefined) url_ += 'SalaryDate=' + encodeURIComponent(salaryDate ? '' + salaryDate.toISOString() : '') + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetListDetail(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetListDetail(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetListDetail(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param salaryId (optional)
     * @param dateSalary (optional)
     * @return Success
     */
    export(salaryId: number | undefined, dateSalary: moment.Moment | undefined): Observable<string> {
        let url_ = this.baseUrl + '/api/services/app/Salary/Export?';
        if (salaryId === null) throw new Error("The parameter 'salaryId' cannot be null.");
        else if (salaryId !== undefined) url_ += 'SalaryId=' + encodeURIComponent('' + salaryId) + '&';
        if (dateSalary === null) throw new Error("The parameter 'dateSalary' cannot be null.");
        else if (dateSalary !== undefined) url_ += 'dateSalary=' + encodeURIComponent(dateSalary ? '' + dateSalary.toISOString() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processExport(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processExport(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<string>;
                        }
                    } else return _observableThrow(response_) as any as Observable<string>;
                })
            );
    }

    protected processExport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    action(body: ActionSalaryDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Salary/Action';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processAction(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processAction(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processAction(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Salary/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class SalaryBasicServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param employeeId (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(employeeId: number | undefined, pageIndex: number | undefined, pageSize: number | undefined): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/SalaryBasic/GetList?';
        if (employeeId === null) throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined) url_ += 'EmployeeId=' + encodeURIComponent('' + employeeId) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getById(id: number | undefined): Observable<SalaryBasicDto> {
        let url_ = this.baseUrl + '/api/services/app/SalaryBasic/GetById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetById(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<SalaryBasicDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<SalaryBasicDto>;
                })
            );
    }

    protected processGetById(response: HttpResponseBase): Observable<SalaryBasicDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = SalaryBasicDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SalaryBasicDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    insert(body: CreateSalaryBasicDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/SalaryBasic/Insert';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processInsert(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processInsert(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processInsert(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateSalaryBasicDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/SalaryBasic/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/SalaryBasic/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + '/api/services/app/Session/GetCurrentLoginInformations';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCurrentLoginInformations(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCurrentLoginInformations(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                        }
                    } else return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
                })
            );
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(null as any);
    }
}

@Injectable()
export class SysAppParamServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param paramCode (optional)
     * @return Success
     */
    getByCode(paramCode: string | undefined): Observable<SysAppParamDto> {
        let url_ = this.baseUrl + '/api/services/app/SysAppParamService/GetByCode?';
        if (paramCode === null) throw new Error("The parameter 'paramCode' cannot be null.");
        else if (paramCode !== undefined) url_ += 'paramCode=' + encodeURIComponent('' + paramCode) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetByCode(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetByCode(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<SysAppParamDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<SysAppParamDto>;
                })
            );
    }

    protected processGetByCode(response: HttpResponseBase): Observable<SysAppParamDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = SysAppParamDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SysAppParamDto>(null as any);
    }

    /**
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(keyword: string | undefined, pageIndex: number | undefined, pageSize: number | undefined): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/SysAppParamService/GetList?';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateSysAppParamDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/SysAppParamService/Create';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateSysAppParamDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/SysAppParamService/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param paramCode (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(paramCode: string | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/SysAppParamService/Delete?';
        if (paramCode === null) throw new Error("The parameter 'paramCode' cannot be null.");
        else if (paramCode !== undefined) url_ += 'ParamCode=' + encodeURIComponent('' + paramCode) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class SysMasterListServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param masterListGroupCde (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(
        masterListGroupCde: string | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/SysMasterList/GetList?';
        if (masterListGroupCde === null) throw new Error("The parameter 'masterListGroupCde' cannot be null.");
        else if (masterListGroupCde !== undefined) url_ += 'MasterListGroupCde=' + encodeURIComponent('' + masterListGroupCde) + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getInfo(id: number | undefined): Observable<SysMasterListInfoDto> {
        let url_ = this.baseUrl + '/api/services/app/SysMasterList/GetInfo?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInfo(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInfo(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<SysMasterListInfoDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<SysMasterListInfoDto>;
                })
            );
    }

    protected processGetInfo(response: HttpResponseBase): Observable<SysMasterListInfoDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = SysMasterListInfoDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SysMasterListInfoDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateSysMasterListDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/SysMasterList/Create';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateSysMasterListDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/SysMasterList/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param masterListID (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(masterListID: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/SysMasterList/Delete?';
        if (masterListID === null) throw new Error("The parameter 'masterListID' cannot be null.");
        else if (masterListID !== undefined) url_ += 'MasterListID=' + encodeURIComponent('' + masterListID) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class SysWorkflowServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(keyword: string | undefined, pageIndex: number | undefined, pageSize: number | undefined): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/SysWorkflow/GetList?';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getInfo(id: number | undefined): Observable<SysWorkflowDto> {
        let url_ = this.baseUrl + '/api/services/app/SysWorkflow/GetInfo?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInfo(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInfo(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<SysWorkflowDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<SysWorkflowDto>;
                })
            );
    }

    protected processGetInfo(response: HttpResponseBase): Observable<SysWorkflowDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = SysWorkflowDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SysWorkflowDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateSysWorkflowDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/SysWorkflow/Create';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateSysWorkflowDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/SysWorkflow/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param workflowID (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(workflowID: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/SysWorkflow/Delete?';
        if (workflowID === null) throw new Error("The parameter 'workflowID' cannot be null.");
        else if (workflowID !== undefined) url_ += 'WorkflowID=' + encodeURIComponent('' + workflowID) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param workflowCode (optional)
     * @param workflowDataCode (optional)
     * @return Success
     */
    getLatestStateOfWfCode(workflowCode: string | undefined, workflowDataCode: string | undefined): Observable<SysWorkflowStateDto> {
        let url_ = this.baseUrl + '/api/services/app/SysWorkflow/GetLatestStateOfWfCode?';
        if (workflowCode === null) throw new Error("The parameter 'workflowCode' cannot be null.");
        else if (workflowCode !== undefined) url_ += 'workflowCode=' + encodeURIComponent('' + workflowCode) + '&';
        if (workflowDataCode === null) throw new Error("The parameter 'workflowDataCode' cannot be null.");
        else if (workflowDataCode !== undefined) url_ += 'workflowDataCode=' + encodeURIComponent('' + workflowDataCode) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetLatestStateOfWfCode(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetLatestStateOfWfCode(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<SysWorkflowStateDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<SysWorkflowStateDto>;
                })
            );
    }

    protected processGetLatestStateOfWfCode(response: HttpResponseBase): Observable<SysWorkflowStateDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = SysWorkflowStateDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SysWorkflowStateDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateWFState(body: SysWorkflowStateDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/SysWorkflow/UpdateWFState';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateWFState(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateWFState(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdateWFState(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/Create';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<TenantDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<TenantDto>;
                })
            );
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TenantDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({})
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<void>;
                        }
                    } else return _observableThrow(response_) as any as Observable<void>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(null as any);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/Get?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGet(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGet(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<TenantDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<TenantDto>;
                })
            );
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TenantDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param keyword (optional)
     * @param isActive (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll(
        keyword: string | undefined,
        isActive: boolean | undefined,
        skipCount: number | undefined,
        maxResultCount: number | undefined
    ): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/GetAll?';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (isActive === null) throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined) url_ += 'IsActive=' + encodeURIComponent('' + isActive) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAll(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAll(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<TenantDtoPagedResultDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<TenantDtoPagedResultDto>;
                })
            );
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TenantDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TenantDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<TenantDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<TenantDto>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TenantDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TenantDto>(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + '/api/TokenAuth/Authenticate';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processAuthenticate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processAuthenticate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                        }
                    } else return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
                })
            );
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = AuthenticateResultModel.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AuthenticateResultModel>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    authenticateClient(body: AuthenticateClientModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + '/api/TokenAuth/AuthenticateClient';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processAuthenticateClient(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processAuthenticateClient(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                        }
                    } else return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
                })
            );
    }

    protected processAuthenticateClient(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = AuthenticateResultModel.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AuthenticateResultModel>(null as any);
    }

    /**
     * @return Success
     */
    getInfoUser(): Observable<InforUserModel> {
        let url_ = this.baseUrl + '/api/TokenAuth/GetInfoUser';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInfoUser(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInfoUser(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<InforUserModel>;
                        }
                    } else return _observableThrow(response_) as any as Observable<InforUserModel>;
                })
            );
    }

    protected processGetInfoUser(response: HttpResponseBase): Observable<InforUserModel> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = InforUserModel.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<InforUserModel>(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + '/api/TokenAuth/GetExternalAuthenticationProviders';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetExternalAuthenticationProviders(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetExternalAuthenticationProviders(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
                })
            );
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ExternalLoginProviderInfoModel.fromJS(item));
                    } else {
                        result200 = <any>null;
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + '/api/TokenAuth/ExternalAuthenticate';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processExternalAuthenticate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processExternalAuthenticate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
                })
            );
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ExternalAuthenticateResultModel>(null as any);
    }

    /**
     * @param token (optional)
     * @return Success
     */
    checkToken(token: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/TokenAuth/CheckToken?';
        if (token === null) throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined) url_ += 'token=' + encodeURIComponent('' + token) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCheckToken(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCheckToken(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processCheckToken(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + '/api/services/app/User/Create';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<UserDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<UserDto>;
                })
            );
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = UserDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + '/api/services/app/User/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<UserDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<UserDto>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = UserDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateUser(body: UserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + '/api/services/app/User/UpdateUser';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateUser(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateUser(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<UserDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<UserDto>;
                })
            );
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = UserDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/User/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({})
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<void>;
                        }
                    } else return _observableThrow(response_) as any as Observable<void>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(null as any);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    activate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/User/Activate';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processActivate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processActivate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<void>;
                        }
                    } else return _observableThrow(response_) as any as Observable<void>;
                })
            );
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(null as any);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    deActivate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/User/DeActivate';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeActivate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeActivate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<void>;
                        }
                    } else return _observableThrow(response_) as any as Observable<void>;
                })
            );
    }

    protected processDeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(null as any);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/User/GetRoles';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetRoles(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetRoles(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<RoleDtoListResultDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<RoleDtoListResultDto>;
                })
            );
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = RoleDtoListResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<RoleDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getUserById(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + '/api/services/app/User/GetUserById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUserById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUserById(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<UserDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<UserDto>;
                })
            );
    }

    protected processGetUserById(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = UserDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    resetPassword(body: ResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/User/ResetPassword';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processResetPassword(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processResetPassword(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + '/api/services/app/User/Get?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGet(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGet(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<UserDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<UserDto>;
                })
            );
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = UserDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param keyword (optional)
     * @param isActive (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll(
        keyword: string | undefined,
        isActive: boolean | undefined,
        skipCount: number | undefined,
        maxResultCount: number | undefined
    ): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/User/GetAll?';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (isActive === null) throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined) url_ += 'IsActive=' + encodeURIComponent('' + isActive) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAll(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAll(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
                })
            );
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = UserDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class WorkingProcessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getById(id: number | undefined): Observable<WorkingProcessDto> {
        let url_ = this.baseUrl + '/api/services/app/WorkingProcess/GetById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetById(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<WorkingProcessDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<WorkingProcessDto>;
                })
            );
    }

    protected processGetById(response: HttpResponseBase): Observable<WorkingProcessDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = WorkingProcessDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<WorkingProcessDto>(null as any);
    }

    /**
     * @param employeeId (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getByEmployeeId(employeeId: number | undefined, pageIndex: number | undefined, pageSize: number | undefined): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/WorkingProcess/GetByEmployeeId?';
        if (employeeId === null) throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined) url_ += 'EmployeeId=' + encodeURIComponent('' + employeeId) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetByEmployeeId(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetByEmployeeId(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetByEmployeeId(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    insert(body: WorkingProcessDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/WorkingProcess/Insert';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processInsert(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processInsert(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processInsert(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateWorkingProcessDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/WorkingProcess/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/WorkingProcess/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class WorkingShiftServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getById(id: number | undefined): Observable<WorkingShiftDto> {
        let url_ = this.baseUrl + '/api/services/app/WorkingShift/GetById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetById(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<WorkingShiftDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<WorkingShiftDto>;
                })
            );
    }

    protected processGetById(response: HttpResponseBase): Observable<WorkingShiftDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = WorkingShiftDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<WorkingShiftDto>(null as any);
    }

    /**
     * @param pickDate (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(
        pickDate: moment.Moment | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/WorkingShift/GetList?';
        if (pickDate === null) throw new Error("The parameter 'pickDate' cannot be null.");
        else if (pickDate !== undefined) url_ += 'PickDate=' + encodeURIComponent(pickDate ? '' + pickDate.toISOString() : '') + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    insert(body: CreateWorkingShiftDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/WorkingShift/Insert';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processInsert(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processInsert(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processInsert(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateWorkingShiftDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/WorkingShift/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/WorkingShift/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class WorkShiftChangeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param pickDate (optional)
     * @param keyword (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getList(
        pickDate: moment.Moment | undefined,
        keyword: string | undefined,
        pageIndex: number | undefined,
        pageSize: number | undefined
    ): Observable<ResultListDto> {
        let url_ = this.baseUrl + '/api/services/app/WorkShiftChange/GetList?';
        if (pickDate === null) throw new Error("The parameter 'pickDate' cannot be null.");
        else if (pickDate !== undefined) url_ += 'PickDate=' + encodeURIComponent(pickDate ? '' + pickDate.toISOString() : '') + '&';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetList(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ResultListDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ResultListDto>;
                })
            );
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultListDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ResultListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ResultListDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getById(id: number | undefined): Observable<WorkShiftChangeDto> {
        let url_ = this.baseUrl + '/api/services/app/WorkShiftChange/GetById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetById(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<WorkShiftChangeDto>;
                        }
                    } else return _observableThrow(response_) as any as Observable<WorkShiftChangeDto>;
                })
            );
    }

    protected processGetById(response: HttpResponseBase): Observable<WorkShiftChangeDto> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = WorkShiftChangeDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<WorkShiftChangeDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    insert(body: CreateWorkShiftChangeDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/WorkShiftChange/Insert';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processInsert(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processInsert(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processInsert(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateWorkShiftChangeDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/WorkShiftChange/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional)
     * @param rowVersion (optional)
     * @return Success
     */
    delete(id: number | undefined, rowVersion: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/WorkShiftChange/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (rowVersion === null) throw new Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined) url_ += 'RowVersion=' + encodeURIComponent('' + rowVersion) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    action(body: ActionWorkShiftChangeDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/WorkShiftChange/Action';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processAction(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processAction(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<boolean>;
                        }
                    } else return _observableThrow(response_) as any as Observable<boolean>;
                })
            );
    }

    protected processAction(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;

                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(null as any);
    }
}

export class ActionAdvanceSalaryDto implements IActionAdvanceSalaryDto {
    keyValue: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    tenantId: number;
    tableName: string | undefined;
    cancelReason: string | undefined;
    workflowStateModel: SysWorkflowStateDto;
    objDynamic: any | undefined;
    statusCde: string | undefined;

    constructor(data?: IActionAdvanceSalaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyValue = _data['keyValue'];
            this.rowVersion = _data['rowVersion'];
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.tableName = _data['tableName'];
            this.cancelReason = _data['cancelReason'];
            this.workflowStateModel = _data['workflowStateModel'] ? SysWorkflowStateDto.fromJS(_data['workflowStateModel']) : <any>undefined;
            this.objDynamic = _data['objDynamic'];
            this.statusCde = _data['statusCde'];
        }
    }

    static fromJS(data: any): ActionAdvanceSalaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionAdvanceSalaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['keyValue'] = this.keyValue;
        data['rowVersion'] = this.rowVersion;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['tableName'] = this.tableName;
        data['cancelReason'] = this.cancelReason;
        data['workflowStateModel'] = this.workflowStateModel ? this.workflowStateModel.toJSON() : <any>undefined;
        data['objDynamic'] = this.objDynamic;
        data['statusCde'] = this.statusCde;
        return data;
    }

    clone(): ActionAdvanceSalaryDto {
        const json = this.toJSON();
        let result = new ActionAdvanceSalaryDto();
        result.init(json);
        return result;
    }
}

export interface IActionAdvanceSalaryDto {
    keyValue: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    tenantId: number;
    tableName: string | undefined;
    cancelReason: string | undefined;
    workflowStateModel: SysWorkflowStateDto;
    objDynamic: any | undefined;
    statusCde: string | undefined;
}

export class ActionAttendanceDto implements IActionAttendanceDto {
    keyValue: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    tenantId: number;
    tableName: string | undefined;
    cancelReason: string | undefined;
    workflowStateModel: SysWorkflowStateDto;
    objDynamic: any | undefined;
    statusCde: string | undefined;

    constructor(data?: IActionAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyValue = _data['keyValue'];
            this.rowVersion = _data['rowVersion'];
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.tableName = _data['tableName'];
            this.cancelReason = _data['cancelReason'];
            this.workflowStateModel = _data['workflowStateModel'] ? SysWorkflowStateDto.fromJS(_data['workflowStateModel']) : <any>undefined;
            this.objDynamic = _data['objDynamic'];
            this.statusCde = _data['statusCde'];
        }
    }

    static fromJS(data: any): ActionAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['keyValue'] = this.keyValue;
        data['rowVersion'] = this.rowVersion;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['tableName'] = this.tableName;
        data['cancelReason'] = this.cancelReason;
        data['workflowStateModel'] = this.workflowStateModel ? this.workflowStateModel.toJSON() : <any>undefined;
        data['objDynamic'] = this.objDynamic;
        data['statusCde'] = this.statusCde;
        return data;
    }

    clone(): ActionAttendanceDto {
        const json = this.toJSON();
        let result = new ActionAttendanceDto();
        result.init(json);
        return result;
    }
}

export interface IActionAttendanceDto {
    keyValue: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    tenantId: number;
    tableName: string | undefined;
    cancelReason: string | undefined;
    workflowStateModel: SysWorkflowStateDto;
    objDynamic: any | undefined;
    statusCde: string | undefined;
}

export class ActionBonusDto implements IActionBonusDto {
    keyValue: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    tenantId: number;
    tableName: string | undefined;
    cancelReason: string | undefined;
    workflowStateModel: SysWorkflowStateDto;
    objDynamic: any | undefined;
    statusCde: string | undefined;

    constructor(data?: IActionBonusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyValue = _data['keyValue'];
            this.rowVersion = _data['rowVersion'];
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.tableName = _data['tableName'];
            this.cancelReason = _data['cancelReason'];
            this.workflowStateModel = _data['workflowStateModel'] ? SysWorkflowStateDto.fromJS(_data['workflowStateModel']) : <any>undefined;
            this.objDynamic = _data['objDynamic'];
            this.statusCde = _data['statusCde'];
        }
    }

    static fromJS(data: any): ActionBonusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionBonusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['keyValue'] = this.keyValue;
        data['rowVersion'] = this.rowVersion;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['tableName'] = this.tableName;
        data['cancelReason'] = this.cancelReason;
        data['workflowStateModel'] = this.workflowStateModel ? this.workflowStateModel.toJSON() : <any>undefined;
        data['objDynamic'] = this.objDynamic;
        data['statusCde'] = this.statusCde;
        return data;
    }

    clone(): ActionBonusDto {
        const json = this.toJSON();
        let result = new ActionBonusDto();
        result.init(json);
        return result;
    }
}

export interface IActionBonusDto {
    keyValue: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    tenantId: number;
    tableName: string | undefined;
    cancelReason: string | undefined;
    workflowStateModel: SysWorkflowStateDto;
    objDynamic: any | undefined;
    statusCde: string | undefined;
}

export class ActionDto implements IActionDto {
    keyValue: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    tenantId: number;
    tableName: string | undefined;
    cancelReason: string | undefined;
    workflowStateModel: SysWorkflowStateDto;
    objDynamic: any | undefined;
    statusCde: string | undefined;
    columnKey: string | undefined;
    columnValue: string | undefined;

    constructor(data?: IActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyValue = _data['keyValue'];
            this.rowVersion = _data['rowVersion'];
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.tableName = _data['tableName'];
            this.cancelReason = _data['cancelReason'];
            this.workflowStateModel = _data['workflowStateModel'] ? SysWorkflowStateDto.fromJS(_data['workflowStateModel']) : <any>undefined;
            this.objDynamic = _data['objDynamic'];
            this.statusCde = _data['statusCde'];
            this.columnKey = _data['columnKey'];
            this.columnValue = _data['columnValue'];
        }
    }

    static fromJS(data: any): ActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['keyValue'] = this.keyValue;
        data['rowVersion'] = this.rowVersion;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['tableName'] = this.tableName;
        data['cancelReason'] = this.cancelReason;
        data['workflowStateModel'] = this.workflowStateModel ? this.workflowStateModel.toJSON() : <any>undefined;
        data['objDynamic'] = this.objDynamic;
        data['statusCde'] = this.statusCde;
        data['columnKey'] = this.columnKey;
        data['columnValue'] = this.columnValue;
        return data;
    }

    clone(): ActionDto {
        const json = this.toJSON();
        let result = new ActionDto();
        result.init(json);
        return result;
    }
}

export interface IActionDto {
    keyValue: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    tenantId: number;
    tableName: string | undefined;
    cancelReason: string | undefined;
    workflowStateModel: SysWorkflowStateDto;
    objDynamic: any | undefined;
    statusCde: string | undefined;
    columnKey: string | undefined;
    columnValue: string | undefined;
}

export class ActionHolidayDto implements IActionHolidayDto {
    keyValue: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    tenantId: number;
    tableName: string | undefined;
    cancelReason: string | undefined;
    workflowStateModel: SysWorkflowStateDto;
    objDynamic: any | undefined;
    statusCde: string | undefined;

    constructor(data?: IActionHolidayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyValue = _data['keyValue'];
            this.rowVersion = _data['rowVersion'];
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.tableName = _data['tableName'];
            this.cancelReason = _data['cancelReason'];
            this.workflowStateModel = _data['workflowStateModel'] ? SysWorkflowStateDto.fromJS(_data['workflowStateModel']) : <any>undefined;
            this.objDynamic = _data['objDynamic'];
            this.statusCde = _data['statusCde'];
        }
    }

    static fromJS(data: any): ActionHolidayDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionHolidayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['keyValue'] = this.keyValue;
        data['rowVersion'] = this.rowVersion;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['tableName'] = this.tableName;
        data['cancelReason'] = this.cancelReason;
        data['workflowStateModel'] = this.workflowStateModel ? this.workflowStateModel.toJSON() : <any>undefined;
        data['objDynamic'] = this.objDynamic;
        data['statusCde'] = this.statusCde;
        return data;
    }

    clone(): ActionHolidayDto {
        const json = this.toJSON();
        let result = new ActionHolidayDto();
        result.init(json);
        return result;
    }
}

export interface IActionHolidayDto {
    keyValue: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    tenantId: number;
    tableName: string | undefined;
    cancelReason: string | undefined;
    workflowStateModel: SysWorkflowStateDto;
    objDynamic: any | undefined;
    statusCde: string | undefined;
}

export class ActionRegisterOvertimeDto implements IActionRegisterOvertimeDto {
    keyValue: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    tenantId: number;
    tableName: string | undefined;
    cancelReason: string | undefined;
    workflowStateModel: SysWorkflowStateDto;
    objDynamic: any | undefined;
    statusCde: string | undefined;

    constructor(data?: IActionRegisterOvertimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyValue = _data['keyValue'];
            this.rowVersion = _data['rowVersion'];
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.tableName = _data['tableName'];
            this.cancelReason = _data['cancelReason'];
            this.workflowStateModel = _data['workflowStateModel'] ? SysWorkflowStateDto.fromJS(_data['workflowStateModel']) : <any>undefined;
            this.objDynamic = _data['objDynamic'];
            this.statusCde = _data['statusCde'];
        }
    }

    static fromJS(data: any): ActionRegisterOvertimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionRegisterOvertimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['keyValue'] = this.keyValue;
        data['rowVersion'] = this.rowVersion;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['tableName'] = this.tableName;
        data['cancelReason'] = this.cancelReason;
        data['workflowStateModel'] = this.workflowStateModel ? this.workflowStateModel.toJSON() : <any>undefined;
        data['objDynamic'] = this.objDynamic;
        data['statusCde'] = this.statusCde;
        return data;
    }

    clone(): ActionRegisterOvertimeDto {
        const json = this.toJSON();
        let result = new ActionRegisterOvertimeDto();
        result.init(json);
        return result;
    }
}

export interface IActionRegisterOvertimeDto {
    keyValue: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    tenantId: number;
    tableName: string | undefined;
    cancelReason: string | undefined;
    workflowStateModel: SysWorkflowStateDto;
    objDynamic: any | undefined;
    statusCde: string | undefined;
}

export class ActionRemainingLeaveDto implements IActionRemainingLeaveDto {
    keyValue: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    tenantId: number;
    tableName: string | undefined;
    cancelReason: string | undefined;
    workflowStateModel: SysWorkflowStateDto;
    objDynamic: any | undefined;
    statusCde: string | undefined;

    constructor(data?: IActionRemainingLeaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyValue = _data['keyValue'];
            this.rowVersion = _data['rowVersion'];
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.tableName = _data['tableName'];
            this.cancelReason = _data['cancelReason'];
            this.workflowStateModel = _data['workflowStateModel'] ? SysWorkflowStateDto.fromJS(_data['workflowStateModel']) : <any>undefined;
            this.objDynamic = _data['objDynamic'];
            this.statusCde = _data['statusCde'];
        }
    }

    static fromJS(data: any): ActionRemainingLeaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionRemainingLeaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['keyValue'] = this.keyValue;
        data['rowVersion'] = this.rowVersion;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['tableName'] = this.tableName;
        data['cancelReason'] = this.cancelReason;
        data['workflowStateModel'] = this.workflowStateModel ? this.workflowStateModel.toJSON() : <any>undefined;
        data['objDynamic'] = this.objDynamic;
        data['statusCde'] = this.statusCde;
        return data;
    }

    clone(): ActionRemainingLeaveDto {
        const json = this.toJSON();
        let result = new ActionRemainingLeaveDto();
        result.init(json);
        return result;
    }
}

export interface IActionRemainingLeaveDto {
    keyValue: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    tenantId: number;
    tableName: string | undefined;
    cancelReason: string | undefined;
    workflowStateModel: SysWorkflowStateDto;
    objDynamic: any | undefined;
    statusCde: string | undefined;
}

export class ActionSalaryDto implements IActionSalaryDto {
    keyValue: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    tenantId: number;
    tableName: string | undefined;
    cancelReason: string | undefined;
    workflowStateModel: SysWorkflowStateDto;
    objDynamic: any | undefined;
    statusCde: string | undefined;
    columnKey: string | undefined;
    columnValue: string | undefined;

    constructor(data?: IActionSalaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyValue = _data['keyValue'];
            this.rowVersion = _data['rowVersion'];
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.tableName = _data['tableName'];
            this.cancelReason = _data['cancelReason'];
            this.workflowStateModel = _data['workflowStateModel'] ? SysWorkflowStateDto.fromJS(_data['workflowStateModel']) : <any>undefined;
            this.objDynamic = _data['objDynamic'];
            this.statusCde = _data['statusCde'];
            this.columnKey = _data['columnKey'];
            this.columnValue = _data['columnValue'];
        }
    }

    static fromJS(data: any): ActionSalaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionSalaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['keyValue'] = this.keyValue;
        data['rowVersion'] = this.rowVersion;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['tableName'] = this.tableName;
        data['cancelReason'] = this.cancelReason;
        data['workflowStateModel'] = this.workflowStateModel ? this.workflowStateModel.toJSON() : <any>undefined;
        data['objDynamic'] = this.objDynamic;
        data['statusCde'] = this.statusCde;
        data['columnKey'] = this.columnKey;
        data['columnValue'] = this.columnValue;
        return data;
    }

    clone(): ActionSalaryDto {
        const json = this.toJSON();
        let result = new ActionSalaryDto();
        result.init(json);
        return result;
    }
}

export interface IActionSalaryDto {
    keyValue: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    tenantId: number;
    tableName: string | undefined;
    cancelReason: string | undefined;
    workflowStateModel: SysWorkflowStateDto;
    objDynamic: any | undefined;
    statusCde: string | undefined;
    columnKey: string | undefined;
    columnValue: string | undefined;
}

export class ActionWorkShiftChangeDto implements IActionWorkShiftChangeDto {
    keyValue: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    tenantId: number;
    tableName: string | undefined;
    cancelReason: string | undefined;
    workflowStateModel: SysWorkflowStateDto;
    objDynamic: any | undefined;
    statusCde: string | undefined;

    constructor(data?: IActionWorkShiftChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyValue = _data['keyValue'];
            this.rowVersion = _data['rowVersion'];
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.tableName = _data['tableName'];
            this.cancelReason = _data['cancelReason'];
            this.workflowStateModel = _data['workflowStateModel'] ? SysWorkflowStateDto.fromJS(_data['workflowStateModel']) : <any>undefined;
            this.objDynamic = _data['objDynamic'];
            this.statusCde = _data['statusCde'];
        }
    }

    static fromJS(data: any): ActionWorkShiftChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionWorkShiftChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['keyValue'] = this.keyValue;
        data['rowVersion'] = this.rowVersion;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['tableName'] = this.tableName;
        data['cancelReason'] = this.cancelReason;
        data['workflowStateModel'] = this.workflowStateModel ? this.workflowStateModel.toJSON() : <any>undefined;
        data['objDynamic'] = this.objDynamic;
        data['statusCde'] = this.statusCde;
        return data;
    }

    clone(): ActionWorkShiftChangeDto {
        const json = this.toJSON();
        let result = new ActionWorkShiftChangeDto();
        result.init(json);
        return result;
    }
}

export interface IActionWorkShiftChangeDto {
    keyValue: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    tenantId: number;
    tableName: string | undefined;
    cancelReason: string | undefined;
    workflowStateModel: SysWorkflowStateDto;
    objDynamic: any | undefined;
    statusCde: string | undefined;
}

export class AnnualLeaveDto implements IAnnualLeaveDto {
    id: number;
    employeeId: number;
    employeeCode: string | undefined;
    annualLeaveType: string | undefined;
    fullName: string | undefined;
    hoursLeft: number;
    description: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    title: string | undefined;
    content: string | undefined;
    cancelReason: string | undefined;
    statusCde: string | undefined;
    wfDataCde: string | undefined;
    rowVersion: string | undefined;
    isDelete: boolean;
    createBy: string | undefined;
    createDate: moment.Moment | undefined;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment | undefined;

    constructor(data?: IAnnualLeaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.employeeCode = _data['employeeCode'];
            this.annualLeaveType = _data['annualLeaveType'];
            this.fullName = _data['fullName'];
            this.hoursLeft = _data['hoursLeft'];
            this.description = _data['description'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.title = _data['title'];
            this.content = _data['content'];
            this.cancelReason = _data['cancelReason'];
            this.statusCde = _data['statusCde'];
            this.wfDataCde = _data['wfDataCde'];
            this.rowVersion = _data['rowVersion'];
            this.isDelete = _data['isDelete'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AnnualLeaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnualLeaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['employeeCode'] = this.employeeCode;
        data['annualLeaveType'] = this.annualLeaveType;
        data['fullName'] = this.fullName;
        data['hoursLeft'] = this.hoursLeft;
        data['description'] = this.description;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['title'] = this.title;
        data['content'] = this.content;
        data['cancelReason'] = this.cancelReason;
        data['statusCde'] = this.statusCde;
        data['wfDataCde'] = this.wfDataCde;
        data['rowVersion'] = this.rowVersion;
        data['isDelete'] = this.isDelete;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): AnnualLeaveDto {
        const json = this.toJSON();
        let result = new AnnualLeaveDto();
        result.init(json);
        return result;
    }
}

export interface IAnnualLeaveDto {
    id: number;
    employeeId: number;
    employeeCode: string | undefined;
    annualLeaveType: string | undefined;
    fullName: string | undefined;
    hoursLeft: number;
    description: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    title: string | undefined;
    content: string | undefined;
    cancelReason: string | undefined;
    statusCde: string | undefined;
    wfDataCde: string | undefined;
    rowVersion: string | undefined;
    isDelete: boolean;
    createBy: string | undefined;
    createDate: moment.Moment | undefined;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data['version'];
            this.releaseDate = _data['releaseDate'] ? moment(_data['releaseDate'].toString()) : <any>undefined;
            if (_data['features']) {
                this.features = {} as any;
                for (let key in _data['features']) {
                    if (_data['features'].hasOwnProperty(key)) (<any>this.features)[key] = _data['features'][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['version'] = this.version;
        data['releaseDate'] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data['features'] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key)) (<any>data['features'])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean } | undefined;
}

export class AttendanceDetailDto implements IAttendanceDetailDto {
    id: number;
    attendanceId: number;
    employeeId: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    attendanceDate: moment.Moment;
    checkIn: string | undefined;
    checkOut: string | undefined;
    attendanceChant100: number;
    attendanceChant150: number;
    attendanceChant200: number;
    attendanceChant300: number;
    annualLeaveType: string | undefined;
    numberHour: number;
    rowVersion: string | undefined;
    shiftCode: string | undefined;
    shiftValue: string | undefined;
    lunchBreak: number;

    constructor(data?: IAttendanceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.attendanceId = _data['attendanceId'];
            this.employeeId = _data['employeeId'];
            this.employeeCode = _data['employeeCode'];
            this.employeeName = _data['employeeName'];
            this.attendanceDate = _data['attendanceDate'] ? moment(_data['attendanceDate'].toString()) : <any>undefined;
            this.checkIn = _data['checkIn'];
            this.checkOut = _data['checkOut'];
            this.attendanceChant100 = _data['attendanceChant100'];
            this.attendanceChant150 = _data['attendanceChant150'];
            this.attendanceChant200 = _data['attendanceChant200'];
            this.attendanceChant300 = _data['attendanceChant300'];
            this.annualLeaveType = _data['annualLeaveType'];
            this.numberHour = _data['numberHour'];
            this.rowVersion = _data['rowVersion'];
            this.shiftCode = _data['shiftCode'];
            this.shiftValue = _data['shiftValue'];
            this.lunchBreak = _data['lunchBreak'];
        }
    }

    static fromJS(data: any): AttendanceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['attendanceId'] = this.attendanceId;
        data['employeeId'] = this.employeeId;
        data['employeeCode'] = this.employeeCode;
        data['employeeName'] = this.employeeName;
        data['attendanceDate'] = this.attendanceDate ? this.attendanceDate.toISOString() : <any>undefined;
        data['checkIn'] = this.checkIn;
        data['checkOut'] = this.checkOut;
        data['attendanceChant100'] = this.attendanceChant100;
        data['attendanceChant150'] = this.attendanceChant150;
        data['attendanceChant200'] = this.attendanceChant200;
        data['attendanceChant300'] = this.attendanceChant300;
        data['annualLeaveType'] = this.annualLeaveType;
        data['numberHour'] = this.numberHour;
        data['rowVersion'] = this.rowVersion;
        data['shiftCode'] = this.shiftCode;
        data['shiftValue'] = this.shiftValue;
        data['lunchBreak'] = this.lunchBreak;
        return data;
    }

    clone(): AttendanceDetailDto {
        const json = this.toJSON();
        let result = new AttendanceDetailDto();
        result.init(json);
        return result;
    }
}

export interface IAttendanceDetailDto {
    id: number;
    attendanceId: number;
    employeeId: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    attendanceDate: moment.Moment;
    checkIn: string | undefined;
    checkOut: string | undefined;
    attendanceChant100: number;
    attendanceChant150: number;
    attendanceChant200: number;
    attendanceChant300: number;
    annualLeaveType: string | undefined;
    numberHour: number;
    rowVersion: string | undefined;
    shiftCode: string | undefined;
    shiftValue: string | undefined;
    lunchBreak: number;
}

export class AttendanceDto implements IAttendanceDto {
    id: number;
    titleName: string | undefined;
    code: string | undefined;
    monthAttendance: moment.Moment | undefined;
    notes: string | undefined;
    rowVersion: string | undefined;
    statusCde: string | undefined;
    cssStatusCde: string | undefined;
    statusName: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    modifiedBy: string | undefined;
    createBy: string | undefined;
    createByName: string | undefined;
    createDate: moment.Moment;

    constructor(data?: IAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.titleName = _data['titleName'];
            this.code = _data['code'];
            this.monthAttendance = _data['monthAttendance'] ? moment(_data['monthAttendance'].toString()) : <any>undefined;
            this.notes = _data['notes'];
            this.rowVersion = _data['rowVersion'];
            this.statusCde = _data['statusCde'];
            this.cssStatusCde = _data['cssStatusCde'];
            this.statusName = _data['statusName'];
            this.wfDataCde = _data['wfDataCde'];
            this.cancelReason = _data['cancelReason'];
            this.modifiedBy = _data['modifiedBy'];
            this.createBy = _data['createBy'];
            this.createByName = _data['createByName'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['titleName'] = this.titleName;
        data['code'] = this.code;
        data['monthAttendance'] = this.monthAttendance ? this.monthAttendance.toISOString() : <any>undefined;
        data['notes'] = this.notes;
        data['rowVersion'] = this.rowVersion;
        data['statusCde'] = this.statusCde;
        data['cssStatusCde'] = this.cssStatusCde;
        data['statusName'] = this.statusName;
        data['wfDataCde'] = this.wfDataCde;
        data['cancelReason'] = this.cancelReason;
        data['modifiedBy'] = this.modifiedBy;
        data['createBy'] = this.createBy;
        data['createByName'] = this.createByName;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): AttendanceDto {
        const json = this.toJSON();
        let result = new AttendanceDto();
        result.init(json);
        return result;
    }
}

export interface IAttendanceDto {
    id: number;
    titleName: string | undefined;
    code: string | undefined;
    monthAttendance: moment.Moment | undefined;
    notes: string | undefined;
    rowVersion: string | undefined;
    statusCde: string | undefined;
    cssStatusCde: string | undefined;
    statusName: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    modifiedBy: string | undefined;
    createBy: string | undefined;
    createByName: string | undefined;
    createDate: moment.Moment;
}

export class AttendanceResultModel implements IAttendanceResultModel {
    totalRows: number;
    rowIndex: number;
    totalPages: number;
    attendanceId: number;
    employeeId: string | undefined;
    employeeCode: string | undefined;
    fullname: string | undefined;
    timeCode: string | undefined;
    total_100: string | undefined;
    total_OT: string | undefined;
    total_Absent: string | undefined;
    total_Absent_Hour: string | undefined;
    stt: number;
    holiday: string | undefined;
    d01: string | undefined;
    d02: string | undefined;
    d03: string | undefined;
    d04: string | undefined;
    d05: string | undefined;
    d06: string | undefined;
    d07: string | undefined;
    d08: string | undefined;
    d09: string | undefined;
    d10: string | undefined;
    d11: string | undefined;
    d12: string | undefined;
    d13: string | undefined;
    d14: string | undefined;
    d15: string | undefined;
    d16: string | undefined;
    d17: string | undefined;
    d18: string | undefined;
    d19: string | undefined;
    d20: string | undefined;
    d21: string | undefined;
    d22: string | undefined;
    d23: string | undefined;
    d24: string | undefined;
    d25: string | undefined;
    d26: string | undefined;
    d27: string | undefined;
    d28: string | undefined;
    d29: string | undefined;
    d30: string | undefined;
    d31: string | undefined;

    constructor(data?: IAttendanceResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data['totalRows'];
            this.rowIndex = _data['rowIndex'];
            this.totalPages = _data['totalPages'];
            this.attendanceId = _data['attendanceId'];
            this.employeeId = _data['employeeId'];
            this.employeeCode = _data['employeeCode'];
            this.fullname = _data['fullname'];
            this.timeCode = _data['timeCode'];
            this.total_100 = _data['total_100'];
            this.total_OT = _data['total_OT'];
            this.total_Absent = _data['total_Absent'];
            this.total_Absent_Hour = _data['total_Absent_Hour'];
            this.stt = _data['stt'];
            this.holiday = _data['holiday'];
            this.d01 = _data['d01'];
            this.d02 = _data['d02'];
            this.d03 = _data['d03'];
            this.d04 = _data['d04'];
            this.d05 = _data['d05'];
            this.d06 = _data['d06'];
            this.d07 = _data['d07'];
            this.d08 = _data['d08'];
            this.d09 = _data['d09'];
            this.d10 = _data['d10'];
            this.d11 = _data['d11'];
            this.d12 = _data['d12'];
            this.d13 = _data['d13'];
            this.d14 = _data['d14'];
            this.d15 = _data['d15'];
            this.d16 = _data['d16'];
            this.d17 = _data['d17'];
            this.d18 = _data['d18'];
            this.d19 = _data['d19'];
            this.d20 = _data['d20'];
            this.d21 = _data['d21'];
            this.d22 = _data['d22'];
            this.d23 = _data['d23'];
            this.d24 = _data['d24'];
            this.d25 = _data['d25'];
            this.d26 = _data['d26'];
            this.d27 = _data['d27'];
            this.d28 = _data['d28'];
            this.d29 = _data['d29'];
            this.d30 = _data['d30'];
            this.d31 = _data['d31'];
        }
    }

    static fromJS(data: any): AttendanceResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalRows'] = this.totalRows;
        data['rowIndex'] = this.rowIndex;
        data['totalPages'] = this.totalPages;
        data['attendanceId'] = this.attendanceId;
        data['employeeId'] = this.employeeId;
        data['employeeCode'] = this.employeeCode;
        data['fullname'] = this.fullname;
        data['timeCode'] = this.timeCode;
        data['total_100'] = this.total_100;
        data['total_OT'] = this.total_OT;
        data['total_Absent'] = this.total_Absent;
        data['total_Absent_Hour'] = this.total_Absent_Hour;
        data['stt'] = this.stt;
        data['holiday'] = this.holiday;
        data['d01'] = this.d01;
        data['d02'] = this.d02;
        data['d03'] = this.d03;
        data['d04'] = this.d04;
        data['d05'] = this.d05;
        data['d06'] = this.d06;
        data['d07'] = this.d07;
        data['d08'] = this.d08;
        data['d09'] = this.d09;
        data['d10'] = this.d10;
        data['d11'] = this.d11;
        data['d12'] = this.d12;
        data['d13'] = this.d13;
        data['d14'] = this.d14;
        data['d15'] = this.d15;
        data['d16'] = this.d16;
        data['d17'] = this.d17;
        data['d18'] = this.d18;
        data['d19'] = this.d19;
        data['d20'] = this.d20;
        data['d21'] = this.d21;
        data['d22'] = this.d22;
        data['d23'] = this.d23;
        data['d24'] = this.d24;
        data['d25'] = this.d25;
        data['d26'] = this.d26;
        data['d27'] = this.d27;
        data['d28'] = this.d28;
        data['d29'] = this.d29;
        data['d30'] = this.d30;
        data['d31'] = this.d31;
        return data;
    }

    clone(): AttendanceResultModel {
        const json = this.toJSON();
        let result = new AttendanceResultModel();
        result.init(json);
        return result;
    }
}

export interface IAttendanceResultModel {
    totalRows: number;
    rowIndex: number;
    totalPages: number;
    attendanceId: number;
    employeeId: string | undefined;
    employeeCode: string | undefined;
    fullname: string | undefined;
    timeCode: string | undefined;
    total_100: string | undefined;
    total_OT: string | undefined;
    total_Absent: string | undefined;
    total_Absent_Hour: string | undefined;
    stt: number;
    holiday: string | undefined;
    d01: string | undefined;
    d02: string | undefined;
    d03: string | undefined;
    d04: string | undefined;
    d05: string | undefined;
    d06: string | undefined;
    d07: string | undefined;
    d08: string | undefined;
    d09: string | undefined;
    d10: string | undefined;
    d11: string | undefined;
    d12: string | undefined;
    d13: string | undefined;
    d14: string | undefined;
    d15: string | undefined;
    d16: string | undefined;
    d17: string | undefined;
    d18: string | undefined;
    d19: string | undefined;
    d20: string | undefined;
    d21: string | undefined;
    d22: string | undefined;
    d23: string | undefined;
    d24: string | undefined;
    d25: string | undefined;
    d26: string | undefined;
    d27: string | undefined;
    d28: string | undefined;
    d29: string | undefined;
    d30: string | undefined;
    d31: string | undefined;
}

export class AuthenticateClientModel implements IAuthenticateClientModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
    tenantName: string;

    constructor(data?: IAuthenticateClientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data['userNameOrEmailAddress'];
            this.password = _data['password'];
            this.rememberClient = _data['rememberClient'];
            this.tenantName = _data['tenantName'];
        }
    }

    static fromJS(data: any): AuthenticateClientModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateClientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userNameOrEmailAddress'] = this.userNameOrEmailAddress;
        data['password'] = this.password;
        data['rememberClient'] = this.rememberClient;
        data['tenantName'] = this.tenantName;
        return data;
    }

    clone(): AuthenticateClientModel {
        const json = this.toJSON();
        let result = new AuthenticateClientModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateClientModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
    tenantName: string;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data['userNameOrEmailAddress'];
            this.password = _data['password'];
            this.rememberClient = _data['rememberClient'];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userNameOrEmailAddress'] = this.userNameOrEmailAddress;
        data['password'] = this.password;
        data['rememberClient'] = this.rememberClient;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data['accessToken'];
            this.encryptedAccessToken = _data['encryptedAccessToken'];
            this.expireInSeconds = _data['expireInSeconds'];
            this.userId = _data['userId'];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['accessToken'] = this.accessToken;
        data['encryptedAccessToken'] = this.encryptedAccessToken;
        data['expireInSeconds'] = this.expireInSeconds;
        data['userId'] = this.userId;
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
}

export class BonusDetailModel implements IBonusDetailModel {
    id: number;
    bonusId: number;
    employeeId: number;
    amounts: number;
    employeeCde: string | undefined;
    employeeName: string | undefined;
    rowVersion: string | undefined;

    constructor(data?: IBonusDetailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.bonusId = _data['bonusId'];
            this.employeeId = _data['employeeId'];
            this.amounts = _data['amounts'];
            this.employeeCde = _data['employeeCde'];
            this.employeeName = _data['employeeName'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): BonusDetailModel {
        data = typeof data === 'object' ? data : {};
        let result = new BonusDetailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['bonusId'] = this.bonusId;
        data['employeeId'] = this.employeeId;
        data['amounts'] = this.amounts;
        data['employeeCde'] = this.employeeCde;
        data['employeeName'] = this.employeeName;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): BonusDetailModel {
        const json = this.toJSON();
        let result = new BonusDetailModel();
        result.init(json);
        return result;
    }
}

export interface IBonusDetailModel {
    id: number;
    bonusId: number;
    employeeId: number;
    amounts: number;
    employeeCde: string | undefined;
    employeeName: string | undefined;
    rowVersion: string | undefined;
}

export class BonusDto implements IBonusDto {
    id: number;
    bonusType: string | undefined;
    bonusCode: string | undefined;
    totalAmounts: number | undefined;
    dateApply: moment.Moment | undefined;
    description: string | undefined;
    isPlusTotalize: boolean;
    title: string | undefined;
    rowVersion: string | undefined;
    statusCde: string | undefined;
    cssStatusCde: string | undefined;
    statusName: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    modifiedBy: string | undefined;
    createBy: string | undefined;
    createByName: string | undefined;
    createDate: moment.Moment;

    constructor(data?: IBonusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.bonusType = _data['bonusType'];
            this.bonusCode = _data['bonusCode'];
            this.totalAmounts = _data['totalAmounts'];
            this.dateApply = _data['dateApply'] ? moment(_data['dateApply'].toString()) : <any>undefined;
            this.description = _data['description'];
            this.isPlusTotalize = _data['isPlusTotalize'];
            this.title = _data['title'];
            this.rowVersion = _data['rowVersion'];
            this.statusCde = _data['statusCde'];
            this.cssStatusCde = _data['cssStatusCde'];
            this.statusName = _data['statusName'];
            this.wfDataCde = _data['wfDataCde'];
            this.cancelReason = _data['cancelReason'];
            this.modifiedBy = _data['modifiedBy'];
            this.createBy = _data['createBy'];
            this.createByName = _data['createByName'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BonusDto {
        data = typeof data === 'object' ? data : {};
        let result = new BonusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['bonusType'] = this.bonusType;
        data['bonusCode'] = this.bonusCode;
        data['totalAmounts'] = this.totalAmounts;
        data['dateApply'] = this.dateApply ? this.dateApply.toISOString() : <any>undefined;
        data['description'] = this.description;
        data['isPlusTotalize'] = this.isPlusTotalize;
        data['title'] = this.title;
        data['rowVersion'] = this.rowVersion;
        data['statusCde'] = this.statusCde;
        data['cssStatusCde'] = this.cssStatusCde;
        data['statusName'] = this.statusName;
        data['wfDataCde'] = this.wfDataCde;
        data['cancelReason'] = this.cancelReason;
        data['modifiedBy'] = this.modifiedBy;
        data['createBy'] = this.createBy;
        data['createByName'] = this.createByName;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): BonusDto {
        const json = this.toJSON();
        let result = new BonusDto();
        result.init(json);
        return result;
    }
}

export interface IBonusDto {
    id: number;
    bonusType: string | undefined;
    bonusCode: string | undefined;
    totalAmounts: number | undefined;
    dateApply: moment.Moment | undefined;
    description: string | undefined;
    isPlusTotalize: boolean;
    title: string | undefined;
    rowVersion: string | undefined;
    statusCde: string | undefined;
    cssStatusCde: string | undefined;
    statusName: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    modifiedBy: string | undefined;
    createBy: string | undefined;
    createByName: string | undefined;
    createDate: moment.Moment;
}

export class CacheDto implements ICacheDto {
    name: string | undefined;

    constructor(data?: ICacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): CacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new CacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        return data;
    }

    clone(): CacheDto {
        const json = this.toJSON();
        let result = new CacheDto();
        result.init(json);
        return result;
    }
}

export interface ICacheDto {
    name: string | undefined;
}

export class CacheDtoListResultDto implements ICacheDtoListResultDto {
    items: CacheDto[] | undefined;

    constructor(data?: ICacheDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(CacheDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CacheDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CacheDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): CacheDtoListResultDto {
        const json = this.toJSON();
        let result = new CacheDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface ICacheDtoListResultDto {
    items: CacheDto[] | undefined;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data['currentPassword'];
            this.newPassword = _data['newPassword'];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['currentPassword'] = this.currentPassword;
        data['newPassword'] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data['theme'];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['theme'] = this.theme;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data['languageName'];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['languageName'] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class ClientAbpLanguageDto implements IClientAbpLanguageDto {
    tenantId: number;
    id: number;
    displayName: string | undefined;
    icon: string | undefined;
    name: string | undefined;

    constructor(data?: IClientAbpLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            this.displayName = _data['displayName'];
            this.icon = _data['icon'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): ClientAbpLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAbpLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        data['displayName'] = this.displayName;
        data['icon'] = this.icon;
        data['name'] = this.name;
        return data;
    }

    clone(): ClientAbpLanguageDto {
        const json = this.toJSON();
        let result = new ClientAbpLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IClientAbpLanguageDto {
    tenantId: number;
    id: number;
    displayName: string | undefined;
    icon: string | undefined;
    name: string | undefined;
}

export class ClientAbpLanguageTextsDto implements IClientAbpLanguageTextsDto {
    tenantId: number;
    id: number;
    key: string | undefined;
    languageName: string | undefined;
    source: string | undefined;
    value: string | undefined;

    constructor(data?: IClientAbpLanguageTextsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            this.key = _data['key'];
            this.languageName = _data['languageName'];
            this.source = _data['source'];
            this.value = _data['value'];
        }
    }

    static fromJS(data: any): ClientAbpLanguageTextsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAbpLanguageTextsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        data['key'] = this.key;
        data['languageName'] = this.languageName;
        data['source'] = this.source;
        data['value'] = this.value;
        return data;
    }

    clone(): ClientAbpLanguageTextsDto {
        const json = this.toJSON();
        let result = new ClientAbpLanguageTextsDto();
        result.init(json);
        return result;
    }
}

export interface IClientAbpLanguageTextsDto {
    tenantId: number;
    id: number;
    key: string | undefined;
    languageName: string | undefined;
    source: string | undefined;
    value: string | undefined;
}

export class ClientActionEvaluationResultDto implements IClientActionEvaluationResultDto {
    keyValue: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    tenantId: number | undefined;
    tableName: string | undefined;
    cancelReason: string | undefined;
    workflowStateModel: SysWorkflowStateDto;
    objDynamic: any | undefined;
    statusCde: string | undefined;
    columnKey: string | undefined;
    columnValue: string | undefined;
    periodId: number;
    resultId: number;
    totalScore: number | undefined;
    comment: string | undefined;
    evaluationResultDetail: ClientEvaluationResultDetailActionModel[] | undefined;

    constructor(data?: IClientActionEvaluationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyValue = _data['keyValue'];
            this.rowVersion = _data['rowVersion'];
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.tableName = _data['tableName'];
            this.cancelReason = _data['cancelReason'];
            this.workflowStateModel = _data['workflowStateModel'] ? SysWorkflowStateDto.fromJS(_data['workflowStateModel']) : <any>undefined;
            this.objDynamic = _data['objDynamic'];
            this.statusCde = _data['statusCde'];
            this.columnKey = _data['columnKey'];
            this.columnValue = _data['columnValue'];
            this.periodId = _data['periodId'];
            this.resultId = _data['resultId'];
            this.totalScore = _data['totalScore'];
            this.comment = _data['comment'];
            if (Array.isArray(_data['evaluationResultDetail'])) {
                this.evaluationResultDetail = [] as any;
                for (let item of _data['evaluationResultDetail']) this.evaluationResultDetail.push(ClientEvaluationResultDetailActionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientActionEvaluationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientActionEvaluationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['keyValue'] = this.keyValue;
        data['rowVersion'] = this.rowVersion;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['tableName'] = this.tableName;
        data['cancelReason'] = this.cancelReason;
        data['workflowStateModel'] = this.workflowStateModel ? this.workflowStateModel.toJSON() : <any>undefined;
        data['objDynamic'] = this.objDynamic;
        data['statusCde'] = this.statusCde;
        data['columnKey'] = this.columnKey;
        data['columnValue'] = this.columnValue;
        data['periodId'] = this.periodId;
        data['resultId'] = this.resultId;
        data['totalScore'] = this.totalScore;
        data['comment'] = this.comment;
        if (Array.isArray(this.evaluationResultDetail)) {
            data['evaluationResultDetail'] = [];
            for (let item of this.evaluationResultDetail) data['evaluationResultDetail'].push(item.toJSON());
        }
        return data;
    }

    clone(): ClientActionEvaluationResultDto {
        const json = this.toJSON();
        let result = new ClientActionEvaluationResultDto();
        result.init(json);
        return result;
    }
}

export interface IClientActionEvaluationResultDto {
    keyValue: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    tenantId: number | undefined;
    tableName: string | undefined;
    cancelReason: string | undefined;
    workflowStateModel: SysWorkflowStateDto;
    objDynamic: any | undefined;
    statusCde: string | undefined;
    columnKey: string | undefined;
    columnValue: string | undefined;
    periodId: number;
    resultId: number;
    totalScore: number | undefined;
    comment: string | undefined;
    evaluationResultDetail: ClientEvaluationResultDetailActionModel[] | undefined;
}

export class ClientAffiliatedEmployeesModel implements IClientAffiliatedEmployeesModel {
    employeeCode: string | undefined;
    fullName: string | undefined;

    constructor(data?: IClientAffiliatedEmployeesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeCode = _data['employeeCode'];
            this.fullName = _data['fullName'];
        }
    }

    static fromJS(data: any): ClientAffiliatedEmployeesModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAffiliatedEmployeesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['employeeCode'] = this.employeeCode;
        data['fullName'] = this.fullName;
        return data;
    }

    clone(): ClientAffiliatedEmployeesModel {
        const json = this.toJSON();
        let result = new ClientAffiliatedEmployeesModel();
        result.init(json);
        return result;
    }
}

export interface IClientAffiliatedEmployeesModel {
    employeeCode: string | undefined;
    fullName: string | undefined;
}

export class ClientAnnualLeaveByManagerPageModel implements IClientAnnualLeaveByManagerPageModel {
    totalRows: number;
    rowIndex: number;
    totalPages: number;
    id: number;
    employeeId: number;
    employeeName: string | undefined;
    annualLeaveType: string | undefined;
    annualLeaveValue: string | undefined;
    content: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    statusCde: string | undefined;
    statusValue: string | undefined;
    rowVersion: string | undefined;

    constructor(data?: IClientAnnualLeaveByManagerPageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data['totalRows'];
            this.rowIndex = _data['rowIndex'];
            this.totalPages = _data['totalPages'];
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.employeeName = _data['employeeName'];
            this.annualLeaveType = _data['annualLeaveType'];
            this.annualLeaveValue = _data['annualLeaveValue'];
            this.content = _data['content'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.statusCde = _data['statusCde'];
            this.statusValue = _data['statusValue'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): ClientAnnualLeaveByManagerPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAnnualLeaveByManagerPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalRows'] = this.totalRows;
        data['rowIndex'] = this.rowIndex;
        data['totalPages'] = this.totalPages;
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['employeeName'] = this.employeeName;
        data['annualLeaveType'] = this.annualLeaveType;
        data['annualLeaveValue'] = this.annualLeaveValue;
        data['content'] = this.content;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['statusCde'] = this.statusCde;
        data['statusValue'] = this.statusValue;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): ClientAnnualLeaveByManagerPageModel {
        const json = this.toJSON();
        let result = new ClientAnnualLeaveByManagerPageModel();
        result.init(json);
        return result;
    }
}

export interface IClientAnnualLeaveByManagerPageModel {
    totalRows: number;
    rowIndex: number;
    totalPages: number;
    id: number;
    employeeId: number;
    employeeName: string | undefined;
    annualLeaveType: string | undefined;
    annualLeaveValue: string | undefined;
    content: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    statusCde: string | undefined;
    statusValue: string | undefined;
    rowVersion: string | undefined;
}

export class ClientAnnualLeaveDetailsModel implements IClientAnnualLeaveDetailsModel {
    id: number;
    employeeId: number;
    employeeName: string | undefined;
    annualLeaveType: string | undefined;
    annualLeaveValue: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    hoursLeft: number;
    content: string | undefined;
    rowVersion: string | undefined;
    statusCde: string | undefined;
    statusValue: string | undefined;
    cancelReason: string | undefined;

    constructor(data?: IClientAnnualLeaveDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.employeeName = _data['employeeName'];
            this.annualLeaveType = _data['annualLeaveType'];
            this.annualLeaveValue = _data['annualLeaveValue'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.hoursLeft = _data['hoursLeft'];
            this.content = _data['content'];
            this.rowVersion = _data['rowVersion'];
            this.statusCde = _data['statusCde'];
            this.statusValue = _data['statusValue'];
            this.cancelReason = _data['cancelReason'];
        }
    }

    static fromJS(data: any): ClientAnnualLeaveDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAnnualLeaveDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['employeeName'] = this.employeeName;
        data['annualLeaveType'] = this.annualLeaveType;
        data['annualLeaveValue'] = this.annualLeaveValue;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['hoursLeft'] = this.hoursLeft;
        data['content'] = this.content;
        data['rowVersion'] = this.rowVersion;
        data['statusCde'] = this.statusCde;
        data['statusValue'] = this.statusValue;
        data['cancelReason'] = this.cancelReason;
        return data;
    }

    clone(): ClientAnnualLeaveDetailsModel {
        const json = this.toJSON();
        let result = new ClientAnnualLeaveDetailsModel();
        result.init(json);
        return result;
    }
}

export interface IClientAnnualLeaveDetailsModel {
    id: number;
    employeeId: number;
    employeeName: string | undefined;
    annualLeaveType: string | undefined;
    annualLeaveValue: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    hoursLeft: number;
    content: string | undefined;
    rowVersion: string | undefined;
    statusCde: string | undefined;
    statusValue: string | undefined;
    cancelReason: string | undefined;
}

export class ClientAnnualLeavePageModel implements IClientAnnualLeavePageModel {
    totalRows: number;
    rowIndex: number;
    totalPages: number;
    id: number;
    employeeName: string | undefined;
    employeeId: number;
    annualLeaveType: string | undefined;
    annualLeaveValue: string | undefined;
    content: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    statusCde: string | undefined;
    statusValue: string | undefined;
    hoursLeft: number;
    rowVersion: string | undefined;

    constructor(data?: IClientAnnualLeavePageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data['totalRows'];
            this.rowIndex = _data['rowIndex'];
            this.totalPages = _data['totalPages'];
            this.id = _data['id'];
            this.employeeName = _data['employeeName'];
            this.employeeId = _data['employeeId'];
            this.annualLeaveType = _data['annualLeaveType'];
            this.annualLeaveValue = _data['annualLeaveValue'];
            this.content = _data['content'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.statusCde = _data['statusCde'];
            this.statusValue = _data['statusValue'];
            this.hoursLeft = _data['hoursLeft'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): ClientAnnualLeavePageModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAnnualLeavePageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalRows'] = this.totalRows;
        data['rowIndex'] = this.rowIndex;
        data['totalPages'] = this.totalPages;
        data['id'] = this.id;
        data['employeeName'] = this.employeeName;
        data['employeeId'] = this.employeeId;
        data['annualLeaveType'] = this.annualLeaveType;
        data['annualLeaveValue'] = this.annualLeaveValue;
        data['content'] = this.content;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['statusCde'] = this.statusCde;
        data['statusValue'] = this.statusValue;
        data['hoursLeft'] = this.hoursLeft;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): ClientAnnualLeavePageModel {
        const json = this.toJSON();
        let result = new ClientAnnualLeavePageModel();
        result.init(json);
        return result;
    }
}

export interface IClientAnnualLeavePageModel {
    totalRows: number;
    rowIndex: number;
    totalPages: number;
    id: number;
    employeeName: string | undefined;
    employeeId: number;
    annualLeaveType: string | undefined;
    annualLeaveValue: string | undefined;
    content: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    statusCde: string | undefined;
    statusValue: string | undefined;
    hoursLeft: number;
    rowVersion: string | undefined;
}

export class ClientAnnualLeaveWorkingShiftModel implements IClientAnnualLeaveWorkingShiftModel {
    employeeId: number;
    shiftCode: string | undefined;
    workDate: moment.Moment;

    constructor(data?: IClientAnnualLeaveWorkingShiftModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data['employeeId'];
            this.shiftCode = _data['shiftCode'];
            this.workDate = _data['workDate'] ? moment(_data['workDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ClientAnnualLeaveWorkingShiftModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAnnualLeaveWorkingShiftModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['employeeId'] = this.employeeId;
        data['shiftCode'] = this.shiftCode;
        data['workDate'] = this.workDate ? this.workDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): ClientAnnualLeaveWorkingShiftModel {
        const json = this.toJSON();
        let result = new ClientAnnualLeaveWorkingShiftModel();
        result.init(json);
        return result;
    }
}

export interface IClientAnnualLeaveWorkingShiftModel {
    employeeId: number;
    shiftCode: string | undefined;
    workDate: moment.Moment;
}

export class ClientAttendanceDetailsModel implements IClientAttendanceDetailsModel {
    attendanceDate: moment.Moment;
    annualLeaveType: string | undefined;
    checkIn: string | undefined;
    checkOut: string | undefined;
    attendanceChant100: string | undefined;

    constructor(data?: IClientAttendanceDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceDate = _data['attendanceDate'] ? moment(_data['attendanceDate'].toString()) : <any>undefined;
            this.annualLeaveType = _data['annualLeaveType'];
            this.checkIn = _data['checkIn'];
            this.checkOut = _data['checkOut'];
            this.attendanceChant100 = _data['attendanceChant100'];
        }
    }

    static fromJS(data: any): ClientAttendanceDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAttendanceDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['attendanceDate'] = this.attendanceDate ? this.attendanceDate.toISOString() : <any>undefined;
        data['annualLeaveType'] = this.annualLeaveType;
        data['checkIn'] = this.checkIn;
        data['checkOut'] = this.checkOut;
        data['attendanceChant100'] = this.attendanceChant100;
        return data;
    }

    clone(): ClientAttendanceDetailsModel {
        const json = this.toJSON();
        let result = new ClientAttendanceDetailsModel();
        result.init(json);
        return result;
    }
}

export interface IClientAttendanceDetailsModel {
    attendanceDate: moment.Moment;
    annualLeaveType: string | undefined;
    checkIn: string | undefined;
    checkOut: string | undefined;
    attendanceChant100: string | undefined;
}

export class ClientAttendanceDto implements IClientAttendanceDto {
    strDay: string | undefined;
    attendanceDate: string | undefined;
    checkIn: string | undefined;
    checkOut: string | undefined;
    attendanceChant100: string | undefined;
    attendanceChant150: string | undefined;
    attendanceChant200: string | undefined;
    attendanceChant300: string | undefined;
    annualLeaveType: string | undefined;
    absentName: string | undefined;
    numberHour: string | undefined;
    isFinish: boolean;
    totalAbsent: string | undefined;
    total100: string | undefined;
    total150: string | undefined;
    total200: string | undefined;
    total300: string | undefined;

    constructor(data?: IClientAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.strDay = _data['strDay'];
            this.attendanceDate = _data['attendanceDate'];
            this.checkIn = _data['checkIn'];
            this.checkOut = _data['checkOut'];
            this.attendanceChant100 = _data['attendanceChant100'];
            this.attendanceChant150 = _data['attendanceChant150'];
            this.attendanceChant200 = _data['attendanceChant200'];
            this.attendanceChant300 = _data['attendanceChant300'];
            this.annualLeaveType = _data['annualLeaveType'];
            this.absentName = _data['absentName'];
            this.numberHour = _data['numberHour'];
            this.isFinish = _data['isFinish'];
            this.totalAbsent = _data['totalAbsent'];
            this.total100 = _data['total100'];
            this.total150 = _data['total150'];
            this.total200 = _data['total200'];
            this.total300 = _data['total300'];
        }
    }

    static fromJS(data: any): ClientAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['strDay'] = this.strDay;
        data['attendanceDate'] = this.attendanceDate;
        data['checkIn'] = this.checkIn;
        data['checkOut'] = this.checkOut;
        data['attendanceChant100'] = this.attendanceChant100;
        data['attendanceChant150'] = this.attendanceChant150;
        data['attendanceChant200'] = this.attendanceChant200;
        data['attendanceChant300'] = this.attendanceChant300;
        data['annualLeaveType'] = this.annualLeaveType;
        data['absentName'] = this.absentName;
        data['numberHour'] = this.numberHour;
        data['isFinish'] = this.isFinish;
        data['totalAbsent'] = this.totalAbsent;
        data['total100'] = this.total100;
        data['total150'] = this.total150;
        data['total200'] = this.total200;
        data['total300'] = this.total300;
        return data;
    }

    clone(): ClientAttendanceDto {
        const json = this.toJSON();
        let result = new ClientAttendanceDto();
        result.init(json);
        return result;
    }
}

export interface IClientAttendanceDto {
    strDay: string | undefined;
    attendanceDate: string | undefined;
    checkIn: string | undefined;
    checkOut: string | undefined;
    attendanceChant100: string | undefined;
    attendanceChant150: string | undefined;
    attendanceChant200: string | undefined;
    attendanceChant300: string | undefined;
    annualLeaveType: string | undefined;
    absentName: string | undefined;
    numberHour: string | undefined;
    isFinish: boolean;
    totalAbsent: string | undefined;
    total100: string | undefined;
    total150: string | undefined;
    total200: string | undefined;
    total300: string | undefined;
}

export class ClientAttendanceInfoDto implements IClientAttendanceInfoDto {
    attendanceId: number;
    employeeId: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    attendanceDate: moment.Moment | undefined;
    totalWorkInMonth: string | undefined;
    totalWork100: string | undefined;
    totalAbsent: string | undefined;
    totalUnpaid: string | undefined;
    totalOvertime150: string | undefined;
    totalOvertime200: string | undefined;
    totalOvertime300: string | undefined;
    lstAttendanceDetail: ClientAttendanceDetailsModel[] | undefined;

    constructor(data?: IClientAttendanceInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceId = _data['attendanceId'];
            this.employeeId = _data['employeeId'];
            this.employeeCode = _data['employeeCode'];
            this.employeeName = _data['employeeName'];
            this.attendanceDate = _data['attendanceDate'] ? moment(_data['attendanceDate'].toString()) : <any>undefined;
            this.totalWorkInMonth = _data['totalWorkInMonth'];
            this.totalWork100 = _data['totalWork100'];
            this.totalAbsent = _data['totalAbsent'];
            this.totalUnpaid = _data['totalUnpaid'];
            this.totalOvertime150 = _data['totalOvertime150'];
            this.totalOvertime200 = _data['totalOvertime200'];
            this.totalOvertime300 = _data['totalOvertime300'];
            if (Array.isArray(_data['lstAttendanceDetail'])) {
                this.lstAttendanceDetail = [] as any;
                for (let item of _data['lstAttendanceDetail']) this.lstAttendanceDetail.push(ClientAttendanceDetailsModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientAttendanceInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAttendanceInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['attendanceId'] = this.attendanceId;
        data['employeeId'] = this.employeeId;
        data['employeeCode'] = this.employeeCode;
        data['employeeName'] = this.employeeName;
        data['attendanceDate'] = this.attendanceDate ? this.attendanceDate.toISOString() : <any>undefined;
        data['totalWorkInMonth'] = this.totalWorkInMonth;
        data['totalWork100'] = this.totalWork100;
        data['totalAbsent'] = this.totalAbsent;
        data['totalUnpaid'] = this.totalUnpaid;
        data['totalOvertime150'] = this.totalOvertime150;
        data['totalOvertime200'] = this.totalOvertime200;
        data['totalOvertime300'] = this.totalOvertime300;
        if (Array.isArray(this.lstAttendanceDetail)) {
            data['lstAttendanceDetail'] = [];
            for (let item of this.lstAttendanceDetail) data['lstAttendanceDetail'].push(item.toJSON());
        }
        return data;
    }

    clone(): ClientAttendanceInfoDto {
        const json = this.toJSON();
        let result = new ClientAttendanceInfoDto();
        result.init(json);
        return result;
    }
}

export interface IClientAttendanceInfoDto {
    attendanceId: number;
    employeeId: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    attendanceDate: moment.Moment | undefined;
    totalWorkInMonth: string | undefined;
    totalWork100: string | undefined;
    totalAbsent: string | undefined;
    totalUnpaid: string | undefined;
    totalOvertime150: string | undefined;
    totalOvertime200: string | undefined;
    totalOvertime300: string | undefined;
    lstAttendanceDetail: ClientAttendanceDetailsModel[] | undefined;
}

export class ClientAttendancePageModel implements IClientAttendancePageModel {
    totalRows: number;
    rowIndex: number;
    totalPages: number;
    id: number;
    code: string | undefined;
    titleName: string | undefined;
    monthAttendance: moment.Moment | undefined;
    notes: string | undefined;
    rowVersion: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment;
    total_100: string | undefined;
    total_Absent: string | undefined;

    constructor(data?: IClientAttendancePageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data['totalRows'];
            this.rowIndex = _data['rowIndex'];
            this.totalPages = _data['totalPages'];
            this.id = _data['id'];
            this.code = _data['code'];
            this.titleName = _data['titleName'];
            this.monthAttendance = _data['monthAttendance'] ? moment(_data['monthAttendance'].toString()) : <any>undefined;
            this.notes = _data['notes'];
            this.rowVersion = _data['rowVersion'];
            this.wfDataCde = _data['wfDataCde'];
            this.cancelReason = _data['cancelReason'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            this.total_100 = _data['total_100'];
            this.total_Absent = _data['total_Absent'];
        }
    }

    static fromJS(data: any): ClientAttendancePageModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAttendancePageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalRows'] = this.totalRows;
        data['rowIndex'] = this.rowIndex;
        data['totalPages'] = this.totalPages;
        data['id'] = this.id;
        data['code'] = this.code;
        data['titleName'] = this.titleName;
        data['monthAttendance'] = this.monthAttendance ? this.monthAttendance.toISOString() : <any>undefined;
        data['notes'] = this.notes;
        data['rowVersion'] = this.rowVersion;
        data['wfDataCde'] = this.wfDataCde;
        data['cancelReason'] = this.cancelReason;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data['total_100'] = this.total_100;
        data['total_Absent'] = this.total_Absent;
        return data;
    }

    clone(): ClientAttendancePageModel {
        const json = this.toJSON();
        let result = new ClientAttendancePageModel();
        result.init(json);
        return result;
    }
}

export interface IClientAttendancePageModel {
    totalRows: number;
    rowIndex: number;
    totalPages: number;
    id: number;
    code: string | undefined;
    titleName: string | undefined;
    monthAttendance: moment.Moment | undefined;
    notes: string | undefined;
    rowVersion: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment;
    total_100: string | undefined;
    total_Absent: string | undefined;
}

export class ClientAttendanceTotalDto implements IClientAttendanceTotalDto {
    totalHour: string | undefined;
    totalOverTime: string | undefined;
    holidayTime: string | undefined;
    totalTimeAnnualLeave: string | undefined;
    attendance: ClientAttendanceDto[] | undefined;

    constructor(data?: IClientAttendanceTotalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalHour = _data['totalHour'];
            this.totalOverTime = _data['totalOverTime'];
            this.holidayTime = _data['holidayTime'];
            this.totalTimeAnnualLeave = _data['totalTimeAnnualLeave'];
            if (Array.isArray(_data['attendance'])) {
                this.attendance = [] as any;
                for (let item of _data['attendance']) this.attendance.push(ClientAttendanceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientAttendanceTotalDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAttendanceTotalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalHour'] = this.totalHour;
        data['totalOverTime'] = this.totalOverTime;
        data['holidayTime'] = this.holidayTime;
        data['totalTimeAnnualLeave'] = this.totalTimeAnnualLeave;
        if (Array.isArray(this.attendance)) {
            data['attendance'] = [];
            for (let item of this.attendance) data['attendance'].push(item.toJSON());
        }
        return data;
    }

    clone(): ClientAttendanceTotalDto {
        const json = this.toJSON();
        let result = new ClientAttendanceTotalDto();
        result.init(json);
        return result;
    }
}

export interface IClientAttendanceTotalDto {
    totalHour: string | undefined;
    totalOverTime: string | undefined;
    holidayTime: string | undefined;
    totalTimeAnnualLeave: string | undefined;
    attendance: ClientAttendanceDto[] | undefined;
}

export class ClientChangePasswordEmployeeDto implements IClientChangePasswordEmployeeDto {
    oldPassword: string | undefined;
    newPassword: string | undefined;
    rowversion: string | undefined;

    constructor(data?: IClientChangePasswordEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data['oldPassword'];
            this.newPassword = _data['newPassword'];
            this.rowversion = _data['rowversion'];
        }
    }

    static fromJS(data: any): ClientChangePasswordEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientChangePasswordEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['oldPassword'] = this.oldPassword;
        data['newPassword'] = this.newPassword;
        data['rowversion'] = this.rowversion;
        return data;
    }

    clone(): ClientChangePasswordEmployeeDto {
        const json = this.toJSON();
        let result = new ClientChangePasswordEmployeeDto();
        result.init(json);
        return result;
    }
}

export interface IClientChangePasswordEmployeeDto {
    oldPassword: string | undefined;
    newPassword: string | undefined;
    rowversion: string | undefined;
}

export class ClientEmployeeDto implements IClientEmployeeDto {
    tenantId: number;
    id: number;
    employeeCode: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    fullname: string | undefined;
    sex: string | undefined;
    birthDay: moment.Moment | undefined;
    identityCard: string | undefined;
    identityCardDate: moment.Moment | undefined;
    identityCardPlace: string | undefined;
    nationalityCode: string | undefined;
    dateOfEntry: moment.Moment | undefined;
    isFederation: boolean;
    departmentCode: string | undefined;
    jobCode: string | undefined;
    familyExemptionNumber: number | undefined;
    familyExemptionDate: moment.Moment | undefined;
    taxYourself: string | undefined;
    isInactivity: boolean;
    bankAccount: string | undefined;
    bankCode: string | undefined;
    permanentAddress: string | undefined;
    temporaryAddress: string | undefined;
    phoneNumber: string | undefined;
    image: string | undefined;
    inactivityDate: moment.Moment | undefined;
    isManager: boolean;
    managerId: number;
    managerName: string | undefined;
    rowVersion: string | undefined;
    affiliatedEmployees: ClientAffiliatedEmployeesModel[] | undefined;

    constructor(data?: IClientEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            this.employeeCode = _data['employeeCode'];
            this.firstName = _data['firstName'];
            this.lastName = _data['lastName'];
            this.fullname = _data['fullname'];
            this.sex = _data['sex'];
            this.birthDay = _data['birthDay'] ? moment(_data['birthDay'].toString()) : <any>undefined;
            this.identityCard = _data['identityCard'];
            this.identityCardDate = _data['identityCardDate'] ? moment(_data['identityCardDate'].toString()) : <any>undefined;
            this.identityCardPlace = _data['identityCardPlace'];
            this.nationalityCode = _data['nationalityCode'];
            this.dateOfEntry = _data['dateOfEntry'] ? moment(_data['dateOfEntry'].toString()) : <any>undefined;
            this.isFederation = _data['isFederation'];
            this.departmentCode = _data['departmentCode'];
            this.jobCode = _data['jobCode'];
            this.familyExemptionNumber = _data['familyExemptionNumber'];
            this.familyExemptionDate = _data['familyExemptionDate'] ? moment(_data['familyExemptionDate'].toString()) : <any>undefined;
            this.taxYourself = _data['taxYourself'];
            this.isInactivity = _data['isInactivity'];
            this.bankAccount = _data['bankAccount'];
            this.bankCode = _data['bankCode'];
            this.permanentAddress = _data['permanentAddress'];
            this.temporaryAddress = _data['temporaryAddress'];
            this.phoneNumber = _data['phoneNumber'];
            this.image = _data['image'];
            this.inactivityDate = _data['inactivityDate'] ? moment(_data['inactivityDate'].toString()) : <any>undefined;
            this.isManager = _data['isManager'];
            this.managerId = _data['managerId'];
            this.managerName = _data['managerName'];
            this.rowVersion = _data['rowVersion'];
            if (Array.isArray(_data['affiliatedEmployees'])) {
                this.affiliatedEmployees = [] as any;
                for (let item of _data['affiliatedEmployees']) this.affiliatedEmployees.push(ClientAffiliatedEmployeesModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        data['employeeCode'] = this.employeeCode;
        data['firstName'] = this.firstName;
        data['lastName'] = this.lastName;
        data['fullname'] = this.fullname;
        data['sex'] = this.sex;
        data['birthDay'] = this.birthDay ? this.birthDay.toISOString() : <any>undefined;
        data['identityCard'] = this.identityCard;
        data['identityCardDate'] = this.identityCardDate ? this.identityCardDate.toISOString() : <any>undefined;
        data['identityCardPlace'] = this.identityCardPlace;
        data['nationalityCode'] = this.nationalityCode;
        data['dateOfEntry'] = this.dateOfEntry ? this.dateOfEntry.toISOString() : <any>undefined;
        data['isFederation'] = this.isFederation;
        data['departmentCode'] = this.departmentCode;
        data['jobCode'] = this.jobCode;
        data['familyExemptionNumber'] = this.familyExemptionNumber;
        data['familyExemptionDate'] = this.familyExemptionDate ? this.familyExemptionDate.toISOString() : <any>undefined;
        data['taxYourself'] = this.taxYourself;
        data['isInactivity'] = this.isInactivity;
        data['bankAccount'] = this.bankAccount;
        data['bankCode'] = this.bankCode;
        data['permanentAddress'] = this.permanentAddress;
        data['temporaryAddress'] = this.temporaryAddress;
        data['phoneNumber'] = this.phoneNumber;
        data['image'] = this.image;
        data['inactivityDate'] = this.inactivityDate ? this.inactivityDate.toISOString() : <any>undefined;
        data['isManager'] = this.isManager;
        data['managerId'] = this.managerId;
        data['managerName'] = this.managerName;
        data['rowVersion'] = this.rowVersion;
        if (Array.isArray(this.affiliatedEmployees)) {
            data['affiliatedEmployees'] = [];
            for (let item of this.affiliatedEmployees) data['affiliatedEmployees'].push(item.toJSON());
        }
        return data;
    }

    clone(): ClientEmployeeDto {
        const json = this.toJSON();
        let result = new ClientEmployeeDto();
        result.init(json);
        return result;
    }
}

export interface IClientEmployeeDto {
    tenantId: number;
    id: number;
    employeeCode: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    fullname: string | undefined;
    sex: string | undefined;
    birthDay: moment.Moment | undefined;
    identityCard: string | undefined;
    identityCardDate: moment.Moment | undefined;
    identityCardPlace: string | undefined;
    nationalityCode: string | undefined;
    dateOfEntry: moment.Moment | undefined;
    isFederation: boolean;
    departmentCode: string | undefined;
    jobCode: string | undefined;
    familyExemptionNumber: number | undefined;
    familyExemptionDate: moment.Moment | undefined;
    taxYourself: string | undefined;
    isInactivity: boolean;
    bankAccount: string | undefined;
    bankCode: string | undefined;
    permanentAddress: string | undefined;
    temporaryAddress: string | undefined;
    phoneNumber: string | undefined;
    image: string | undefined;
    inactivityDate: moment.Moment | undefined;
    isManager: boolean;
    managerId: number;
    managerName: string | undefined;
    rowVersion: string | undefined;
    affiliatedEmployees: ClientAffiliatedEmployeesModel[] | undefined;
}

export class ClientEmployeeLoginDto implements IClientEmployeeLoginDto {
    tenantId: number;
    rowVersion: string | undefined;
    id: number;
    employeeCode: string | undefined;
    employeeToken: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    isFirstLogin: boolean;
    isManager: boolean;

    constructor(data?: IClientEmployeeLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.rowVersion = _data['rowVersion'];
            this.id = _data['id'];
            this.employeeCode = _data['employeeCode'];
            this.employeeToken = _data['employeeToken'];
            this.firstName = _data['firstName'];
            this.lastName = _data['lastName'];
            this.isFirstLogin = _data['isFirstLogin'];
            this.isManager = _data['isManager'];
        }
    }

    static fromJS(data: any): ClientEmployeeLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientEmployeeLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['rowVersion'] = this.rowVersion;
        data['id'] = this.id;
        data['employeeCode'] = this.employeeCode;
        data['employeeToken'] = this.employeeToken;
        data['firstName'] = this.firstName;
        data['lastName'] = this.lastName;
        data['isFirstLogin'] = this.isFirstLogin;
        data['isManager'] = this.isManager;
        return data;
    }

    clone(): ClientEmployeeLoginDto {
        const json = this.toJSON();
        let result = new ClientEmployeeLoginDto();
        result.init(json);
        return result;
    }
}

export interface IClientEmployeeLoginDto {
    tenantId: number;
    rowVersion: string | undefined;
    id: number;
    employeeCode: string | undefined;
    employeeToken: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    isFirstLogin: boolean;
    isManager: boolean;
}

export class ClientEmployeeResetPasswordDto implements IClientEmployeeResetPasswordDto {
    email: string | undefined;

    constructor(data?: IClientEmployeeResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data['email'];
        }
    }

    static fromJS(data: any): ClientEmployeeResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientEmployeeResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['email'] = this.email;
        return data;
    }

    clone(): ClientEmployeeResetPasswordDto {
        const json = this.toJSON();
        let result = new ClientEmployeeResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IClientEmployeeResetPasswordDto {
    email: string | undefined;
}

export class ClientEmployeeStatWidgetModel implements IClientEmployeeStatWidgetModel {
    tenantId: number;
    id: number;
    employeeCode: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    fullname: string | undefined;
    email: string | undefined;
    sex: string | undefined;
    birthday: string | undefined;
    managerId: string | undefined;
    jobCode: string | undefined;
    phoneNumber: string | undefined;
    salaryBasic: number;
    salaryDate: moment.Moment | undefined;
    numberDayWork: string | undefined;
    totalWorkInMonth: number;
    annualLeaveNumber: string | undefined;
    workingShift: string | undefined;
    workingShiftTime: string | undefined;
    numberDayAL: string | undefined;

    constructor(data?: IClientEmployeeStatWidgetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            this.employeeCode = _data['employeeCode'];
            this.firstName = _data['firstName'];
            this.lastName = _data['lastName'];
            this.fullname = _data['fullname'];
            this.email = _data['email'];
            this.sex = _data['sex'];
            this.birthday = _data['birthday'];
            this.managerId = _data['managerId'];
            this.jobCode = _data['jobCode'];
            this.phoneNumber = _data['phoneNumber'];
            this.salaryBasic = _data['salaryBasic'];
            this.salaryDate = _data['salaryDate'] ? moment(_data['salaryDate'].toString()) : <any>undefined;
            this.numberDayWork = _data['numberDayWork'];
            this.totalWorkInMonth = _data['totalWorkInMonth'];
            this.annualLeaveNumber = _data['annualLeaveNumber'];
            this.workingShift = _data['workingShift'];
            this.workingShiftTime = _data['workingShiftTime'];
            this.numberDayAL = _data['numberDayAL'];
        }
    }

    static fromJS(data: any): ClientEmployeeStatWidgetModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientEmployeeStatWidgetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        data['employeeCode'] = this.employeeCode;
        data['firstName'] = this.firstName;
        data['lastName'] = this.lastName;
        data['fullname'] = this.fullname;
        data['email'] = this.email;
        data['sex'] = this.sex;
        data['birthday'] = this.birthday;
        data['managerId'] = this.managerId;
        data['jobCode'] = this.jobCode;
        data['phoneNumber'] = this.phoneNumber;
        data['salaryBasic'] = this.salaryBasic;
        data['salaryDate'] = this.salaryDate ? this.salaryDate.toISOString() : <any>undefined;
        data['numberDayWork'] = this.numberDayWork;
        data['totalWorkInMonth'] = this.totalWorkInMonth;
        data['annualLeaveNumber'] = this.annualLeaveNumber;
        data['workingShift'] = this.workingShift;
        data['workingShiftTime'] = this.workingShiftTime;
        data['numberDayAL'] = this.numberDayAL;
        return data;
    }

    clone(): ClientEmployeeStatWidgetModel {
        const json = this.toJSON();
        let result = new ClientEmployeeStatWidgetModel();
        result.init(json);
        return result;
    }
}

export interface IClientEmployeeStatWidgetModel {
    tenantId: number;
    id: number;
    employeeCode: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    fullname: string | undefined;
    email: string | undefined;
    sex: string | undefined;
    birthday: string | undefined;
    managerId: string | undefined;
    jobCode: string | undefined;
    phoneNumber: string | undefined;
    salaryBasic: number;
    salaryDate: moment.Moment | undefined;
    numberDayWork: string | undefined;
    totalWorkInMonth: number;
    annualLeaveNumber: string | undefined;
    workingShift: string | undefined;
    workingShiftTime: string | undefined;
    numberDayAL: string | undefined;
}

export class ClientEmployeeUpdateImageDto implements IClientEmployeeUpdateImageDto {
    email: string | undefined;
    image: string | undefined;
    rowVersion: string | undefined;

    constructor(data?: IClientEmployeeUpdateImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data['email'];
            this.image = _data['image'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): ClientEmployeeUpdateImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientEmployeeUpdateImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['email'] = this.email;
        data['image'] = this.image;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): ClientEmployeeUpdateImageDto {
        const json = this.toJSON();
        let result = new ClientEmployeeUpdateImageDto();
        result.init(json);
        return result;
    }
}

export interface IClientEmployeeUpdateImageDto {
    email: string | undefined;
    image: string | undefined;
    rowVersion: string | undefined;
}

export class ClientEmployeeUpdatePasswordDto implements IClientEmployeeUpdatePasswordDto {
    email: string | undefined;
    otpCde: string | undefined;

    constructor(data?: IClientEmployeeUpdatePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data['email'];
            this.otpCde = _data['otpCde'];
        }
    }

    static fromJS(data: any): ClientEmployeeUpdatePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientEmployeeUpdatePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['email'] = this.email;
        data['otpCde'] = this.otpCde;
        return data;
    }

    clone(): ClientEmployeeUpdatePasswordDto {
        const json = this.toJSON();
        let result = new ClientEmployeeUpdatePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IClientEmployeeUpdatePasswordDto {
    email: string | undefined;
    otpCde: string | undefined;
}

export class ClientEvaluationResultDetailActionModel implements IClientEvaluationResultDetailActionModel {
    resultId: number;
    questionId: number;
    answerId: number;
    score: number;
    notes: string | undefined;
    managerNotes: string | undefined;
    hrNotes: string | undefined;

    constructor(data?: IClientEvaluationResultDetailActionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultId = _data['resultId'];
            this.questionId = _data['questionId'];
            this.answerId = _data['answerId'];
            this.score = _data['score'];
            this.notes = _data['notes'];
            this.managerNotes = _data['managerNotes'];
            this.hrNotes = _data['hrNotes'];
        }
    }

    static fromJS(data: any): ClientEvaluationResultDetailActionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientEvaluationResultDetailActionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['resultId'] = this.resultId;
        data['questionId'] = this.questionId;
        data['answerId'] = this.answerId;
        data['score'] = this.score;
        data['notes'] = this.notes;
        data['managerNotes'] = this.managerNotes;
        data['hrNotes'] = this.hrNotes;
        return data;
    }

    clone(): ClientEvaluationResultDetailActionModel {
        const json = this.toJSON();
        let result = new ClientEvaluationResultDetailActionModel();
        result.init(json);
        return result;
    }
}

export interface IClientEvaluationResultDetailActionModel {
    resultId: number;
    questionId: number;
    answerId: number;
    score: number;
    notes: string | undefined;
    managerNotes: string | undefined;
    hrNotes: string | undefined;
}

export class ClientEvaluationResultDto implements IClientEvaluationResultDto {
    id: number;
    periodId: number;
    periodName: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    templateId: number;
    templateName: string | undefined;
    employeeId: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    dateOfWork: moment.Moment;
    jobName: string | undefined;
    mainTask: string | undefined;
    dateOfEntry: moment.Moment;
    contractType: string | undefined;
    resultId: number;
    evaluationType: string | undefined;
    selfTotalScore: number;
    selfComment: string | undefined;
    statusCde: string | undefined;
    wfDataCde: string | undefined;
    cancelReason: string | undefined;
    resultManagerId: number;
    managerId: number;
    managerName: string | undefined;
    managerTotalScore: number;
    managerComment: string | undefined;
    resultCompanyId: number;
    companyComment: string | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment;
    employeeType: string | undefined;
    evaluationQuestion: EvaluationQuestionModel[] | undefined;
    evaluationResultDetail: EvaluationResultDetailModel[] | undefined;

    constructor(data?: IClientEvaluationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.periodId = _data['periodId'];
            this.periodName = _data['periodName'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.templateId = _data['templateId'];
            this.templateName = _data['templateName'];
            this.employeeId = _data['employeeId'];
            this.employeeCode = _data['employeeCode'];
            this.employeeName = _data['employeeName'];
            this.dateOfWork = _data['dateOfWork'] ? moment(_data['dateOfWork'].toString()) : <any>undefined;
            this.jobName = _data['jobName'];
            this.mainTask = _data['mainTask'];
            this.dateOfEntry = _data['dateOfEntry'] ? moment(_data['dateOfEntry'].toString()) : <any>undefined;
            this.contractType = _data['contractType'];
            this.resultId = _data['resultId'];
            this.evaluationType = _data['evaluationType'];
            this.selfTotalScore = _data['selfTotalScore'];
            this.selfComment = _data['selfComment'];
            this.statusCde = _data['statusCde'];
            this.wfDataCde = _data['wfDataCde'];
            this.cancelReason = _data['cancelReason'];
            this.resultManagerId = _data['resultManagerId'];
            this.managerId = _data['managerId'];
            this.managerName = _data['managerName'];
            this.managerTotalScore = _data['managerTotalScore'];
            this.managerComment = _data['managerComment'];
            this.resultCompanyId = _data['resultCompanyId'];
            this.companyComment = _data['companyComment'];
            this.tenantId = _data['tenantId'];
            this.rowVersion = _data['rowVersion'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            this.employeeType = _data['employeeType'];
            if (Array.isArray(_data['evaluationQuestion'])) {
                this.evaluationQuestion = [] as any;
                for (let item of _data['evaluationQuestion']) this.evaluationQuestion.push(EvaluationQuestionModel.fromJS(item));
            }
            if (Array.isArray(_data['evaluationResultDetail'])) {
                this.evaluationResultDetail = [] as any;
                for (let item of _data['evaluationResultDetail']) this.evaluationResultDetail.push(EvaluationResultDetailModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientEvaluationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientEvaluationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['periodId'] = this.periodId;
        data['periodName'] = this.periodName;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['templateId'] = this.templateId;
        data['templateName'] = this.templateName;
        data['employeeId'] = this.employeeId;
        data['employeeCode'] = this.employeeCode;
        data['employeeName'] = this.employeeName;
        data['dateOfWork'] = this.dateOfWork ? this.dateOfWork.toISOString() : <any>undefined;
        data['jobName'] = this.jobName;
        data['mainTask'] = this.mainTask;
        data['dateOfEntry'] = this.dateOfEntry ? this.dateOfEntry.toISOString() : <any>undefined;
        data['contractType'] = this.contractType;
        data['resultId'] = this.resultId;
        data['evaluationType'] = this.evaluationType;
        data['selfTotalScore'] = this.selfTotalScore;
        data['selfComment'] = this.selfComment;
        data['statusCde'] = this.statusCde;
        data['wfDataCde'] = this.wfDataCde;
        data['cancelReason'] = this.cancelReason;
        data['resultManagerId'] = this.resultManagerId;
        data['managerId'] = this.managerId;
        data['managerName'] = this.managerName;
        data['managerTotalScore'] = this.managerTotalScore;
        data['managerComment'] = this.managerComment;
        data['resultCompanyId'] = this.resultCompanyId;
        data['companyComment'] = this.companyComment;
        data['tenantId'] = this.tenantId;
        data['rowVersion'] = this.rowVersion;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data['employeeType'] = this.employeeType;
        if (Array.isArray(this.evaluationQuestion)) {
            data['evaluationQuestion'] = [];
            for (let item of this.evaluationQuestion) data['evaluationQuestion'].push(item.toJSON());
        }
        if (Array.isArray(this.evaluationResultDetail)) {
            data['evaluationResultDetail'] = [];
            for (let item of this.evaluationResultDetail) data['evaluationResultDetail'].push(item.toJSON());
        }
        return data;
    }

    clone(): ClientEvaluationResultDto {
        const json = this.toJSON();
        let result = new ClientEvaluationResultDto();
        result.init(json);
        return result;
    }
}

export interface IClientEvaluationResultDto {
    id: number;
    periodId: number;
    periodName: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    templateId: number;
    templateName: string | undefined;
    employeeId: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    dateOfWork: moment.Moment;
    jobName: string | undefined;
    mainTask: string | undefined;
    dateOfEntry: moment.Moment;
    contractType: string | undefined;
    resultId: number;
    evaluationType: string | undefined;
    selfTotalScore: number;
    selfComment: string | undefined;
    statusCde: string | undefined;
    wfDataCde: string | undefined;
    cancelReason: string | undefined;
    resultManagerId: number;
    managerId: number;
    managerName: string | undefined;
    managerTotalScore: number;
    managerComment: string | undefined;
    resultCompanyId: number;
    companyComment: string | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment;
    employeeType: string | undefined;
    evaluationQuestion: EvaluationQuestionModel[] | undefined;
    evaluationResultDetail: EvaluationResultDetailModel[] | undefined;
}

export class ClientEvaluationResultModel implements IClientEvaluationResultModel {
    totalRows: number;
    rowIndex: number;
    totalPages: number;
    id: number;
    periodId: number;
    periodCde: string | undefined;
    periodName: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    templateId: number;
    employeeId: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    resultId: number;
    evaluationType: string | undefined;
    totalScore: number;
    statusCde: string | undefined;
    comment: string | undefined;
    statusName: string | undefined;
    cssStatusCde: string | undefined;
    wfDataCde: string | undefined;
    cancelReason: string | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment;

    constructor(data?: IClientEvaluationResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data['totalRows'];
            this.rowIndex = _data['rowIndex'];
            this.totalPages = _data['totalPages'];
            this.id = _data['id'];
            this.periodId = _data['periodId'];
            this.periodCde = _data['periodCde'];
            this.periodName = _data['periodName'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.templateId = _data['templateId'];
            this.employeeId = _data['employeeId'];
            this.employeeCode = _data['employeeCode'];
            this.employeeName = _data['employeeName'];
            this.resultId = _data['resultId'];
            this.evaluationType = _data['evaluationType'];
            this.totalScore = _data['totalScore'];
            this.statusCde = _data['statusCde'];
            this.comment = _data['comment'];
            this.statusName = _data['statusName'];
            this.cssStatusCde = _data['cssStatusCde'];
            this.wfDataCde = _data['wfDataCde'];
            this.cancelReason = _data['cancelReason'];
            this.tenantId = _data['tenantId'];
            this.rowVersion = _data['rowVersion'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ClientEvaluationResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientEvaluationResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalRows'] = this.totalRows;
        data['rowIndex'] = this.rowIndex;
        data['totalPages'] = this.totalPages;
        data['id'] = this.id;
        data['periodId'] = this.periodId;
        data['periodCde'] = this.periodCde;
        data['periodName'] = this.periodName;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['templateId'] = this.templateId;
        data['employeeId'] = this.employeeId;
        data['employeeCode'] = this.employeeCode;
        data['employeeName'] = this.employeeName;
        data['resultId'] = this.resultId;
        data['evaluationType'] = this.evaluationType;
        data['totalScore'] = this.totalScore;
        data['statusCde'] = this.statusCde;
        data['comment'] = this.comment;
        data['statusName'] = this.statusName;
        data['cssStatusCde'] = this.cssStatusCde;
        data['wfDataCde'] = this.wfDataCde;
        data['cancelReason'] = this.cancelReason;
        data['tenantId'] = this.tenantId;
        data['rowVersion'] = this.rowVersion;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): ClientEvaluationResultModel {
        const json = this.toJSON();
        let result = new ClientEvaluationResultModel();
        result.init(json);
        return result;
    }
}

export interface IClientEvaluationResultModel {
    totalRows: number;
    rowIndex: number;
    totalPages: number;
    id: number;
    periodId: number;
    periodCde: string | undefined;
    periodName: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    templateId: number;
    employeeId: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    resultId: number;
    evaluationType: string | undefined;
    totalScore: number;
    statusCde: string | undefined;
    comment: string | undefined;
    statusName: string | undefined;
    cssStatusCde: string | undefined;
    wfDataCde: string | undefined;
    cancelReason: string | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment;
}

export class ClientGetNotificationNotReadDto implements IClientGetNotificationNotReadDto {
    constructor(data?: IClientGetNotificationNotReadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {}

    static fromJS(data: any): ClientGetNotificationNotReadDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientGetNotificationNotReadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ClientGetNotificationNotReadDto {
        const json = this.toJSON();
        let result = new ClientGetNotificationNotReadDto();
        result.init(json);
        return result;
    }
}

export interface IClientGetNotificationNotReadDto {}

export class ClientGetNotificationReadAllDto implements IClientGetNotificationReadAllDto {
    constructor(data?: IClientGetNotificationReadAllDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {}

    static fromJS(data: any): ClientGetNotificationReadAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientGetNotificationReadAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ClientGetNotificationReadAllDto {
        const json = this.toJSON();
        let result = new ClientGetNotificationReadAllDto();
        result.init(json);
        return result;
    }
}

export interface IClientGetNotificationReadAllDto {}

export class ClientGetNotificationReadDto implements IClientGetNotificationReadDto {
    id: number;
    rowVersion: string | undefined;

    constructor(data?: IClientGetNotificationReadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): ClientGetNotificationReadDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientGetNotificationReadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): ClientGetNotificationReadDto {
        const json = this.toJSON();
        let result = new ClientGetNotificationReadDto();
        result.init(json);
        return result;
    }
}

export interface IClientGetNotificationReadDto {
    id: number;
    rowVersion: string | undefined;
}

export class ClientInfoNotificationDto implements IClientInfoNotificationDto {
    id: number;
    employeeCode: string | undefined;
    title: string | undefined;
    body: string | undefined;
    content: string | undefined;
    notificationName: string | undefined;
    isRead: boolean;
    urlImage: string | undefined;
    refId: string | undefined;
    createdBy: string | undefined;
    createdDate: moment.Moment;
    rowVersion: string | undefined;

    constructor(data?: IClientInfoNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeCode = _data['employeeCode'];
            this.title = _data['title'];
            this.body = _data['body'];
            this.content = _data['content'];
            this.notificationName = _data['notificationName'];
            this.isRead = _data['isRead'];
            this.urlImage = _data['urlImage'];
            this.refId = _data['refId'];
            this.createdBy = _data['createdBy'];
            this.createdDate = _data['createdDate'] ? moment(_data['createdDate'].toString()) : <any>undefined;
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): ClientInfoNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientInfoNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeCode'] = this.employeeCode;
        data['title'] = this.title;
        data['body'] = this.body;
        data['content'] = this.content;
        data['notificationName'] = this.notificationName;
        data['isRead'] = this.isRead;
        data['urlImage'] = this.urlImage;
        data['refId'] = this.refId;
        data['createdBy'] = this.createdBy;
        data['createdDate'] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): ClientInfoNotificationDto {
        const json = this.toJSON();
        let result = new ClientInfoNotificationDto();
        result.init(json);
        return result;
    }
}

export interface IClientInfoNotificationDto {
    id: number;
    employeeCode: string | undefined;
    title: string | undefined;
    body: string | undefined;
    content: string | undefined;
    notificationName: string | undefined;
    isRead: boolean;
    urlImage: string | undefined;
    refId: string | undefined;
    createdBy: string | undefined;
    createdDate: moment.Moment;
    rowVersion: string | undefined;
}

export class ClientInfoTenantsDto implements IClientInfoTenantsDto {
    id: number;
    name: string | undefined;
    tenancyName: string | undefined;
    employeeCode: string | undefined;
    email: string | undefined;

    constructor(data?: IClientInfoTenantsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.tenancyName = _data['tenancyName'];
            this.employeeCode = _data['employeeCode'];
            this.email = _data['email'];
        }
    }

    static fromJS(data: any): ClientInfoTenantsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientInfoTenantsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['tenancyName'] = this.tenancyName;
        data['employeeCode'] = this.employeeCode;
        data['email'] = this.email;
        return data;
    }

    clone(): ClientInfoTenantsDto {
        const json = this.toJSON();
        let result = new ClientInfoTenantsDto();
        result.init(json);
        return result;
    }
}

export interface IClientInfoTenantsDto {
    id: number;
    name: string | undefined;
    tenancyName: string | undefined;
    employeeCode: string | undefined;
    email: string | undefined;
}

export class ClientInsuranceResultModel implements IClientInsuranceResultModel {
    id: number;
    employeeId: number;
    insuranceNumber: string | undefined;
    fullName: string | undefined;
    hospitalCode: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    amount: number;
    social: number;
    health: number;
    accident: number;
    socialIndividual: number;
    healthIndividual: number;
    accidentIndividual: number;
    description: string | undefined;
    rowVersion: string | undefined;

    constructor(data?: IClientInsuranceResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.insuranceNumber = _data['insuranceNumber'];
            this.fullName = _data['fullName'];
            this.hospitalCode = _data['hospitalCode'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.amount = _data['amount'];
            this.social = _data['social'];
            this.health = _data['health'];
            this.accident = _data['accident'];
            this.socialIndividual = _data['socialIndividual'];
            this.healthIndividual = _data['healthIndividual'];
            this.accidentIndividual = _data['accidentIndividual'];
            this.description = _data['description'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): ClientInsuranceResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientInsuranceResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['insuranceNumber'] = this.insuranceNumber;
        data['fullName'] = this.fullName;
        data['hospitalCode'] = this.hospitalCode;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['amount'] = this.amount;
        data['social'] = this.social;
        data['health'] = this.health;
        data['accident'] = this.accident;
        data['socialIndividual'] = this.socialIndividual;
        data['healthIndividual'] = this.healthIndividual;
        data['accidentIndividual'] = this.accidentIndividual;
        data['description'] = this.description;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): ClientInsuranceResultModel {
        const json = this.toJSON();
        let result = new ClientInsuranceResultModel();
        result.init(json);
        return result;
    }
}

export interface IClientInsuranceResultModel {
    id: number;
    employeeId: number;
    insuranceNumber: string | undefined;
    fullName: string | undefined;
    hospitalCode: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    amount: number;
    social: number;
    health: number;
    accident: number;
    socialIndividual: number;
    healthIndividual: number;
    accidentIndividual: number;
    description: string | undefined;
    rowVersion: string | undefined;
}

export class ClientLoginEmployeeDto implements IClientLoginEmployeeDto {
    tenantId: number;
    userName: string | undefined;
    password: string | undefined;
    deviceID: string | undefined;
    platForm: string | undefined;

    constructor(data?: IClientLoginEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.userName = _data['userName'];
            this.password = _data['password'];
            this.deviceID = _data['deviceID'];
            this.platForm = _data['platForm'];
        }
    }

    static fromJS(data: any): ClientLoginEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientLoginEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['userName'] = this.userName;
        data['password'] = this.password;
        data['deviceID'] = this.deviceID;
        data['platForm'] = this.platForm;
        return data;
    }

    clone(): ClientLoginEmployeeDto {
        const json = this.toJSON();
        let result = new ClientLoginEmployeeDto();
        result.init(json);
        return result;
    }
}

export interface IClientLoginEmployeeDto {
    tenantId: number;
    userName: string | undefined;
    password: string | undefined;
    deviceID: string | undefined;
    platForm: string | undefined;
}

export class ClientMasterListDto implements IClientMasterListDto {
    masterListID: number;
    masterListCode: string | undefined;
    masterListGroupCde: string | undefined;
    masterListCdeName: string | undefined;
    mastListDefaultValue: string | undefined;
    mastListExtendValue1: string | undefined;
    mastListExtendValue2: string | undefined;
    mastListExtendValue3: string | undefined;
    mastListExtendValue4: string | undefined;
    mastListExtendValue5: string | undefined;
    description: string | undefined;
    orderNo: number;

    constructor(data?: IClientMasterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.masterListID = _data['masterListID'];
            this.masterListCode = _data['masterListCode'];
            this.masterListGroupCde = _data['masterListGroupCde'];
            this.masterListCdeName = _data['masterListCdeName'];
            this.mastListDefaultValue = _data['mastListDefaultValue'];
            this.mastListExtendValue1 = _data['mastListExtendValue1'];
            this.mastListExtendValue2 = _data['mastListExtendValue2'];
            this.mastListExtendValue3 = _data['mastListExtendValue3'];
            this.mastListExtendValue4 = _data['mastListExtendValue4'];
            this.mastListExtendValue5 = _data['mastListExtendValue5'];
            this.description = _data['description'];
            this.orderNo = _data['orderNo'];
        }
    }

    static fromJS(data: any): ClientMasterListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientMasterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['masterListID'] = this.masterListID;
        data['masterListCode'] = this.masterListCode;
        data['masterListGroupCde'] = this.masterListGroupCde;
        data['masterListCdeName'] = this.masterListCdeName;
        data['mastListDefaultValue'] = this.mastListDefaultValue;
        data['mastListExtendValue1'] = this.mastListExtendValue1;
        data['mastListExtendValue2'] = this.mastListExtendValue2;
        data['mastListExtendValue3'] = this.mastListExtendValue3;
        data['mastListExtendValue4'] = this.mastListExtendValue4;
        data['mastListExtendValue5'] = this.mastListExtendValue5;
        data['description'] = this.description;
        data['orderNo'] = this.orderNo;
        return data;
    }

    clone(): ClientMasterListDto {
        const json = this.toJSON();
        let result = new ClientMasterListDto();
        result.init(json);
        return result;
    }
}

export interface IClientMasterListDto {
    masterListID: number;
    masterListCode: string | undefined;
    masterListGroupCde: string | undefined;
    masterListCdeName: string | undefined;
    mastListDefaultValue: string | undefined;
    mastListExtendValue1: string | undefined;
    mastListExtendValue2: string | undefined;
    mastListExtendValue3: string | undefined;
    mastListExtendValue4: string | undefined;
    mastListExtendValue5: string | undefined;
    description: string | undefined;
    orderNo: number;
}

export class ClientNotificationDto implements IClientNotificationDto {
    totalRows: number;
    rowIndex: number;
    totalPages: number;
    id: number;
    employeeCode: number;
    title: string | undefined;
    body: string | undefined;
    notificationName: string | undefined;
    notificationType: string | undefined;
    isRead: boolean;
    urlImage: string | undefined;
    refId: string | undefined;
    createdBy: string | undefined;
    createdDate: moment.Moment;
    rowVersion: string | undefined;

    constructor(data?: IClientNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data['totalRows'];
            this.rowIndex = _data['rowIndex'];
            this.totalPages = _data['totalPages'];
            this.id = _data['id'];
            this.employeeCode = _data['employeeCode'];
            this.title = _data['title'];
            this.body = _data['body'];
            this.notificationName = _data['notificationName'];
            this.notificationType = _data['notificationType'];
            this.isRead = _data['isRead'];
            this.urlImage = _data['urlImage'];
            this.refId = _data['refId'];
            this.createdBy = _data['createdBy'];
            this.createdDate = _data['createdDate'] ? moment(_data['createdDate'].toString()) : <any>undefined;
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): ClientNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalRows'] = this.totalRows;
        data['rowIndex'] = this.rowIndex;
        data['totalPages'] = this.totalPages;
        data['id'] = this.id;
        data['employeeCode'] = this.employeeCode;
        data['title'] = this.title;
        data['body'] = this.body;
        data['notificationName'] = this.notificationName;
        data['notificationType'] = this.notificationType;
        data['isRead'] = this.isRead;
        data['urlImage'] = this.urlImage;
        data['refId'] = this.refId;
        data['createdBy'] = this.createdBy;
        data['createdDate'] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): ClientNotificationDto {
        const json = this.toJSON();
        let result = new ClientNotificationDto();
        result.init(json);
        return result;
    }
}

export interface IClientNotificationDto {
    totalRows: number;
    rowIndex: number;
    totalPages: number;
    id: number;
    employeeCode: number;
    title: string | undefined;
    body: string | undefined;
    notificationName: string | undefined;
    notificationType: string | undefined;
    isRead: boolean;
    urlImage: string | undefined;
    refId: string | undefined;
    createdBy: string | undefined;
    createdDate: moment.Moment;
    rowVersion: string | undefined;
}

export class ClientNotificationNotReadDto implements IClientNotificationNotReadDto {
    isRead: string | undefined;

    constructor(data?: IClientNotificationNotReadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isRead = _data['isRead'];
        }
    }

    static fromJS(data: any): ClientNotificationNotReadDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientNotificationNotReadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['isRead'] = this.isRead;
        return data;
    }

    clone(): ClientNotificationNotReadDto {
        const json = this.toJSON();
        let result = new ClientNotificationNotReadDto();
        result.init(json);
        return result;
    }
}

export interface IClientNotificationNotReadDto {
    isRead: string | undefined;
}

export class ClientProfileDto implements IClientProfileDto {
    tenantId: number;
    id: number;
    employeeCode: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    fullname: string | undefined;
    sex: string | undefined;
    birthDay: moment.Moment | undefined;
    dateOfEntry: moment.Moment | undefined;
    jobCode: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    permanentAddress: string | undefined;
    temporaryAddress: string | undefined;
    image: string | undefined;
    isManager: boolean;
    isDeleted: boolean;
    createBy: string | undefined;
    createDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    managerId: number;
    managerName: string | undefined;
    jobCodeName: string | undefined;
    genderName: string | undefined;
    identityCard: string | undefined;
    identityCardDate: moment.Moment | undefined;
    identityCardPlace: string | undefined;
    dateOfWork: moment.Moment | undefined;
    isFederation: boolean;
    departmentCode: string | undefined;
    nationalityCode: string | undefined;
    familyExemptionNumber: number | undefined;
    familyExemptionDate: moment.Moment | undefined;
    taxYourself: string | undefined;
    isInactivity: boolean;
    bankAccount: string | undefined;
    bankCode: string | undefined;
    inactivityDate: moment.Moment | undefined;
    religiousCode: string | undefined;
    educatedCode: string | undefined;
    insuranceNumber: string | undefined;
    maritalStatus: string | undefined;
    rowVersion: string | undefined;
    identityCard2: string | undefined;
    identityCardDate2: moment.Moment | undefined;
    identityCardPlace2: string | undefined;
    lstWorkingProcess: ClientWorkingProcessModel[] | undefined;
    lstSalaryBasic: ClientSalaryBasicModel[] | undefined;
    lstInsurance: ClientInsuranceResultModel[] | undefined;

    constructor(data?: IClientProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.id = _data['id'];
            this.employeeCode = _data['employeeCode'];
            this.firstName = _data['firstName'];
            this.lastName = _data['lastName'];
            this.fullname = _data['fullname'];
            this.sex = _data['sex'];
            this.birthDay = _data['birthDay'] ? moment(_data['birthDay'].toString()) : <any>undefined;
            this.dateOfEntry = _data['dateOfEntry'] ? moment(_data['dateOfEntry'].toString()) : <any>undefined;
            this.jobCode = _data['jobCode'];
            this.email = _data['email'];
            this.phoneNumber = _data['phoneNumber'];
            this.permanentAddress = _data['permanentAddress'];
            this.temporaryAddress = _data['temporaryAddress'];
            this.image = _data['image'];
            this.isManager = _data['isManager'];
            this.isDeleted = _data['isDeleted'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
            this.managerId = _data['managerId'];
            this.managerName = _data['managerName'];
            this.jobCodeName = _data['jobCodeName'];
            this.genderName = _data['genderName'];
            this.identityCard = _data['identityCard'];
            this.identityCardDate = _data['identityCardDate'] ? moment(_data['identityCardDate'].toString()) : <any>undefined;
            this.identityCardPlace = _data['identityCardPlace'];
            this.dateOfWork = _data['dateOfWork'] ? moment(_data['dateOfWork'].toString()) : <any>undefined;
            this.isFederation = _data['isFederation'];
            this.departmentCode = _data['departmentCode'];
            this.nationalityCode = _data['nationalityCode'];
            this.familyExemptionNumber = _data['familyExemptionNumber'];
            this.familyExemptionDate = _data['familyExemptionDate'] ? moment(_data['familyExemptionDate'].toString()) : <any>undefined;
            this.taxYourself = _data['taxYourself'];
            this.isInactivity = _data['isInactivity'];
            this.bankAccount = _data['bankAccount'];
            this.bankCode = _data['bankCode'];
            this.inactivityDate = _data['inactivityDate'] ? moment(_data['inactivityDate'].toString()) : <any>undefined;
            this.religiousCode = _data['religiousCode'];
            this.educatedCode = _data['educatedCode'];
            this.insuranceNumber = _data['insuranceNumber'];
            this.maritalStatus = _data['maritalStatus'];
            this.rowVersion = _data['rowVersion'];
            this.identityCard2 = _data['identityCard2'];
            this.identityCardDate2 = _data['identityCardDate2'] ? moment(_data['identityCardDate2'].toString()) : <any>undefined;
            this.identityCardPlace2 = _data['identityCardPlace2'];
            if (Array.isArray(_data['lstWorkingProcess'])) {
                this.lstWorkingProcess = [] as any;
                for (let item of _data['lstWorkingProcess']) this.lstWorkingProcess.push(ClientWorkingProcessModel.fromJS(item));
            }
            if (Array.isArray(_data['lstSalaryBasic'])) {
                this.lstSalaryBasic = [] as any;
                for (let item of _data['lstSalaryBasic']) this.lstSalaryBasic.push(ClientSalaryBasicModel.fromJS(item));
            }
            if (Array.isArray(_data['lstInsurance'])) {
                this.lstInsurance = [] as any;
                for (let item of _data['lstInsurance']) this.lstInsurance.push(ClientInsuranceResultModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['id'] = this.id;
        data['employeeCode'] = this.employeeCode;
        data['firstName'] = this.firstName;
        data['lastName'] = this.lastName;
        data['fullname'] = this.fullname;
        data['sex'] = this.sex;
        data['birthDay'] = this.birthDay ? this.birthDay.toISOString() : <any>undefined;
        data['dateOfEntry'] = this.dateOfEntry ? this.dateOfEntry.toISOString() : <any>undefined;
        data['jobCode'] = this.jobCode;
        data['email'] = this.email;
        data['phoneNumber'] = this.phoneNumber;
        data['permanentAddress'] = this.permanentAddress;
        data['temporaryAddress'] = this.temporaryAddress;
        data['image'] = this.image;
        data['isManager'] = this.isManager;
        data['isDeleted'] = this.isDeleted;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data['managerId'] = this.managerId;
        data['managerName'] = this.managerName;
        data['jobCodeName'] = this.jobCodeName;
        data['genderName'] = this.genderName;
        data['identityCard'] = this.identityCard;
        data['identityCardDate'] = this.identityCardDate ? this.identityCardDate.toISOString() : <any>undefined;
        data['identityCardPlace'] = this.identityCardPlace;
        data['dateOfWork'] = this.dateOfWork ? this.dateOfWork.toISOString() : <any>undefined;
        data['isFederation'] = this.isFederation;
        data['departmentCode'] = this.departmentCode;
        data['nationalityCode'] = this.nationalityCode;
        data['familyExemptionNumber'] = this.familyExemptionNumber;
        data['familyExemptionDate'] = this.familyExemptionDate ? this.familyExemptionDate.toISOString() : <any>undefined;
        data['taxYourself'] = this.taxYourself;
        data['isInactivity'] = this.isInactivity;
        data['bankAccount'] = this.bankAccount;
        data['bankCode'] = this.bankCode;
        data['inactivityDate'] = this.inactivityDate ? this.inactivityDate.toISOString() : <any>undefined;
        data['religiousCode'] = this.religiousCode;
        data['educatedCode'] = this.educatedCode;
        data['insuranceNumber'] = this.insuranceNumber;
        data['maritalStatus'] = this.maritalStatus;
        data['rowVersion'] = this.rowVersion;
        data['identityCard2'] = this.identityCard2;
        data['identityCardDate2'] = this.identityCardDate2 ? this.identityCardDate2.toISOString() : <any>undefined;
        data['identityCardPlace2'] = this.identityCardPlace2;
        if (Array.isArray(this.lstWorkingProcess)) {
            data['lstWorkingProcess'] = [];
            for (let item of this.lstWorkingProcess) data['lstWorkingProcess'].push(item.toJSON());
        }
        if (Array.isArray(this.lstSalaryBasic)) {
            data['lstSalaryBasic'] = [];
            for (let item of this.lstSalaryBasic) data['lstSalaryBasic'].push(item.toJSON());
        }
        if (Array.isArray(this.lstInsurance)) {
            data['lstInsurance'] = [];
            for (let item of this.lstInsurance) data['lstInsurance'].push(item.toJSON());
        }
        return data;
    }

    clone(): ClientProfileDto {
        const json = this.toJSON();
        let result = new ClientProfileDto();
        result.init(json);
        return result;
    }
}

export interface IClientProfileDto {
    tenantId: number;
    id: number;
    employeeCode: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    fullname: string | undefined;
    sex: string | undefined;
    birthDay: moment.Moment | undefined;
    dateOfEntry: moment.Moment | undefined;
    jobCode: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    permanentAddress: string | undefined;
    temporaryAddress: string | undefined;
    image: string | undefined;
    isManager: boolean;
    isDeleted: boolean;
    createBy: string | undefined;
    createDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    managerId: number;
    managerName: string | undefined;
    jobCodeName: string | undefined;
    genderName: string | undefined;
    identityCard: string | undefined;
    identityCardDate: moment.Moment | undefined;
    identityCardPlace: string | undefined;
    dateOfWork: moment.Moment | undefined;
    isFederation: boolean;
    departmentCode: string | undefined;
    nationalityCode: string | undefined;
    familyExemptionNumber: number | undefined;
    familyExemptionDate: moment.Moment | undefined;
    taxYourself: string | undefined;
    isInactivity: boolean;
    bankAccount: string | undefined;
    bankCode: string | undefined;
    inactivityDate: moment.Moment | undefined;
    religiousCode: string | undefined;
    educatedCode: string | undefined;
    insuranceNumber: string | undefined;
    maritalStatus: string | undefined;
    rowVersion: string | undefined;
    identityCard2: string | undefined;
    identityCardDate2: moment.Moment | undefined;
    identityCardPlace2: string | undefined;
    lstWorkingProcess: ClientWorkingProcessModel[] | undefined;
    lstSalaryBasic: ClientSalaryBasicModel[] | undefined;
    lstInsurance: ClientInsuranceResultModel[] | undefined;
}

export class ClientRegisterOvertimeByManagerIdModel implements IClientRegisterOvertimeByManagerIdModel {
    totalRows: number;
    rowIndex: number;
    totalPages: number;
    id: number;
    employeeId: number;
    employeeName: string | undefined;
    hoursOvertime: number;
    overtimeDate: moment.Moment;
    content: string | undefined;
    statusCde: string | undefined;
    statusValue: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    rowVersion: string | undefined;

    constructor(data?: IClientRegisterOvertimeByManagerIdModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data['totalRows'];
            this.rowIndex = _data['rowIndex'];
            this.totalPages = _data['totalPages'];
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.employeeName = _data['employeeName'];
            this.hoursOvertime = _data['hoursOvertime'];
            this.overtimeDate = _data['overtimeDate'] ? moment(_data['overtimeDate'].toString()) : <any>undefined;
            this.content = _data['content'];
            this.statusCde = _data['statusCde'];
            this.statusValue = _data['statusValue'];
            this.startTime = _data['startTime'];
            this.endTime = _data['endTime'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): ClientRegisterOvertimeByManagerIdModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientRegisterOvertimeByManagerIdModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalRows'] = this.totalRows;
        data['rowIndex'] = this.rowIndex;
        data['totalPages'] = this.totalPages;
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['employeeName'] = this.employeeName;
        data['hoursOvertime'] = this.hoursOvertime;
        data['overtimeDate'] = this.overtimeDate ? this.overtimeDate.toISOString() : <any>undefined;
        data['content'] = this.content;
        data['statusCde'] = this.statusCde;
        data['statusValue'] = this.statusValue;
        data['startTime'] = this.startTime;
        data['endTime'] = this.endTime;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): ClientRegisterOvertimeByManagerIdModel {
        const json = this.toJSON();
        let result = new ClientRegisterOvertimeByManagerIdModel();
        result.init(json);
        return result;
    }
}

export interface IClientRegisterOvertimeByManagerIdModel {
    totalRows: number;
    rowIndex: number;
    totalPages: number;
    id: number;
    employeeId: number;
    employeeName: string | undefined;
    hoursOvertime: number;
    overtimeDate: moment.Moment;
    content: string | undefined;
    statusCde: string | undefined;
    statusValue: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    rowVersion: string | undefined;
}

export class ClientRegisterOvertimeDetailModel implements IClientRegisterOvertimeDetailModel {
    id: number;
    employeeId: number;
    employeeName: string | undefined;
    hoursOvertime: number;
    overtimeDate: moment.Moment;
    content: string | undefined;
    statusCde: string | undefined;
    statusValue: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    rowVersion: string | undefined;

    constructor(data?: IClientRegisterOvertimeDetailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.employeeName = _data['employeeName'];
            this.hoursOvertime = _data['hoursOvertime'];
            this.overtimeDate = _data['overtimeDate'] ? moment(_data['overtimeDate'].toString()) : <any>undefined;
            this.content = _data['content'];
            this.statusCde = _data['statusCde'];
            this.statusValue = _data['statusValue'];
            this.startTime = _data['startTime'];
            this.endTime = _data['endTime'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): ClientRegisterOvertimeDetailModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientRegisterOvertimeDetailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['employeeName'] = this.employeeName;
        data['hoursOvertime'] = this.hoursOvertime;
        data['overtimeDate'] = this.overtimeDate ? this.overtimeDate.toISOString() : <any>undefined;
        data['content'] = this.content;
        data['statusCde'] = this.statusCde;
        data['statusValue'] = this.statusValue;
        data['startTime'] = this.startTime;
        data['endTime'] = this.endTime;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): ClientRegisterOvertimeDetailModel {
        const json = this.toJSON();
        let result = new ClientRegisterOvertimeDetailModel();
        result.init(json);
        return result;
    }
}

export interface IClientRegisterOvertimeDetailModel {
    id: number;
    employeeId: number;
    employeeName: string | undefined;
    hoursOvertime: number;
    overtimeDate: moment.Moment;
    content: string | undefined;
    statusCde: string | undefined;
    statusValue: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    rowVersion: string | undefined;
}

export class ClientRegisterOvertimeDto implements IClientRegisterOvertimeDto {
    hoursOvertime: number;
    overtimeDate: moment.Moment;
    startTime: string | undefined;
    endTime: string | undefined;
    content: string | undefined;

    constructor(data?: IClientRegisterOvertimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hoursOvertime = _data['hoursOvertime'];
            this.overtimeDate = _data['overtimeDate'] ? moment(_data['overtimeDate'].toString()) : <any>undefined;
            this.startTime = _data['startTime'];
            this.endTime = _data['endTime'];
            this.content = _data['content'];
        }
    }

    static fromJS(data: any): ClientRegisterOvertimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientRegisterOvertimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['hoursOvertime'] = this.hoursOvertime;
        data['overtimeDate'] = this.overtimeDate ? this.overtimeDate.toISOString() : <any>undefined;
        data['startTime'] = this.startTime;
        data['endTime'] = this.endTime;
        data['content'] = this.content;
        return data;
    }

    clone(): ClientRegisterOvertimeDto {
        const json = this.toJSON();
        let result = new ClientRegisterOvertimeDto();
        result.init(json);
        return result;
    }
}

export interface IClientRegisterOvertimeDto {
    hoursOvertime: number;
    overtimeDate: moment.Moment;
    startTime: string | undefined;
    endTime: string | undefined;
    content: string | undefined;
}

export class ClientRegisterOvertimeModel implements IClientRegisterOvertimeModel {
    totalRows: number;
    rowIndex: number;
    totalPages: number;
    id: number;
    employeeName: string | undefined;
    employeeId: number;
    hoursOvertime: number;
    overtimeDate: moment.Moment;
    content: string | undefined;
    statusCde: string | undefined;
    statusValue: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;

    constructor(data?: IClientRegisterOvertimeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data['totalRows'];
            this.rowIndex = _data['rowIndex'];
            this.totalPages = _data['totalPages'];
            this.id = _data['id'];
            this.employeeName = _data['employeeName'];
            this.employeeId = _data['employeeId'];
            this.hoursOvertime = _data['hoursOvertime'];
            this.overtimeDate = _data['overtimeDate'] ? moment(_data['overtimeDate'].toString()) : <any>undefined;
            this.content = _data['content'];
            this.statusCde = _data['statusCde'];
            this.statusValue = _data['statusValue'];
            this.startTime = _data['startTime'];
            this.endTime = _data['endTime'];
        }
    }

    static fromJS(data: any): ClientRegisterOvertimeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientRegisterOvertimeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalRows'] = this.totalRows;
        data['rowIndex'] = this.rowIndex;
        data['totalPages'] = this.totalPages;
        data['id'] = this.id;
        data['employeeName'] = this.employeeName;
        data['employeeId'] = this.employeeId;
        data['hoursOvertime'] = this.hoursOvertime;
        data['overtimeDate'] = this.overtimeDate ? this.overtimeDate.toISOString() : <any>undefined;
        data['content'] = this.content;
        data['statusCde'] = this.statusCde;
        data['statusValue'] = this.statusValue;
        data['startTime'] = this.startTime;
        data['endTime'] = this.endTime;
        return data;
    }

    clone(): ClientRegisterOvertimeModel {
        const json = this.toJSON();
        let result = new ClientRegisterOvertimeModel();
        result.init(json);
        return result;
    }
}

export interface IClientRegisterOvertimeModel {
    totalRows: number;
    rowIndex: number;
    totalPages: number;
    id: number;
    employeeName: string | undefined;
    employeeId: number;
    hoursOvertime: number;
    overtimeDate: moment.Moment;
    content: string | undefined;
    statusCde: string | undefined;
    statusValue: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
}

export class ClientSalaryBasicModel implements IClientSalaryBasicModel {
    id: number;
    employeeId: number;
    employeeCode: string | undefined;
    fullName: string | undefined;
    salaryType: string | undefined;
    salaryAmount: number | undefined;
    salaryDate: moment.Moment | undefined;
    laborContractCode: string | undefined;
    laborContractName: string | undefined;
    contractNumber: string | undefined;
    dateContract: moment.Moment | undefined;
    contractFile: string | undefined;
    rowVersion: string | undefined;

    constructor(data?: IClientSalaryBasicModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.employeeCode = _data['employeeCode'];
            this.fullName = _data['fullName'];
            this.salaryType = _data['salaryType'];
            this.salaryAmount = _data['salaryAmount'];
            this.salaryDate = _data['salaryDate'] ? moment(_data['salaryDate'].toString()) : <any>undefined;
            this.laborContractCode = _data['laborContractCode'];
            this.laborContractName = _data['laborContractName'];
            this.contractNumber = _data['contractNumber'];
            this.dateContract = _data['dateContract'] ? moment(_data['dateContract'].toString()) : <any>undefined;
            this.contractFile = _data['contractFile'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): ClientSalaryBasicModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientSalaryBasicModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['employeeCode'] = this.employeeCode;
        data['fullName'] = this.fullName;
        data['salaryType'] = this.salaryType;
        data['salaryAmount'] = this.salaryAmount;
        data['salaryDate'] = this.salaryDate ? this.salaryDate.toISOString() : <any>undefined;
        data['laborContractCode'] = this.laborContractCode;
        data['laborContractName'] = this.laborContractName;
        data['contractNumber'] = this.contractNumber;
        data['dateContract'] = this.dateContract ? this.dateContract.toISOString() : <any>undefined;
        data['contractFile'] = this.contractFile;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): ClientSalaryBasicModel {
        const json = this.toJSON();
        let result = new ClientSalaryBasicModel();
        result.init(json);
        return result;
    }
}

export interface IClientSalaryBasicModel {
    id: number;
    employeeId: number;
    employeeCode: string | undefined;
    fullName: string | undefined;
    salaryType: string | undefined;
    salaryAmount: number | undefined;
    salaryDate: moment.Moment | undefined;
    laborContractCode: string | undefined;
    laborContractName: string | undefined;
    contractNumber: string | undefined;
    dateContract: moment.Moment | undefined;
    contractFile: string | undefined;
    rowVersion: string | undefined;
}

export class ClientSalaryExportDto implements IClientSalaryExportDto {
    fileName: string | undefined;
    url: string | undefined;
    password: string | undefined;
    desciption: string | undefined;

    constructor(data?: IClientSalaryExportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data['fileName'];
            this.url = _data['url'];
            this.password = _data['password'];
            this.desciption = _data['desciption'];
        }
    }

    static fromJS(data: any): ClientSalaryExportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientSalaryExportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['fileName'] = this.fileName;
        data['url'] = this.url;
        data['password'] = this.password;
        data['desciption'] = this.desciption;
        return data;
    }

    clone(): ClientSalaryExportDto {
        const json = this.toJSON();
        let result = new ClientSalaryExportDto();
        result.init(json);
        return result;
    }
}

export interface IClientSalaryExportDto {
    fileName: string | undefined;
    url: string | undefined;
    password: string | undefined;
    desciption: string | undefined;
}

export class ClientSalaryPayrollModel implements IClientSalaryPayrollModel {
    employeeId: string | undefined;
    id: string | undefined;
    code: string | undefined;
    titleName: string | undefined;
    salaryDate: string | undefined;
    statusCde: string | undefined;
    salaryType: string | undefined;
    salaryBasic: number;
    numberDayWork: string | undefined;
    childSupport: number;
    bonus: number;
    bonusOther: number;
    monthSalary13: number;
    seniority: number;
    birthdayAmount: number;
    osAllowance: number;
    infringe: number;
    infringeSalary: number;
    socialIndividual: number;
    healthIndividual: number;
    accidentIndividual: number;
    insurance: number;
    familyExemption: number;
    personalIncomeTax: number;
    advancePayment: number;
    federation: number;
    bonusTet: number;
    subsidizeAmount: number;
    subsidizedOrtherAmount: number;
    diligenceAmount: number;
    allowaceRiceAmount: number;
    annualLeave: string | undefined;
    annualLeaveAmount: number;
    otherDeductions: number;
    amountSalary: number;
    totalSalary: number;
    totalWorkInMonth: string | undefined;
    overTime150: number;
    amountOverTime150: number;
    overTime200: number;
    amountOverTime200: number;
    overTime300: number;
    amountOverTime300: number;
    holiday100: string | undefined;
    amountHoliday100: number;
    taxYourself: number;
    unpaidLeave: string | undefined;
    taxableAmount: number;

    constructor(data?: IClientSalaryPayrollModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data['employeeId'];
            this.id = _data['id'];
            this.code = _data['code'];
            this.titleName = _data['titleName'];
            this.salaryDate = _data['salaryDate'];
            this.statusCde = _data['statusCde'];
            this.salaryType = _data['salaryType'];
            this.salaryBasic = _data['salaryBasic'];
            this.numberDayWork = _data['numberDayWork'];
            this.childSupport = _data['childSupport'];
            this.bonus = _data['bonus'];
            this.bonusOther = _data['bonusOther'];
            this.monthSalary13 = _data['monthSalary13'];
            this.seniority = _data['seniority'];
            this.birthdayAmount = _data['birthdayAmount'];
            this.osAllowance = _data['osAllowance'];
            this.infringe = _data['infringe'];
            this.infringeSalary = _data['infringeSalary'];
            this.socialIndividual = _data['socialIndividual'];
            this.healthIndividual = _data['healthIndividual'];
            this.accidentIndividual = _data['accidentIndividual'];
            this.insurance = _data['insurance'];
            this.familyExemption = _data['familyExemption'];
            this.personalIncomeTax = _data['personalIncomeTax'];
            this.advancePayment = _data['advancePayment'];
            this.federation = _data['federation'];
            this.bonusTet = _data['bonusTet'];
            this.subsidizeAmount = _data['subsidizeAmount'];
            this.subsidizedOrtherAmount = _data['subsidizedOrtherAmount'];
            this.diligenceAmount = _data['diligenceAmount'];
            this.allowaceRiceAmount = _data['allowaceRiceAmount'];
            this.annualLeave = _data['annualLeave'];
            this.annualLeaveAmount = _data['annualLeaveAmount'];
            this.otherDeductions = _data['otherDeductions'];
            this.amountSalary = _data['amountSalary'];
            this.totalSalary = _data['totalSalary'];
            this.totalWorkInMonth = _data['totalWorkInMonth'];
            this.overTime150 = _data['overTime150'];
            this.amountOverTime150 = _data['amountOverTime150'];
            this.overTime200 = _data['overTime200'];
            this.amountOverTime200 = _data['amountOverTime200'];
            this.overTime300 = _data['overTime300'];
            this.amountOverTime300 = _data['amountOverTime300'];
            this.holiday100 = _data['holiday100'];
            this.amountHoliday100 = _data['amountHoliday100'];
            this.taxYourself = _data['taxYourself'];
            this.unpaidLeave = _data['unpaidLeave'];
            this.taxableAmount = _data['taxableAmount'];
        }
    }

    static fromJS(data: any): ClientSalaryPayrollModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientSalaryPayrollModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['employeeId'] = this.employeeId;
        data['id'] = this.id;
        data['code'] = this.code;
        data['titleName'] = this.titleName;
        data['salaryDate'] = this.salaryDate;
        data['statusCde'] = this.statusCde;
        data['salaryType'] = this.salaryType;
        data['salaryBasic'] = this.salaryBasic;
        data['numberDayWork'] = this.numberDayWork;
        data['childSupport'] = this.childSupport;
        data['bonus'] = this.bonus;
        data['bonusOther'] = this.bonusOther;
        data['monthSalary13'] = this.monthSalary13;
        data['seniority'] = this.seniority;
        data['birthdayAmount'] = this.birthdayAmount;
        data['osAllowance'] = this.osAllowance;
        data['infringe'] = this.infringe;
        data['infringeSalary'] = this.infringeSalary;
        data['socialIndividual'] = this.socialIndividual;
        data['healthIndividual'] = this.healthIndividual;
        data['accidentIndividual'] = this.accidentIndividual;
        data['insurance'] = this.insurance;
        data['familyExemption'] = this.familyExemption;
        data['personalIncomeTax'] = this.personalIncomeTax;
        data['advancePayment'] = this.advancePayment;
        data['federation'] = this.federation;
        data['bonusTet'] = this.bonusTet;
        data['subsidizeAmount'] = this.subsidizeAmount;
        data['subsidizedOrtherAmount'] = this.subsidizedOrtherAmount;
        data['diligenceAmount'] = this.diligenceAmount;
        data['allowaceRiceAmount'] = this.allowaceRiceAmount;
        data['annualLeave'] = this.annualLeave;
        data['annualLeaveAmount'] = this.annualLeaveAmount;
        data['otherDeductions'] = this.otherDeductions;
        data['amountSalary'] = this.amountSalary;
        data['totalSalary'] = this.totalSalary;
        data['totalWorkInMonth'] = this.totalWorkInMonth;
        data['overTime150'] = this.overTime150;
        data['amountOverTime150'] = this.amountOverTime150;
        data['overTime200'] = this.overTime200;
        data['amountOverTime200'] = this.amountOverTime200;
        data['overTime300'] = this.overTime300;
        data['amountOverTime300'] = this.amountOverTime300;
        data['holiday100'] = this.holiday100;
        data['amountHoliday100'] = this.amountHoliday100;
        data['taxYourself'] = this.taxYourself;
        data['unpaidLeave'] = this.unpaidLeave;
        data['taxableAmount'] = this.taxableAmount;
        return data;
    }

    clone(): ClientSalaryPayrollModel {
        const json = this.toJSON();
        let result = new ClientSalaryPayrollModel();
        result.init(json);
        return result;
    }
}

export interface IClientSalaryPayrollModel {
    employeeId: string | undefined;
    id: string | undefined;
    code: string | undefined;
    titleName: string | undefined;
    salaryDate: string | undefined;
    statusCde: string | undefined;
    salaryType: string | undefined;
    salaryBasic: number;
    numberDayWork: string | undefined;
    childSupport: number;
    bonus: number;
    bonusOther: number;
    monthSalary13: number;
    seniority: number;
    birthdayAmount: number;
    osAllowance: number;
    infringe: number;
    infringeSalary: number;
    socialIndividual: number;
    healthIndividual: number;
    accidentIndividual: number;
    insurance: number;
    familyExemption: number;
    personalIncomeTax: number;
    advancePayment: number;
    federation: number;
    bonusTet: number;
    subsidizeAmount: number;
    subsidizedOrtherAmount: number;
    diligenceAmount: number;
    allowaceRiceAmount: number;
    annualLeave: string | undefined;
    annualLeaveAmount: number;
    otherDeductions: number;
    amountSalary: number;
    totalSalary: number;
    totalWorkInMonth: string | undefined;
    overTime150: number;
    amountOverTime150: number;
    overTime200: number;
    amountOverTime200: number;
    overTime300: number;
    amountOverTime300: number;
    holiday100: string | undefined;
    amountHoliday100: number;
    taxYourself: number;
    unpaidLeave: string | undefined;
    taxableAmount: number;
}

export class ClientTrackingLeaveModel implements IClientTrackingLeaveModel {
    totalRows: number;
    rowIndex: number;
    totalPages: number;
    id: number;
    employeeId: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    annualLeaveType: string | undefined;
    annualLeaveValue: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    statusCde: string | undefined;
    statusValue: string | undefined;
    cssStatusCde: string | undefined;
    content: string | undefined;
    hoursLeft: number;
    rowVersion: string | undefined;

    constructor(data?: IClientTrackingLeaveModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data['totalRows'];
            this.rowIndex = _data['rowIndex'];
            this.totalPages = _data['totalPages'];
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.employeeCode = _data['employeeCode'];
            this.employeeName = _data['employeeName'];
            this.annualLeaveType = _data['annualLeaveType'];
            this.annualLeaveValue = _data['annualLeaveValue'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.statusCde = _data['statusCde'];
            this.statusValue = _data['statusValue'];
            this.cssStatusCde = _data['cssStatusCde'];
            this.content = _data['content'];
            this.hoursLeft = _data['hoursLeft'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): ClientTrackingLeaveModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientTrackingLeaveModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalRows'] = this.totalRows;
        data['rowIndex'] = this.rowIndex;
        data['totalPages'] = this.totalPages;
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['employeeCode'] = this.employeeCode;
        data['employeeName'] = this.employeeName;
        data['annualLeaveType'] = this.annualLeaveType;
        data['annualLeaveValue'] = this.annualLeaveValue;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['statusCde'] = this.statusCde;
        data['statusValue'] = this.statusValue;
        data['cssStatusCde'] = this.cssStatusCde;
        data['content'] = this.content;
        data['hoursLeft'] = this.hoursLeft;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): ClientTrackingLeaveModel {
        const json = this.toJSON();
        let result = new ClientTrackingLeaveModel();
        result.init(json);
        return result;
    }
}

export interface IClientTrackingLeaveModel {
    totalRows: number;
    rowIndex: number;
    totalPages: number;
    id: number;
    employeeId: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    annualLeaveType: string | undefined;
    annualLeaveValue: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    statusCde: string | undefined;
    statusValue: string | undefined;
    cssStatusCde: string | undefined;
    content: string | undefined;
    hoursLeft: number;
    rowVersion: string | undefined;
}

export class ClientUpdateRegisterOvertimeDto implements IClientUpdateRegisterOvertimeDto {
    id: number;
    overtimeDate: moment.Moment;
    hoursOvertime: number;
    startTime: string | undefined;
    endTime: string | undefined;
    content: string | undefined;
    statusCde: string | undefined;
    rowVersion: string | undefined;
    cancelReason: string | undefined;

    constructor(data?: IClientUpdateRegisterOvertimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.overtimeDate = _data['overtimeDate'] ? moment(_data['overtimeDate'].toString()) : <any>undefined;
            this.hoursOvertime = _data['hoursOvertime'];
            this.startTime = _data['startTime'];
            this.endTime = _data['endTime'];
            this.content = _data['content'];
            this.statusCde = _data['statusCde'];
            this.rowVersion = _data['rowVersion'];
            this.cancelReason = _data['cancelReason'];
        }
    }

    static fromJS(data: any): ClientUpdateRegisterOvertimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUpdateRegisterOvertimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['overtimeDate'] = this.overtimeDate ? this.overtimeDate.toISOString() : <any>undefined;
        data['hoursOvertime'] = this.hoursOvertime;
        data['startTime'] = this.startTime;
        data['endTime'] = this.endTime;
        data['content'] = this.content;
        data['statusCde'] = this.statusCde;
        data['rowVersion'] = this.rowVersion;
        data['cancelReason'] = this.cancelReason;
        return data;
    }

    clone(): ClientUpdateRegisterOvertimeDto {
        const json = this.toJSON();
        let result = new ClientUpdateRegisterOvertimeDto();
        result.init(json);
        return result;
    }
}

export interface IClientUpdateRegisterOvertimeDto {
    id: number;
    overtimeDate: moment.Moment;
    hoursOvertime: number;
    startTime: string | undefined;
    endTime: string | undefined;
    content: string | undefined;
    statusCde: string | undefined;
    rowVersion: string | undefined;
    cancelReason: string | undefined;
}

export class ClientWorkingProcessModel implements IClientWorkingProcessModel {
    id: number;
    employeeId: number;
    fullName: string | undefined;
    partner: string | undefined;
    partnerAddress: string | undefined;
    partnerPhone: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment | undefined;
    description: string | undefined;
    rowVersion: string | undefined;

    constructor(data?: IClientWorkingProcessModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.fullName = _data['fullName'];
            this.partner = _data['partner'];
            this.partnerAddress = _data['partnerAddress'];
            this.partnerPhone = _data['partnerPhone'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.description = _data['description'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): ClientWorkingProcessModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientWorkingProcessModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['fullName'] = this.fullName;
        data['partner'] = this.partner;
        data['partnerAddress'] = this.partnerAddress;
        data['partnerPhone'] = this.partnerPhone;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['description'] = this.description;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): ClientWorkingProcessModel {
        const json = this.toJSON();
        let result = new ClientWorkingProcessModel();
        result.init(json);
        return result;
    }
}

export interface IClientWorkingProcessModel {
    id: number;
    employeeId: number;
    fullName: string | undefined;
    partner: string | undefined;
    partnerAddress: string | undefined;
    partnerPhone: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment | undefined;
    description: string | undefined;
    rowVersion: string | undefined;
}

export class ContractDto implements IContractDto {
    id: number;
    contractNo: string | undefined;
    contractNoOld: string | undefined;
    company: string | undefined;
    representative: string | undefined;
    amount: number | undefined;
    onePayment: number | undefined;
    twoPayment: number | undefined;
    threePayment: number | undefined;
    remainingAmount: number;
    address: string | undefined;
    phone: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    description: string | undefined;
    fileAttach: string | undefined;
    rowVersion: string | undefined;
    isDeleted: boolean;
    createBy: string | undefined;
    createDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    cssStatusCde: string | undefined;
    statusName: string | undefined;
    statusCde: string | undefined;

    constructor(data?: IContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.contractNo = _data['contractNo'];
            this.contractNoOld = _data['contractNoOld'];
            this.company = _data['company'];
            this.representative = _data['representative'];
            this.amount = _data['amount'];
            this.onePayment = _data['onePayment'];
            this.twoPayment = _data['twoPayment'];
            this.threePayment = _data['threePayment'];
            this.remainingAmount = _data['remainingAmount'];
            this.address = _data['address'];
            this.phone = _data['phone'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.description = _data['description'];
            this.fileAttach = _data['fileAttach'];
            this.rowVersion = _data['rowVersion'];
            this.isDeleted = _data['isDeleted'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
            this.cssStatusCde = _data['cssStatusCde'];
            this.statusName = _data['statusName'];
            this.statusCde = _data['statusCde'];
        }
    }

    static fromJS(data: any): ContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['contractNo'] = this.contractNo;
        data['contractNoOld'] = this.contractNoOld;
        data['company'] = this.company;
        data['representative'] = this.representative;
        data['amount'] = this.amount;
        data['onePayment'] = this.onePayment;
        data['twoPayment'] = this.twoPayment;
        data['threePayment'] = this.threePayment;
        data['remainingAmount'] = this.remainingAmount;
        data['address'] = this.address;
        data['phone'] = this.phone;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['description'] = this.description;
        data['fileAttach'] = this.fileAttach;
        data['rowVersion'] = this.rowVersion;
        data['isDeleted'] = this.isDeleted;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data['cssStatusCde'] = this.cssStatusCde;
        data['statusName'] = this.statusName;
        data['statusCde'] = this.statusCde;
        return data;
    }

    clone(): ContractDto {
        const json = this.toJSON();
        let result = new ContractDto();
        result.init(json);
        return result;
    }
}

export interface IContractDto {
    id: number;
    contractNo: string | undefined;
    contractNoOld: string | undefined;
    company: string | undefined;
    representative: string | undefined;
    amount: number | undefined;
    onePayment: number | undefined;
    twoPayment: number | undefined;
    threePayment: number | undefined;
    remainingAmount: number;
    address: string | undefined;
    phone: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    description: string | undefined;
    fileAttach: string | undefined;
    rowVersion: string | undefined;
    isDeleted: boolean;
    createBy: string | undefined;
    createDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    cssStatusCde: string | undefined;
    statusName: string | undefined;
    statusCde: string | undefined;
}

export class CreateAttendanceDto implements ICreateAttendanceDto {
    monthAttendance: moment.Moment | undefined;
    titleName: string | undefined;
    tenantId: number;
    statusCde: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    createBy: string | undefined;

    constructor(data?: ICreateAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthAttendance = _data['monthAttendance'] ? moment(_data['monthAttendance'].toString()) : <any>undefined;
            this.titleName = _data['titleName'];
            this.tenantId = _data['tenantId'];
            this.statusCde = _data['statusCde'];
            this.wfDataCde = _data['wfDataCde'];
            this.cancelReason = _data['cancelReason'];
            this.createBy = _data['createBy'];
        }
    }

    static fromJS(data: any): CreateAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['monthAttendance'] = this.monthAttendance ? this.monthAttendance.toISOString() : <any>undefined;
        data['titleName'] = this.titleName;
        data['tenantId'] = this.tenantId;
        data['statusCde'] = this.statusCde;
        data['wfDataCde'] = this.wfDataCde;
        data['cancelReason'] = this.cancelReason;
        data['createBy'] = this.createBy;
        return data;
    }

    clone(): CreateAttendanceDto {
        const json = this.toJSON();
        let result = new CreateAttendanceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAttendanceDto {
    monthAttendance: moment.Moment | undefined;
    titleName: string | undefined;
    tenantId: number;
    statusCde: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    createBy: string | undefined;
}

export class CreateBonusDto implements ICreateBonusDto {
    bonusType: string | undefined;
    bonusCode: string | undefined;
    totalAmounts: number;
    dateApply: moment.Moment | undefined;
    description: string | undefined;
    isPlusTotalize: boolean;
    title: string | undefined;
    tenantId: number;
    statusCde: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    createBy: string | undefined;
    lstBonusDetail: BonusDetailModel[] | undefined;

    constructor(data?: ICreateBonusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bonusType = _data['bonusType'];
            this.bonusCode = _data['bonusCode'];
            this.totalAmounts = _data['totalAmounts'];
            this.dateApply = _data['dateApply'] ? moment(_data['dateApply'].toString()) : <any>undefined;
            this.description = _data['description'];
            this.isPlusTotalize = _data['isPlusTotalize'];
            this.title = _data['title'];
            this.tenantId = _data['tenantId'];
            this.statusCde = _data['statusCde'];
            this.wfDataCde = _data['wfDataCde'];
            this.cancelReason = _data['cancelReason'];
            this.createBy = _data['createBy'];
            if (Array.isArray(_data['lstBonusDetail'])) {
                this.lstBonusDetail = [] as any;
                for (let item of _data['lstBonusDetail']) this.lstBonusDetail.push(BonusDetailModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateBonusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBonusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['bonusType'] = this.bonusType;
        data['bonusCode'] = this.bonusCode;
        data['totalAmounts'] = this.totalAmounts;
        data['dateApply'] = this.dateApply ? this.dateApply.toISOString() : <any>undefined;
        data['description'] = this.description;
        data['isPlusTotalize'] = this.isPlusTotalize;
        data['title'] = this.title;
        data['tenantId'] = this.tenantId;
        data['statusCde'] = this.statusCde;
        data['wfDataCde'] = this.wfDataCde;
        data['cancelReason'] = this.cancelReason;
        data['createBy'] = this.createBy;
        if (Array.isArray(this.lstBonusDetail)) {
            data['lstBonusDetail'] = [];
            for (let item of this.lstBonusDetail) data['lstBonusDetail'].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateBonusDto {
        const json = this.toJSON();
        let result = new CreateBonusDto();
        result.init(json);
        return result;
    }
}

export interface ICreateBonusDto {
    bonusType: string | undefined;
    bonusCode: string | undefined;
    totalAmounts: number;
    dateApply: moment.Moment | undefined;
    description: string | undefined;
    isPlusTotalize: boolean;
    title: string | undefined;
    tenantId: number;
    statusCde: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    createBy: string | undefined;
    lstBonusDetail: BonusDetailModel[] | undefined;
}

export class CreateContractDto implements ICreateContractDto {
    contractNo: string | undefined;
    company: string | undefined;
    representative: string | undefined;
    amount: number | undefined;
    onePayment: number | undefined;
    twoPayment: number | undefined;
    threePayment: number | undefined;
    remainingAmount: number | undefined;
    address: string | undefined;
    phone: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    description: string | undefined;
    fileAttach: string | undefined;
    createBy: string | undefined;
    statusCde: string | undefined;

    constructor(data?: ICreateContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractNo = _data['contractNo'];
            this.company = _data['company'];
            this.representative = _data['representative'];
            this.amount = _data['amount'];
            this.onePayment = _data['onePayment'];
            this.twoPayment = _data['twoPayment'];
            this.threePayment = _data['threePayment'];
            this.remainingAmount = _data['remainingAmount'];
            this.address = _data['address'];
            this.phone = _data['phone'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.description = _data['description'];
            this.fileAttach = _data['fileAttach'];
            this.createBy = _data['createBy'];
            this.statusCde = _data['statusCde'];
        }
    }

    static fromJS(data: any): CreateContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['contractNo'] = this.contractNo;
        data['company'] = this.company;
        data['representative'] = this.representative;
        data['amount'] = this.amount;
        data['onePayment'] = this.onePayment;
        data['twoPayment'] = this.twoPayment;
        data['threePayment'] = this.threePayment;
        data['remainingAmount'] = this.remainingAmount;
        data['address'] = this.address;
        data['phone'] = this.phone;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['description'] = this.description;
        data['fileAttach'] = this.fileAttach;
        data['createBy'] = this.createBy;
        data['statusCde'] = this.statusCde;
        return data;
    }

    clone(): CreateContractDto {
        const json = this.toJSON();
        let result = new CreateContractDto();
        result.init(json);
        return result;
    }
}

export interface ICreateContractDto {
    contractNo: string | undefined;
    company: string | undefined;
    representative: string | undefined;
    amount: number | undefined;
    onePayment: number | undefined;
    twoPayment: number | undefined;
    threePayment: number | undefined;
    remainingAmount: number | undefined;
    address: string | undefined;
    phone: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    description: string | undefined;
    fileAttach: string | undefined;
    createBy: string | undefined;
    statusCde: string | undefined;
}

export class CreateEmployeeDto implements ICreateEmployeeDto {
    employeeCode: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    sex: string | undefined;
    email: string | undefined;
    managerId: number;
    birthDay: moment.Moment | undefined;
    identityCard: string | undefined;
    identityCardDate: moment.Moment | undefined;
    identityCardPlace: string | undefined;
    nationalityCode: string | undefined;
    dateOfWork: moment.Moment | undefined;
    dateOfEntry: moment.Moment | undefined;
    isFederation: boolean;
    departmentCode: string | undefined;
    jobCode: string | undefined;
    familyExemptionNumber: number | undefined;
    familyExemptionDate: moment.Moment | undefined;
    taxYourself: string | undefined;
    religiousCode: string | undefined;
    educatedCode: string | undefined;
    maritalStatus: string | undefined;
    isInactivity: boolean;
    bankAccount: string | undefined;
    bankCode: string | undefined;
    permanentAddress: string | undefined;
    temporaryAddress: string | undefined;
    phoneNumber: string | undefined;
    image: string | undefined;
    insuranceNumber: string | undefined;
    inactivityDate: moment.Moment | undefined;
    createBy: string | undefined;
    identityCard2: string | undefined;
    identityCardDate2: moment.Moment | undefined;
    identityCardPlace2: string | undefined;

    constructor(data?: ICreateEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeCode = _data['employeeCode'];
            this.firstName = _data['firstName'];
            this.lastName = _data['lastName'];
            this.sex = _data['sex'];
            this.email = _data['email'];
            this.managerId = _data['managerId'];
            this.birthDay = _data['birthDay'] ? moment(_data['birthDay'].toString()) : <any>undefined;
            this.identityCard = _data['identityCard'];
            this.identityCardDate = _data['identityCardDate'] ? moment(_data['identityCardDate'].toString()) : <any>undefined;
            this.identityCardPlace = _data['identityCardPlace'];
            this.nationalityCode = _data['nationalityCode'];
            this.dateOfWork = _data['dateOfWork'] ? moment(_data['dateOfWork'].toString()) : <any>undefined;
            this.dateOfEntry = _data['dateOfEntry'] ? moment(_data['dateOfEntry'].toString()) : <any>undefined;
            this.isFederation = _data['isFederation'];
            this.departmentCode = _data['departmentCode'];
            this.jobCode = _data['jobCode'];
            this.familyExemptionNumber = _data['familyExemptionNumber'];
            this.familyExemptionDate = _data['familyExemptionDate'] ? moment(_data['familyExemptionDate'].toString()) : <any>undefined;
            this.taxYourself = _data['taxYourself'];
            this.religiousCode = _data['religiousCode'];
            this.educatedCode = _data['educatedCode'];
            this.maritalStatus = _data['maritalStatus'];
            this.isInactivity = _data['isInactivity'];
            this.bankAccount = _data['bankAccount'];
            this.bankCode = _data['bankCode'];
            this.permanentAddress = _data['permanentAddress'];
            this.temporaryAddress = _data['temporaryAddress'];
            this.phoneNumber = _data['phoneNumber'];
            this.image = _data['image'];
            this.insuranceNumber = _data['insuranceNumber'];
            this.inactivityDate = _data['inactivityDate'] ? moment(_data['inactivityDate'].toString()) : <any>undefined;
            this.createBy = _data['createBy'];
            this.identityCard2 = _data['identityCard2'];
            this.identityCardDate2 = _data['identityCardDate2'] ? moment(_data['identityCardDate2'].toString()) : <any>undefined;
            this.identityCardPlace2 = _data['identityCardPlace2'];
        }
    }

    static fromJS(data: any): CreateEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['employeeCode'] = this.employeeCode;
        data['firstName'] = this.firstName;
        data['lastName'] = this.lastName;
        data['sex'] = this.sex;
        data['email'] = this.email;
        data['managerId'] = this.managerId;
        data['birthDay'] = this.birthDay ? this.birthDay.toISOString() : <any>undefined;
        data['identityCard'] = this.identityCard;
        data['identityCardDate'] = this.identityCardDate ? this.identityCardDate.toISOString() : <any>undefined;
        data['identityCardPlace'] = this.identityCardPlace;
        data['nationalityCode'] = this.nationalityCode;
        data['dateOfWork'] = this.dateOfWork ? this.dateOfWork.toISOString() : <any>undefined;
        data['dateOfEntry'] = this.dateOfEntry ? this.dateOfEntry.toISOString() : <any>undefined;
        data['isFederation'] = this.isFederation;
        data['departmentCode'] = this.departmentCode;
        data['jobCode'] = this.jobCode;
        data['familyExemptionNumber'] = this.familyExemptionNumber;
        data['familyExemptionDate'] = this.familyExemptionDate ? this.familyExemptionDate.toISOString() : <any>undefined;
        data['taxYourself'] = this.taxYourself;
        data['religiousCode'] = this.religiousCode;
        data['educatedCode'] = this.educatedCode;
        data['maritalStatus'] = this.maritalStatus;
        data['isInactivity'] = this.isInactivity;
        data['bankAccount'] = this.bankAccount;
        data['bankCode'] = this.bankCode;
        data['permanentAddress'] = this.permanentAddress;
        data['temporaryAddress'] = this.temporaryAddress;
        data['phoneNumber'] = this.phoneNumber;
        data['image'] = this.image;
        data['insuranceNumber'] = this.insuranceNumber;
        data['inactivityDate'] = this.inactivityDate ? this.inactivityDate.toISOString() : <any>undefined;
        data['createBy'] = this.createBy;
        data['identityCard2'] = this.identityCard2;
        data['identityCardDate2'] = this.identityCardDate2 ? this.identityCardDate2.toISOString() : <any>undefined;
        data['identityCardPlace2'] = this.identityCardPlace2;
        return data;
    }

    clone(): CreateEmployeeDto {
        const json = this.toJSON();
        let result = new CreateEmployeeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateEmployeeDto {
    employeeCode: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    sex: string | undefined;
    email: string | undefined;
    managerId: number;
    birthDay: moment.Moment | undefined;
    identityCard: string | undefined;
    identityCardDate: moment.Moment | undefined;
    identityCardPlace: string | undefined;
    nationalityCode: string | undefined;
    dateOfWork: moment.Moment | undefined;
    dateOfEntry: moment.Moment | undefined;
    isFederation: boolean;
    departmentCode: string | undefined;
    jobCode: string | undefined;
    familyExemptionNumber: number | undefined;
    familyExemptionDate: moment.Moment | undefined;
    taxYourself: string | undefined;
    religiousCode: string | undefined;
    educatedCode: string | undefined;
    maritalStatus: string | undefined;
    isInactivity: boolean;
    bankAccount: string | undefined;
    bankCode: string | undefined;
    permanentAddress: string | undefined;
    temporaryAddress: string | undefined;
    phoneNumber: string | undefined;
    image: string | undefined;
    insuranceNumber: string | undefined;
    inactivityDate: moment.Moment | undefined;
    createBy: string | undefined;
    identityCard2: string | undefined;
    identityCardDate2: moment.Moment | undefined;
    identityCardPlace2: string | undefined;
}

export class CreateEvaluationPeriodDto implements ICreateEvaluationPeriodDto {
    name: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    statusCde: string | undefined;
    evaluationTemplate: EvaluationTemplateModel;
    evaluationQuestion: EvaluationQuestionModel[] | undefined;
    evaluationAnswer: EvaluationAnswerModel[] | undefined;

    constructor(data?: ICreateEvaluationPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.statusCde = _data['statusCde'];
            this.evaluationTemplate = _data['evaluationTemplate'] ? EvaluationTemplateModel.fromJS(_data['evaluationTemplate']) : <any>undefined;
            if (Array.isArray(_data['evaluationQuestion'])) {
                this.evaluationQuestion = [] as any;
                for (let item of _data['evaluationQuestion']) this.evaluationQuestion.push(EvaluationQuestionModel.fromJS(item));
            }
            if (Array.isArray(_data['evaluationAnswer'])) {
                this.evaluationAnswer = [] as any;
                for (let item of _data['evaluationAnswer']) this.evaluationAnswer.push(EvaluationAnswerModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateEvaluationPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEvaluationPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['statusCde'] = this.statusCde;
        data['evaluationTemplate'] = this.evaluationTemplate ? this.evaluationTemplate.toJSON() : <any>undefined;
        if (Array.isArray(this.evaluationQuestion)) {
            data['evaluationQuestion'] = [];
            for (let item of this.evaluationQuestion) data['evaluationQuestion'].push(item.toJSON());
        }
        if (Array.isArray(this.evaluationAnswer)) {
            data['evaluationAnswer'] = [];
            for (let item of this.evaluationAnswer) data['evaluationAnswer'].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateEvaluationPeriodDto {
        const json = this.toJSON();
        let result = new CreateEvaluationPeriodDto();
        result.init(json);
        return result;
    }
}

export interface ICreateEvaluationPeriodDto {
    name: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    statusCde: string | undefined;
    evaluationTemplate: EvaluationTemplateModel;
    evaluationQuestion: EvaluationQuestionModel[] | undefined;
    evaluationAnswer: EvaluationAnswerModel[] | undefined;
}

export class CreateEvaluationResultDto implements ICreateEvaluationResultDto {
    periodId: number;
    templateId: number;
    employees: DropDownEmployeeModel[] | undefined;

    constructor(data?: ICreateEvaluationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.periodId = _data['periodId'];
            this.templateId = _data['templateId'];
            if (Array.isArray(_data['employees'])) {
                this.employees = [] as any;
                for (let item of _data['employees']) this.employees.push(DropDownEmployeeModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateEvaluationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEvaluationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['periodId'] = this.periodId;
        data['templateId'] = this.templateId;
        if (Array.isArray(this.employees)) {
            data['employees'] = [];
            for (let item of this.employees) data['employees'].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateEvaluationResultDto {
        const json = this.toJSON();
        let result = new CreateEvaluationResultDto();
        result.init(json);
        return result;
    }
}

export interface ICreateEvaluationResultDto {
    periodId: number;
    templateId: number;
    employees: DropDownEmployeeModel[] | undefined;
}

export class CreateFamilyExemptionDto implements ICreateFamilyExemptionDto {
    id: number;
    employeeId: number;
    familyExemptionCode: string | undefined;
    familyExemptionName: string | undefined;
    rowVersion: string | undefined;
    familyExemptionNumber: number;
    familyExemptionDate: moment.Moment | undefined;
    empRowVersion: string | undefined;
    createBy: string | undefined;
    tenantId: number;

    constructor(data?: ICreateFamilyExemptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.familyExemptionCode = _data['familyExemptionCode'];
            this.familyExemptionName = _data['familyExemptionName'];
            this.rowVersion = _data['rowVersion'];
            this.familyExemptionNumber = _data['familyExemptionNumber'];
            this.familyExemptionDate = _data['familyExemptionDate'] ? moment(_data['familyExemptionDate'].toString()) : <any>undefined;
            this.empRowVersion = _data['empRowVersion'];
            this.createBy = _data['createBy'];
            this.tenantId = _data['tenantId'];
        }
    }

    static fromJS(data: any): CreateFamilyExemptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFamilyExemptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['familyExemptionCode'] = this.familyExemptionCode;
        data['familyExemptionName'] = this.familyExemptionName;
        data['rowVersion'] = this.rowVersion;
        data['familyExemptionNumber'] = this.familyExemptionNumber;
        data['familyExemptionDate'] = this.familyExemptionDate ? this.familyExemptionDate.toISOString() : <any>undefined;
        data['empRowVersion'] = this.empRowVersion;
        data['createBy'] = this.createBy;
        data['tenantId'] = this.tenantId;
        return data;
    }

    clone(): CreateFamilyExemptionDto {
        const json = this.toJSON();
        let result = new CreateFamilyExemptionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateFamilyExemptionDto {
    id: number;
    employeeId: number;
    familyExemptionCode: string | undefined;
    familyExemptionName: string | undefined;
    rowVersion: string | undefined;
    familyExemptionNumber: number;
    familyExemptionDate: moment.Moment | undefined;
    empRowVersion: string | undefined;
    createBy: string | undefined;
    tenantId: number;
}

export class CreateHolidayDto implements ICreateHolidayDto {
    id: number;
    holidayName: string | undefined;
    effectiveFromDate: moment.Moment;
    effectiveToDate: moment.Moment;
    numberHoliday: number;
    statusCde: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    description: string | undefined;
    tenantId: number;
    createBy: string | undefined;
    makeUpDays: moment.Moment[] | undefined;

    constructor(data?: ICreateHolidayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.holidayName = _data['holidayName'];
            this.effectiveFromDate = _data['effectiveFromDate'] ? moment(_data['effectiveFromDate'].toString()) : <any>undefined;
            this.effectiveToDate = _data['effectiveToDate'] ? moment(_data['effectiveToDate'].toString()) : <any>undefined;
            this.numberHoliday = _data['numberHoliday'];
            this.statusCde = _data['statusCde'];
            this.wfDataCde = _data['wfDataCde'];
            this.cancelReason = _data['cancelReason'];
            this.description = _data['description'];
            this.tenantId = _data['tenantId'];
            this.createBy = _data['createBy'];
            if (Array.isArray(_data['makeUpDays'])) {
                this.makeUpDays = [] as any;
                for (let item of _data['makeUpDays']) this.makeUpDays.push(moment(item));
            }
        }
    }

    static fromJS(data: any): CreateHolidayDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHolidayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['holidayName'] = this.holidayName;
        data['effectiveFromDate'] = this.effectiveFromDate ? this.effectiveFromDate.toISOString() : <any>undefined;
        data['effectiveToDate'] = this.effectiveToDate ? this.effectiveToDate.toISOString() : <any>undefined;
        data['numberHoliday'] = this.numberHoliday;
        data['statusCde'] = this.statusCde;
        data['wfDataCde'] = this.wfDataCde;
        data['cancelReason'] = this.cancelReason;
        data['description'] = this.description;
        data['tenantId'] = this.tenantId;
        data['createBy'] = this.createBy;
        if (Array.isArray(this.makeUpDays)) {
            data['makeUpDays'] = [];
            for (let item of this.makeUpDays) data['makeUpDays'].push(item.toISOString());
        }
        return data;
    }

    clone(): CreateHolidayDto {
        const json = this.toJSON();
        let result = new CreateHolidayDto();
        result.init(json);
        return result;
    }
}

export interface ICreateHolidayDto {
    id: number;
    holidayName: string | undefined;
    effectiveFromDate: moment.Moment;
    effectiveToDate: moment.Moment;
    numberHoliday: number;
    statusCde: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    description: string | undefined;
    tenantId: number;
    createBy: string | undefined;
    makeUpDays: moment.Moment[] | undefined;
}

export class CreateInsuranceDto implements ICreateInsuranceDto {
    employeeId: number;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    hospitalCode: string | undefined;
    amount: number;
    social: number;
    health: number;
    accident: number;
    socialIndividual: number;
    healthIndividual: number;
    accidentIndividual: number;
    createBy: string | undefined;

    constructor(data?: ICreateInsuranceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data['employeeId'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.hospitalCode = _data['hospitalCode'];
            this.amount = _data['amount'];
            this.social = _data['social'];
            this.health = _data['health'];
            this.accident = _data['accident'];
            this.socialIndividual = _data['socialIndividual'];
            this.healthIndividual = _data['healthIndividual'];
            this.accidentIndividual = _data['accidentIndividual'];
            this.createBy = _data['createBy'];
        }
    }

    static fromJS(data: any): CreateInsuranceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInsuranceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['employeeId'] = this.employeeId;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['hospitalCode'] = this.hospitalCode;
        data['amount'] = this.amount;
        data['social'] = this.social;
        data['health'] = this.health;
        data['accident'] = this.accident;
        data['socialIndividual'] = this.socialIndividual;
        data['healthIndividual'] = this.healthIndividual;
        data['accidentIndividual'] = this.accidentIndividual;
        data['createBy'] = this.createBy;
        return data;
    }

    clone(): CreateInsuranceDto {
        const json = this.toJSON();
        let result = new CreateInsuranceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateInsuranceDto {
    employeeId: number;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    hospitalCode: string | undefined;
    amount: number;
    social: number;
    health: number;
    accident: number;
    socialIndividual: number;
    healthIndividual: number;
    accidentIndividual: number;
    createBy: string | undefined;
}

export class CreateLanguageTextsDto implements ICreateLanguageTextsDto {
    key: string | undefined;
    languageName: string | undefined;
    value: string | undefined;

    constructor(data?: ICreateLanguageTextsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data['key'];
            this.languageName = _data['languageName'];
            this.value = _data['value'];
        }
    }

    static fromJS(data: any): CreateLanguageTextsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLanguageTextsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['key'] = this.key;
        data['languageName'] = this.languageName;
        data['value'] = this.value;
        return data;
    }

    clone(): CreateLanguageTextsDto {
        const json = this.toJSON();
        let result = new CreateLanguageTextsDto();
        result.init(json);
        return result;
    }
}

export interface ICreateLanguageTextsDto {
    key: string | undefined;
    languageName: string | undefined;
    value: string | undefined;
}

export class CreateListNotificationDto implements ICreateListNotificationDto {
    title: string | undefined;
    body: string | undefined;
    content: string | undefined;
    notificationType: string | undefined;
    createdBy: string | undefined;
    isActive: boolean;

    constructor(data?: ICreateListNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data['title'];
            this.body = _data['body'];
            this.content = _data['content'];
            this.notificationType = _data['notificationType'];
            this.createdBy = _data['createdBy'];
            this.isActive = _data['isActive'];
        }
    }

    static fromJS(data: any): CreateListNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateListNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['title'] = this.title;
        data['body'] = this.body;
        data['content'] = this.content;
        data['notificationType'] = this.notificationType;
        data['createdBy'] = this.createdBy;
        data['isActive'] = this.isActive;
        return data;
    }

    clone(): CreateListNotificationDto {
        const json = this.toJSON();
        let result = new CreateListNotificationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateListNotificationDto {
    title: string | undefined;
    body: string | undefined;
    content: string | undefined;
    notificationType: string | undefined;
    createdBy: string | undefined;
    isActive: boolean;
}

export class CreateRECRequestDto implements ICreateRECRequestDto {
    departmentCode: string | undefined;
    position: string | undefined;
    quantity: number;
    reason: string | undefined;
    statusCode: string | undefined;

    constructor(data?: ICreateRECRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentCode = _data['departmentCode'];
            this.position = _data['position'];
            this.quantity = _data['quantity'];
            this.reason = _data['reason'];
            this.statusCode = _data['statusCode'];
        }
    }

    static fromJS(data: any): CreateRECRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRECRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['departmentCode'] = this.departmentCode;
        data['position'] = this.position;
        data['quantity'] = this.quantity;
        data['reason'] = this.reason;
        data['statusCode'] = this.statusCode;
        return data;
    }

    clone(): CreateRECRequestDto {
        const json = this.toJSON();
        let result = new CreateRECRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRECRequestDto {
    departmentCode: string | undefined;
    position: string | undefined;
    quantity: number;
    reason: string | undefined;
    statusCode: string | undefined;
}

export class CreateRecruitmentCandidatesDto implements ICreateRecruitmentCandidatesDto {
    fullName: string | undefined;
    birthday: moment.Moment | undefined;
    sex: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    address: string | undefined;
    expertise: string | undefined;
    expectedSalary: number | undefined;
    offeredSalary: number | undefined;
    interviewDateTime: moment.Moment | undefined;
    availableStartDate: moment.Moment | undefined;
    cvType: string | undefined;
    cvFilePath: string | undefined;
    cvExternalLink: string | undefined;
    statusCde: string | undefined;
    note: string | undefined;

    constructor(data?: ICreateRecruitmentCandidatesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data['fullName'];
            this.birthday = _data['birthday'] ? moment(_data['birthday'].toString()) : <any>undefined;
            this.sex = _data['sex'];
            this.phoneNumber = _data['phoneNumber'];
            this.email = _data['email'];
            this.address = _data['address'];
            this.expertise = _data['expertise'];
            this.expectedSalary = _data['expectedSalary'];
            this.offeredSalary = _data['offeredSalary'];
            this.interviewDateTime = _data['interviewDateTime'] ? moment(_data['interviewDateTime'].toString()) : <any>undefined;
            this.availableStartDate = _data['availableStartDate'] ? moment(_data['availableStartDate'].toString()) : <any>undefined;
            this.cvType = _data['cvType'];
            this.cvFilePath = _data['cvFilePath'];
            this.cvExternalLink = _data['cvExternalLink'];
            this.statusCde = _data['statusCde'];
            this.note = _data['note'];
        }
    }

    static fromJS(data: any): CreateRecruitmentCandidatesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRecruitmentCandidatesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['fullName'] = this.fullName;
        data['birthday'] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data['sex'] = this.sex;
        data['phoneNumber'] = this.phoneNumber;
        data['email'] = this.email;
        data['address'] = this.address;
        data['expertise'] = this.expertise;
        data['expectedSalary'] = this.expectedSalary;
        data['offeredSalary'] = this.offeredSalary;
        data['interviewDateTime'] = this.interviewDateTime ? this.interviewDateTime.toISOString() : <any>undefined;
        data['availableStartDate'] = this.availableStartDate ? this.availableStartDate.toISOString() : <any>undefined;
        data['cvType'] = this.cvType;
        data['cvFilePath'] = this.cvFilePath;
        data['cvExternalLink'] = this.cvExternalLink;
        data['statusCde'] = this.statusCde;
        data['note'] = this.note;
        return data;
    }

    clone(): CreateRecruitmentCandidatesDto {
        const json = this.toJSON();
        let result = new CreateRecruitmentCandidatesDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRecruitmentCandidatesDto {
    fullName: string | undefined;
    birthday: moment.Moment | undefined;
    sex: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    address: string | undefined;
    expertise: string | undefined;
    expectedSalary: number | undefined;
    offeredSalary: number | undefined;
    interviewDateTime: moment.Moment | undefined;
    availableStartDate: moment.Moment | undefined;
    cvType: string | undefined;
    cvFilePath: string | undefined;
    cvExternalLink: string | undefined;
    statusCde: string | undefined;
    note: string | undefined;
}

export class CreateRecruitmentDto implements ICreateRecruitmentDto {
    fullName: string | undefined;
    birthday: moment.Moment | undefined;
    sex: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    address: string | undefined;
    expertise: string | undefined;
    expectedSalary: number | undefined;
    offeredSalary: number | undefined;
    interviewDateTime: moment.Moment | undefined;
    availableStartDate: moment.Moment | undefined;
    cvType: string | undefined;
    cvFilePath: string | undefined;
    cvExternalLink: string | undefined;
    statusCde: string | undefined;
    note: string | undefined;

    constructor(data?: ICreateRecruitmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data['fullName'];
            this.birthday = _data['birthday'] ? moment(_data['birthday'].toString()) : <any>undefined;
            this.sex = _data['sex'];
            this.phoneNumber = _data['phoneNumber'];
            this.email = _data['email'];
            this.address = _data['address'];
            this.expertise = _data['expertise'];
            this.expectedSalary = _data['expectedSalary'];
            this.offeredSalary = _data['offeredSalary'];
            this.interviewDateTime = _data['interviewDateTime'] ? moment(_data['interviewDateTime'].toString()) : <any>undefined;
            this.availableStartDate = _data['availableStartDate'] ? moment(_data['availableStartDate'].toString()) : <any>undefined;
            this.cvType = _data['cvType'];
            this.cvFilePath = _data['cvFilePath'];
            this.cvExternalLink = _data['cvExternalLink'];
            this.statusCde = _data['statusCde'];
            this.note = _data['note'];
        }
    }

    static fromJS(data: any): CreateRecruitmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRecruitmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['fullName'] = this.fullName;
        data['birthday'] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data['sex'] = this.sex;
        data['phoneNumber'] = this.phoneNumber;
        data['email'] = this.email;
        data['address'] = this.address;
        data['expertise'] = this.expertise;
        data['expectedSalary'] = this.expectedSalary;
        data['offeredSalary'] = this.offeredSalary;
        data['interviewDateTime'] = this.interviewDateTime ? this.interviewDateTime.toISOString() : <any>undefined;
        data['availableStartDate'] = this.availableStartDate ? this.availableStartDate.toISOString() : <any>undefined;
        data['cvType'] = this.cvType;
        data['cvFilePath'] = this.cvFilePath;
        data['cvExternalLink'] = this.cvExternalLink;
        data['statusCde'] = this.statusCde;
        data['note'] = this.note;
        return data;
    }

    clone(): CreateRecruitmentDto {
        const json = this.toJSON();
        let result = new CreateRecruitmentDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRecruitmentDto {
    fullName: string | undefined;
    birthday: moment.Moment | undefined;
    sex: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    address: string | undefined;
    expertise: string | undefined;
    expectedSalary: number | undefined;
    offeredSalary: number | undefined;
    interviewDateTime: moment.Moment | undefined;
    availableStartDate: moment.Moment | undefined;
    cvType: string | undefined;
    cvFilePath: string | undefined;
    cvExternalLink: string | undefined;
    statusCde: string | undefined;
    note: string | undefined;
}

export class CreateRecruitmentJobPostsDto implements ICreateRecruitmentJobPostsDto {
    planId: number;
    title: string | undefined;
    description: string | undefined;
    channel: string | undefined;
    publishDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    jobPostsCde: string | undefined;
    statusCode: string | undefined;

    constructor(data?: ICreateRecruitmentJobPostsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planId = _data['planId'];
            this.title = _data['title'];
            this.description = _data['description'];
            this.channel = _data['channel'];
            this.publishDate = _data['publishDate'] ? moment(_data['publishDate'].toString()) : <any>undefined;
            this.expireDate = _data['expireDate'] ? moment(_data['expireDate'].toString()) : <any>undefined;
            this.jobPostsCde = _data['jobPostsCde'];
            this.statusCode = _data['statusCode'];
        }
    }

    static fromJS(data: any): CreateRecruitmentJobPostsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRecruitmentJobPostsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['planId'] = this.planId;
        data['title'] = this.title;
        data['description'] = this.description;
        data['channel'] = this.channel;
        data['publishDate'] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data['expireDate'] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data['jobPostsCde'] = this.jobPostsCde;
        data['statusCode'] = this.statusCode;
        return data;
    }

    clone(): CreateRecruitmentJobPostsDto {
        const json = this.toJSON();
        let result = new CreateRecruitmentJobPostsDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRecruitmentJobPostsDto {
    planId: number;
    title: string | undefined;
    description: string | undefined;
    channel: string | undefined;
    publishDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    jobPostsCde: string | undefined;
    statusCode: string | undefined;
}

export class CreateRecruitmentPlansDto implements ICreateRecruitmentPlansDto {
    requestId: number;
    planName: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    budget: number;
    statusCode: string | undefined;

    constructor(data?: ICreateRecruitmentPlansDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data['requestId'];
            this.planName = _data['planName'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.budget = _data['budget'];
            this.statusCode = _data['statusCode'];
        }
    }

    static fromJS(data: any): CreateRecruitmentPlansDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRecruitmentPlansDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['requestId'] = this.requestId;
        data['planName'] = this.planName;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['budget'] = this.budget;
        data['statusCode'] = this.statusCode;
        return data;
    }

    clone(): CreateRecruitmentPlansDto {
        const json = this.toJSON();
        let result = new CreateRecruitmentPlansDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRecruitmentPlansDto {
    requestId: number;
    planName: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    budget: number;
    statusCode: string | undefined;
}

export class CreateRegisterOvertimeDto implements ICreateRegisterOvertimeDto {
    employeeId: number;
    overtimeDate: moment.Moment | undefined;
    hoursOvertime: number;
    startTime: string | undefined;
    endTime: string | undefined;
    description: string | undefined;
    content: string | undefined;
    createBy: string | undefined;

    constructor(data?: ICreateRegisterOvertimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data['employeeId'];
            this.overtimeDate = _data['overtimeDate'] ? moment(_data['overtimeDate'].toString()) : <any>undefined;
            this.hoursOvertime = _data['hoursOvertime'];
            this.startTime = _data['startTime'];
            this.endTime = _data['endTime'];
            this.description = _data['description'];
            this.content = _data['content'];
            this.createBy = _data['createBy'];
        }
    }

    static fromJS(data: any): CreateRegisterOvertimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegisterOvertimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['employeeId'] = this.employeeId;
        data['overtimeDate'] = this.overtimeDate ? this.overtimeDate.toISOString() : <any>undefined;
        data['hoursOvertime'] = this.hoursOvertime;
        data['startTime'] = this.startTime;
        data['endTime'] = this.endTime;
        data['description'] = this.description;
        data['content'] = this.content;
        data['createBy'] = this.createBy;
        return data;
    }

    clone(): CreateRegisterOvertimeDto {
        const json = this.toJSON();
        let result = new CreateRegisterOvertimeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRegisterOvertimeDto {
    employeeId: number;
    overtimeDate: moment.Moment | undefined;
    hoursOvertime: number;
    startTime: string | undefined;
    endTime: string | undefined;
    description: string | undefined;
    content: string | undefined;
    createBy: string | undefined;
}

export class CreateRemainingLeaveDto implements ICreateRemainingLeaveDto {
    leaveYear: number | undefined;
    totalHoursLeft: number;
    titleName: string | undefined;
    tenantId: number;
    statusCde: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    createBy: string | undefined;
    lstRemainingLeaveDetail: RemainingLeaveDetailModel[] | undefined;

    constructor(data?: ICreateRemainingLeaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveYear = _data['leaveYear'];
            this.totalHoursLeft = _data['totalHoursLeft'];
            this.titleName = _data['titleName'];
            this.tenantId = _data['tenantId'];
            this.statusCde = _data['statusCde'];
            this.wfDataCde = _data['wfDataCde'];
            this.cancelReason = _data['cancelReason'];
            this.createBy = _data['createBy'];
            if (Array.isArray(_data['lstRemainingLeaveDetail'])) {
                this.lstRemainingLeaveDetail = [] as any;
                for (let item of _data['lstRemainingLeaveDetail']) this.lstRemainingLeaveDetail.push(RemainingLeaveDetailModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateRemainingLeaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRemainingLeaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['leaveYear'] = this.leaveYear;
        data['totalHoursLeft'] = this.totalHoursLeft;
        data['titleName'] = this.titleName;
        data['tenantId'] = this.tenantId;
        data['statusCde'] = this.statusCde;
        data['wfDataCde'] = this.wfDataCde;
        data['cancelReason'] = this.cancelReason;
        data['createBy'] = this.createBy;
        if (Array.isArray(this.lstRemainingLeaveDetail)) {
            data['lstRemainingLeaveDetail'] = [];
            for (let item of this.lstRemainingLeaveDetail) data['lstRemainingLeaveDetail'].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateRemainingLeaveDto {
        const json = this.toJSON();
        let result = new CreateRemainingLeaveDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRemainingLeaveDto {
    leaveYear: number | undefined;
    totalHoursLeft: number;
    titleName: string | undefined;
    tenantId: number;
    statusCde: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    createBy: string | undefined;
    lstRemainingLeaveDetail: RemainingLeaveDetailModel[] | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.normalizedName = _data['normalizedName'];
            this.description = _data['description'];
            if (Array.isArray(_data['grantedPermissions'])) {
                this.grantedPermissions = [] as any;
                for (let item of _data['grantedPermissions']) this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['normalizedName'] = this.normalizedName;
        data['description'] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data['grantedPermissions'] = [];
            for (let item of this.grantedPermissions) data['grantedPermissions'].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class CreateSalaryBasicDto implements ICreateSalaryBasicDto {
    employeeId: number;
    salaryType: string | undefined;
    salaryAmount: number | undefined;
    salaryDate: moment.Moment | undefined;
    laborContractCode: string | undefined;
    contractNumber: string | undefined;
    dateContract: moment.Moment | undefined;
    contractFile: string | undefined;
    createBy: string | undefined;

    constructor(data?: ICreateSalaryBasicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data['employeeId'];
            this.salaryType = _data['salaryType'];
            this.salaryAmount = _data['salaryAmount'];
            this.salaryDate = _data['salaryDate'] ? moment(_data['salaryDate'].toString()) : <any>undefined;
            this.laborContractCode = _data['laborContractCode'];
            this.contractNumber = _data['contractNumber'];
            this.dateContract = _data['dateContract'] ? moment(_data['dateContract'].toString()) : <any>undefined;
            this.contractFile = _data['contractFile'];
            this.createBy = _data['createBy'];
        }
    }

    static fromJS(data: any): CreateSalaryBasicDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSalaryBasicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['employeeId'] = this.employeeId;
        data['salaryType'] = this.salaryType;
        data['salaryAmount'] = this.salaryAmount;
        data['salaryDate'] = this.salaryDate ? this.salaryDate.toISOString() : <any>undefined;
        data['laborContractCode'] = this.laborContractCode;
        data['contractNumber'] = this.contractNumber;
        data['dateContract'] = this.dateContract ? this.dateContract.toISOString() : <any>undefined;
        data['contractFile'] = this.contractFile;
        data['createBy'] = this.createBy;
        return data;
    }

    clone(): CreateSalaryBasicDto {
        const json = this.toJSON();
        let result = new CreateSalaryBasicDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSalaryBasicDto {
    employeeId: number;
    salaryType: string | undefined;
    salaryAmount: number | undefined;
    salaryDate: moment.Moment | undefined;
    laborContractCode: string | undefined;
    contractNumber: string | undefined;
    dateContract: moment.Moment | undefined;
    contractFile: string | undefined;
    createBy: string | undefined;
}

export class CreateSalaryDto implements ICreateSalaryDto {
    salaryDate: moment.Moment | undefined;
    titleName: string | undefined;
    tenantId: number;
    statusCde: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    createBy: string | undefined;

    constructor(data?: ICreateSalaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salaryDate = _data['salaryDate'] ? moment(_data['salaryDate'].toString()) : <any>undefined;
            this.titleName = _data['titleName'];
            this.tenantId = _data['tenantId'];
            this.statusCde = _data['statusCde'];
            this.wfDataCde = _data['wfDataCde'];
            this.cancelReason = _data['cancelReason'];
            this.createBy = _data['createBy'];
        }
    }

    static fromJS(data: any): CreateSalaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSalaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['salaryDate'] = this.salaryDate ? this.salaryDate.toISOString() : <any>undefined;
        data['titleName'] = this.titleName;
        data['tenantId'] = this.tenantId;
        data['statusCde'] = this.statusCde;
        data['wfDataCde'] = this.wfDataCde;
        data['cancelReason'] = this.cancelReason;
        data['createBy'] = this.createBy;
        return data;
    }

    clone(): CreateSalaryDto {
        const json = this.toJSON();
        let result = new CreateSalaryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSalaryDto {
    salaryDate: moment.Moment | undefined;
    titleName: string | undefined;
    tenantId: number;
    statusCde: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    createBy: string | undefined;
}

export class CreateSysAppParamDto implements ICreateSysAppParamDto {
    paramCode: string | undefined;
    paramValue: string | undefined;
    description: string | undefined;
    isActive: boolean;
    createdBy: string | undefined;

    constructor(data?: ICreateSysAppParamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paramCode = _data['paramCode'];
            this.paramValue = _data['paramValue'];
            this.description = _data['description'];
            this.isActive = _data['isActive'];
            this.createdBy = _data['createdBy'];
        }
    }

    static fromJS(data: any): CreateSysAppParamDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSysAppParamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['paramCode'] = this.paramCode;
        data['paramValue'] = this.paramValue;
        data['description'] = this.description;
        data['isActive'] = this.isActive;
        data['createdBy'] = this.createdBy;
        return data;
    }

    clone(): CreateSysAppParamDto {
        const json = this.toJSON();
        let result = new CreateSysAppParamDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSysAppParamDto {
    paramCode: string | undefined;
    paramValue: string | undefined;
    description: string | undefined;
    isActive: boolean;
    createdBy: string | undefined;
}

export class CreateSysMasterListDto implements ICreateSysMasterListDto {
    masterListCode: string | undefined;
    masterListGroupCde: string | undefined;
    masterListCdeName: string | undefined;
    mastListDefaultValue: string | undefined;
    mastListExtendValue1: string | undefined;
    mastListExtendValue2: string | undefined;
    mastListExtendValue3: string | undefined;
    mastListExtendValue4: string | undefined;
    mastListExtendValue5: string | undefined;
    description: string | undefined;
    orderNo: number;
    isActive: boolean | undefined;
    rowVersion: string | undefined;

    constructor(data?: ICreateSysMasterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.masterListCode = _data['masterListCode'];
            this.masterListGroupCde = _data['masterListGroupCde'];
            this.masterListCdeName = _data['masterListCdeName'];
            this.mastListDefaultValue = _data['mastListDefaultValue'];
            this.mastListExtendValue1 = _data['mastListExtendValue1'];
            this.mastListExtendValue2 = _data['mastListExtendValue2'];
            this.mastListExtendValue3 = _data['mastListExtendValue3'];
            this.mastListExtendValue4 = _data['mastListExtendValue4'];
            this.mastListExtendValue5 = _data['mastListExtendValue5'];
            this.description = _data['description'];
            this.orderNo = _data['orderNo'];
            this.isActive = _data['isActive'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): CreateSysMasterListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSysMasterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['masterListCode'] = this.masterListCode;
        data['masterListGroupCde'] = this.masterListGroupCde;
        data['masterListCdeName'] = this.masterListCdeName;
        data['mastListDefaultValue'] = this.mastListDefaultValue;
        data['mastListExtendValue1'] = this.mastListExtendValue1;
        data['mastListExtendValue2'] = this.mastListExtendValue2;
        data['mastListExtendValue3'] = this.mastListExtendValue3;
        data['mastListExtendValue4'] = this.mastListExtendValue4;
        data['mastListExtendValue5'] = this.mastListExtendValue5;
        data['description'] = this.description;
        data['orderNo'] = this.orderNo;
        data['isActive'] = this.isActive;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): CreateSysMasterListDto {
        const json = this.toJSON();
        let result = new CreateSysMasterListDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSysMasterListDto {
    masterListCode: string | undefined;
    masterListGroupCde: string | undefined;
    masterListCdeName: string | undefined;
    mastListDefaultValue: string | undefined;
    mastListExtendValue1: string | undefined;
    mastListExtendValue2: string | undefined;
    mastListExtendValue3: string | undefined;
    mastListExtendValue4: string | undefined;
    mastListExtendValue5: string | undefined;
    description: string | undefined;
    orderNo: number;
    isActive: boolean | undefined;
    rowVersion: string | undefined;
}

export class CreateSysWorkflowDto implements ICreateSysWorkflowDto {
    workflowCode: string | undefined;
    workflowName: string | undefined;
    currentStep: number;
    nextStep: number;
    hardStep: string | undefined;
    actionName: string | undefined;
    statusCde: string | undefined;
    currentSystemCde: string | undefined;
    usrRoleCde: string | undefined;
    buttonDisplayCde: string | undefined;
    inputCanSee: string | undefined;
    inputCanEdit: string | undefined;
    preProcessFunc: string | undefined;
    cssClass: string | undefined;
    cssIcon: string | undefined;
    isRequiredComment: boolean;
    isActive: boolean;
    createdBy: string | undefined;
    createdDate: moment.Moment | undefined;
    tenantId: number;
    tableName: string | undefined;

    constructor(data?: ICreateSysWorkflowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowCode = _data['workflowCode'];
            this.workflowName = _data['workflowName'];
            this.currentStep = _data['currentStep'];
            this.nextStep = _data['nextStep'];
            this.hardStep = _data['hardStep'];
            this.actionName = _data['actionName'];
            this.statusCde = _data['statusCde'];
            this.currentSystemCde = _data['currentSystemCde'];
            this.usrRoleCde = _data['usrRoleCde'];
            this.buttonDisplayCde = _data['buttonDisplayCde'];
            this.inputCanSee = _data['inputCanSee'];
            this.inputCanEdit = _data['inputCanEdit'];
            this.preProcessFunc = _data['preProcessFunc'];
            this.cssClass = _data['cssClass'];
            this.cssIcon = _data['cssIcon'];
            this.isRequiredComment = _data['isRequiredComment'];
            this.isActive = _data['isActive'];
            this.createdBy = _data['createdBy'];
            this.createdDate = _data['createdDate'] ? moment(_data['createdDate'].toString()) : <any>undefined;
            this.tenantId = _data['tenantId'];
            this.tableName = _data['tableName'];
        }
    }

    static fromJS(data: any): CreateSysWorkflowDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSysWorkflowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['workflowCode'] = this.workflowCode;
        data['workflowName'] = this.workflowName;
        data['currentStep'] = this.currentStep;
        data['nextStep'] = this.nextStep;
        data['hardStep'] = this.hardStep;
        data['actionName'] = this.actionName;
        data['statusCde'] = this.statusCde;
        data['currentSystemCde'] = this.currentSystemCde;
        data['usrRoleCde'] = this.usrRoleCde;
        data['buttonDisplayCde'] = this.buttonDisplayCde;
        data['inputCanSee'] = this.inputCanSee;
        data['inputCanEdit'] = this.inputCanEdit;
        data['preProcessFunc'] = this.preProcessFunc;
        data['cssClass'] = this.cssClass;
        data['cssIcon'] = this.cssIcon;
        data['isRequiredComment'] = this.isRequiredComment;
        data['isActive'] = this.isActive;
        data['createdBy'] = this.createdBy;
        data['createdDate'] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data['tenantId'] = this.tenantId;
        data['tableName'] = this.tableName;
        return data;
    }

    clone(): CreateSysWorkflowDto {
        const json = this.toJSON();
        let result = new CreateSysWorkflowDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSysWorkflowDto {
    workflowCode: string | undefined;
    workflowName: string | undefined;
    currentStep: number;
    nextStep: number;
    hardStep: string | undefined;
    actionName: string | undefined;
    statusCde: string | undefined;
    currentSystemCde: string | undefined;
    usrRoleCde: string | undefined;
    buttonDisplayCde: string | undefined;
    inputCanSee: string | undefined;
    inputCanEdit: string | undefined;
    preProcessFunc: string | undefined;
    cssClass: string | undefined;
    cssIcon: string | undefined;
    isRequiredComment: boolean;
    isActive: boolean;
    createdBy: string | undefined;
    createdDate: moment.Moment | undefined;
    tenantId: number;
    tableName: string | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data['tenancyName'];
            this.name = _data['name'];
            this.adminEmailAddress = _data['adminEmailAddress'];
            this.connectionString = _data['connectionString'];
            this.isActive = _data['isActive'];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenancyName'] = this.tenancyName;
        data['name'] = this.name;
        data['adminEmailAddress'] = this.adminEmailAddress;
        data['connectionString'] = this.connectionString;
        data['isActive'] = this.isActive;
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
}

export class CreateUserDto implements ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;
    phoneNumber: string | undefined;
    gender: string | undefined;
    birthday: moment.Moment | undefined;
    identityCard: string | undefined;
    identityCardDate: string | undefined;
    identityCardPlace: string | undefined;
    permanentAddress: string | undefined;
    temporaryAddress: string | undefined;
    avatar: string | undefined;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data['userName'];
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.emailAddress = _data['emailAddress'];
            this.isActive = _data['isActive'];
            if (Array.isArray(_data['roleNames'])) {
                this.roleNames = [] as any;
                for (let item of _data['roleNames']) this.roleNames.push(item);
            }
            this.password = _data['password'];
            this.phoneNumber = _data['phoneNumber'];
            this.gender = _data['gender'];
            this.birthday = _data['birthday'] ? moment(_data['birthday'].toString()) : <any>undefined;
            this.identityCard = _data['identityCard'];
            this.identityCardDate = _data['identityCardDate'];
            this.identityCardPlace = _data['identityCardPlace'];
            this.permanentAddress = _data['permanentAddress'];
            this.temporaryAddress = _data['temporaryAddress'];
            this.avatar = _data['avatar'];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userName'] = this.userName;
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['emailAddress'] = this.emailAddress;
        data['isActive'] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data['roleNames'] = [];
            for (let item of this.roleNames) data['roleNames'].push(item);
        }
        data['password'] = this.password;
        data['phoneNumber'] = this.phoneNumber;
        data['gender'] = this.gender;
        data['birthday'] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data['identityCard'] = this.identityCard;
        data['identityCardDate'] = this.identityCardDate;
        data['identityCardPlace'] = this.identityCardPlace;
        data['permanentAddress'] = this.permanentAddress;
        data['temporaryAddress'] = this.temporaryAddress;
        data['avatar'] = this.avatar;
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;
    phoneNumber: string | undefined;
    gender: string | undefined;
    birthday: moment.Moment | undefined;
    identityCard: string | undefined;
    identityCardDate: string | undefined;
    identityCardPlace: string | undefined;
    permanentAddress: string | undefined;
    temporaryAddress: string | undefined;
    avatar: string | undefined;
}

export class CreateWorkShiftChangeDto implements ICreateWorkShiftChangeDto {
    id: number;
    employeeId: number;
    currentShiftCode: string | undefined;
    changeShiftCode: string | undefined;
    month: number;
    year: number;
    dateWork: string | undefined;
    description: string | undefined;
    statusCde: string | undefined;
    wfDataCde: string | undefined;
    createBy: string | undefined;
    content: string | undefined;

    constructor(data?: ICreateWorkShiftChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.currentShiftCode = _data['currentShiftCode'];
            this.changeShiftCode = _data['changeShiftCode'];
            this.month = _data['month'];
            this.year = _data['year'];
            this.dateWork = _data['dateWork'];
            this.description = _data['description'];
            this.statusCde = _data['statusCde'];
            this.wfDataCde = _data['wfDataCde'];
            this.createBy = _data['createBy'];
            this.content = _data['content'];
        }
    }

    static fromJS(data: any): CreateWorkShiftChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkShiftChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['currentShiftCode'] = this.currentShiftCode;
        data['changeShiftCode'] = this.changeShiftCode;
        data['month'] = this.month;
        data['year'] = this.year;
        data['dateWork'] = this.dateWork;
        data['description'] = this.description;
        data['statusCde'] = this.statusCde;
        data['wfDataCde'] = this.wfDataCde;
        data['createBy'] = this.createBy;
        data['content'] = this.content;
        return data;
    }

    clone(): CreateWorkShiftChangeDto {
        const json = this.toJSON();
        let result = new CreateWorkShiftChangeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateWorkShiftChangeDto {
    id: number;
    employeeId: number;
    currentShiftCode: string | undefined;
    changeShiftCode: string | undefined;
    month: number;
    year: number;
    dateWork: string | undefined;
    description: string | undefined;
    statusCde: string | undefined;
    wfDataCde: string | undefined;
    createBy: string | undefined;
    content: string | undefined;
}

export class CreateWorkingShiftDto implements ICreateWorkingShiftDto {
    employeeId: number[] | undefined;
    shiftCode: string | undefined;
    month: number;
    year: number;
    dateWork: string | undefined;
    createBy: string | undefined;

    constructor(data?: ICreateWorkingShiftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['employeeId'])) {
                this.employeeId = [] as any;
                for (let item of _data['employeeId']) this.employeeId.push(item);
            }
            this.shiftCode = _data['shiftCode'];
            this.month = _data['month'];
            this.year = _data['year'];
            this.dateWork = _data['dateWork'];
            this.createBy = _data['createBy'];
        }
    }

    static fromJS(data: any): CreateWorkingShiftDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkingShiftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employeeId)) {
            data['employeeId'] = [];
            for (let item of this.employeeId) data['employeeId'].push(item);
        }
        data['shiftCode'] = this.shiftCode;
        data['month'] = this.month;
        data['year'] = this.year;
        data['dateWork'] = this.dateWork;
        data['createBy'] = this.createBy;
        return data;
    }

    clone(): CreateWorkingShiftDto {
        const json = this.toJSON();
        let result = new CreateWorkingShiftDto();
        result.init(json);
        return result;
    }
}

export interface ICreateWorkingShiftDto {
    employeeId: number[] | undefined;
    shiftCode: string | undefined;
    month: number;
    year: number;
    dateWork: string | undefined;
    createBy: string | undefined;
}

export class DashboardInfoDto implements IDashboardInfoDto {
    css: string | undefined;
    total: number;
    name: string | undefined;
    horizontalName: string | undefined;
    data: string | undefined;
    lstHorizontalName: string[] | undefined;
    lstData: number[] | undefined;

    constructor(data?: IDashboardInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.css = _data['css'];
            this.total = _data['total'];
            this.name = _data['name'];
            this.horizontalName = _data['horizontalName'];
            this.data = _data['data'];
            if (Array.isArray(_data['lstHorizontalName'])) {
                this.lstHorizontalName = [] as any;
                for (let item of _data['lstHorizontalName']) this.lstHorizontalName.push(item);
            }
            if (Array.isArray(_data['lstData'])) {
                this.lstData = [] as any;
                for (let item of _data['lstData']) this.lstData.push(item);
            }
        }
    }

    static fromJS(data: any): DashboardInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['css'] = this.css;
        data['total'] = this.total;
        data['name'] = this.name;
        data['horizontalName'] = this.horizontalName;
        data['data'] = this.data;
        if (Array.isArray(this.lstHorizontalName)) {
            data['lstHorizontalName'] = [];
            for (let item of this.lstHorizontalName) data['lstHorizontalName'].push(item);
        }
        if (Array.isArray(this.lstData)) {
            data['lstData'] = [];
            for (let item of this.lstData) data['lstData'].push(item);
        }
        return data;
    }

    clone(): DashboardInfoDto {
        const json = this.toJSON();
        let result = new DashboardInfoDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardInfoDto {
    css: string | undefined;
    total: number;
    name: string | undefined;
    horizontalName: string | undefined;
    data: string | undefined;
    lstHorizontalName: string[] | undefined;
    lstData: number[] | undefined;
}

export class DashboardListDto implements IDashboardListDto {
    lstDashboardPurchaseOrderFinishInfo: DashboardInfoDto[] | undefined;
    lstDashboardRatePurchaseOrderInfo: DashboardInfoDto[] | undefined;
    lstDashboardSalaryInfo: DashboardInfoDto[] | undefined;

    constructor(data?: IDashboardListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['lstDashboardPurchaseOrderFinishInfo'])) {
                this.lstDashboardPurchaseOrderFinishInfo = [] as any;
                for (let item of _data['lstDashboardPurchaseOrderFinishInfo']) this.lstDashboardPurchaseOrderFinishInfo.push(DashboardInfoDto.fromJS(item));
            }
            if (Array.isArray(_data['lstDashboardRatePurchaseOrderInfo'])) {
                this.lstDashboardRatePurchaseOrderInfo = [] as any;
                for (let item of _data['lstDashboardRatePurchaseOrderInfo']) this.lstDashboardRatePurchaseOrderInfo.push(DashboardInfoDto.fromJS(item));
            }
            if (Array.isArray(_data['lstDashboardSalaryInfo'])) {
                this.lstDashboardSalaryInfo = [] as any;
                for (let item of _data['lstDashboardSalaryInfo']) this.lstDashboardSalaryInfo.push(DashboardInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lstDashboardPurchaseOrderFinishInfo)) {
            data['lstDashboardPurchaseOrderFinishInfo'] = [];
            for (let item of this.lstDashboardPurchaseOrderFinishInfo) data['lstDashboardPurchaseOrderFinishInfo'].push(item.toJSON());
        }
        if (Array.isArray(this.lstDashboardRatePurchaseOrderInfo)) {
            data['lstDashboardRatePurchaseOrderInfo'] = [];
            for (let item of this.lstDashboardRatePurchaseOrderInfo) data['lstDashboardRatePurchaseOrderInfo'].push(item.toJSON());
        }
        if (Array.isArray(this.lstDashboardSalaryInfo)) {
            data['lstDashboardSalaryInfo'] = [];
            for (let item of this.lstDashboardSalaryInfo) data['lstDashboardSalaryInfo'].push(item.toJSON());
        }
        return data;
    }

    clone(): DashboardListDto {
        const json = this.toJSON();
        let result = new DashboardListDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardListDto {
    lstDashboardPurchaseOrderFinishInfo: DashboardInfoDto[] | undefined;
    lstDashboardRatePurchaseOrderInfo: DashboardInfoDto[] | undefined;
    lstDashboardSalaryInfo: DashboardInfoDto[] | undefined;
}

export class DistrictModel implements IDistrictModel {
    id: number;
    provinceCde: string | undefined;
    code: string | undefined;
    name: string | undefined;
    districtType: string | undefined;
    isDeleted: boolean;
    rowVersion: string | undefined;
    createdBy: string | undefined;
    createdDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    tenantId: number;

    constructor(data?: IDistrictModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.provinceCde = _data['provinceCde'];
            this.code = _data['code'];
            this.name = _data['name'];
            this.districtType = _data['districtType'];
            this.isDeleted = _data['isDeleted'];
            this.rowVersion = _data['rowVersion'];
            this.createdBy = _data['createdBy'];
            this.createdDate = _data['createdDate'] ? moment(_data['createdDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
            this.tenantId = _data['tenantId'];
        }
    }

    static fromJS(data: any): DistrictModel {
        data = typeof data === 'object' ? data : {};
        let result = new DistrictModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['provinceCde'] = this.provinceCde;
        data['code'] = this.code;
        data['name'] = this.name;
        data['districtType'] = this.districtType;
        data['isDeleted'] = this.isDeleted;
        data['rowVersion'] = this.rowVersion;
        data['createdBy'] = this.createdBy;
        data['createdDate'] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data['tenantId'] = this.tenantId;
        return data;
    }

    clone(): DistrictModel {
        const json = this.toJSON();
        let result = new DistrictModel();
        result.init(json);
        return result;
    }
}

export interface IDistrictModel {
    id: number;
    provinceCde: string | undefined;
    code: string | undefined;
    name: string | undefined;
    districtType: string | undefined;
    isDeleted: boolean;
    rowVersion: string | undefined;
    createdBy: string | undefined;
    createdDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    tenantId: number;
}

export class DropDownEmployeeDto implements IDropDownEmployeeDto {
    id: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    managerId: number;
    managerName: string | undefined;

    constructor(data?: IDropDownEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeCode = _data['employeeCode'];
            this.employeeName = _data['employeeName'];
            this.managerId = _data['managerId'];
            this.managerName = _data['managerName'];
        }
    }

    static fromJS(data: any): DropDownEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DropDownEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeCode'] = this.employeeCode;
        data['employeeName'] = this.employeeName;
        data['managerId'] = this.managerId;
        data['managerName'] = this.managerName;
        return data;
    }

    clone(): DropDownEmployeeDto {
        const json = this.toJSON();
        let result = new DropDownEmployeeDto();
        result.init(json);
        return result;
    }
}

export interface IDropDownEmployeeDto {
    id: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    managerId: number;
    managerName: string | undefined;
}

export class DropDownEmployeeModel implements IDropDownEmployeeModel {
    id: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    managerId: number;
    managerName: string | undefined;

    constructor(data?: IDropDownEmployeeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeCode = _data['employeeCode'];
            this.employeeName = _data['employeeName'];
            this.managerId = _data['managerId'];
            this.managerName = _data['managerName'];
        }
    }

    static fromJS(data: any): DropDownEmployeeModel {
        data = typeof data === 'object' ? data : {};
        let result = new DropDownEmployeeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeCode'] = this.employeeCode;
        data['employeeName'] = this.employeeName;
        data['managerId'] = this.managerId;
        data['managerName'] = this.managerName;
        return data;
    }

    clone(): DropDownEmployeeModel {
        const json = this.toJSON();
        let result = new DropDownEmployeeModel();
        result.init(json);
        return result;
    }
}

export interface IDropDownEmployeeModel {
    id: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    managerId: number;
    managerName: string | undefined;
}

export class DropDownEvaluationPeriodDto implements IDropDownEvaluationPeriodDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
    statusCde: string | undefined;

    constructor(data?: IDropDownEvaluationPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.code = _data['code'];
            this.name = _data['name'];
            this.statusCde = _data['statusCde'];
        }
    }

    static fromJS(data: any): DropDownEvaluationPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new DropDownEvaluationPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['code'] = this.code;
        data['name'] = this.name;
        data['statusCde'] = this.statusCde;
        return data;
    }

    clone(): DropDownEvaluationPeriodDto {
        const json = this.toJSON();
        let result = new DropDownEvaluationPeriodDto();
        result.init(json);
        return result;
    }
}

export interface IDropDownEvaluationPeriodDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
    statusCde: string | undefined;
}

export class EmployeeDto implements IEmployeeDto {
    id: number;
    employeeCode: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    fullname: string | undefined;
    email: string | undefined;
    managerId: number;
    sex: string | undefined;
    birthDay: moment.Moment | undefined;
    identityCard: string | undefined;
    identityCardDate: moment.Moment | undefined;
    identityCardPlace: string | undefined;
    dateOfWork: moment.Moment | undefined;
    dateOfEntry: moment.Moment | undefined;
    isFederation: boolean;
    departmentCode: string | undefined;
    jobCode: string | undefined;
    nationalityCode: string | undefined;
    familyExemptionNumber: number | undefined;
    familyExemptionDate: moment.Moment | undefined;
    taxYourself: string | undefined;
    isInactivity: boolean;
    bankAccount: string | undefined;
    bankCode: string | undefined;
    permanentAddress: string | undefined;
    temporaryAddress: string | undefined;
    phoneNumber: string | undefined;
    image: string | undefined;
    inactivityDate: moment.Moment | undefined;
    religiousCode: string | undefined;
    educatedCode: string | undefined;
    insuranceNumber: string | undefined;
    maritalStatus: string | undefined;
    rowVersion: string | undefined;
    isDelete: boolean;
    createBy: string | undefined;
    createDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    identityCard2: string | undefined;
    identityCardDate2: moment.Moment | undefined;
    identityCardPlace2: string | undefined;

    constructor(data?: IEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeCode = _data['employeeCode'];
            this.firstName = _data['firstName'];
            this.lastName = _data['lastName'];
            this.fullname = _data['fullname'];
            this.email = _data['email'];
            this.managerId = _data['managerId'];
            this.sex = _data['sex'];
            this.birthDay = _data['birthDay'] ? moment(_data['birthDay'].toString()) : <any>undefined;
            this.identityCard = _data['identityCard'];
            this.identityCardDate = _data['identityCardDate'] ? moment(_data['identityCardDate'].toString()) : <any>undefined;
            this.identityCardPlace = _data['identityCardPlace'];
            this.dateOfWork = _data['dateOfWork'] ? moment(_data['dateOfWork'].toString()) : <any>undefined;
            this.dateOfEntry = _data['dateOfEntry'] ? moment(_data['dateOfEntry'].toString()) : <any>undefined;
            this.isFederation = _data['isFederation'];
            this.departmentCode = _data['departmentCode'];
            this.jobCode = _data['jobCode'];
            this.nationalityCode = _data['nationalityCode'];
            this.familyExemptionNumber = _data['familyExemptionNumber'];
            this.familyExemptionDate = _data['familyExemptionDate'] ? moment(_data['familyExemptionDate'].toString()) : <any>undefined;
            this.taxYourself = _data['taxYourself'];
            this.isInactivity = _data['isInactivity'];
            this.bankAccount = _data['bankAccount'];
            this.bankCode = _data['bankCode'];
            this.permanentAddress = _data['permanentAddress'];
            this.temporaryAddress = _data['temporaryAddress'];
            this.phoneNumber = _data['phoneNumber'];
            this.image = _data['image'];
            this.inactivityDate = _data['inactivityDate'] ? moment(_data['inactivityDate'].toString()) : <any>undefined;
            this.religiousCode = _data['religiousCode'];
            this.educatedCode = _data['educatedCode'];
            this.insuranceNumber = _data['insuranceNumber'];
            this.maritalStatus = _data['maritalStatus'];
            this.rowVersion = _data['rowVersion'];
            this.isDelete = _data['isDelete'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
            this.identityCard2 = _data['identityCard2'];
            this.identityCardDate2 = _data['identityCardDate2'] ? moment(_data['identityCardDate2'].toString()) : <any>undefined;
            this.identityCardPlace2 = _data['identityCardPlace2'];
        }
    }

    static fromJS(data: any): EmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeCode'] = this.employeeCode;
        data['firstName'] = this.firstName;
        data['lastName'] = this.lastName;
        data['fullname'] = this.fullname;
        data['email'] = this.email;
        data['managerId'] = this.managerId;
        data['sex'] = this.sex;
        data['birthDay'] = this.birthDay ? this.birthDay.toISOString() : <any>undefined;
        data['identityCard'] = this.identityCard;
        data['identityCardDate'] = this.identityCardDate ? this.identityCardDate.toISOString() : <any>undefined;
        data['identityCardPlace'] = this.identityCardPlace;
        data['dateOfWork'] = this.dateOfWork ? this.dateOfWork.toISOString() : <any>undefined;
        data['dateOfEntry'] = this.dateOfEntry ? this.dateOfEntry.toISOString() : <any>undefined;
        data['isFederation'] = this.isFederation;
        data['departmentCode'] = this.departmentCode;
        data['jobCode'] = this.jobCode;
        data['nationalityCode'] = this.nationalityCode;
        data['familyExemptionNumber'] = this.familyExemptionNumber;
        data['familyExemptionDate'] = this.familyExemptionDate ? this.familyExemptionDate.toISOString() : <any>undefined;
        data['taxYourself'] = this.taxYourself;
        data['isInactivity'] = this.isInactivity;
        data['bankAccount'] = this.bankAccount;
        data['bankCode'] = this.bankCode;
        data['permanentAddress'] = this.permanentAddress;
        data['temporaryAddress'] = this.temporaryAddress;
        data['phoneNumber'] = this.phoneNumber;
        data['image'] = this.image;
        data['inactivityDate'] = this.inactivityDate ? this.inactivityDate.toISOString() : <any>undefined;
        data['religiousCode'] = this.religiousCode;
        data['educatedCode'] = this.educatedCode;
        data['insuranceNumber'] = this.insuranceNumber;
        data['maritalStatus'] = this.maritalStatus;
        data['rowVersion'] = this.rowVersion;
        data['isDelete'] = this.isDelete;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data['identityCard2'] = this.identityCard2;
        data['identityCardDate2'] = this.identityCardDate2 ? this.identityCardDate2.toISOString() : <any>undefined;
        data['identityCardPlace2'] = this.identityCardPlace2;
        return data;
    }

    clone(): EmployeeDto {
        const json = this.toJSON();
        let result = new EmployeeDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeDto {
    id: number;
    employeeCode: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    fullname: string | undefined;
    email: string | undefined;
    managerId: number;
    sex: string | undefined;
    birthDay: moment.Moment | undefined;
    identityCard: string | undefined;
    identityCardDate: moment.Moment | undefined;
    identityCardPlace: string | undefined;
    dateOfWork: moment.Moment | undefined;
    dateOfEntry: moment.Moment | undefined;
    isFederation: boolean;
    departmentCode: string | undefined;
    jobCode: string | undefined;
    nationalityCode: string | undefined;
    familyExemptionNumber: number | undefined;
    familyExemptionDate: moment.Moment | undefined;
    taxYourself: string | undefined;
    isInactivity: boolean;
    bankAccount: string | undefined;
    bankCode: string | undefined;
    permanentAddress: string | undefined;
    temporaryAddress: string | undefined;
    phoneNumber: string | undefined;
    image: string | undefined;
    inactivityDate: moment.Moment | undefined;
    religiousCode: string | undefined;
    educatedCode: string | undefined;
    insuranceNumber: string | undefined;
    maritalStatus: string | undefined;
    rowVersion: string | undefined;
    isDelete: boolean;
    createBy: string | undefined;
    createDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    identityCard2: string | undefined;
    identityCardDate2: moment.Moment | undefined;
    identityCardPlace2: string | undefined;
}

export class EmployeeGetAllManagerDto implements IEmployeeGetAllManagerDto {
    id: number;
    text: string | undefined;

    constructor(data?: IEmployeeGetAllManagerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.text = _data['text'];
        }
    }

    static fromJS(data: any): EmployeeGetAllManagerDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGetAllManagerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['text'] = this.text;
        return data;
    }

    clone(): EmployeeGetAllManagerDto {
        const json = this.toJSON();
        let result = new EmployeeGetAllManagerDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeGetAllManagerDto {
    id: number;
    text: string | undefined;
}

export class EmployeeOverviewReportDto implements IEmployeeOverviewReportDto {
    css: string | undefined;
    total: number;
    name: string | undefined;
    horizontalName: string | undefined;
    data: string | undefined;
    lstHorizontalName: string[] | undefined;
    lstData: number[] | undefined;

    constructor(data?: IEmployeeOverviewReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.css = _data['css'];
            this.total = _data['total'];
            this.name = _data['name'];
            this.horizontalName = _data['horizontalName'];
            this.data = _data['data'];
            if (Array.isArray(_data['lstHorizontalName'])) {
                this.lstHorizontalName = [] as any;
                for (let item of _data['lstHorizontalName']) this.lstHorizontalName.push(item);
            }
            if (Array.isArray(_data['lstData'])) {
                this.lstData = [] as any;
                for (let item of _data['lstData']) this.lstData.push(item);
            }
        }
    }

    static fromJS(data: any): EmployeeOverviewReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeOverviewReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['css'] = this.css;
        data['total'] = this.total;
        data['name'] = this.name;
        data['horizontalName'] = this.horizontalName;
        data['data'] = this.data;
        if (Array.isArray(this.lstHorizontalName)) {
            data['lstHorizontalName'] = [];
            for (let item of this.lstHorizontalName) data['lstHorizontalName'].push(item);
        }
        if (Array.isArray(this.lstData)) {
            data['lstData'] = [];
            for (let item of this.lstData) data['lstData'].push(item);
        }
        return data;
    }

    clone(): EmployeeOverviewReportDto {
        const json = this.toJSON();
        let result = new EmployeeOverviewReportDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeOverviewReportDto {
    css: string | undefined;
    total: number;
    name: string | undefined;
    horizontalName: string | undefined;
    data: string | undefined;
    lstHorizontalName: string[] | undefined;
    lstData: number[] | undefined;
}

export class EmployeePayrollDisbursementReportChartDto implements IEmployeePayrollDisbursementReportChartDto {
    css: string | undefined;
    total: number;
    name: string | undefined;
    horizontalName: string | undefined;
    data: string | undefined;
    dataDate: moment.Moment | undefined;
    lstHorizontalName: string[] | undefined;
    lstData: number[] | undefined;

    constructor(data?: IEmployeePayrollDisbursementReportChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.css = _data['css'];
            this.total = _data['total'];
            this.name = _data['name'];
            this.horizontalName = _data['horizontalName'];
            this.data = _data['data'];
            this.dataDate = _data['dataDate'] ? moment(_data['dataDate'].toString()) : <any>undefined;
            if (Array.isArray(_data['lstHorizontalName'])) {
                this.lstHorizontalName = [] as any;
                for (let item of _data['lstHorizontalName']) this.lstHorizontalName.push(item);
            }
            if (Array.isArray(_data['lstData'])) {
                this.lstData = [] as any;
                for (let item of _data['lstData']) this.lstData.push(item);
            }
        }
    }

    static fromJS(data: any): EmployeePayrollDisbursementReportChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePayrollDisbursementReportChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['css'] = this.css;
        data['total'] = this.total;
        data['name'] = this.name;
        data['horizontalName'] = this.horizontalName;
        data['data'] = this.data;
        data['dataDate'] = this.dataDate ? this.dataDate.toISOString() : <any>undefined;
        if (Array.isArray(this.lstHorizontalName)) {
            data['lstHorizontalName'] = [];
            for (let item of this.lstHorizontalName) data['lstHorizontalName'].push(item);
        }
        if (Array.isArray(this.lstData)) {
            data['lstData'] = [];
            for (let item of this.lstData) data['lstData'].push(item);
        }
        return data;
    }

    clone(): EmployeePayrollDisbursementReportChartDto {
        const json = this.toJSON();
        let result = new EmployeePayrollDisbursementReportChartDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeePayrollDisbursementReportChartDto {
    css: string | undefined;
    total: number;
    name: string | undefined;
    horizontalName: string | undefined;
    data: string | undefined;
    dataDate: moment.Moment | undefined;
    lstHorizontalName: string[] | undefined;
    lstData: number[] | undefined;
}

export class EmployeePayrollDisbursementReportDto implements IEmployeePayrollDisbursementReportDto {
    totalHardSalary: number;
    totalSalary: number;
    totalIncome: number;
    totalReceived: number;
    osAllowance: number;
    socialInsurance: number;
    personalIncomeTax: number;
    totalEmployee: number;
    officialEmployee: number;
    probationEmployee: number;
    averageIncome: number;
    salaryDate: moment.Moment | undefined;

    constructor(data?: IEmployeePayrollDisbursementReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalHardSalary = _data['totalHardSalary'];
            this.totalSalary = _data['totalSalary'];
            this.totalIncome = _data['totalIncome'];
            this.totalReceived = _data['totalReceived'];
            this.osAllowance = _data['osAllowance'];
            this.socialInsurance = _data['socialInsurance'];
            this.personalIncomeTax = _data['personalIncomeTax'];
            this.totalEmployee = _data['totalEmployee'];
            this.officialEmployee = _data['officialEmployee'];
            this.probationEmployee = _data['probationEmployee'];
            this.averageIncome = _data['averageIncome'];
            this.salaryDate = _data['salaryDate'] ? moment(_data['salaryDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeePayrollDisbursementReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePayrollDisbursementReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalHardSalary'] = this.totalHardSalary;
        data['totalSalary'] = this.totalSalary;
        data['totalIncome'] = this.totalIncome;
        data['totalReceived'] = this.totalReceived;
        data['osAllowance'] = this.osAllowance;
        data['socialInsurance'] = this.socialInsurance;
        data['personalIncomeTax'] = this.personalIncomeTax;
        data['totalEmployee'] = this.totalEmployee;
        data['officialEmployee'] = this.officialEmployee;
        data['probationEmployee'] = this.probationEmployee;
        data['averageIncome'] = this.averageIncome;
        data['salaryDate'] = this.salaryDate ? this.salaryDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): EmployeePayrollDisbursementReportDto {
        const json = this.toJSON();
        let result = new EmployeePayrollDisbursementReportDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeePayrollDisbursementReportDto {
    totalHardSalary: number;
    totalSalary: number;
    totalIncome: number;
    totalReceived: number;
    osAllowance: number;
    socialInsurance: number;
    personalIncomeTax: number;
    totalEmployee: number;
    officialEmployee: number;
    probationEmployee: number;
    averageIncome: number;
    salaryDate: moment.Moment | undefined;
}

export class EvaluationAnswerModel implements IEvaluationAnswerModel {
    id: number;
    questionId: number;
    content: string | undefined;
    answerType: string | undefined;
    score: number;
    orderNo: number;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment | undefined;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment | undefined;

    constructor(data?: IEvaluationAnswerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.questionId = _data['questionId'];
            this.content = _data['content'];
            this.answerType = _data['answerType'];
            this.score = _data['score'];
            this.orderNo = _data['orderNo'];
            this.tenantId = _data['tenantId'];
            this.rowVersion = _data['rowVersion'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EvaluationAnswerModel {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationAnswerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['questionId'] = this.questionId;
        data['content'] = this.content;
        data['answerType'] = this.answerType;
        data['score'] = this.score;
        data['orderNo'] = this.orderNo;
        data['tenantId'] = this.tenantId;
        data['rowVersion'] = this.rowVersion;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): EvaluationAnswerModel {
        const json = this.toJSON();
        let result = new EvaluationAnswerModel();
        result.init(json);
        return result;
    }
}

export interface IEvaluationAnswerModel {
    id: number;
    questionId: number;
    content: string | undefined;
    answerType: string | undefined;
    score: number;
    orderNo: number;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment | undefined;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment | undefined;
}

export class EvaluationPeriodDto implements IEvaluationPeriodDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    statusCde: string | undefined;
    statusName: string | undefined;
    cssStatusCde: string | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment | undefined;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment | undefined;
    evaluationTemplate: EvaluationTemplateModel;
    evaluationQuestion: EvaluationQuestionModel[] | undefined;
    evaluationAnswer: EvaluationAnswerModel[] | undefined;

    constructor(data?: IEvaluationPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.code = _data['code'];
            this.name = _data['name'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.statusCde = _data['statusCde'];
            this.statusName = _data['statusName'];
            this.cssStatusCde = _data['cssStatusCde'];
            this.tenantId = _data['tenantId'];
            this.rowVersion = _data['rowVersion'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
            this.evaluationTemplate = _data['evaluationTemplate'] ? EvaluationTemplateModel.fromJS(_data['evaluationTemplate']) : <any>undefined;
            if (Array.isArray(_data['evaluationQuestion'])) {
                this.evaluationQuestion = [] as any;
                for (let item of _data['evaluationQuestion']) this.evaluationQuestion.push(EvaluationQuestionModel.fromJS(item));
            }
            if (Array.isArray(_data['evaluationAnswer'])) {
                this.evaluationAnswer = [] as any;
                for (let item of _data['evaluationAnswer']) this.evaluationAnswer.push(EvaluationAnswerModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EvaluationPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['code'] = this.code;
        data['name'] = this.name;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['statusCde'] = this.statusCde;
        data['statusName'] = this.statusName;
        data['cssStatusCde'] = this.cssStatusCde;
        data['tenantId'] = this.tenantId;
        data['rowVersion'] = this.rowVersion;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data['evaluationTemplate'] = this.evaluationTemplate ? this.evaluationTemplate.toJSON() : <any>undefined;
        if (Array.isArray(this.evaluationQuestion)) {
            data['evaluationQuestion'] = [];
            for (let item of this.evaluationQuestion) data['evaluationQuestion'].push(item.toJSON());
        }
        if (Array.isArray(this.evaluationAnswer)) {
            data['evaluationAnswer'] = [];
            for (let item of this.evaluationAnswer) data['evaluationAnswer'].push(item.toJSON());
        }
        return data;
    }

    clone(): EvaluationPeriodDto {
        const json = this.toJSON();
        let result = new EvaluationPeriodDto();
        result.init(json);
        return result;
    }
}

export interface IEvaluationPeriodDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    statusCde: string | undefined;
    statusName: string | undefined;
    cssStatusCde: string | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment | undefined;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment | undefined;
    evaluationTemplate: EvaluationTemplateModel;
    evaluationQuestion: EvaluationQuestionModel[] | undefined;
    evaluationAnswer: EvaluationAnswerModel[] | undefined;
}

export class EvaluationQuestionModel implements IEvaluationQuestionModel {
    id: number;
    templateId: number;
    content: string | undefined;
    questionType: string | undefined;
    orderNo: number;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment | undefined;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment | undefined;
    employeeType: string | undefined;

    constructor(data?: IEvaluationQuestionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.templateId = _data['templateId'];
            this.content = _data['content'];
            this.questionType = _data['questionType'];
            this.orderNo = _data['orderNo'];
            this.tenantId = _data['tenantId'];
            this.rowVersion = _data['rowVersion'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
            this.employeeType = _data['employeeType'];
        }
    }

    static fromJS(data: any): EvaluationQuestionModel {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationQuestionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['templateId'] = this.templateId;
        data['content'] = this.content;
        data['questionType'] = this.questionType;
        data['orderNo'] = this.orderNo;
        data['tenantId'] = this.tenantId;
        data['rowVersion'] = this.rowVersion;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data['employeeType'] = this.employeeType;
        return data;
    }

    clone(): EvaluationQuestionModel {
        const json = this.toJSON();
        let result = new EvaluationQuestionModel();
        result.init(json);
        return result;
    }
}

export interface IEvaluationQuestionModel {
    id: number;
    templateId: number;
    content: string | undefined;
    questionType: string | undefined;
    orderNo: number;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment | undefined;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment | undefined;
    employeeType: string | undefined;
}

export class EvaluationResultDetailModel implements IEvaluationResultDetailModel {
    id: number;
    questionId: number;
    questionType: string | undefined;
    answerType: string | undefined;
    content: string | undefined;
    score: number;
    orderNo: number;
    seltResultDetailId: number;
    seftResultId: number;
    seftScore: number;
    seltChecked: boolean;
    notes: string | undefined;
    managerResultDetailId: number;
    managerResultId: number;
    managerScore: number;
    managerChecked: boolean;
    managerNotes: string | undefined;
    hrResultDetailId: number;
    hrResultId: number;
    hrScore: number;
    hrChecked: boolean;
    hrNotes: string | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment | undefined;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment | undefined;

    constructor(data?: IEvaluationResultDetailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.questionId = _data['questionId'];
            this.questionType = _data['questionType'];
            this.answerType = _data['answerType'];
            this.content = _data['content'];
            this.score = _data['score'];
            this.orderNo = _data['orderNo'];
            this.seltResultDetailId = _data['seltResultDetailId'];
            this.seftResultId = _data['seftResultId'];
            this.seftScore = _data['seftScore'];
            this.seltChecked = _data['seltChecked'];
            this.notes = _data['notes'];
            this.managerResultDetailId = _data['managerResultDetailId'];
            this.managerResultId = _data['managerResultId'];
            this.managerScore = _data['managerScore'];
            this.managerChecked = _data['managerChecked'];
            this.managerNotes = _data['managerNotes'];
            this.hrResultDetailId = _data['hrResultDetailId'];
            this.hrResultId = _data['hrResultId'];
            this.hrScore = _data['hrScore'];
            this.hrChecked = _data['hrChecked'];
            this.hrNotes = _data['hrNotes'];
            this.tenantId = _data['tenantId'];
            this.rowVersion = _data['rowVersion'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EvaluationResultDetailModel {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationResultDetailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['questionId'] = this.questionId;
        data['questionType'] = this.questionType;
        data['answerType'] = this.answerType;
        data['content'] = this.content;
        data['score'] = this.score;
        data['orderNo'] = this.orderNo;
        data['seltResultDetailId'] = this.seltResultDetailId;
        data['seftResultId'] = this.seftResultId;
        data['seftScore'] = this.seftScore;
        data['seltChecked'] = this.seltChecked;
        data['notes'] = this.notes;
        data['managerResultDetailId'] = this.managerResultDetailId;
        data['managerResultId'] = this.managerResultId;
        data['managerScore'] = this.managerScore;
        data['managerChecked'] = this.managerChecked;
        data['managerNotes'] = this.managerNotes;
        data['hrResultDetailId'] = this.hrResultDetailId;
        data['hrResultId'] = this.hrResultId;
        data['hrScore'] = this.hrScore;
        data['hrChecked'] = this.hrChecked;
        data['hrNotes'] = this.hrNotes;
        data['tenantId'] = this.tenantId;
        data['rowVersion'] = this.rowVersion;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): EvaluationResultDetailModel {
        const json = this.toJSON();
        let result = new EvaluationResultDetailModel();
        result.init(json);
        return result;
    }
}

export interface IEvaluationResultDetailModel {
    id: number;
    questionId: number;
    questionType: string | undefined;
    answerType: string | undefined;
    content: string | undefined;
    score: number;
    orderNo: number;
    seltResultDetailId: number;
    seftResultId: number;
    seftScore: number;
    seltChecked: boolean;
    notes: string | undefined;
    managerResultDetailId: number;
    managerResultId: number;
    managerScore: number;
    managerChecked: boolean;
    managerNotes: string | undefined;
    hrResultDetailId: number;
    hrResultId: number;
    hrScore: number;
    hrChecked: boolean;
    hrNotes: string | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment | undefined;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment | undefined;
}

export class EvaluationResultDto implements IEvaluationResultDto {
    id: number;
    periodId: number;
    periodName: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    templateId: number;
    templateName: string | undefined;
    employeeId: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    resultId: number;
    evaluationType: string | undefined;
    selfTotalScore: number;
    selfComment: string | undefined;
    statusCde: string | undefined;
    wfDataCde: string | undefined;
    cancelReason: string | undefined;
    resultManagerId: number;
    managerId: number;
    managerName: string | undefined;
    managerTotalScore: number;
    managerComment: string | undefined;
    resultCompanyId: number;
    companyComment: string | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment;
    evaluationQuestion: EvaluationQuestionModel[] | undefined;
    evaluationResultDetail: EvaluationResultDetailModel[] | undefined;

    constructor(data?: IEvaluationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.periodId = _data['periodId'];
            this.periodName = _data['periodName'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.templateId = _data['templateId'];
            this.templateName = _data['templateName'];
            this.employeeId = _data['employeeId'];
            this.employeeCode = _data['employeeCode'];
            this.employeeName = _data['employeeName'];
            this.resultId = _data['resultId'];
            this.evaluationType = _data['evaluationType'];
            this.selfTotalScore = _data['selfTotalScore'];
            this.selfComment = _data['selfComment'];
            this.statusCde = _data['statusCde'];
            this.wfDataCde = _data['wfDataCde'];
            this.cancelReason = _data['cancelReason'];
            this.resultManagerId = _data['resultManagerId'];
            this.managerId = _data['managerId'];
            this.managerName = _data['managerName'];
            this.managerTotalScore = _data['managerTotalScore'];
            this.managerComment = _data['managerComment'];
            this.resultCompanyId = _data['resultCompanyId'];
            this.companyComment = _data['companyComment'];
            this.tenantId = _data['tenantId'];
            this.rowVersion = _data['rowVersion'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            if (Array.isArray(_data['evaluationQuestion'])) {
                this.evaluationQuestion = [] as any;
                for (let item of _data['evaluationQuestion']) this.evaluationQuestion.push(EvaluationQuestionModel.fromJS(item));
            }
            if (Array.isArray(_data['evaluationResultDetail'])) {
                this.evaluationResultDetail = [] as any;
                for (let item of _data['evaluationResultDetail']) this.evaluationResultDetail.push(EvaluationResultDetailModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EvaluationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['periodId'] = this.periodId;
        data['periodName'] = this.periodName;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['templateId'] = this.templateId;
        data['templateName'] = this.templateName;
        data['employeeId'] = this.employeeId;
        data['employeeCode'] = this.employeeCode;
        data['employeeName'] = this.employeeName;
        data['resultId'] = this.resultId;
        data['evaluationType'] = this.evaluationType;
        data['selfTotalScore'] = this.selfTotalScore;
        data['selfComment'] = this.selfComment;
        data['statusCde'] = this.statusCde;
        data['wfDataCde'] = this.wfDataCde;
        data['cancelReason'] = this.cancelReason;
        data['resultManagerId'] = this.resultManagerId;
        data['managerId'] = this.managerId;
        data['managerName'] = this.managerName;
        data['managerTotalScore'] = this.managerTotalScore;
        data['managerComment'] = this.managerComment;
        data['resultCompanyId'] = this.resultCompanyId;
        data['companyComment'] = this.companyComment;
        data['tenantId'] = this.tenantId;
        data['rowVersion'] = this.rowVersion;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        if (Array.isArray(this.evaluationQuestion)) {
            data['evaluationQuestion'] = [];
            for (let item of this.evaluationQuestion) data['evaluationQuestion'].push(item.toJSON());
        }
        if (Array.isArray(this.evaluationResultDetail)) {
            data['evaluationResultDetail'] = [];
            for (let item of this.evaluationResultDetail) data['evaluationResultDetail'].push(item.toJSON());
        }
        return data;
    }

    clone(): EvaluationResultDto {
        const json = this.toJSON();
        let result = new EvaluationResultDto();
        result.init(json);
        return result;
    }
}

export interface IEvaluationResultDto {
    id: number;
    periodId: number;
    periodName: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    templateId: number;
    templateName: string | undefined;
    employeeId: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    resultId: number;
    evaluationType: string | undefined;
    selfTotalScore: number;
    selfComment: string | undefined;
    statusCde: string | undefined;
    wfDataCde: string | undefined;
    cancelReason: string | undefined;
    resultManagerId: number;
    managerId: number;
    managerName: string | undefined;
    managerTotalScore: number;
    managerComment: string | undefined;
    resultCompanyId: number;
    companyComment: string | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment;
    evaluationQuestion: EvaluationQuestionModel[] | undefined;
    evaluationResultDetail: EvaluationResultDetailModel[] | undefined;
}

export class EvaluationTemplateModel implements IEvaluationTemplateModel {
    id: number;
    periodId: number;
    name: string | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment | undefined;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment | undefined;

    constructor(data?: IEvaluationTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.periodId = _data['periodId'];
            this.name = _data['name'];
            this.tenantId = _data['tenantId'];
            this.rowVersion = _data['rowVersion'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EvaluationTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['periodId'] = this.periodId;
        data['name'] = this.name;
        data['tenantId'] = this.tenantId;
        data['rowVersion'] = this.rowVersion;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): EvaluationTemplateModel {
        const json = this.toJSON();
        let result = new EvaluationTemplateModel();
        result.init(json);
        return result;
    }
}

export interface IEvaluationTemplateModel {
    id: number;
    periodId: number;
    name: string | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment | undefined;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment | undefined;
}

export class ExpenditureIncomeContractDto implements IExpenditureIncomeContractDto {
    id: number;
    contractName: string | undefined;
    remainingAmount: number;

    constructor(data?: IExpenditureIncomeContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.contractName = _data['contractName'];
            this.remainingAmount = _data['remainingAmount'];
        }
    }

    static fromJS(data: any): ExpenditureIncomeContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenditureIncomeContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['contractName'] = this.contractName;
        data['remainingAmount'] = this.remainingAmount;
        return data;
    }

    clone(): ExpenditureIncomeContractDto {
        const json = this.toJSON();
        let result = new ExpenditureIncomeContractDto();
        result.init(json);
        return result;
    }
}

export interface IExpenditureIncomeContractDto {
    id: number;
    contractName: string | undefined;
    remainingAmount: number;
}

export class ExpenditureIncomeDto implements IExpenditureIncomeDto {
    id: number;
    employeeId: number;
    contractId: number;
    targetType: string | undefined;
    type: string | undefined;
    amount: number;
    content: string | undefined;
    dateEI: moment.Moment;
    fileAttach: string | undefined;
    statusCde: string | undefined;
    rowVersion: string | undefined;
    remainingAmount: number | undefined;
    invoiceNumber: string | undefined;
    createBy: string | undefined;

    constructor(data?: IExpenditureIncomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.contractId = _data['contractId'];
            this.targetType = _data['targetType'];
            this.type = _data['type'];
            this.amount = _data['amount'];
            this.content = _data['content'];
            this.dateEI = _data['dateEI'] ? moment(_data['dateEI'].toString()) : <any>undefined;
            this.fileAttach = _data['fileAttach'];
            this.statusCde = _data['statusCde'];
            this.rowVersion = _data['rowVersion'];
            this.remainingAmount = _data['remainingAmount'];
            this.invoiceNumber = _data['invoiceNumber'];
            this.createBy = _data['createBy'];
        }
    }

    static fromJS(data: any): ExpenditureIncomeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenditureIncomeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['contractId'] = this.contractId;
        data['targetType'] = this.targetType;
        data['type'] = this.type;
        data['amount'] = this.amount;
        data['content'] = this.content;
        data['dateEI'] = this.dateEI ? this.dateEI.toISOString() : <any>undefined;
        data['fileAttach'] = this.fileAttach;
        data['statusCde'] = this.statusCde;
        data['rowVersion'] = this.rowVersion;
        data['remainingAmount'] = this.remainingAmount;
        data['invoiceNumber'] = this.invoiceNumber;
        data['createBy'] = this.createBy;
        return data;
    }

    clone(): ExpenditureIncomeDto {
        const json = this.toJSON();
        let result = new ExpenditureIncomeDto();
        result.init(json);
        return result;
    }
}

export interface IExpenditureIncomeDto {
    id: number;
    employeeId: number;
    contractId: number;
    targetType: string | undefined;
    type: string | undefined;
    amount: number;
    content: string | undefined;
    dateEI: moment.Moment;
    fileAttach: string | undefined;
    statusCde: string | undefined;
    rowVersion: string | undefined;
    remainingAmount: number | undefined;
    invoiceNumber: string | undefined;
    createBy: string | undefined;
}

export class ExpenditureIncomeEmployeeDto implements IExpenditureIncomeEmployeeDto {
    id: number;
    employeeName: string | undefined;

    constructor(data?: IExpenditureIncomeEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeName = _data['employeeName'];
        }
    }

    static fromJS(data: any): ExpenditureIncomeEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenditureIncomeEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeName'] = this.employeeName;
        return data;
    }

    clone(): ExpenditureIncomeEmployeeDto {
        const json = this.toJSON();
        let result = new ExpenditureIncomeEmployeeDto();
        result.init(json);
        return result;
    }
}

export interface IExpenditureIncomeEmployeeDto {
    id: number;
    employeeName: string | undefined;
}

export class ExportClientSalaryDto implements IExportClientSalaryDto {
    month: number;
    year: number;

    constructor(data?: IExportClientSalaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data['month'];
            this.year = _data['year'];
        }
    }

    static fromJS(data: any): ExportClientSalaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportClientSalaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['month'] = this.month;
        data['year'] = this.year;
        return data;
    }

    clone(): ExportClientSalaryDto {
        const json = this.toJSON();
        let result = new ExportClientSalaryDto();
        result.init(json);
        return result;
    }
}

export interface IExportClientSalaryDto {
    month: number;
    year: number;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data['authProvider'];
            this.providerKey = _data['providerKey'];
            this.providerAccessCode = _data['providerAccessCode'];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['authProvider'] = this.authProvider;
        data['providerKey'] = this.providerKey;
        data['providerAccessCode'] = this.providerAccessCode;
        return data;
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data['accessToken'];
            this.encryptedAccessToken = _data['encryptedAccessToken'];
            this.expireInSeconds = _data['expireInSeconds'];
            this.waitingForActivation = _data['waitingForActivation'];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['accessToken'] = this.accessToken;
        data['encryptedAccessToken'] = this.encryptedAccessToken;
        data['expireInSeconds'] = this.expireInSeconds;
        data['waitingForActivation'] = this.waitingForActivation;
        return data;
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.clientId = _data['clientId'];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['clientId'] = this.clientId;
        return data;
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class FamilyExemptionDto implements IFamilyExemptionDto {
    id: number;
    employeeId: number;
    familyExemptionCode: string | undefined;
    familyExemptionName: string | undefined;
    rowVersion: string | undefined;
    familyExemptionNumber: number;
    familyExemptionDate: moment.Moment | undefined;
    empRowVersion: string | undefined;
    createBy: string | undefined;

    constructor(data?: IFamilyExemptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.familyExemptionCode = _data['familyExemptionCode'];
            this.familyExemptionName = _data['familyExemptionName'];
            this.rowVersion = _data['rowVersion'];
            this.familyExemptionNumber = _data['familyExemptionNumber'];
            this.familyExemptionDate = _data['familyExemptionDate'] ? moment(_data['familyExemptionDate'].toString()) : <any>undefined;
            this.empRowVersion = _data['empRowVersion'];
            this.createBy = _data['createBy'];
        }
    }

    static fromJS(data: any): FamilyExemptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyExemptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['familyExemptionCode'] = this.familyExemptionCode;
        data['familyExemptionName'] = this.familyExemptionName;
        data['rowVersion'] = this.rowVersion;
        data['familyExemptionNumber'] = this.familyExemptionNumber;
        data['familyExemptionDate'] = this.familyExemptionDate ? this.familyExemptionDate.toISOString() : <any>undefined;
        data['empRowVersion'] = this.empRowVersion;
        data['createBy'] = this.createBy;
        return data;
    }

    clone(): FamilyExemptionDto {
        const json = this.toJSON();
        let result = new FamilyExemptionDto();
        result.init(json);
        return result;
    }
}

export interface IFamilyExemptionDto {
    id: number;
    employeeId: number;
    familyExemptionCode: string | undefined;
    familyExemptionName: string | undefined;
    rowVersion: string | undefined;
    familyExemptionNumber: number;
    familyExemptionDate: moment.Moment | undefined;
    empRowVersion: string | undefined;
    createBy: string | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.description = _data['description'];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['description'] = this.description;
        return data;
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data['application'] ? ApplicationInfoDto.fromJS(_data['application']) : <any>undefined;
            this.user = _data['user'] ? UserLoginInfoDto.fromJS(_data['user']) : <any>undefined;
            this.tenant = _data['tenant'] ? TenantLoginInfoDto.fromJS(_data['tenant']) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['application'] = this.application ? this.application.toJSON() : <any>undefined;
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        data['tenant'] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
}

export class GetInfoAttendanceDto implements IGetInfoAttendanceDto {
    attendanceId: number;
    attendanceDate: moment.Moment;

    constructor(data?: IGetInfoAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceId = _data['attendanceId'];
            this.attendanceDate = _data['attendanceDate'] ? moment(_data['attendanceDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetInfoAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetInfoAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['attendanceId'] = this.attendanceId;
        data['attendanceDate'] = this.attendanceDate ? this.attendanceDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): GetInfoAttendanceDto {
        const json = this.toJSON();
        let result = new GetInfoAttendanceDto();
        result.init(json);
        return result;
    }
}

export interface IGetInfoAttendanceDto {
    attendanceId: number;
    attendanceDate: moment.Moment;
}

export class GetInfoListNotificationDto implements IGetInfoListNotificationDto {
    id: number;
    title: string | undefined;
    body: string | undefined;
    content: string | undefined;
    notificationType: string | undefined;
    rowVersion: string | undefined;
    isActive: boolean;
    isSend: boolean;
    createBy: string | undefined;

    constructor(data?: IGetInfoListNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.title = _data['title'];
            this.body = _data['body'];
            this.content = _data['content'];
            this.notificationType = _data['notificationType'];
            this.rowVersion = _data['rowVersion'];
            this.isActive = _data['isActive'];
            this.isSend = _data['isSend'];
            this.createBy = _data['createBy'];
        }
    }

    static fromJS(data: any): GetInfoListNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetInfoListNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['title'] = this.title;
        data['body'] = this.body;
        data['content'] = this.content;
        data['notificationType'] = this.notificationType;
        data['rowVersion'] = this.rowVersion;
        data['isActive'] = this.isActive;
        data['isSend'] = this.isSend;
        data['createBy'] = this.createBy;
        return data;
    }

    clone(): GetInfoListNotificationDto {
        const json = this.toJSON();
        let result = new GetInfoListNotificationDto();
        result.init(json);
        return result;
    }
}

export interface IGetInfoListNotificationDto {
    id: number;
    title: string | undefined;
    body: string | undefined;
    content: string | undefined;
    notificationType: string | undefined;
    rowVersion: string | undefined;
    isActive: boolean;
    isSend: boolean;
    createBy: string | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data['role'] ? RoleEditDto.fromJS(_data['role']) : <any>undefined;
            if (Array.isArray(_data['permissions'])) {
                this.permissions = [] as any;
                for (let item of _data['permissions']) this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data['grantedPermissionNames'])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data['grantedPermissionNames']) this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['role'] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data['permissions'] = [];
            for (let item of this.permissions) data['permissions'].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data['grantedPermissionNames'] = [];
            for (let item of this.grantedPermissionNames) data['grantedPermissionNames'].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class HolidayDto implements IHolidayDto {
    id: number;
    holidayName: string | undefined;
    effectiveFromDate: moment.Moment;
    effectiveToDate: moment.Moment;
    numberHoliday: number;
    statusCde: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    description: string | undefined;
    isDeleted: boolean;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    makeUpDays: moment.Moment[] | undefined;

    constructor(data?: IHolidayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.holidayName = _data['holidayName'];
            this.effectiveFromDate = _data['effectiveFromDate'] ? moment(_data['effectiveFromDate'].toString()) : <any>undefined;
            this.effectiveToDate = _data['effectiveToDate'] ? moment(_data['effectiveToDate'].toString()) : <any>undefined;
            this.numberHoliday = _data['numberHoliday'];
            this.statusCde = _data['statusCde'];
            this.wfDataCde = _data['wfDataCde'];
            this.cancelReason = _data['cancelReason'];
            this.description = _data['description'];
            this.isDeleted = _data['isDeleted'];
            this.tenantId = _data['tenantId'];
            this.rowVersion = _data['rowVersion'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
            if (Array.isArray(_data['makeUpDays'])) {
                this.makeUpDays = [] as any;
                for (let item of _data['makeUpDays']) this.makeUpDays.push(moment(item));
            }
        }
    }

    static fromJS(data: any): HolidayDto {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['holidayName'] = this.holidayName;
        data['effectiveFromDate'] = this.effectiveFromDate ? this.effectiveFromDate.toISOString() : <any>undefined;
        data['effectiveToDate'] = this.effectiveToDate ? this.effectiveToDate.toISOString() : <any>undefined;
        data['numberHoliday'] = this.numberHoliday;
        data['statusCde'] = this.statusCde;
        data['wfDataCde'] = this.wfDataCde;
        data['cancelReason'] = this.cancelReason;
        data['description'] = this.description;
        data['isDeleted'] = this.isDeleted;
        data['tenantId'] = this.tenantId;
        data['rowVersion'] = this.rowVersion;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.makeUpDays)) {
            data['makeUpDays'] = [];
            for (let item of this.makeUpDays) data['makeUpDays'].push(item.toISOString());
        }
        return data;
    }

    clone(): HolidayDto {
        const json = this.toJSON();
        let result = new HolidayDto();
        result.init(json);
        return result;
    }
}

export interface IHolidayDto {
    id: number;
    holidayName: string | undefined;
    effectiveFromDate: moment.Moment;
    effectiveToDate: moment.Moment;
    numberHoliday: number;
    statusCde: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    description: string | undefined;
    isDeleted: boolean;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    makeUpDays: moment.Moment[] | undefined;
}

export class HomeGetExpiresPartnerContractDto implements IHomeGetExpiresPartnerContractDto {
    rowIndex: number;
    employeeCode: string | undefined;
    fullName: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment | undefined;
    partnerName: string | undefined;
    partnerAddress: string | undefined;
    partnerPhone: string | undefined;

    constructor(data?: IHomeGetExpiresPartnerContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowIndex = _data['rowIndex'];
            this.employeeCode = _data['employeeCode'];
            this.fullName = _data['fullName'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.partnerName = _data['partnerName'];
            this.partnerAddress = _data['partnerAddress'];
            this.partnerPhone = _data['partnerPhone'];
        }
    }

    static fromJS(data: any): HomeGetExpiresPartnerContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new HomeGetExpiresPartnerContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['rowIndex'] = this.rowIndex;
        data['employeeCode'] = this.employeeCode;
        data['fullName'] = this.fullName;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['partnerName'] = this.partnerName;
        data['partnerAddress'] = this.partnerAddress;
        data['partnerPhone'] = this.partnerPhone;
        return data;
    }

    clone(): HomeGetExpiresPartnerContractDto {
        const json = this.toJSON();
        let result = new HomeGetExpiresPartnerContractDto();
        result.init(json);
        return result;
    }
}

export interface IHomeGetExpiresPartnerContractDto {
    rowIndex: number;
    employeeCode: string | undefined;
    fullName: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment | undefined;
    partnerName: string | undefined;
    partnerAddress: string | undefined;
    partnerPhone: string | undefined;
}

export class HomeListBirthdayDto implements IHomeListBirthdayDto {
    rowIndex: number;
    employeeCode: string | undefined;
    fullName: string | undefined;
    birthday: moment.Moment | undefined;

    constructor(data?: IHomeListBirthdayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowIndex = _data['rowIndex'];
            this.employeeCode = _data['employeeCode'];
            this.fullName = _data['fullName'];
            this.birthday = _data['birthday'] ? moment(_data['birthday'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HomeListBirthdayDto {
        data = typeof data === 'object' ? data : {};
        let result = new HomeListBirthdayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['rowIndex'] = this.rowIndex;
        data['employeeCode'] = this.employeeCode;
        data['fullName'] = this.fullName;
        data['birthday'] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        return data;
    }

    clone(): HomeListBirthdayDto {
        const json = this.toJSON();
        let result = new HomeListBirthdayDto();
        result.init(json);
        return result;
    }
}

export interface IHomeListBirthdayDto {
    rowIndex: number;
    employeeCode: string | undefined;
    fullName: string | undefined;
    birthday: moment.Moment | undefined;
}

export class InfoAdvanceSalaryDto implements IInfoAdvanceSalaryDto {
    id: number;
    advanceType: string | undefined;
    amount: number;
    advanceDate: moment.Moment;
    employeeId: number;
    fullName: string | undefined;
    description: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment;
    rowVersion: string | undefined;
    statusCde: string | undefined;
    wfDataCde: string;

    constructor(data?: IInfoAdvanceSalaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.advanceType = _data['advanceType'];
            this.amount = _data['amount'];
            this.advanceDate = _data['advanceDate'] ? moment(_data['advanceDate'].toString()) : <any>undefined;
            this.employeeId = _data['employeeId'];
            this.fullName = _data['fullName'];
            this.description = _data['description'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            this.rowVersion = _data['rowVersion'];
            this.statusCde = _data['statusCde'];
            this.wfDataCde = _data['wfDataCde'];
        }
    }

    static fromJS(data: any): InfoAdvanceSalaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new InfoAdvanceSalaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['advanceType'] = this.advanceType;
        data['amount'] = this.amount;
        data['advanceDate'] = this.advanceDate ? this.advanceDate.toISOString() : <any>undefined;
        data['employeeId'] = this.employeeId;
        data['fullName'] = this.fullName;
        data['description'] = this.description;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data['rowVersion'] = this.rowVersion;
        data['statusCde'] = this.statusCde;
        data['wfDataCde'] = this.wfDataCde;
        return data;
    }

    clone(): InfoAdvanceSalaryDto {
        const json = this.toJSON();
        let result = new InfoAdvanceSalaryDto();
        result.init(json);
        return result;
    }
}

export interface IInfoAdvanceSalaryDto {
    id: number;
    advanceType: string | undefined;
    amount: number;
    advanceDate: moment.Moment;
    employeeId: number;
    fullName: string | undefined;
    description: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment;
    rowVersion: string | undefined;
    statusCde: string | undefined;
    wfDataCde: string;
}

export class InforUserModel implements IInforUserModel {
    id: number;
    creationTime: moment.Moment;
    userName: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    emailAddress: string | undefined;
    isActive: boolean;
    fullName: string | undefined;
    roleNames: string[] | undefined;
    phoneNumber: string | undefined;
    gender: string | undefined;
    birthday: moment.Moment | undefined;
    identityCard: string | undefined;
    identityCardDate: string | undefined;
    identityCardPlace: string | undefined;
    permanentAddress: string | undefined;
    temporaryAddress: string | undefined;
    avatar: string | undefined;
    tenantId: number;

    constructor(data?: IInforUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.userName = _data['userName'];
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.emailAddress = _data['emailAddress'];
            this.isActive = _data['isActive'];
            this.fullName = _data['fullName'];
            if (Array.isArray(_data['roleNames'])) {
                this.roleNames = [] as any;
                for (let item of _data['roleNames']) this.roleNames.push(item);
            }
            this.phoneNumber = _data['phoneNumber'];
            this.gender = _data['gender'];
            this.birthday = _data['birthday'] ? moment(_data['birthday'].toString()) : <any>undefined;
            this.identityCard = _data['identityCard'];
            this.identityCardDate = _data['identityCardDate'];
            this.identityCardPlace = _data['identityCardPlace'];
            this.permanentAddress = _data['permanentAddress'];
            this.temporaryAddress = _data['temporaryAddress'];
            this.avatar = _data['avatar'];
            this.tenantId = _data['tenantId'];
        }
    }

    static fromJS(data: any): InforUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new InforUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['userName'] = this.userName;
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['emailAddress'] = this.emailAddress;
        data['isActive'] = this.isActive;
        data['fullName'] = this.fullName;
        if (Array.isArray(this.roleNames)) {
            data['roleNames'] = [];
            for (let item of this.roleNames) data['roleNames'].push(item);
        }
        data['phoneNumber'] = this.phoneNumber;
        data['gender'] = this.gender;
        data['birthday'] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data['identityCard'] = this.identityCard;
        data['identityCardDate'] = this.identityCardDate;
        data['identityCardPlace'] = this.identityCardPlace;
        data['permanentAddress'] = this.permanentAddress;
        data['temporaryAddress'] = this.temporaryAddress;
        data['avatar'] = this.avatar;
        data['tenantId'] = this.tenantId;
        return data;
    }

    clone(): InforUserModel {
        const json = this.toJSON();
        let result = new InforUserModel();
        result.init(json);
        return result;
    }
}

export interface IInforUserModel {
    id: number;
    creationTime: moment.Moment;
    userName: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    emailAddress: string | undefined;
    isActive: boolean;
    fullName: string | undefined;
    roleNames: string[] | undefined;
    phoneNumber: string | undefined;
    gender: string | undefined;
    birthday: moment.Moment | undefined;
    identityCard: string | undefined;
    identityCardDate: string | undefined;
    identityCardPlace: string | undefined;
    permanentAddress: string | undefined;
    temporaryAddress: string | undefined;
    avatar: string | undefined;
    tenantId: number;
}

export class InsertAdvanceSalaryDto implements IInsertAdvanceSalaryDto {
    advanceType: string | undefined;
    amount: number;
    advanceDate: moment.Moment;
    employeeId: number;
    description: string | undefined;
    statusCde: string | undefined;
    wfDataCde: string;

    constructor(data?: IInsertAdvanceSalaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advanceType = _data['advanceType'];
            this.amount = _data['amount'];
            this.advanceDate = _data['advanceDate'] ? moment(_data['advanceDate'].toString()) : <any>undefined;
            this.employeeId = _data['employeeId'];
            this.description = _data['description'];
            this.statusCde = _data['statusCde'];
            this.wfDataCde = _data['wfDataCde'];
        }
    }

    static fromJS(data: any): InsertAdvanceSalaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsertAdvanceSalaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['advanceType'] = this.advanceType;
        data['amount'] = this.amount;
        data['advanceDate'] = this.advanceDate ? this.advanceDate.toISOString() : <any>undefined;
        data['employeeId'] = this.employeeId;
        data['description'] = this.description;
        data['statusCde'] = this.statusCde;
        data['wfDataCde'] = this.wfDataCde;
        return data;
    }

    clone(): InsertAdvanceSalaryDto {
        const json = this.toJSON();
        let result = new InsertAdvanceSalaryDto();
        result.init(json);
        return result;
    }
}

export interface IInsertAdvanceSalaryDto {
    advanceType: string | undefined;
    amount: number;
    advanceDate: moment.Moment;
    employeeId: number;
    description: string | undefined;
    statusCde: string | undefined;
    wfDataCde: string;
}

export class InsertExpenditureIncomeDto implements IInsertExpenditureIncomeDto {
    employeeId: number | undefined;
    type: string | undefined;
    amount: number;
    content: string | undefined;
    dateEI: moment.Moment;
    fileAttach: string | undefined;
    contractId: number | undefined;
    targetType: string | undefined;
    invoiceNumber: string | undefined;

    constructor(data?: IInsertExpenditureIncomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data['employeeId'];
            this.type = _data['type'];
            this.amount = _data['amount'];
            this.content = _data['content'];
            this.dateEI = _data['dateEI'] ? moment(_data['dateEI'].toString()) : <any>undefined;
            this.fileAttach = _data['fileAttach'];
            this.contractId = _data['contractId'];
            this.targetType = _data['targetType'];
            this.invoiceNumber = _data['invoiceNumber'];
        }
    }

    static fromJS(data: any): InsertExpenditureIncomeDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsertExpenditureIncomeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['employeeId'] = this.employeeId;
        data['type'] = this.type;
        data['amount'] = this.amount;
        data['content'] = this.content;
        data['dateEI'] = this.dateEI ? this.dateEI.toISOString() : <any>undefined;
        data['fileAttach'] = this.fileAttach;
        data['contractId'] = this.contractId;
        data['targetType'] = this.targetType;
        data['invoiceNumber'] = this.invoiceNumber;
        return data;
    }

    clone(): InsertExpenditureIncomeDto {
        const json = this.toJSON();
        let result = new InsertExpenditureIncomeDto();
        result.init(json);
        return result;
    }
}

export interface IInsertExpenditureIncomeDto {
    employeeId: number | undefined;
    type: string | undefined;
    amount: number;
    content: string | undefined;
    dateEI: moment.Moment;
    fileAttach: string | undefined;
    contractId: number | undefined;
    targetType: string | undefined;
    invoiceNumber: string | undefined;
}

export class InsuranceGetByIdDto implements IInsuranceGetByIdDto {
    id: number;
    employeeCode: string | undefined;
    insuranceNumber: string | undefined;
    fullName: string | undefined;
    hospitalCode: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    amount: number;
    social: number;
    health: number;
    accident: number;
    socialIndividual: number;
    healthIndividual: number;
    accidentIndividual: number;
    description: string | undefined;
    rowVersion: string | undefined;
    createBy: string | undefined;

    constructor(data?: IInsuranceGetByIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeCode = _data['employeeCode'];
            this.insuranceNumber = _data['insuranceNumber'];
            this.fullName = _data['fullName'];
            this.hospitalCode = _data['hospitalCode'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.amount = _data['amount'];
            this.social = _data['social'];
            this.health = _data['health'];
            this.accident = _data['accident'];
            this.socialIndividual = _data['socialIndividual'];
            this.healthIndividual = _data['healthIndividual'];
            this.accidentIndividual = _data['accidentIndividual'];
            this.description = _data['description'];
            this.rowVersion = _data['rowVersion'];
            this.createBy = _data['createBy'];
        }
    }

    static fromJS(data: any): InsuranceGetByIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceGetByIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeCode'] = this.employeeCode;
        data['insuranceNumber'] = this.insuranceNumber;
        data['fullName'] = this.fullName;
        data['hospitalCode'] = this.hospitalCode;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['amount'] = this.amount;
        data['social'] = this.social;
        data['health'] = this.health;
        data['accident'] = this.accident;
        data['socialIndividual'] = this.socialIndividual;
        data['healthIndividual'] = this.healthIndividual;
        data['accidentIndividual'] = this.accidentIndividual;
        data['description'] = this.description;
        data['rowVersion'] = this.rowVersion;
        data['createBy'] = this.createBy;
        return data;
    }

    clone(): InsuranceGetByIdDto {
        const json = this.toJSON();
        let result = new InsuranceGetByIdDto();
        result.init(json);
        return result;
    }
}

export interface IInsuranceGetByIdDto {
    id: number;
    employeeCode: string | undefined;
    insuranceNumber: string | undefined;
    fullName: string | undefined;
    hospitalCode: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    amount: number;
    social: number;
    health: number;
    accident: number;
    socialIndividual: number;
    healthIndividual: number;
    accidentIndividual: number;
    description: string | undefined;
    rowVersion: string | undefined;
    createBy: string | undefined;
}

export class Int64EntityDto implements IInt64EntityDto {
    id: number;

    constructor(data?: IInt64EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): Int64EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        return data;
    }

    clone(): Int64EntityDto {
        const json = this.toJSON();
        let result = new Int64EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt64EntityDto {
    id: number;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data['tenancyName'];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenancyName'] = this.tenancyName;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data['state'];
            this.tenantId = _data['tenantId'];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['state'] = this.state;
        data['tenantId'] = this.tenantId;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
}

export class LanguageTextsDto implements ILanguageTextsDto {
    id: number;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    key: string | undefined;
    languageName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    source: string | undefined;
    tenantId: number | undefined;
    value: string | undefined;

    constructor(data?: ILanguageTextsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.key = _data['key'];
            this.languageName = _data['languageName'];
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
            this.lastModifierUserId = _data['lastModifierUserId'];
            this.source = _data['source'];
            this.tenantId = _data['tenantId'];
            this.value = _data['value'];
        }
    }

    static fromJS(data: any): LanguageTextsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['key'] = this.key;
        data['languageName'] = this.languageName;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data['lastModifierUserId'] = this.lastModifierUserId;
        data['source'] = this.source;
        data['tenantId'] = this.tenantId;
        data['value'] = this.value;
        return data;
    }

    clone(): LanguageTextsDto {
        const json = this.toJSON();
        let result = new LanguageTextsDto();
        result.init(json);
        return result;
    }
}

export interface ILanguageTextsDto {
    id: number;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    key: string | undefined;
    languageName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    source: string | undefined;
    tenantId: number | undefined;
    value: string | undefined;
}

export class LanguagesDisplayNameDto implements ILanguagesDisplayNameDto {
    name: string | undefined;
    displayName: string | undefined;

    constructor(data?: ILanguagesDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.displayName = _data['displayName'];
        }
    }

    static fromJS(data: any): LanguagesDisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguagesDisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        return data;
    }

    clone(): LanguagesDisplayNameDto {
        const json = this.toJSON();
        let result = new LanguagesDisplayNameDto();
        result.init(json);
        return result;
    }
}

export interface ILanguagesDisplayNameDto {
    name: string | undefined;
    displayName: string | undefined;
}

export class MasterDataModel implements IMasterDataModel {
    id: number;
    code: string | undefined;
    name: string | undefined;
    nameLevel: string | undefined;

    constructor(data?: IMasterDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.code = _data['code'];
            this.name = _data['name'];
            this.nameLevel = _data['nameLevel'];
        }
    }

    static fromJS(data: any): MasterDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['code'] = this.code;
        data['name'] = this.name;
        data['nameLevel'] = this.nameLevel;
        return data;
    }

    clone(): MasterDataModel {
        const json = this.toJSON();
        let result = new MasterDataModel();
        result.init(json);
        return result;
    }
}

export interface IMasterDataModel {
    id: number;
    code: string | undefined;
    name: string | undefined;
    nameLevel: string | undefined;
}

export class MasterUserModel implements IMasterUserModel {
    userId: number;
    isActive: boolean;
    name: string | undefined;
    surname: string | undefined;
    tenantId: number;
    userName: string | undefined;
    fullName: string | undefined;

    constructor(data?: IMasterUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data['userId'];
            this.isActive = _data['isActive'];
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.tenantId = _data['tenantId'];
            this.userName = _data['userName'];
            this.fullName = _data['fullName'];
        }
    }

    static fromJS(data: any): MasterUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new MasterUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userId'] = this.userId;
        data['isActive'] = this.isActive;
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['tenantId'] = this.tenantId;
        data['userName'] = this.userName;
        data['fullName'] = this.fullName;
        return data;
    }

    clone(): MasterUserModel {
        const json = this.toJSON();
        let result = new MasterUserModel();
        result.init(json);
        return result;
    }
}

export interface IMasterUserModel {
    userId: number;
    isActive: boolean;
    name: string | undefined;
    surname: string | undefined;
    tenantId: number;
    userName: string | undefined;
    fullName: string | undefined;
}

export class PermissionDto implements IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.description = _data['description'];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['description'] = this.description;
        return data;
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export class ProvinceModel implements IProvinceModel {
    id: number;
    code: string | undefined;
    name: string | undefined;
    areaCde: string | undefined;
    provinceType: string | undefined;
    countryCde: string | undefined;
    isDeleted: boolean;
    rowVersion: string | undefined;
    createdBy: string | undefined;
    createdDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    tenantId: number;

    constructor(data?: IProvinceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.code = _data['code'];
            this.name = _data['name'];
            this.areaCde = _data['areaCde'];
            this.provinceType = _data['provinceType'];
            this.countryCde = _data['countryCde'];
            this.isDeleted = _data['isDeleted'];
            this.rowVersion = _data['rowVersion'];
            this.createdBy = _data['createdBy'];
            this.createdDate = _data['createdDate'] ? moment(_data['createdDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
            this.tenantId = _data['tenantId'];
        }
    }

    static fromJS(data: any): ProvinceModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProvinceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['code'] = this.code;
        data['name'] = this.name;
        data['areaCde'] = this.areaCde;
        data['provinceType'] = this.provinceType;
        data['countryCde'] = this.countryCde;
        data['isDeleted'] = this.isDeleted;
        data['rowVersion'] = this.rowVersion;
        data['createdBy'] = this.createdBy;
        data['createdDate'] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data['tenantId'] = this.tenantId;
        return data;
    }

    clone(): ProvinceModel {
        const json = this.toJSON();
        let result = new ProvinceModel();
        result.init(json);
        return result;
    }
}

export interface IProvinceModel {
    id: number;
    code: string | undefined;
    name: string | undefined;
    areaCde: string | undefined;
    provinceType: string | undefined;
    countryCde: string | undefined;
    isDeleted: boolean;
    rowVersion: string | undefined;
    createdBy: string | undefined;
    createdDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    tenantId: number;
}

export class RECRequestDto implements IRECRequestDto {
    id: number;
    departmentCode: string | undefined;
    position: string | undefined;
    quantity: number;
    reason: string | undefined;
    requestDate: moment.Moment | undefined;
    statusCode: string | undefined;
    approvedBy: string | undefined;
    approvedDate: moment.Moment | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment | undefined;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment | undefined;

    constructor(data?: IRECRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.departmentCode = _data['departmentCode'];
            this.position = _data['position'];
            this.quantity = _data['quantity'];
            this.reason = _data['reason'];
            this.requestDate = _data['requestDate'] ? moment(_data['requestDate'].toString()) : <any>undefined;
            this.statusCode = _data['statusCode'];
            this.approvedBy = _data['approvedBy'];
            this.approvedDate = _data['approvedDate'] ? moment(_data['approvedDate'].toString()) : <any>undefined;
            this.tenantId = _data['tenantId'];
            this.rowVersion = _data['rowVersion'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RECRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RECRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['departmentCode'] = this.departmentCode;
        data['position'] = this.position;
        data['quantity'] = this.quantity;
        data['reason'] = this.reason;
        data['requestDate'] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data['statusCode'] = this.statusCode;
        data['approvedBy'] = this.approvedBy;
        data['approvedDate'] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data['tenantId'] = this.tenantId;
        data['rowVersion'] = this.rowVersion;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): RECRequestDto {
        const json = this.toJSON();
        let result = new RECRequestDto();
        result.init(json);
        return result;
    }
}

export interface IRECRequestDto {
    id: number;
    departmentCode: string | undefined;
    position: string | undefined;
    quantity: number;
    reason: string | undefined;
    requestDate: moment.Moment | undefined;
    statusCode: string | undefined;
    approvedBy: string | undefined;
    approvedDate: moment.Moment | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment | undefined;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment | undefined;
}

export class RecruitmentCandidatesDto implements IRecruitmentCandidatesDto {
    id: number;
    fullName: string | undefined;
    birthday: moment.Moment | undefined;
    sex: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    address: string | undefined;
    expertise: string | undefined;
    expectedSalary: number | undefined;
    offeredSalary: number | undefined;
    interviewDateTime: moment.Moment | undefined;
    availableStartDate: moment.Moment | undefined;
    cvType: string | undefined;
    cvFilePath: string | undefined;
    cvExternalLink: string | undefined;
    statusCde: string | undefined;
    note: string | undefined;
    isDeleted: boolean;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    cssStatusCde: string | undefined;
    statusName: string | undefined;

    constructor(data?: IRecruitmentCandidatesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.fullName = _data['fullName'];
            this.birthday = _data['birthday'] ? moment(_data['birthday'].toString()) : <any>undefined;
            this.sex = _data['sex'];
            this.phoneNumber = _data['phoneNumber'];
            this.email = _data['email'];
            this.address = _data['address'];
            this.expertise = _data['expertise'];
            this.expectedSalary = _data['expectedSalary'];
            this.offeredSalary = _data['offeredSalary'];
            this.interviewDateTime = _data['interviewDateTime'] ? moment(_data['interviewDateTime'].toString()) : <any>undefined;
            this.availableStartDate = _data['availableStartDate'] ? moment(_data['availableStartDate'].toString()) : <any>undefined;
            this.cvType = _data['cvType'];
            this.cvFilePath = _data['cvFilePath'];
            this.cvExternalLink = _data['cvExternalLink'];
            this.statusCde = _data['statusCde'];
            this.note = _data['note'];
            this.isDeleted = _data['isDeleted'];
            this.tenantId = _data['tenantId'];
            this.rowVersion = _data['rowVersion'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
            this.cssStatusCde = _data['cssStatusCde'];
            this.statusName = _data['statusName'];
        }
    }

    static fromJS(data: any): RecruitmentCandidatesDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecruitmentCandidatesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['fullName'] = this.fullName;
        data['birthday'] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data['sex'] = this.sex;
        data['phoneNumber'] = this.phoneNumber;
        data['email'] = this.email;
        data['address'] = this.address;
        data['expertise'] = this.expertise;
        data['expectedSalary'] = this.expectedSalary;
        data['offeredSalary'] = this.offeredSalary;
        data['interviewDateTime'] = this.interviewDateTime ? this.interviewDateTime.toISOString() : <any>undefined;
        data['availableStartDate'] = this.availableStartDate ? this.availableStartDate.toISOString() : <any>undefined;
        data['cvType'] = this.cvType;
        data['cvFilePath'] = this.cvFilePath;
        data['cvExternalLink'] = this.cvExternalLink;
        data['statusCde'] = this.statusCde;
        data['note'] = this.note;
        data['isDeleted'] = this.isDeleted;
        data['tenantId'] = this.tenantId;
        data['rowVersion'] = this.rowVersion;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data['cssStatusCde'] = this.cssStatusCde;
        data['statusName'] = this.statusName;
        return data;
    }

    clone(): RecruitmentCandidatesDto {
        const json = this.toJSON();
        let result = new RecruitmentCandidatesDto();
        result.init(json);
        return result;
    }
}

export interface IRecruitmentCandidatesDto {
    id: number;
    fullName: string | undefined;
    birthday: moment.Moment | undefined;
    sex: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    address: string | undefined;
    expertise: string | undefined;
    expectedSalary: number | undefined;
    offeredSalary: number | undefined;
    interviewDateTime: moment.Moment | undefined;
    availableStartDate: moment.Moment | undefined;
    cvType: string | undefined;
    cvFilePath: string | undefined;
    cvExternalLink: string | undefined;
    statusCde: string | undefined;
    note: string | undefined;
    isDeleted: boolean;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    cssStatusCde: string | undefined;
    statusName: string | undefined;
}

export class RecruitmentDto implements IRecruitmentDto {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    birthday: moment.Moment | undefined;
    sex: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    address: string | undefined;
    expertise: string | undefined;
    expectedSalary: number | undefined;
    offeredSalary: number | undefined;
    interviewDateTime: moment.Moment | undefined;
    availableStartDate: moment.Moment | undefined;
    cvType: string | undefined;
    cvFilePath: string | undefined;
    cvExternalLink: string | undefined;
    statusCde: string | undefined;
    note: string | undefined;
    isDeleted: boolean;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    cssStatusCde: string | undefined;
    statusName: string | undefined;

    constructor(data?: IRecruitmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.firstName = _data['firstName'];
            this.lastName = _data['lastName'];
            this.birthday = _data['birthday'] ? moment(_data['birthday'].toString()) : <any>undefined;
            this.sex = _data['sex'];
            this.phoneNumber = _data['phoneNumber'];
            this.email = _data['email'];
            this.address = _data['address'];
            this.expertise = _data['expertise'];
            this.expectedSalary = _data['expectedSalary'];
            this.offeredSalary = _data['offeredSalary'];
            this.interviewDateTime = _data['interviewDateTime'] ? moment(_data['interviewDateTime'].toString()) : <any>undefined;
            this.availableStartDate = _data['availableStartDate'] ? moment(_data['availableStartDate'].toString()) : <any>undefined;
            this.cvType = _data['cvType'];
            this.cvFilePath = _data['cvFilePath'];
            this.cvExternalLink = _data['cvExternalLink'];
            this.statusCde = _data['statusCde'];
            this.note = _data['note'];
            this.isDeleted = _data['isDeleted'];
            this.tenantId = _data['tenantId'];
            this.rowVersion = _data['rowVersion'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
            this.cssStatusCde = _data['cssStatusCde'];
            this.statusName = _data['statusName'];
        }
    }

    static fromJS(data: any): RecruitmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecruitmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['firstName'] = this.firstName;
        data['lastName'] = this.lastName;
        data['birthday'] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data['sex'] = this.sex;
        data['phoneNumber'] = this.phoneNumber;
        data['email'] = this.email;
        data['address'] = this.address;
        data['expertise'] = this.expertise;
        data['expectedSalary'] = this.expectedSalary;
        data['offeredSalary'] = this.offeredSalary;
        data['interviewDateTime'] = this.interviewDateTime ? this.interviewDateTime.toISOString() : <any>undefined;
        data['availableStartDate'] = this.availableStartDate ? this.availableStartDate.toISOString() : <any>undefined;
        data['cvType'] = this.cvType;
        data['cvFilePath'] = this.cvFilePath;
        data['cvExternalLink'] = this.cvExternalLink;
        data['statusCde'] = this.statusCde;
        data['note'] = this.note;
        data['isDeleted'] = this.isDeleted;
        data['tenantId'] = this.tenantId;
        data['rowVersion'] = this.rowVersion;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data['cssStatusCde'] = this.cssStatusCde;
        data['statusName'] = this.statusName;
        return data;
    }

    clone(): RecruitmentDto {
        const json = this.toJSON();
        let result = new RecruitmentDto();
        result.init(json);
        return result;
    }
}

export interface IRecruitmentDto {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    birthday: moment.Moment | undefined;
    sex: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    address: string | undefined;
    expertise: string | undefined;
    expectedSalary: number | undefined;
    offeredSalary: number | undefined;
    interviewDateTime: moment.Moment | undefined;
    availableStartDate: moment.Moment | undefined;
    cvType: string | undefined;
    cvFilePath: string | undefined;
    cvExternalLink: string | undefined;
    statusCde: string | undefined;
    note: string | undefined;
    isDeleted: boolean;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    cssStatusCde: string | undefined;
    statusName: string | undefined;
}

export class RecruitmentJobPostsDto implements IRecruitmentJobPostsDto {
    id: number;
    planId: number;
    title: string | undefined;
    description: string | undefined;
    channel: string | undefined;
    publishDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    jobPostsCde: string | undefined;
    statusCode: string | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment | undefined;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment | undefined;

    constructor(data?: IRecruitmentJobPostsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.planId = _data['planId'];
            this.title = _data['title'];
            this.description = _data['description'];
            this.channel = _data['channel'];
            this.publishDate = _data['publishDate'] ? moment(_data['publishDate'].toString()) : <any>undefined;
            this.expireDate = _data['expireDate'] ? moment(_data['expireDate'].toString()) : <any>undefined;
            this.jobPostsCde = _data['jobPostsCde'];
            this.statusCode = _data['statusCode'];
            this.tenantId = _data['tenantId'];
            this.rowVersion = _data['rowVersion'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecruitmentJobPostsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecruitmentJobPostsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['planId'] = this.planId;
        data['title'] = this.title;
        data['description'] = this.description;
        data['channel'] = this.channel;
        data['publishDate'] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data['expireDate'] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data['jobPostsCde'] = this.jobPostsCde;
        data['statusCode'] = this.statusCode;
        data['tenantId'] = this.tenantId;
        data['rowVersion'] = this.rowVersion;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): RecruitmentJobPostsDto {
        const json = this.toJSON();
        let result = new RecruitmentJobPostsDto();
        result.init(json);
        return result;
    }
}

export interface IRecruitmentJobPostsDto {
    id: number;
    planId: number;
    title: string | undefined;
    description: string | undefined;
    channel: string | undefined;
    publishDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    jobPostsCde: string | undefined;
    statusCode: string | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment | undefined;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment | undefined;
}

export class RecruitmentPlansDto implements IRecruitmentPlansDto {
    id: number;
    requestId: number;
    planName: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    budget: number;
    statusCode: string | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment | undefined;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment | undefined;

    constructor(data?: IRecruitmentPlansDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.requestId = _data['requestId'];
            this.planName = _data['planName'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.budget = _data['budget'];
            this.statusCode = _data['statusCode'];
            this.tenantId = _data['tenantId'];
            this.rowVersion = _data['rowVersion'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecruitmentPlansDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecruitmentPlansDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['requestId'] = this.requestId;
        data['planName'] = this.planName;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['budget'] = this.budget;
        data['statusCode'] = this.statusCode;
        data['tenantId'] = this.tenantId;
        data['rowVersion'] = this.rowVersion;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): RecruitmentPlansDto {
        const json = this.toJSON();
        let result = new RecruitmentPlansDto();
        result.init(json);
        return result;
    }
}

export interface IRecruitmentPlansDto {
    id: number;
    requestId: number;
    planName: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    budget: number;
    statusCode: string | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    createBy: string | undefined;
    createDate: moment.Moment | undefined;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment | undefined;
}

export class RegisterClientAnnualLeaveDto implements IRegisterClientAnnualLeaveDto {
    annualLeaveType: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    hoursLeft: number;
    content: string | undefined;
    employeeName: string | undefined;
    annualLeaveTypeName: string | undefined;

    constructor(data?: IRegisterClientAnnualLeaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.annualLeaveType = _data['annualLeaveType'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.hoursLeft = _data['hoursLeft'];
            this.content = _data['content'];
            this.employeeName = _data['employeeName'];
            this.annualLeaveTypeName = _data['annualLeaveTypeName'];
        }
    }

    static fromJS(data: any): RegisterClientAnnualLeaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterClientAnnualLeaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['annualLeaveType'] = this.annualLeaveType;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['hoursLeft'] = this.hoursLeft;
        data['content'] = this.content;
        data['employeeName'] = this.employeeName;
        data['annualLeaveTypeName'] = this.annualLeaveTypeName;
        return data;
    }

    clone(): RegisterClientAnnualLeaveDto {
        const json = this.toJSON();
        let result = new RegisterClientAnnualLeaveDto();
        result.init(json);
        return result;
    }
}

export interface IRegisterClientAnnualLeaveDto {
    annualLeaveType: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    hoursLeft: number;
    content: string | undefined;
    employeeName: string | undefined;
    annualLeaveTypeName: string | undefined;
}

export class RegisterInput implements IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.userName = _data['userName'];
            this.emailAddress = _data['emailAddress'];
            this.password = _data['password'];
            this.captchaResponse = _data['captchaResponse'];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['userName'] = this.userName;
        data['emailAddress'] = this.emailAddress;
        data['password'] = this.password;
        data['captchaResponse'] = this.captchaResponse;
        return data;
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data['canLogin'];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['canLogin'] = this.canLogin;
        return data;
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class RegisterOvertimeDto implements IRegisterOvertimeDto {
    id: number;
    employeeId: number;
    employeeCode: string | undefined;
    fullName: string | undefined;
    hoursOvertime: number;
    overtimeDate: moment.Moment | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    description: string | undefined;
    content: string | undefined;
    statusCde: string | undefined;
    title: string | undefined;
    cancelReason: string | undefined;
    wfDataCde: string | undefined;
    rowVersion: string | undefined;
    isDeleted: boolean;
    createBy: string | undefined;
    createDate: moment.Moment | undefined;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment | undefined;
    tenantId: number;

    constructor(data?: IRegisterOvertimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.employeeCode = _data['employeeCode'];
            this.fullName = _data['fullName'];
            this.hoursOvertime = _data['hoursOvertime'];
            this.overtimeDate = _data['overtimeDate'] ? moment(_data['overtimeDate'].toString()) : <any>undefined;
            this.startTime = _data['startTime'];
            this.endTime = _data['endTime'];
            this.description = _data['description'];
            this.content = _data['content'];
            this.statusCde = _data['statusCde'];
            this.title = _data['title'];
            this.cancelReason = _data['cancelReason'];
            this.wfDataCde = _data['wfDataCde'];
            this.rowVersion = _data['rowVersion'];
            this.isDeleted = _data['isDeleted'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
            this.tenantId = _data['tenantId'];
        }
    }

    static fromJS(data: any): RegisterOvertimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOvertimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['employeeCode'] = this.employeeCode;
        data['fullName'] = this.fullName;
        data['hoursOvertime'] = this.hoursOvertime;
        data['overtimeDate'] = this.overtimeDate ? this.overtimeDate.toISOString() : <any>undefined;
        data['startTime'] = this.startTime;
        data['endTime'] = this.endTime;
        data['description'] = this.description;
        data['content'] = this.content;
        data['statusCde'] = this.statusCde;
        data['title'] = this.title;
        data['cancelReason'] = this.cancelReason;
        data['wfDataCde'] = this.wfDataCde;
        data['rowVersion'] = this.rowVersion;
        data['isDeleted'] = this.isDeleted;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data['tenantId'] = this.tenantId;
        return data;
    }

    clone(): RegisterOvertimeDto {
        const json = this.toJSON();
        let result = new RegisterOvertimeDto();
        result.init(json);
        return result;
    }
}

export interface IRegisterOvertimeDto {
    id: number;
    employeeId: number;
    employeeCode: string | undefined;
    fullName: string | undefined;
    hoursOvertime: number;
    overtimeDate: moment.Moment | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    description: string | undefined;
    content: string | undefined;
    statusCde: string | undefined;
    title: string | undefined;
    cancelReason: string | undefined;
    wfDataCde: string | undefined;
    rowVersion: string | undefined;
    isDeleted: boolean;
    createBy: string | undefined;
    createDate: moment.Moment | undefined;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment | undefined;
    tenantId: number;
}

export class RemainingLeaveDetailModel implements IRemainingLeaveDetailModel {
    id: number;
    remainingLeaveId: number;
    employeeID: number;
    employeeCode: string | undefined;
    fullName: string | undefined;
    hoursLeft: number;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    note: string | undefined;
    rowVersion: string | undefined;

    constructor(data?: IRemainingLeaveDetailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.remainingLeaveId = _data['remainingLeaveId'];
            this.employeeID = _data['employeeID'];
            this.employeeCode = _data['employeeCode'];
            this.fullName = _data['fullName'];
            this.hoursLeft = _data['hoursLeft'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.note = _data['note'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): RemainingLeaveDetailModel {
        data = typeof data === 'object' ? data : {};
        let result = new RemainingLeaveDetailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['remainingLeaveId'] = this.remainingLeaveId;
        data['employeeID'] = this.employeeID;
        data['employeeCode'] = this.employeeCode;
        data['fullName'] = this.fullName;
        data['hoursLeft'] = this.hoursLeft;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['note'] = this.note;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): RemainingLeaveDetailModel {
        const json = this.toJSON();
        let result = new RemainingLeaveDetailModel();
        result.init(json);
        return result;
    }
}

export interface IRemainingLeaveDetailModel {
    id: number;
    remainingLeaveId: number;
    employeeID: number;
    employeeCode: string | undefined;
    fullName: string | undefined;
    hoursLeft: number;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    note: string | undefined;
    rowVersion: string | undefined;
}

export class RemainingLeaveDto implements IRemainingLeaveDto {
    id: number;
    titleName: string | undefined;
    code: string | undefined;
    leaveYear: number | undefined;
    totalHoursLeft: number;
    notes: string | undefined;
    rowVersion: string | undefined;
    statusCde: string | undefined;
    cssStatusCde: string | undefined;
    statusName: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    modifiedBy: string | undefined;
    createBy: string | undefined;
    createByName: string | undefined;
    createDate: moment.Moment;

    constructor(data?: IRemainingLeaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.titleName = _data['titleName'];
            this.code = _data['code'];
            this.leaveYear = _data['leaveYear'];
            this.totalHoursLeft = _data['totalHoursLeft'];
            this.notes = _data['notes'];
            this.rowVersion = _data['rowVersion'];
            this.statusCde = _data['statusCde'];
            this.cssStatusCde = _data['cssStatusCde'];
            this.statusName = _data['statusName'];
            this.wfDataCde = _data['wfDataCde'];
            this.cancelReason = _data['cancelReason'];
            this.modifiedBy = _data['modifiedBy'];
            this.createBy = _data['createBy'];
            this.createByName = _data['createByName'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RemainingLeaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemainingLeaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['titleName'] = this.titleName;
        data['code'] = this.code;
        data['leaveYear'] = this.leaveYear;
        data['totalHoursLeft'] = this.totalHoursLeft;
        data['notes'] = this.notes;
        data['rowVersion'] = this.rowVersion;
        data['statusCde'] = this.statusCde;
        data['cssStatusCde'] = this.cssStatusCde;
        data['statusName'] = this.statusName;
        data['wfDataCde'] = this.wfDataCde;
        data['cancelReason'] = this.cancelReason;
        data['modifiedBy'] = this.modifiedBy;
        data['createBy'] = this.createBy;
        data['createByName'] = this.createByName;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): RemainingLeaveDto {
        const json = this.toJSON();
        let result = new RemainingLeaveDto();
        result.init(json);
        return result;
    }
}

export interface IRemainingLeaveDto {
    id: number;
    titleName: string | undefined;
    code: string | undefined;
    leaveYear: number | undefined;
    totalHoursLeft: number;
    notes: string | undefined;
    rowVersion: string | undefined;
    statusCde: string | undefined;
    cssStatusCde: string | undefined;
    statusName: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    modifiedBy: string | undefined;
    createBy: string | undefined;
    createByName: string | undefined;
    createDate: moment.Moment;
}

export class ResetPasswordDto implements IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data['adminPassword'];
            this.userId = _data['userId'];
            this.newPassword = _data['newPassword'];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['adminPassword'] = this.adminPassword;
        data['userId'] = this.userId;
        data['newPassword'] = this.newPassword;
        return data;
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class ResetPasswordEmployeeDto implements IResetPasswordEmployeeDto {
    id: number;
    newPassword: string | undefined;
    rowVersion: string | undefined;
    email: string | undefined;

    constructor(data?: IResetPasswordEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.newPassword = _data['newPassword'];
            this.rowVersion = _data['rowVersion'];
            this.email = _data['email'];
        }
    }

    static fromJS(data: any): ResetPasswordEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['newPassword'] = this.newPassword;
        data['rowVersion'] = this.rowVersion;
        data['email'] = this.email;
        return data;
    }

    clone(): ResetPasswordEmployeeDto {
        const json = this.toJSON();
        let result = new ResetPasswordEmployeeDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordEmployeeDto {
    id: number;
    newPassword: string | undefined;
    rowVersion: string | undefined;
    email: string | undefined;
}

export class ResultListDto implements IResultListDto {
    totalCount: number;
    items: any | undefined;

    constructor(data?: IResultListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            this.items = _data['items'];
        }
    }

    static fromJS(data: any): ResultListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        data['items'] = this.items;
        return data;
    }

    clone(): ResultListDto {
        const json = this.toJSON();
        let result = new ResultListDto();
        result.init(json);
        return result;
    }
}

export interface IResultListDto {
    totalCount: number;
    items: any | undefined;
}

export class RoleDto implements IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.normalizedName = _data['normalizedName'];
            this.description = _data['description'];
            if (Array.isArray(_data['grantedPermissions'])) {
                this.grantedPermissions = [] as any;
                for (let item of _data['grantedPermissions']) this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['normalizedName'] = this.normalizedName;
        data['description'] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data['grantedPermissions'] = [];
            for (let item of this.grantedPermissions) data['grantedPermissions'].push(item);
        }
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoListResultDto {
    items: RoleDto[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(RoleDto.fromJS(item));
            }
            this.totalCount = _data['totalCount'];
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        data['totalCount'] = this.totalCount;
        return data;
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;
}

export class RoleEditDto implements IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.description = _data['description'];
            this.isStatic = _data['isStatic'];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['description'] = this.description;
        data['isStatic'] = this.isStatic;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
}

export class RoleListDto implements IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.isStatic = _data['isStatic'];
            this.isDefault = _data['isDefault'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['isStatic'] = this.isStatic;
        data['isDefault'] = this.isDefault;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class SalaryBasicDto implements ISalaryBasicDto {
    id: number;
    employeeId: number;
    employeeCode: string | undefined;
    fullName: string | undefined;
    salaryType: string | undefined;
    salaryAmount: number | undefined;
    salaryDate: moment.Moment | undefined;
    laborContractCode: string | undefined;
    contractNumber: string | undefined;
    dateContract: moment.Moment | undefined;
    contractFile: string | undefined;
    filename: string | undefined;
    rowVersion: string | undefined;
    createBy: string | undefined;

    constructor(data?: ISalaryBasicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.employeeCode = _data['employeeCode'];
            this.fullName = _data['fullName'];
            this.salaryType = _data['salaryType'];
            this.salaryAmount = _data['salaryAmount'];
            this.salaryDate = _data['salaryDate'] ? moment(_data['salaryDate'].toString()) : <any>undefined;
            this.laborContractCode = _data['laborContractCode'];
            this.contractNumber = _data['contractNumber'];
            this.dateContract = _data['dateContract'] ? moment(_data['dateContract'].toString()) : <any>undefined;
            this.contractFile = _data['contractFile'];
            this.filename = _data['filename'];
            this.rowVersion = _data['rowVersion'];
            this.createBy = _data['createBy'];
        }
    }

    static fromJS(data: any): SalaryBasicDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryBasicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['employeeCode'] = this.employeeCode;
        data['fullName'] = this.fullName;
        data['salaryType'] = this.salaryType;
        data['salaryAmount'] = this.salaryAmount;
        data['salaryDate'] = this.salaryDate ? this.salaryDate.toISOString() : <any>undefined;
        data['laborContractCode'] = this.laborContractCode;
        data['contractNumber'] = this.contractNumber;
        data['dateContract'] = this.dateContract ? this.dateContract.toISOString() : <any>undefined;
        data['contractFile'] = this.contractFile;
        data['filename'] = this.filename;
        data['rowVersion'] = this.rowVersion;
        data['createBy'] = this.createBy;
        return data;
    }

    clone(): SalaryBasicDto {
        const json = this.toJSON();
        let result = new SalaryBasicDto();
        result.init(json);
        return result;
    }
}

export interface ISalaryBasicDto {
    id: number;
    employeeId: number;
    employeeCode: string | undefined;
    fullName: string | undefined;
    salaryType: string | undefined;
    salaryAmount: number | undefined;
    salaryDate: moment.Moment | undefined;
    laborContractCode: string | undefined;
    contractNumber: string | undefined;
    dateContract: moment.Moment | undefined;
    contractFile: string | undefined;
    filename: string | undefined;
    rowVersion: string | undefined;
    createBy: string | undefined;
}

export class SalaryDto implements ISalaryDto {
    id: number;
    titleName: string | undefined;
    code: string | undefined;
    salaryDate: moment.Moment | undefined;
    notes: string | undefined;
    rowVersion: string | undefined;
    statusCde: string | undefined;
    cssStatusCde: string | undefined;
    statusName: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    modifiedBy: string | undefined;
    createBy: string | undefined;
    createByName: string | undefined;
    createDate: moment.Moment;
    attendanceStatusCde: string | undefined;

    constructor(data?: ISalaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.titleName = _data['titleName'];
            this.code = _data['code'];
            this.salaryDate = _data['salaryDate'] ? moment(_data['salaryDate'].toString()) : <any>undefined;
            this.notes = _data['notes'];
            this.rowVersion = _data['rowVersion'];
            this.statusCde = _data['statusCde'];
            this.cssStatusCde = _data['cssStatusCde'];
            this.statusName = _data['statusName'];
            this.wfDataCde = _data['wfDataCde'];
            this.cancelReason = _data['cancelReason'];
            this.modifiedBy = _data['modifiedBy'];
            this.createBy = _data['createBy'];
            this.createByName = _data['createByName'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            this.attendanceStatusCde = _data['attendanceStatusCde'];
        }
    }

    static fromJS(data: any): SalaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['titleName'] = this.titleName;
        data['code'] = this.code;
        data['salaryDate'] = this.salaryDate ? this.salaryDate.toISOString() : <any>undefined;
        data['notes'] = this.notes;
        data['rowVersion'] = this.rowVersion;
        data['statusCde'] = this.statusCde;
        data['cssStatusCde'] = this.cssStatusCde;
        data['statusName'] = this.statusName;
        data['wfDataCde'] = this.wfDataCde;
        data['cancelReason'] = this.cancelReason;
        data['modifiedBy'] = this.modifiedBy;
        data['createBy'] = this.createBy;
        data['createByName'] = this.createByName;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data['attendanceStatusCde'] = this.attendanceStatusCde;
        return data;
    }

    clone(): SalaryDto {
        const json = this.toJSON();
        let result = new SalaryDto();
        result.init(json);
        return result;
    }
}

export interface ISalaryDto {
    id: number;
    titleName: string | undefined;
    code: string | undefined;
    salaryDate: moment.Moment | undefined;
    notes: string | undefined;
    rowVersion: string | undefined;
    statusCde: string | undefined;
    cssStatusCde: string | undefined;
    statusName: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    modifiedBy: string | undefined;
    createBy: string | undefined;
    createByName: string | undefined;
    createDate: moment.Moment;
    attendanceStatusCde: string | undefined;
}

export class SendListNotificationDto implements ISendListNotificationDto {
    id: number;
    notificationType: string | undefined;
    title: string | undefined;
    body: string | undefined;
    content: string | undefined;
    rowVersion: string | undefined;

    constructor(data?: ISendListNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.notificationType = _data['notificationType'];
            this.title = _data['title'];
            this.body = _data['body'];
            this.content = _data['content'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): SendListNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendListNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['notificationType'] = this.notificationType;
        data['title'] = this.title;
        data['body'] = this.body;
        data['content'] = this.content;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): SendListNotificationDto {
        const json = this.toJSON();
        let result = new SendListNotificationDto();
        result.init(json);
        return result;
    }
}

export interface ISendListNotificationDto {
    id: number;
    notificationType: string | undefined;
    title: string | undefined;
    body: string | undefined;
    content: string | undefined;
    rowVersion: string | undefined;
}

export class StringEntityDto implements IStringEntityDto {
    id: string | undefined;

    constructor(data?: IStringEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): StringEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new StringEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        return data;
    }

    clone(): StringEntityDto {
        const json = this.toJSON();
        let result = new StringEntityDto();
        result.init(json);
        return result;
    }
}

export interface IStringEntityDto {
    id: string | undefined;
}

export class SysAppParamDto implements ISysAppParamDto {
    paramCode: string | undefined;
    paramValue: string | undefined;
    description: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
    rowVersion: string | undefined;
    createdBy: string | undefined;
    createdDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    tenantId: number;

    constructor(data?: ISysAppParamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paramCode = _data['paramCode'];
            this.paramValue = _data['paramValue'];
            this.description = _data['description'];
            this.isActive = _data['isActive'];
            this.isDeleted = _data['isDeleted'];
            this.rowVersion = _data['rowVersion'];
            this.createdBy = _data['createdBy'];
            this.createdDate = _data['createdDate'] ? moment(_data['createdDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
            this.tenantId = _data['tenantId'];
        }
    }

    static fromJS(data: any): SysAppParamDto {
        data = typeof data === 'object' ? data : {};
        let result = new SysAppParamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['paramCode'] = this.paramCode;
        data['paramValue'] = this.paramValue;
        data['description'] = this.description;
        data['isActive'] = this.isActive;
        data['isDeleted'] = this.isDeleted;
        data['rowVersion'] = this.rowVersion;
        data['createdBy'] = this.createdBy;
        data['createdDate'] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data['tenantId'] = this.tenantId;
        return data;
    }

    clone(): SysAppParamDto {
        const json = this.toJSON();
        let result = new SysAppParamDto();
        result.init(json);
        return result;
    }
}

export interface ISysAppParamDto {
    paramCode: string | undefined;
    paramValue: string | undefined;
    description: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
    rowVersion: string | undefined;
    createdBy: string | undefined;
    createdDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    tenantId: number;
}

export class SysMasterListDto implements ISysMasterListDto {
    masterListID: number;
    masterListCode: string | undefined;
    masterListGroupCde: string | undefined;
    masterListCdeName: string | undefined;
    mastListDefaultValue: string | undefined;
    mastListExtendValue1: string | undefined;

    constructor(data?: ISysMasterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.masterListID = _data['masterListID'];
            this.masterListCode = _data['masterListCode'];
            this.masterListGroupCde = _data['masterListGroupCde'];
            this.masterListCdeName = _data['masterListCdeName'];
            this.mastListDefaultValue = _data['mastListDefaultValue'];
            this.mastListExtendValue1 = _data['mastListExtendValue1'];
        }
    }

    static fromJS(data: any): SysMasterListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SysMasterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['masterListID'] = this.masterListID;
        data['masterListCode'] = this.masterListCode;
        data['masterListGroupCde'] = this.masterListGroupCde;
        data['masterListCdeName'] = this.masterListCdeName;
        data['mastListDefaultValue'] = this.mastListDefaultValue;
        data['mastListExtendValue1'] = this.mastListExtendValue1;
        return data;
    }

    clone(): SysMasterListDto {
        const json = this.toJSON();
        let result = new SysMasterListDto();
        result.init(json);
        return result;
    }
}

export interface ISysMasterListDto {
    masterListID: number;
    masterListCode: string | undefined;
    masterListGroupCde: string | undefined;
    masterListCdeName: string | undefined;
    mastListDefaultValue: string | undefined;
    mastListExtendValue1: string | undefined;
}

export class SysMasterListInfoDto implements ISysMasterListInfoDto {
    masterListID: number;
    masterListCode: string | undefined;
    masterListGroupCde: string | undefined;
    masterListCdeName: string | undefined;
    mastListDefaultValue: string | undefined;
    mastListExtendValue1: string | undefined;
    mastListExtendValue2: string | undefined;
    mastListExtendValue3: string | undefined;
    mastListExtendValue4: string | undefined;
    mastListExtendValue5: string | undefined;
    description: string | undefined;
    orderNo: number;
    isActive: boolean | undefined;
    rowVersion: string | undefined;

    constructor(data?: ISysMasterListInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.masterListID = _data['masterListID'];
            this.masterListCode = _data['masterListCode'];
            this.masterListGroupCde = _data['masterListGroupCde'];
            this.masterListCdeName = _data['masterListCdeName'];
            this.mastListDefaultValue = _data['mastListDefaultValue'];
            this.mastListExtendValue1 = _data['mastListExtendValue1'];
            this.mastListExtendValue2 = _data['mastListExtendValue2'];
            this.mastListExtendValue3 = _data['mastListExtendValue3'];
            this.mastListExtendValue4 = _data['mastListExtendValue4'];
            this.mastListExtendValue5 = _data['mastListExtendValue5'];
            this.description = _data['description'];
            this.orderNo = _data['orderNo'];
            this.isActive = _data['isActive'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): SysMasterListInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SysMasterListInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['masterListID'] = this.masterListID;
        data['masterListCode'] = this.masterListCode;
        data['masterListGroupCde'] = this.masterListGroupCde;
        data['masterListCdeName'] = this.masterListCdeName;
        data['mastListDefaultValue'] = this.mastListDefaultValue;
        data['mastListExtendValue1'] = this.mastListExtendValue1;
        data['mastListExtendValue2'] = this.mastListExtendValue2;
        data['mastListExtendValue3'] = this.mastListExtendValue3;
        data['mastListExtendValue4'] = this.mastListExtendValue4;
        data['mastListExtendValue5'] = this.mastListExtendValue5;
        data['description'] = this.description;
        data['orderNo'] = this.orderNo;
        data['isActive'] = this.isActive;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): SysMasterListInfoDto {
        const json = this.toJSON();
        let result = new SysMasterListInfoDto();
        result.init(json);
        return result;
    }
}

export interface ISysMasterListInfoDto {
    masterListID: number;
    masterListCode: string | undefined;
    masterListGroupCde: string | undefined;
    masterListCdeName: string | undefined;
    mastListDefaultValue: string | undefined;
    mastListExtendValue1: string | undefined;
    mastListExtendValue2: string | undefined;
    mastListExtendValue3: string | undefined;
    mastListExtendValue4: string | undefined;
    mastListExtendValue5: string | undefined;
    description: string | undefined;
    orderNo: number;
    isActive: boolean | undefined;
    rowVersion: string | undefined;
}

export class SysWorkflowDto implements ISysWorkflowDto {
    totalRows: number;
    rowIndex: number;
    totalPages: number;
    workflowID: number;
    workflowCode: string | undefined;
    workflowName: string | undefined;
    currentStep: number;
    nextStep: number;
    hardStep: string | undefined;
    actionName: string | undefined;
    statusCde: string | undefined;
    currentSystemCde: string | undefined;
    usrRoleCde: string | undefined;
    buttonDisplayCde: string | undefined;
    inputCanSee: string | undefined;
    inputCanEdit: string | undefined;
    preProcessFunc: string | undefined;
    cssClass: string | undefined;
    cssIcon: string | undefined;
    isRequiredComment: boolean;
    isActive: boolean;
    createdBy: string | undefined;
    createdDate: moment.Moment | undefined;
    isDeleted: boolean;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment | undefined;
    tenantId: number;
    workflowCodeName: string | undefined;
    tableName: string | undefined;
    usrRoleCdeName: string | undefined;

    constructor(data?: ISysWorkflowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data['totalRows'];
            this.rowIndex = _data['rowIndex'];
            this.totalPages = _data['totalPages'];
            this.workflowID = _data['workflowID'];
            this.workflowCode = _data['workflowCode'];
            this.workflowName = _data['workflowName'];
            this.currentStep = _data['currentStep'];
            this.nextStep = _data['nextStep'];
            this.hardStep = _data['hardStep'];
            this.actionName = _data['actionName'];
            this.statusCde = _data['statusCde'];
            this.currentSystemCde = _data['currentSystemCde'];
            this.usrRoleCde = _data['usrRoleCde'];
            this.buttonDisplayCde = _data['buttonDisplayCde'];
            this.inputCanSee = _data['inputCanSee'];
            this.inputCanEdit = _data['inputCanEdit'];
            this.preProcessFunc = _data['preProcessFunc'];
            this.cssClass = _data['cssClass'];
            this.cssIcon = _data['cssIcon'];
            this.isRequiredComment = _data['isRequiredComment'];
            this.isActive = _data['isActive'];
            this.createdBy = _data['createdBy'];
            this.createdDate = _data['createdDate'] ? moment(_data['createdDate'].toString()) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.rowVersion = _data['rowVersion'];
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
            this.tenantId = _data['tenantId'];
            this.workflowCodeName = _data['workflowCodeName'];
            this.tableName = _data['tableName'];
            this.usrRoleCdeName = _data['usrRoleCdeName'];
        }
    }

    static fromJS(data: any): SysWorkflowDto {
        data = typeof data === 'object' ? data : {};
        let result = new SysWorkflowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalRows'] = this.totalRows;
        data['rowIndex'] = this.rowIndex;
        data['totalPages'] = this.totalPages;
        data['workflowID'] = this.workflowID;
        data['workflowCode'] = this.workflowCode;
        data['workflowName'] = this.workflowName;
        data['currentStep'] = this.currentStep;
        data['nextStep'] = this.nextStep;
        data['hardStep'] = this.hardStep;
        data['actionName'] = this.actionName;
        data['statusCde'] = this.statusCde;
        data['currentSystemCde'] = this.currentSystemCde;
        data['usrRoleCde'] = this.usrRoleCde;
        data['buttonDisplayCde'] = this.buttonDisplayCde;
        data['inputCanSee'] = this.inputCanSee;
        data['inputCanEdit'] = this.inputCanEdit;
        data['preProcessFunc'] = this.preProcessFunc;
        data['cssClass'] = this.cssClass;
        data['cssIcon'] = this.cssIcon;
        data['isRequiredComment'] = this.isRequiredComment;
        data['isActive'] = this.isActive;
        data['createdBy'] = this.createdBy;
        data['createdDate'] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['rowVersion'] = this.rowVersion;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data['tenantId'] = this.tenantId;
        data['workflowCodeName'] = this.workflowCodeName;
        data['tableName'] = this.tableName;
        data['usrRoleCdeName'] = this.usrRoleCdeName;
        return data;
    }

    clone(): SysWorkflowDto {
        const json = this.toJSON();
        let result = new SysWorkflowDto();
        result.init(json);
        return result;
    }
}

export interface ISysWorkflowDto {
    totalRows: number;
    rowIndex: number;
    totalPages: number;
    workflowID: number;
    workflowCode: string | undefined;
    workflowName: string | undefined;
    currentStep: number;
    nextStep: number;
    hardStep: string | undefined;
    actionName: string | undefined;
    statusCde: string | undefined;
    currentSystemCde: string | undefined;
    usrRoleCde: string | undefined;
    buttonDisplayCde: string | undefined;
    inputCanSee: string | undefined;
    inputCanEdit: string | undefined;
    preProcessFunc: string | undefined;
    cssClass: string | undefined;
    cssIcon: string | undefined;
    isRequiredComment: boolean;
    isActive: boolean;
    createdBy: string | undefined;
    createdDate: moment.Moment | undefined;
    isDeleted: boolean;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment | undefined;
    tenantId: number;
    workflowCodeName: string | undefined;
    tableName: string | undefined;
    usrRoleCdeName: string | undefined;
}

export class SysWorkflowStateDto implements ISysWorkflowStateDto {
    workflowStateID: number | undefined;
    workflowCde: string | undefined;
    dataStateCde: string | undefined;
    currentStep: number | undefined;
    nextStep: number | undefined;
    hardStep: string | undefined;
    actionName: string | undefined;
    statusCde: string | undefined;
    departmentCde: string | undefined;
    usrRoleCde: string | undefined;
    remark: string | undefined;
    createdDate: moment.Moment;
    createdBy: string | undefined;
    statusName: string | undefined;
    fullName: string | undefined;

    constructor(data?: ISysWorkflowStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowStateID = _data['workflowStateID'];
            this.workflowCde = _data['workflowCde'];
            this.dataStateCde = _data['dataStateCde'];
            this.currentStep = _data['currentStep'];
            this.nextStep = _data['nextStep'];
            this.hardStep = _data['hardStep'];
            this.actionName = _data['actionName'];
            this.statusCde = _data['statusCde'];
            this.departmentCde = _data['departmentCde'];
            this.usrRoleCde = _data['usrRoleCde'];
            this.remark = _data['remark'];
            this.createdDate = _data['createdDate'] ? moment(_data['createdDate'].toString()) : <any>undefined;
            this.createdBy = _data['createdBy'];
            this.statusName = _data['statusName'];
            this.fullName = _data['fullName'];
        }
    }

    static fromJS(data: any): SysWorkflowStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SysWorkflowStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['workflowStateID'] = this.workflowStateID;
        data['workflowCde'] = this.workflowCde;
        data['dataStateCde'] = this.dataStateCde;
        data['currentStep'] = this.currentStep;
        data['nextStep'] = this.nextStep;
        data['hardStep'] = this.hardStep;
        data['actionName'] = this.actionName;
        data['statusCde'] = this.statusCde;
        data['departmentCde'] = this.departmentCde;
        data['usrRoleCde'] = this.usrRoleCde;
        data['remark'] = this.remark;
        data['createdDate'] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data['createdBy'] = this.createdBy;
        data['statusName'] = this.statusName;
        data['fullName'] = this.fullName;
        return data;
    }

    clone(): SysWorkflowStateDto {
        const json = this.toJSON();
        let result = new SysWorkflowStateDto();
        result.init(json);
        return result;
    }
}

export interface ISysWorkflowStateDto {
    workflowStateID: number | undefined;
    workflowCde: string | undefined;
    dataStateCde: string | undefined;
    currentStep: number | undefined;
    nextStep: number | undefined;
    hardStep: string | undefined;
    actionName: string | undefined;
    statusCde: string | undefined;
    departmentCde: string | undefined;
    usrRoleCde: string | undefined;
    remark: string | undefined;
    createdDate: moment.Moment;
    createdBy: string | undefined;
    statusName: string | undefined;
    fullName: string | undefined;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3
}

export class TenantDto implements ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.tenancyName = _data['tenancyName'];
            this.name = _data['name'];
            this.isActive = _data['isActive'];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['tenancyName'] = this.tenancyName;
        data['name'] = this.name;
        data['isActive'] = this.isActive;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(TenantDto.fromJS(item));
            }
            this.totalCount = _data['totalCount'];
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        data['totalCount'] = this.totalCount;
        return data;
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.tenancyName = _data['tenancyName'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['tenancyName'] = this.tenancyName;
        data['name'] = this.name;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
}

export class UpdateAdvanceSalaryDto implements IUpdateAdvanceSalaryDto {
    id: number;
    advanceType: string | undefined;
    amount: number;
    advanceDate: moment.Moment;
    employeeId: number;
    description: string | undefined;
    rowVersion: string | undefined;
    statusCde: string | undefined;
    wfDataCde: string;

    constructor(data?: IUpdateAdvanceSalaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.advanceType = _data['advanceType'];
            this.amount = _data['amount'];
            this.advanceDate = _data['advanceDate'] ? moment(_data['advanceDate'].toString()) : <any>undefined;
            this.employeeId = _data['employeeId'];
            this.description = _data['description'];
            this.rowVersion = _data['rowVersion'];
            this.statusCde = _data['statusCde'];
            this.wfDataCde = _data['wfDataCde'];
        }
    }

    static fromJS(data: any): UpdateAdvanceSalaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAdvanceSalaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['advanceType'] = this.advanceType;
        data['amount'] = this.amount;
        data['advanceDate'] = this.advanceDate ? this.advanceDate.toISOString() : <any>undefined;
        data['employeeId'] = this.employeeId;
        data['description'] = this.description;
        data['rowVersion'] = this.rowVersion;
        data['statusCde'] = this.statusCde;
        data['wfDataCde'] = this.wfDataCde;
        return data;
    }

    clone(): UpdateAdvanceSalaryDto {
        const json = this.toJSON();
        let result = new UpdateAdvanceSalaryDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAdvanceSalaryDto {
    id: number;
    advanceType: string | undefined;
    amount: number;
    advanceDate: moment.Moment;
    employeeId: number;
    description: string | undefined;
    rowVersion: string | undefined;
    statusCde: string | undefined;
    wfDataCde: string;
}

export class UpdateAnnualLeaveDto implements IUpdateAnnualLeaveDto {
    id: number;
    employeeId: number;
    employeeCode: string | undefined;
    fullName: string | undefined;
    annualLeaveType: string | undefined;
    statusCde: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    content: string | undefined;
    hoursLeft: number;
    description: string | undefined;
    rowVersion: string | undefined;

    constructor(data?: IUpdateAnnualLeaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.employeeCode = _data['employeeCode'];
            this.fullName = _data['fullName'];
            this.annualLeaveType = _data['annualLeaveType'];
            this.statusCde = _data['statusCde'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.content = _data['content'];
            this.hoursLeft = _data['hoursLeft'];
            this.description = _data['description'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): UpdateAnnualLeaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAnnualLeaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['employeeCode'] = this.employeeCode;
        data['fullName'] = this.fullName;
        data['annualLeaveType'] = this.annualLeaveType;
        data['statusCde'] = this.statusCde;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['content'] = this.content;
        data['hoursLeft'] = this.hoursLeft;
        data['description'] = this.description;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): UpdateAnnualLeaveDto {
        const json = this.toJSON();
        let result = new UpdateAnnualLeaveDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAnnualLeaveDto {
    id: number;
    employeeId: number;
    employeeCode: string | undefined;
    fullName: string | undefined;
    annualLeaveType: string | undefined;
    statusCde: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    content: string | undefined;
    hoursLeft: number;
    description: string | undefined;
    rowVersion: string | undefined;
}

export class UpdateAttendanceDto implements IUpdateAttendanceDto {
    id: number;
    titleName: string | undefined;
    monthAttendance: moment.Moment | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    lstAttendanceDetail: AttendanceResultModel[] | undefined;

    constructor(data?: IUpdateAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.titleName = _data['titleName'];
            this.monthAttendance = _data['monthAttendance'] ? moment(_data['monthAttendance'].toString()) : <any>undefined;
            this.tenantId = _data['tenantId'];
            this.rowVersion = _data['rowVersion'];
            this.modifiedBy = _data['modifiedBy'];
            if (Array.isArray(_data['lstAttendanceDetail'])) {
                this.lstAttendanceDetail = [] as any;
                for (let item of _data['lstAttendanceDetail']) this.lstAttendanceDetail.push(AttendanceResultModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['titleName'] = this.titleName;
        data['monthAttendance'] = this.monthAttendance ? this.monthAttendance.toISOString() : <any>undefined;
        data['tenantId'] = this.tenantId;
        data['rowVersion'] = this.rowVersion;
        data['modifiedBy'] = this.modifiedBy;
        if (Array.isArray(this.lstAttendanceDetail)) {
            data['lstAttendanceDetail'] = [];
            for (let item of this.lstAttendanceDetail) data['lstAttendanceDetail'].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateAttendanceDto {
        const json = this.toJSON();
        let result = new UpdateAttendanceDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAttendanceDto {
    id: number;
    titleName: string | undefined;
    monthAttendance: moment.Moment | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    lstAttendanceDetail: AttendanceResultModel[] | undefined;
}

export class UpdateBonusDto implements IUpdateBonusDto {
    id: number;
    bonusType: string | undefined;
    bonusCode: string | undefined;
    totalAmounts: number;
    dateApply: moment.Moment | undefined;
    description: string | undefined;
    isPlusTotalize: boolean;
    title: string | undefined;
    tenantId: number;
    statusCde: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    lstBonusDetail: BonusDetailModel[] | undefined;

    constructor(data?: IUpdateBonusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.bonusType = _data['bonusType'];
            this.bonusCode = _data['bonusCode'];
            this.totalAmounts = _data['totalAmounts'];
            this.dateApply = _data['dateApply'] ? moment(_data['dateApply'].toString()) : <any>undefined;
            this.description = _data['description'];
            this.isPlusTotalize = _data['isPlusTotalize'];
            this.title = _data['title'];
            this.tenantId = _data['tenantId'];
            this.statusCde = _data['statusCde'];
            this.wfDataCde = _data['wfDataCde'];
            this.cancelReason = _data['cancelReason'];
            this.rowVersion = _data['rowVersion'];
            this.modifiedBy = _data['modifiedBy'];
            if (Array.isArray(_data['lstBonusDetail'])) {
                this.lstBonusDetail = [] as any;
                for (let item of _data['lstBonusDetail']) this.lstBonusDetail.push(BonusDetailModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateBonusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBonusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['bonusType'] = this.bonusType;
        data['bonusCode'] = this.bonusCode;
        data['totalAmounts'] = this.totalAmounts;
        data['dateApply'] = this.dateApply ? this.dateApply.toISOString() : <any>undefined;
        data['description'] = this.description;
        data['isPlusTotalize'] = this.isPlusTotalize;
        data['title'] = this.title;
        data['tenantId'] = this.tenantId;
        data['statusCde'] = this.statusCde;
        data['wfDataCde'] = this.wfDataCde;
        data['cancelReason'] = this.cancelReason;
        data['rowVersion'] = this.rowVersion;
        data['modifiedBy'] = this.modifiedBy;
        if (Array.isArray(this.lstBonusDetail)) {
            data['lstBonusDetail'] = [];
            for (let item of this.lstBonusDetail) data['lstBonusDetail'].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateBonusDto {
        const json = this.toJSON();
        let result = new UpdateBonusDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateBonusDto {
    id: number;
    bonusType: string | undefined;
    bonusCode: string | undefined;
    totalAmounts: number;
    dateApply: moment.Moment | undefined;
    description: string | undefined;
    isPlusTotalize: boolean;
    title: string | undefined;
    tenantId: number;
    statusCde: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    lstBonusDetail: BonusDetailModel[] | undefined;
}

export class UpdateClientAnnualLeaveDto implements IUpdateClientAnnualLeaveDto {
    annualLeaveType: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    hoursLeft: number;
    content: string | undefined;
    employeeName: string | undefined;
    annualLeaveTypeName: string | undefined;
    id: number;
    rowVersion: string | undefined;
    statusCde: string | undefined;
    cancelReason: string | undefined;

    constructor(data?: IUpdateClientAnnualLeaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.annualLeaveType = _data['annualLeaveType'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.hoursLeft = _data['hoursLeft'];
            this.content = _data['content'];
            this.employeeName = _data['employeeName'];
            this.annualLeaveTypeName = _data['annualLeaveTypeName'];
            this.id = _data['id'];
            this.rowVersion = _data['rowVersion'];
            this.statusCde = _data['statusCde'];
            this.cancelReason = _data['cancelReason'];
        }
    }

    static fromJS(data: any): UpdateClientAnnualLeaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientAnnualLeaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['annualLeaveType'] = this.annualLeaveType;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['hoursLeft'] = this.hoursLeft;
        data['content'] = this.content;
        data['employeeName'] = this.employeeName;
        data['annualLeaveTypeName'] = this.annualLeaveTypeName;
        data['id'] = this.id;
        data['rowVersion'] = this.rowVersion;
        data['statusCde'] = this.statusCde;
        data['cancelReason'] = this.cancelReason;
        return data;
    }

    clone(): UpdateClientAnnualLeaveDto {
        const json = this.toJSON();
        let result = new UpdateClientAnnualLeaveDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateClientAnnualLeaveDto {
    annualLeaveType: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    hoursLeft: number;
    content: string | undefined;
    employeeName: string | undefined;
    annualLeaveTypeName: string | undefined;
    id: number;
    rowVersion: string | undefined;
    statusCde: string | undefined;
    cancelReason: string | undefined;
}

export class UpdateContractDto implements IUpdateContractDto {
    id: number;
    contractNo: string | undefined;
    contractNoOld: string | undefined;
    company: string | undefined;
    representative: string | undefined;
    amount: number | undefined;
    onePayment: number | undefined;
    twoPayment: number | undefined;
    threePayment: number | undefined;
    remainingAmount: number | undefined;
    address: string | undefined;
    phone: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    description: string | undefined;
    fileAttach: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    statusCde: string | undefined;

    constructor(data?: IUpdateContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.contractNo = _data['contractNo'];
            this.contractNoOld = _data['contractNoOld'];
            this.company = _data['company'];
            this.representative = _data['representative'];
            this.amount = _data['amount'];
            this.onePayment = _data['onePayment'];
            this.twoPayment = _data['twoPayment'];
            this.threePayment = _data['threePayment'];
            this.remainingAmount = _data['remainingAmount'];
            this.address = _data['address'];
            this.phone = _data['phone'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.description = _data['description'];
            this.fileAttach = _data['fileAttach'];
            this.rowVersion = _data['rowVersion'];
            this.modifiedBy = _data['modifiedBy'];
            this.statusCde = _data['statusCde'];
        }
    }

    static fromJS(data: any): UpdateContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['contractNo'] = this.contractNo;
        data['contractNoOld'] = this.contractNoOld;
        data['company'] = this.company;
        data['representative'] = this.representative;
        data['amount'] = this.amount;
        data['onePayment'] = this.onePayment;
        data['twoPayment'] = this.twoPayment;
        data['threePayment'] = this.threePayment;
        data['remainingAmount'] = this.remainingAmount;
        data['address'] = this.address;
        data['phone'] = this.phone;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['description'] = this.description;
        data['fileAttach'] = this.fileAttach;
        data['rowVersion'] = this.rowVersion;
        data['modifiedBy'] = this.modifiedBy;
        data['statusCde'] = this.statusCde;
        return data;
    }

    clone(): UpdateContractDto {
        const json = this.toJSON();
        let result = new UpdateContractDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateContractDto {
    id: number;
    contractNo: string | undefined;
    contractNoOld: string | undefined;
    company: string | undefined;
    representative: string | undefined;
    amount: number | undefined;
    onePayment: number | undefined;
    twoPayment: number | undefined;
    threePayment: number | undefined;
    remainingAmount: number | undefined;
    address: string | undefined;
    phone: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    description: string | undefined;
    fileAttach: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    statusCde: string | undefined;
}

export class UpdateDateFamilyExemptionDto implements IUpdateDateFamilyExemptionDto {
    employeeId: number;
    familyExemptionDate: moment.Moment | undefined;
    rowVersion: string | undefined;

    constructor(data?: IUpdateDateFamilyExemptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data['employeeId'];
            this.familyExemptionDate = _data['familyExemptionDate'] ? moment(_data['familyExemptionDate'].toString()) : <any>undefined;
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): UpdateDateFamilyExemptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDateFamilyExemptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['employeeId'] = this.employeeId;
        data['familyExemptionDate'] = this.familyExemptionDate ? this.familyExemptionDate.toISOString() : <any>undefined;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): UpdateDateFamilyExemptionDto {
        const json = this.toJSON();
        let result = new UpdateDateFamilyExemptionDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateDateFamilyExemptionDto {
    employeeId: number;
    familyExemptionDate: moment.Moment | undefined;
    rowVersion: string | undefined;
}

export class UpdateEmployeeDto implements IUpdateEmployeeDto {
    id: number;
    employeeCode: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    managerId: number;
    sex: string | undefined;
    birthDay: moment.Moment | undefined;
    identityCard: string | undefined;
    identityCardDate: moment.Moment | undefined;
    identityCardPlace: string | undefined;
    nationalityCode: string | undefined;
    dateOfWork: moment.Moment | undefined;
    dateOfEntry: moment.Moment | undefined;
    isFederation: boolean;
    departmentCode: string | undefined;
    jobCode: string | undefined;
    religiousCode: string | undefined;
    educatedCode: string | undefined;
    maritalStatus: string | undefined;
    familyExemptionNumber: number | undefined;
    familyExemptionDate: moment.Moment | undefined;
    taxYourself: string | undefined;
    isInactivity: boolean;
    bankAccount: string | undefined;
    bankCode: string | undefined;
    permanentAddress: string | undefined;
    temporaryAddress: string | undefined;
    phoneNumber: string | undefined;
    image: string | undefined;
    insuranceNumber: string | undefined;
    inactivityDate: moment.Moment | undefined;
    rowVersion: string | undefined;
    identityCard2: string | undefined;
    identityCardDate2: moment.Moment | undefined;
    identityCardPlace2: string | undefined;

    constructor(data?: IUpdateEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeCode = _data['employeeCode'];
            this.firstName = _data['firstName'];
            this.lastName = _data['lastName'];
            this.email = _data['email'];
            this.managerId = _data['managerId'];
            this.sex = _data['sex'];
            this.birthDay = _data['birthDay'] ? moment(_data['birthDay'].toString()) : <any>undefined;
            this.identityCard = _data['identityCard'];
            this.identityCardDate = _data['identityCardDate'] ? moment(_data['identityCardDate'].toString()) : <any>undefined;
            this.identityCardPlace = _data['identityCardPlace'];
            this.nationalityCode = _data['nationalityCode'];
            this.dateOfWork = _data['dateOfWork'] ? moment(_data['dateOfWork'].toString()) : <any>undefined;
            this.dateOfEntry = _data['dateOfEntry'] ? moment(_data['dateOfEntry'].toString()) : <any>undefined;
            this.isFederation = _data['isFederation'];
            this.departmentCode = _data['departmentCode'];
            this.jobCode = _data['jobCode'];
            this.religiousCode = _data['religiousCode'];
            this.educatedCode = _data['educatedCode'];
            this.maritalStatus = _data['maritalStatus'];
            this.familyExemptionNumber = _data['familyExemptionNumber'];
            this.familyExemptionDate = _data['familyExemptionDate'] ? moment(_data['familyExemptionDate'].toString()) : <any>undefined;
            this.taxYourself = _data['taxYourself'];
            this.isInactivity = _data['isInactivity'];
            this.bankAccount = _data['bankAccount'];
            this.bankCode = _data['bankCode'];
            this.permanentAddress = _data['permanentAddress'];
            this.temporaryAddress = _data['temporaryAddress'];
            this.phoneNumber = _data['phoneNumber'];
            this.image = _data['image'];
            this.insuranceNumber = _data['insuranceNumber'];
            this.inactivityDate = _data['inactivityDate'] ? moment(_data['inactivityDate'].toString()) : <any>undefined;
            this.rowVersion = _data['rowVersion'];
            this.identityCard2 = _data['identityCard2'];
            this.identityCardDate2 = _data['identityCardDate2'] ? moment(_data['identityCardDate2'].toString()) : <any>undefined;
            this.identityCardPlace2 = _data['identityCardPlace2'];
        }
    }

    static fromJS(data: any): UpdateEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeCode'] = this.employeeCode;
        data['firstName'] = this.firstName;
        data['lastName'] = this.lastName;
        data['email'] = this.email;
        data['managerId'] = this.managerId;
        data['sex'] = this.sex;
        data['birthDay'] = this.birthDay ? this.birthDay.toISOString() : <any>undefined;
        data['identityCard'] = this.identityCard;
        data['identityCardDate'] = this.identityCardDate ? this.identityCardDate.toISOString() : <any>undefined;
        data['identityCardPlace'] = this.identityCardPlace;
        data['nationalityCode'] = this.nationalityCode;
        data['dateOfWork'] = this.dateOfWork ? this.dateOfWork.toISOString() : <any>undefined;
        data['dateOfEntry'] = this.dateOfEntry ? this.dateOfEntry.toISOString() : <any>undefined;
        data['isFederation'] = this.isFederation;
        data['departmentCode'] = this.departmentCode;
        data['jobCode'] = this.jobCode;
        data['religiousCode'] = this.religiousCode;
        data['educatedCode'] = this.educatedCode;
        data['maritalStatus'] = this.maritalStatus;
        data['familyExemptionNumber'] = this.familyExemptionNumber;
        data['familyExemptionDate'] = this.familyExemptionDate ? this.familyExemptionDate.toISOString() : <any>undefined;
        data['taxYourself'] = this.taxYourself;
        data['isInactivity'] = this.isInactivity;
        data['bankAccount'] = this.bankAccount;
        data['bankCode'] = this.bankCode;
        data['permanentAddress'] = this.permanentAddress;
        data['temporaryAddress'] = this.temporaryAddress;
        data['phoneNumber'] = this.phoneNumber;
        data['image'] = this.image;
        data['insuranceNumber'] = this.insuranceNumber;
        data['inactivityDate'] = this.inactivityDate ? this.inactivityDate.toISOString() : <any>undefined;
        data['rowVersion'] = this.rowVersion;
        data['identityCard2'] = this.identityCard2;
        data['identityCardDate2'] = this.identityCardDate2 ? this.identityCardDate2.toISOString() : <any>undefined;
        data['identityCardPlace2'] = this.identityCardPlace2;
        return data;
    }

    clone(): UpdateEmployeeDto {
        const json = this.toJSON();
        let result = new UpdateEmployeeDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateEmployeeDto {
    id: number;
    employeeCode: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    managerId: number;
    sex: string | undefined;
    birthDay: moment.Moment | undefined;
    identityCard: string | undefined;
    identityCardDate: moment.Moment | undefined;
    identityCardPlace: string | undefined;
    nationalityCode: string | undefined;
    dateOfWork: moment.Moment | undefined;
    dateOfEntry: moment.Moment | undefined;
    isFederation: boolean;
    departmentCode: string | undefined;
    jobCode: string | undefined;
    religiousCode: string | undefined;
    educatedCode: string | undefined;
    maritalStatus: string | undefined;
    familyExemptionNumber: number | undefined;
    familyExemptionDate: moment.Moment | undefined;
    taxYourself: string | undefined;
    isInactivity: boolean;
    bankAccount: string | undefined;
    bankCode: string | undefined;
    permanentAddress: string | undefined;
    temporaryAddress: string | undefined;
    phoneNumber: string | undefined;
    image: string | undefined;
    insuranceNumber: string | undefined;
    inactivityDate: moment.Moment | undefined;
    rowVersion: string | undefined;
    identityCard2: string | undefined;
    identityCardDate2: moment.Moment | undefined;
    identityCardPlace2: string | undefined;
}

export class UpdateEvaluationPeriodDto implements IUpdateEvaluationPeriodDto {
    id: number;
    name: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    rowVersion: string | undefined;
    evaluationTemplate: EvaluationTemplateModel;
    evaluationQuestion: EvaluationQuestionModel[] | undefined;
    evaluationAnswer: EvaluationAnswerModel[] | undefined;

    constructor(data?: IUpdateEvaluationPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.rowVersion = _data['rowVersion'];
            this.evaluationTemplate = _data['evaluationTemplate'] ? EvaluationTemplateModel.fromJS(_data['evaluationTemplate']) : <any>undefined;
            if (Array.isArray(_data['evaluationQuestion'])) {
                this.evaluationQuestion = [] as any;
                for (let item of _data['evaluationQuestion']) this.evaluationQuestion.push(EvaluationQuestionModel.fromJS(item));
            }
            if (Array.isArray(_data['evaluationAnswer'])) {
                this.evaluationAnswer = [] as any;
                for (let item of _data['evaluationAnswer']) this.evaluationAnswer.push(EvaluationAnswerModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateEvaluationPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEvaluationPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['rowVersion'] = this.rowVersion;
        data['evaluationTemplate'] = this.evaluationTemplate ? this.evaluationTemplate.toJSON() : <any>undefined;
        if (Array.isArray(this.evaluationQuestion)) {
            data['evaluationQuestion'] = [];
            for (let item of this.evaluationQuestion) data['evaluationQuestion'].push(item.toJSON());
        }
        if (Array.isArray(this.evaluationAnswer)) {
            data['evaluationAnswer'] = [];
            for (let item of this.evaluationAnswer) data['evaluationAnswer'].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateEvaluationPeriodDto {
        const json = this.toJSON();
        let result = new UpdateEvaluationPeriodDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateEvaluationPeriodDto {
    id: number;
    name: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    rowVersion: string | undefined;
    evaluationTemplate: EvaluationTemplateModel;
    evaluationQuestion: EvaluationQuestionModel[] | undefined;
    evaluationAnswer: EvaluationAnswerModel[] | undefined;
}

export class UpdateExpenditureIncomeDto implements IUpdateExpenditureIncomeDto {
    id: number;
    employeeId: number;
    type: string | undefined;
    amount: number;
    content: string | undefined;
    dateEI: moment.Moment;
    fileAttach: string | undefined;
    rowVersion: string | undefined;
    contractId: number;
    statusCde: string | undefined;
    invoiceNumber: string | undefined;

    constructor(data?: IUpdateExpenditureIncomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.type = _data['type'];
            this.amount = _data['amount'];
            this.content = _data['content'];
            this.dateEI = _data['dateEI'] ? moment(_data['dateEI'].toString()) : <any>undefined;
            this.fileAttach = _data['fileAttach'];
            this.rowVersion = _data['rowVersion'];
            this.contractId = _data['contractId'];
            this.statusCde = _data['statusCde'];
            this.invoiceNumber = _data['invoiceNumber'];
        }
    }

    static fromJS(data: any): UpdateExpenditureIncomeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExpenditureIncomeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['type'] = this.type;
        data['amount'] = this.amount;
        data['content'] = this.content;
        data['dateEI'] = this.dateEI ? this.dateEI.toISOString() : <any>undefined;
        data['fileAttach'] = this.fileAttach;
        data['rowVersion'] = this.rowVersion;
        data['contractId'] = this.contractId;
        data['statusCde'] = this.statusCde;
        data['invoiceNumber'] = this.invoiceNumber;
        return data;
    }

    clone(): UpdateExpenditureIncomeDto {
        const json = this.toJSON();
        let result = new UpdateExpenditureIncomeDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateExpenditureIncomeDto {
    id: number;
    employeeId: number;
    type: string | undefined;
    amount: number;
    content: string | undefined;
    dateEI: moment.Moment;
    fileAttach: string | undefined;
    rowVersion: string | undefined;
    contractId: number;
    statusCde: string | undefined;
    invoiceNumber: string | undefined;
}

export class UpdateFamilyExemptionDto implements IUpdateFamilyExemptionDto {
    id: number;
    employeeId: number;
    familyExemptionCode: string | undefined;
    familyExemptionName: string | undefined;
    rowVersion: string | undefined;
    familyExemptionNumber: number;
    familyExemptionDate: moment.Moment | undefined;
    empRowVersion: string | undefined;
    createBy: string | undefined;
    modifiedBy: string | undefined;
    tenantId: number;

    constructor(data?: IUpdateFamilyExemptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.familyExemptionCode = _data['familyExemptionCode'];
            this.familyExemptionName = _data['familyExemptionName'];
            this.rowVersion = _data['rowVersion'];
            this.familyExemptionNumber = _data['familyExemptionNumber'];
            this.familyExemptionDate = _data['familyExemptionDate'] ? moment(_data['familyExemptionDate'].toString()) : <any>undefined;
            this.empRowVersion = _data['empRowVersion'];
            this.createBy = _data['createBy'];
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
        }
    }

    static fromJS(data: any): UpdateFamilyExemptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFamilyExemptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['familyExemptionCode'] = this.familyExemptionCode;
        data['familyExemptionName'] = this.familyExemptionName;
        data['rowVersion'] = this.rowVersion;
        data['familyExemptionNumber'] = this.familyExemptionNumber;
        data['familyExemptionDate'] = this.familyExemptionDate ? this.familyExemptionDate.toISOString() : <any>undefined;
        data['empRowVersion'] = this.empRowVersion;
        data['createBy'] = this.createBy;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        return data;
    }

    clone(): UpdateFamilyExemptionDto {
        const json = this.toJSON();
        let result = new UpdateFamilyExemptionDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateFamilyExemptionDto {
    id: number;
    employeeId: number;
    familyExemptionCode: string | undefined;
    familyExemptionName: string | undefined;
    rowVersion: string | undefined;
    familyExemptionNumber: number;
    familyExemptionDate: moment.Moment | undefined;
    empRowVersion: string | undefined;
    createBy: string | undefined;
    modifiedBy: string | undefined;
    tenantId: number;
}

export class UpdateHolidayDto implements IUpdateHolidayDto {
    id: number;
    holidayName: string | undefined;
    effectiveFromDate: moment.Moment;
    effectiveToDate: moment.Moment;
    numberHoliday: number;
    statusCde: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    description: string | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    makeUpDays: moment.Moment[] | undefined;

    constructor(data?: IUpdateHolidayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.holidayName = _data['holidayName'];
            this.effectiveFromDate = _data['effectiveFromDate'] ? moment(_data['effectiveFromDate'].toString()) : <any>undefined;
            this.effectiveToDate = _data['effectiveToDate'] ? moment(_data['effectiveToDate'].toString()) : <any>undefined;
            this.numberHoliday = _data['numberHoliday'];
            this.statusCde = _data['statusCde'];
            this.wfDataCde = _data['wfDataCde'];
            this.cancelReason = _data['cancelReason'];
            this.description = _data['description'];
            this.tenantId = _data['tenantId'];
            this.rowVersion = _data['rowVersion'];
            this.modifiedBy = _data['modifiedBy'];
            if (Array.isArray(_data['makeUpDays'])) {
                this.makeUpDays = [] as any;
                for (let item of _data['makeUpDays']) this.makeUpDays.push(moment(item));
            }
        }
    }

    static fromJS(data: any): UpdateHolidayDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHolidayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['holidayName'] = this.holidayName;
        data['effectiveFromDate'] = this.effectiveFromDate ? this.effectiveFromDate.toISOString() : <any>undefined;
        data['effectiveToDate'] = this.effectiveToDate ? this.effectiveToDate.toISOString() : <any>undefined;
        data['numberHoliday'] = this.numberHoliday;
        data['statusCde'] = this.statusCde;
        data['wfDataCde'] = this.wfDataCde;
        data['cancelReason'] = this.cancelReason;
        data['description'] = this.description;
        data['tenantId'] = this.tenantId;
        data['rowVersion'] = this.rowVersion;
        data['modifiedBy'] = this.modifiedBy;
        if (Array.isArray(this.makeUpDays)) {
            data['makeUpDays'] = [];
            for (let item of this.makeUpDays) data['makeUpDays'].push(item.toISOString());
        }
        return data;
    }

    clone(): UpdateHolidayDto {
        const json = this.toJSON();
        let result = new UpdateHolidayDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateHolidayDto {
    id: number;
    holidayName: string | undefined;
    effectiveFromDate: moment.Moment;
    effectiveToDate: moment.Moment;
    numberHoliday: number;
    statusCde: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    description: string | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    makeUpDays: moment.Moment[] | undefined;
}

export class UpdateInsuranceDto implements IUpdateInsuranceDto {
    id: number;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    hospitalCode: string | undefined;
    amount: number;
    social: number;
    health: number;
    accident: number;
    socialIndividual: number;
    healthIndividual: number;
    accidentIndividual: number;
    modifiedBy: string | undefined;
    rowVersion: string | undefined;

    constructor(data?: IUpdateInsuranceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.hospitalCode = _data['hospitalCode'];
            this.amount = _data['amount'];
            this.social = _data['social'];
            this.health = _data['health'];
            this.accident = _data['accident'];
            this.socialIndividual = _data['socialIndividual'];
            this.healthIndividual = _data['healthIndividual'];
            this.accidentIndividual = _data['accidentIndividual'];
            this.modifiedBy = _data['modifiedBy'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): UpdateInsuranceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInsuranceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['hospitalCode'] = this.hospitalCode;
        data['amount'] = this.amount;
        data['social'] = this.social;
        data['health'] = this.health;
        data['accident'] = this.accident;
        data['socialIndividual'] = this.socialIndividual;
        data['healthIndividual'] = this.healthIndividual;
        data['accidentIndividual'] = this.accidentIndividual;
        data['modifiedBy'] = this.modifiedBy;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): UpdateInsuranceDto {
        const json = this.toJSON();
        let result = new UpdateInsuranceDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateInsuranceDto {
    id: number;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    hospitalCode: string | undefined;
    amount: number;
    social: number;
    health: number;
    accident: number;
    socialIndividual: number;
    healthIndividual: number;
    accidentIndividual: number;
    modifiedBy: string | undefined;
    rowVersion: string | undefined;
}

export class UpdateLanguageTextsDto implements IUpdateLanguageTextsDto {
    id: number;
    value: string | undefined;

    constructor(data?: IUpdateLanguageTextsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.value = _data['value'];
        }
    }

    static fromJS(data: any): UpdateLanguageTextsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLanguageTextsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['value'] = this.value;
        return data;
    }

    clone(): UpdateLanguageTextsDto {
        const json = this.toJSON();
        let result = new UpdateLanguageTextsDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateLanguageTextsDto {
    id: number;
    value: string | undefined;
}

export class UpdateListNotificationDto implements IUpdateListNotificationDto {
    id: number;
    title: string | undefined;
    body: string | undefined;
    content: string | undefined;
    notificationType: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    isActive: boolean;

    constructor(data?: IUpdateListNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.title = _data['title'];
            this.body = _data['body'];
            this.content = _data['content'];
            this.notificationType = _data['notificationType'];
            this.rowVersion = _data['rowVersion'];
            this.modifiedBy = _data['modifiedBy'];
            this.isActive = _data['isActive'];
        }
    }

    static fromJS(data: any): UpdateListNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateListNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['title'] = this.title;
        data['body'] = this.body;
        data['content'] = this.content;
        data['notificationType'] = this.notificationType;
        data['rowVersion'] = this.rowVersion;
        data['modifiedBy'] = this.modifiedBy;
        data['isActive'] = this.isActive;
        return data;
    }

    clone(): UpdateListNotificationDto {
        const json = this.toJSON();
        let result = new UpdateListNotificationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateListNotificationDto {
    id: number;
    title: string | undefined;
    body: string | undefined;
    content: string | undefined;
    notificationType: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    isActive: boolean;
}

export class UpdateRECRequestDto implements IUpdateRECRequestDto {
    id: number;
    departmentCode: string | undefined;
    position: string | undefined;
    quantity: number;
    reason: string | undefined;
    rowVersion: string | undefined;

    constructor(data?: IUpdateRECRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.departmentCode = _data['departmentCode'];
            this.position = _data['position'];
            this.quantity = _data['quantity'];
            this.reason = _data['reason'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): UpdateRECRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRECRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['departmentCode'] = this.departmentCode;
        data['position'] = this.position;
        data['quantity'] = this.quantity;
        data['reason'] = this.reason;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): UpdateRECRequestDto {
        const json = this.toJSON();
        let result = new UpdateRECRequestDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateRECRequestDto {
    id: number;
    departmentCode: string | undefined;
    position: string | undefined;
    quantity: number;
    reason: string | undefined;
    rowVersion: string | undefined;
}

export class UpdateRecruitmentCandidatesDto implements IUpdateRecruitmentCandidatesDto {
    id: number;
    fullName: string | undefined;
    birthday: moment.Moment | undefined;
    sex: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    address: string | undefined;
    expertise: string | undefined;
    expectedSalary: number | undefined;
    offeredSalary: number | undefined;
    interviewDateTime: moment.Moment | undefined;
    availableStartDate: moment.Moment | undefined;
    cvType: string | undefined;
    cvFilePath: string | undefined;
    cvExternalLink: string | undefined;
    statusCde: string | undefined;
    note: string | undefined;
    rowVersion: string | undefined;

    constructor(data?: IUpdateRecruitmentCandidatesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.fullName = _data['fullName'];
            this.birthday = _data['birthday'] ? moment(_data['birthday'].toString()) : <any>undefined;
            this.sex = _data['sex'];
            this.phoneNumber = _data['phoneNumber'];
            this.email = _data['email'];
            this.address = _data['address'];
            this.expertise = _data['expertise'];
            this.expectedSalary = _data['expectedSalary'];
            this.offeredSalary = _data['offeredSalary'];
            this.interviewDateTime = _data['interviewDateTime'] ? moment(_data['interviewDateTime'].toString()) : <any>undefined;
            this.availableStartDate = _data['availableStartDate'] ? moment(_data['availableStartDate'].toString()) : <any>undefined;
            this.cvType = _data['cvType'];
            this.cvFilePath = _data['cvFilePath'];
            this.cvExternalLink = _data['cvExternalLink'];
            this.statusCde = _data['statusCde'];
            this.note = _data['note'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): UpdateRecruitmentCandidatesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRecruitmentCandidatesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['fullName'] = this.fullName;
        data['birthday'] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data['sex'] = this.sex;
        data['phoneNumber'] = this.phoneNumber;
        data['email'] = this.email;
        data['address'] = this.address;
        data['expertise'] = this.expertise;
        data['expectedSalary'] = this.expectedSalary;
        data['offeredSalary'] = this.offeredSalary;
        data['interviewDateTime'] = this.interviewDateTime ? this.interviewDateTime.toISOString() : <any>undefined;
        data['availableStartDate'] = this.availableStartDate ? this.availableStartDate.toISOString() : <any>undefined;
        data['cvType'] = this.cvType;
        data['cvFilePath'] = this.cvFilePath;
        data['cvExternalLink'] = this.cvExternalLink;
        data['statusCde'] = this.statusCde;
        data['note'] = this.note;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): UpdateRecruitmentCandidatesDto {
        const json = this.toJSON();
        let result = new UpdateRecruitmentCandidatesDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateRecruitmentCandidatesDto {
    id: number;
    fullName: string | undefined;
    birthday: moment.Moment | undefined;
    sex: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    address: string | undefined;
    expertise: string | undefined;
    expectedSalary: number | undefined;
    offeredSalary: number | undefined;
    interviewDateTime: moment.Moment | undefined;
    availableStartDate: moment.Moment | undefined;
    cvType: string | undefined;
    cvFilePath: string | undefined;
    cvExternalLink: string | undefined;
    statusCde: string | undefined;
    note: string | undefined;
    rowVersion: string | undefined;
}

export class UpdateRecruitmentDto implements IUpdateRecruitmentDto {
    id: number;
    fullName: string | undefined;
    birthday: moment.Moment | undefined;
    sex: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    address: string | undefined;
    expertise: string | undefined;
    expectedSalary: number | undefined;
    offeredSalary: number | undefined;
    interviewDateTime: moment.Moment | undefined;
    availableStartDate: moment.Moment | undefined;
    cvType: string | undefined;
    cvFilePath: string | undefined;
    cvExternalLink: string | undefined;
    statusCde: string | undefined;
    note: string | undefined;
    rowVersion: string | undefined;

    constructor(data?: IUpdateRecruitmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.fullName = _data['fullName'];
            this.birthday = _data['birthday'] ? moment(_data['birthday'].toString()) : <any>undefined;
            this.sex = _data['sex'];
            this.phoneNumber = _data['phoneNumber'];
            this.email = _data['email'];
            this.address = _data['address'];
            this.expertise = _data['expertise'];
            this.expectedSalary = _data['expectedSalary'];
            this.offeredSalary = _data['offeredSalary'];
            this.interviewDateTime = _data['interviewDateTime'] ? moment(_data['interviewDateTime'].toString()) : <any>undefined;
            this.availableStartDate = _data['availableStartDate'] ? moment(_data['availableStartDate'].toString()) : <any>undefined;
            this.cvType = _data['cvType'];
            this.cvFilePath = _data['cvFilePath'];
            this.cvExternalLink = _data['cvExternalLink'];
            this.statusCde = _data['statusCde'];
            this.note = _data['note'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): UpdateRecruitmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRecruitmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['fullName'] = this.fullName;
        data['birthday'] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data['sex'] = this.sex;
        data['phoneNumber'] = this.phoneNumber;
        data['email'] = this.email;
        data['address'] = this.address;
        data['expertise'] = this.expertise;
        data['expectedSalary'] = this.expectedSalary;
        data['offeredSalary'] = this.offeredSalary;
        data['interviewDateTime'] = this.interviewDateTime ? this.interviewDateTime.toISOString() : <any>undefined;
        data['availableStartDate'] = this.availableStartDate ? this.availableStartDate.toISOString() : <any>undefined;
        data['cvType'] = this.cvType;
        data['cvFilePath'] = this.cvFilePath;
        data['cvExternalLink'] = this.cvExternalLink;
        data['statusCde'] = this.statusCde;
        data['note'] = this.note;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): UpdateRecruitmentDto {
        const json = this.toJSON();
        let result = new UpdateRecruitmentDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateRecruitmentDto {
    id: number;
    fullName: string | undefined;
    birthday: moment.Moment | undefined;
    sex: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    address: string | undefined;
    expertise: string | undefined;
    expectedSalary: number | undefined;
    offeredSalary: number | undefined;
    interviewDateTime: moment.Moment | undefined;
    availableStartDate: moment.Moment | undefined;
    cvType: string | undefined;
    cvFilePath: string | undefined;
    cvExternalLink: string | undefined;
    statusCde: string | undefined;
    note: string | undefined;
    rowVersion: string | undefined;
}

export class UpdateRecruitmentJobPostsDto implements IUpdateRecruitmentJobPostsDto {
    id: number;
    planId: number;
    title: string | undefined;
    description: string | undefined;
    channel: string | undefined;
    publishDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    jobPostsCde: string | undefined;
    rowVersion: string | undefined;

    constructor(data?: IUpdateRecruitmentJobPostsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.planId = _data['planId'];
            this.title = _data['title'];
            this.description = _data['description'];
            this.channel = _data['channel'];
            this.publishDate = _data['publishDate'] ? moment(_data['publishDate'].toString()) : <any>undefined;
            this.expireDate = _data['expireDate'] ? moment(_data['expireDate'].toString()) : <any>undefined;
            this.jobPostsCde = _data['jobPostsCde'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): UpdateRecruitmentJobPostsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRecruitmentJobPostsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['planId'] = this.planId;
        data['title'] = this.title;
        data['description'] = this.description;
        data['channel'] = this.channel;
        data['publishDate'] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data['expireDate'] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data['jobPostsCde'] = this.jobPostsCde;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): UpdateRecruitmentJobPostsDto {
        const json = this.toJSON();
        let result = new UpdateRecruitmentJobPostsDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateRecruitmentJobPostsDto {
    id: number;
    planId: number;
    title: string | undefined;
    description: string | undefined;
    channel: string | undefined;
    publishDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    jobPostsCde: string | undefined;
    rowVersion: string | undefined;
}

export class UpdateRecruitmentPlansDto implements IUpdateRecruitmentPlansDto {
    id: number;
    requestId: number;
    planName: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    budget: number;
    statusCode: string | undefined;
    rowVersion: string | undefined;

    constructor(data?: IUpdateRecruitmentPlansDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.requestId = _data['requestId'];
            this.planName = _data['planName'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.budget = _data['budget'];
            this.statusCode = _data['statusCode'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): UpdateRecruitmentPlansDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRecruitmentPlansDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['requestId'] = this.requestId;
        data['planName'] = this.planName;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['budget'] = this.budget;
        data['statusCode'] = this.statusCode;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): UpdateRecruitmentPlansDto {
        const json = this.toJSON();
        let result = new UpdateRecruitmentPlansDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateRecruitmentPlansDto {
    id: number;
    requestId: number;
    planName: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    budget: number;
    statusCode: string | undefined;
    rowVersion: string | undefined;
}

export class UpdateRegisterOvertimeDto implements IUpdateRegisterOvertimeDto {
    id: number;
    employeeCode: string | undefined;
    fullName: string | undefined;
    overtimeDate: moment.Moment | undefined;
    hoursOvertime: number;
    startTime: string | undefined;
    endTime: string | undefined;
    statusCde: string | undefined;
    description: string | undefined;
    content: string | undefined;
    rowVersion: string | undefined;
    createBy: string | undefined;

    constructor(data?: IUpdateRegisterOvertimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeCode = _data['employeeCode'];
            this.fullName = _data['fullName'];
            this.overtimeDate = _data['overtimeDate'] ? moment(_data['overtimeDate'].toString()) : <any>undefined;
            this.hoursOvertime = _data['hoursOvertime'];
            this.startTime = _data['startTime'];
            this.endTime = _data['endTime'];
            this.statusCde = _data['statusCde'];
            this.description = _data['description'];
            this.content = _data['content'];
            this.rowVersion = _data['rowVersion'];
            this.createBy = _data['createBy'];
        }
    }

    static fromJS(data: any): UpdateRegisterOvertimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRegisterOvertimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeCode'] = this.employeeCode;
        data['fullName'] = this.fullName;
        data['overtimeDate'] = this.overtimeDate ? this.overtimeDate.toISOString() : <any>undefined;
        data['hoursOvertime'] = this.hoursOvertime;
        data['startTime'] = this.startTime;
        data['endTime'] = this.endTime;
        data['statusCde'] = this.statusCde;
        data['description'] = this.description;
        data['content'] = this.content;
        data['rowVersion'] = this.rowVersion;
        data['createBy'] = this.createBy;
        return data;
    }

    clone(): UpdateRegisterOvertimeDto {
        const json = this.toJSON();
        let result = new UpdateRegisterOvertimeDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateRegisterOvertimeDto {
    id: number;
    employeeCode: string | undefined;
    fullName: string | undefined;
    overtimeDate: moment.Moment | undefined;
    hoursOvertime: number;
    startTime: string | undefined;
    endTime: string | undefined;
    statusCde: string | undefined;
    description: string | undefined;
    content: string | undefined;
    rowVersion: string | undefined;
    createBy: string | undefined;
}

export class UpdateRemainingLeaveDto implements IUpdateRemainingLeaveDto {
    id: number;
    code: string | undefined;
    totalHoursLeft: number;
    leaveYear: number | undefined;
    note: string | undefined;
    titleName: string | undefined;
    tenantId: number;
    statusCde: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    lstRemainingLeaveDetail: RemainingLeaveDetailModel[] | undefined;

    constructor(data?: IUpdateRemainingLeaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.code = _data['code'];
            this.totalHoursLeft = _data['totalHoursLeft'];
            this.leaveYear = _data['leaveYear'];
            this.note = _data['note'];
            this.titleName = _data['titleName'];
            this.tenantId = _data['tenantId'];
            this.statusCde = _data['statusCde'];
            this.wfDataCde = _data['wfDataCde'];
            this.cancelReason = _data['cancelReason'];
            this.rowVersion = _data['rowVersion'];
            this.modifiedBy = _data['modifiedBy'];
            if (Array.isArray(_data['lstRemainingLeaveDetail'])) {
                this.lstRemainingLeaveDetail = [] as any;
                for (let item of _data['lstRemainingLeaveDetail']) this.lstRemainingLeaveDetail.push(RemainingLeaveDetailModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateRemainingLeaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRemainingLeaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['code'] = this.code;
        data['totalHoursLeft'] = this.totalHoursLeft;
        data['leaveYear'] = this.leaveYear;
        data['note'] = this.note;
        data['titleName'] = this.titleName;
        data['tenantId'] = this.tenantId;
        data['statusCde'] = this.statusCde;
        data['wfDataCde'] = this.wfDataCde;
        data['cancelReason'] = this.cancelReason;
        data['rowVersion'] = this.rowVersion;
        data['modifiedBy'] = this.modifiedBy;
        if (Array.isArray(this.lstRemainingLeaveDetail)) {
            data['lstRemainingLeaveDetail'] = [];
            for (let item of this.lstRemainingLeaveDetail) data['lstRemainingLeaveDetail'].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateRemainingLeaveDto {
        const json = this.toJSON();
        let result = new UpdateRemainingLeaveDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateRemainingLeaveDto {
    id: number;
    code: string | undefined;
    totalHoursLeft: number;
    leaveYear: number | undefined;
    note: string | undefined;
    titleName: string | undefined;
    tenantId: number;
    statusCde: string | undefined;
    wfDataCde: string;
    cancelReason: string | undefined;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
    lstRemainingLeaveDetail: RemainingLeaveDetailModel[] | undefined;
}

export class UpdateSalaryBasicDto implements IUpdateSalaryBasicDto {
    id: number;
    employeeId: number;
    salaryType: string | undefined;
    salaryAmount: number | undefined;
    salaryDate: moment.Moment | undefined;
    laborContractCode: string | undefined;
    contractNumber: string | undefined;
    dateContract: moment.Moment | undefined;
    contractFile: string | undefined;
    modifiedBy: string | undefined;
    rowVersion: string | undefined;

    constructor(data?: IUpdateSalaryBasicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.salaryType = _data['salaryType'];
            this.salaryAmount = _data['salaryAmount'];
            this.salaryDate = _data['salaryDate'] ? moment(_data['salaryDate'].toString()) : <any>undefined;
            this.laborContractCode = _data['laborContractCode'];
            this.contractNumber = _data['contractNumber'];
            this.dateContract = _data['dateContract'] ? moment(_data['dateContract'].toString()) : <any>undefined;
            this.contractFile = _data['contractFile'];
            this.modifiedBy = _data['modifiedBy'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): UpdateSalaryBasicDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSalaryBasicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['salaryType'] = this.salaryType;
        data['salaryAmount'] = this.salaryAmount;
        data['salaryDate'] = this.salaryDate ? this.salaryDate.toISOString() : <any>undefined;
        data['laborContractCode'] = this.laborContractCode;
        data['contractNumber'] = this.contractNumber;
        data['dateContract'] = this.dateContract ? this.dateContract.toISOString() : <any>undefined;
        data['contractFile'] = this.contractFile;
        data['modifiedBy'] = this.modifiedBy;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): UpdateSalaryBasicDto {
        const json = this.toJSON();
        let result = new UpdateSalaryBasicDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSalaryBasicDto {
    id: number;
    employeeId: number;
    salaryType: string | undefined;
    salaryAmount: number | undefined;
    salaryDate: moment.Moment | undefined;
    laborContractCode: string | undefined;
    contractNumber: string | undefined;
    dateContract: moment.Moment | undefined;
    contractFile: string | undefined;
    modifiedBy: string | undefined;
    rowVersion: string | undefined;
}

export class UpdateSalaryDto implements IUpdateSalaryDto {
    id: number;
    titleName: string | undefined;
    salaryDate: moment.Moment | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;

    constructor(data?: IUpdateSalaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.titleName = _data['titleName'];
            this.salaryDate = _data['salaryDate'] ? moment(_data['salaryDate'].toString()) : <any>undefined;
            this.tenantId = _data['tenantId'];
            this.rowVersion = _data['rowVersion'];
            this.modifiedBy = _data['modifiedBy'];
        }
    }

    static fromJS(data: any): UpdateSalaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSalaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['titleName'] = this.titleName;
        data['salaryDate'] = this.salaryDate ? this.salaryDate.toISOString() : <any>undefined;
        data['tenantId'] = this.tenantId;
        data['rowVersion'] = this.rowVersion;
        data['modifiedBy'] = this.modifiedBy;
        return data;
    }

    clone(): UpdateSalaryDto {
        const json = this.toJSON();
        let result = new UpdateSalaryDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSalaryDto {
    id: number;
    titleName: string | undefined;
    salaryDate: moment.Moment | undefined;
    tenantId: number;
    rowVersion: string | undefined;
    modifiedBy: string | undefined;
}

export class UpdateSysAppParamDto implements IUpdateSysAppParamDto {
    paramCode: string | undefined;
    paramValue: string | undefined;
    description: string | undefined;
    isActive: boolean;
    modifiedBy: string | undefined;
    rowVersion: string | undefined;

    constructor(data?: IUpdateSysAppParamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paramCode = _data['paramCode'];
            this.paramValue = _data['paramValue'];
            this.description = _data['description'];
            this.isActive = _data['isActive'];
            this.modifiedBy = _data['modifiedBy'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): UpdateSysAppParamDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSysAppParamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['paramCode'] = this.paramCode;
        data['paramValue'] = this.paramValue;
        data['description'] = this.description;
        data['isActive'] = this.isActive;
        data['modifiedBy'] = this.modifiedBy;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): UpdateSysAppParamDto {
        const json = this.toJSON();
        let result = new UpdateSysAppParamDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSysAppParamDto {
    paramCode: string | undefined;
    paramValue: string | undefined;
    description: string | undefined;
    isActive: boolean;
    modifiedBy: string | undefined;
    rowVersion: string | undefined;
}

export class UpdateSysMasterListDto implements IUpdateSysMasterListDto {
    masterListID: number;
    masterListCode: string | undefined;
    masterListGroupCde: string | undefined;
    masterListCdeName: string | undefined;
    mastListDefaultValue: string | undefined;
    mastListExtendValue1: string | undefined;
    mastListExtendValue2: string | undefined;
    mastListExtendValue3: string | undefined;
    mastListExtendValue4: string | undefined;
    mastListExtendValue5: string | undefined;
    description: string | undefined;
    orderNo: number;
    isActive: boolean | undefined;
    rowVersion: string | undefined;

    constructor(data?: IUpdateSysMasterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.masterListID = _data['masterListID'];
            this.masterListCode = _data['masterListCode'];
            this.masterListGroupCde = _data['masterListGroupCde'];
            this.masterListCdeName = _data['masterListCdeName'];
            this.mastListDefaultValue = _data['mastListDefaultValue'];
            this.mastListExtendValue1 = _data['mastListExtendValue1'];
            this.mastListExtendValue2 = _data['mastListExtendValue2'];
            this.mastListExtendValue3 = _data['mastListExtendValue3'];
            this.mastListExtendValue4 = _data['mastListExtendValue4'];
            this.mastListExtendValue5 = _data['mastListExtendValue5'];
            this.description = _data['description'];
            this.orderNo = _data['orderNo'];
            this.isActive = _data['isActive'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): UpdateSysMasterListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSysMasterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['masterListID'] = this.masterListID;
        data['masterListCode'] = this.masterListCode;
        data['masterListGroupCde'] = this.masterListGroupCde;
        data['masterListCdeName'] = this.masterListCdeName;
        data['mastListDefaultValue'] = this.mastListDefaultValue;
        data['mastListExtendValue1'] = this.mastListExtendValue1;
        data['mastListExtendValue2'] = this.mastListExtendValue2;
        data['mastListExtendValue3'] = this.mastListExtendValue3;
        data['mastListExtendValue4'] = this.mastListExtendValue4;
        data['mastListExtendValue5'] = this.mastListExtendValue5;
        data['description'] = this.description;
        data['orderNo'] = this.orderNo;
        data['isActive'] = this.isActive;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): UpdateSysMasterListDto {
        const json = this.toJSON();
        let result = new UpdateSysMasterListDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSysMasterListDto {
    masterListID: number;
    masterListCode: string | undefined;
    masterListGroupCde: string | undefined;
    masterListCdeName: string | undefined;
    mastListDefaultValue: string | undefined;
    mastListExtendValue1: string | undefined;
    mastListExtendValue2: string | undefined;
    mastListExtendValue3: string | undefined;
    mastListExtendValue4: string | undefined;
    mastListExtendValue5: string | undefined;
    description: string | undefined;
    orderNo: number;
    isActive: boolean | undefined;
    rowVersion: string | undefined;
}

export class UpdateSysWorkflowDto implements IUpdateSysWorkflowDto {
    workflowID: number;
    workflowCode: string | undefined;
    workflowName: string | undefined;
    currentStep: number;
    nextStep: number;
    hardStep: string | undefined;
    actionName: string | undefined;
    statusCde: string | undefined;
    currentSystemCde: string | undefined;
    usrRoleCde: string | undefined;
    buttonDisplayCde: string | undefined;
    inputCanSee: string | undefined;
    inputCanEdit: string | undefined;
    preProcessFunc: string | undefined;
    cssClass: string | undefined;
    cssIcon: string | undefined;
    isRequiredComment: boolean;
    isActive: boolean;
    rowVersion: string | undefined;
    modifiedDate: moment.Moment | undefined;
    modifiedBy: string | undefined;
    tenantId: number;
    tableName: string | undefined;

    constructor(data?: IUpdateSysWorkflowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowID = _data['workflowID'];
            this.workflowCode = _data['workflowCode'];
            this.workflowName = _data['workflowName'];
            this.currentStep = _data['currentStep'];
            this.nextStep = _data['nextStep'];
            this.hardStep = _data['hardStep'];
            this.actionName = _data['actionName'];
            this.statusCde = _data['statusCde'];
            this.currentSystemCde = _data['currentSystemCde'];
            this.usrRoleCde = _data['usrRoleCde'];
            this.buttonDisplayCde = _data['buttonDisplayCde'];
            this.inputCanSee = _data['inputCanSee'];
            this.inputCanEdit = _data['inputCanEdit'];
            this.preProcessFunc = _data['preProcessFunc'];
            this.cssClass = _data['cssClass'];
            this.cssIcon = _data['cssIcon'];
            this.isRequiredComment = _data['isRequiredComment'];
            this.isActive = _data['isActive'];
            this.rowVersion = _data['rowVersion'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.tenantId = _data['tenantId'];
            this.tableName = _data['tableName'];
        }
    }

    static fromJS(data: any): UpdateSysWorkflowDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSysWorkflowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['workflowID'] = this.workflowID;
        data['workflowCode'] = this.workflowCode;
        data['workflowName'] = this.workflowName;
        data['currentStep'] = this.currentStep;
        data['nextStep'] = this.nextStep;
        data['hardStep'] = this.hardStep;
        data['actionName'] = this.actionName;
        data['statusCde'] = this.statusCde;
        data['currentSystemCde'] = this.currentSystemCde;
        data['usrRoleCde'] = this.usrRoleCde;
        data['buttonDisplayCde'] = this.buttonDisplayCde;
        data['inputCanSee'] = this.inputCanSee;
        data['inputCanEdit'] = this.inputCanEdit;
        data['preProcessFunc'] = this.preProcessFunc;
        data['cssClass'] = this.cssClass;
        data['cssIcon'] = this.cssIcon;
        data['isRequiredComment'] = this.isRequiredComment;
        data['isActive'] = this.isActive;
        data['rowVersion'] = this.rowVersion;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['tenantId'] = this.tenantId;
        data['tableName'] = this.tableName;
        return data;
    }

    clone(): UpdateSysWorkflowDto {
        const json = this.toJSON();
        let result = new UpdateSysWorkflowDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSysWorkflowDto {
    workflowID: number;
    workflowCode: string | undefined;
    workflowName: string | undefined;
    currentStep: number;
    nextStep: number;
    hardStep: string | undefined;
    actionName: string | undefined;
    statusCde: string | undefined;
    currentSystemCde: string | undefined;
    usrRoleCde: string | undefined;
    buttonDisplayCde: string | undefined;
    inputCanSee: string | undefined;
    inputCanEdit: string | undefined;
    preProcessFunc: string | undefined;
    cssClass: string | undefined;
    cssIcon: string | undefined;
    isRequiredComment: boolean;
    isActive: boolean;
    rowVersion: string | undefined;
    modifiedDate: moment.Moment | undefined;
    modifiedBy: string | undefined;
    tenantId: number;
    tableName: string | undefined;
}

export class UpdateWorkShiftChangeDto implements IUpdateWorkShiftChangeDto {
    id: number;
    employeeId: number;
    currentShiftCode: string | undefined;
    changeShiftCode: string | undefined;
    year: number;
    month: number;
    dateWork: string | undefined;
    description: string | undefined;
    statusCde: string | undefined;
    wfDataCde: string | undefined;
    modifiedBy: string | undefined;
    rowVersion: string | undefined;
    content: string | undefined;

    constructor(data?: IUpdateWorkShiftChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.currentShiftCode = _data['currentShiftCode'];
            this.changeShiftCode = _data['changeShiftCode'];
            this.year = _data['year'];
            this.month = _data['month'];
            this.dateWork = _data['dateWork'];
            this.description = _data['description'];
            this.statusCde = _data['statusCde'];
            this.wfDataCde = _data['wfDataCde'];
            this.modifiedBy = _data['modifiedBy'];
            this.rowVersion = _data['rowVersion'];
            this.content = _data['content'];
        }
    }

    static fromJS(data: any): UpdateWorkShiftChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkShiftChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['currentShiftCode'] = this.currentShiftCode;
        data['changeShiftCode'] = this.changeShiftCode;
        data['year'] = this.year;
        data['month'] = this.month;
        data['dateWork'] = this.dateWork;
        data['description'] = this.description;
        data['statusCde'] = this.statusCde;
        data['wfDataCde'] = this.wfDataCde;
        data['modifiedBy'] = this.modifiedBy;
        data['rowVersion'] = this.rowVersion;
        data['content'] = this.content;
        return data;
    }

    clone(): UpdateWorkShiftChangeDto {
        const json = this.toJSON();
        let result = new UpdateWorkShiftChangeDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateWorkShiftChangeDto {
    id: number;
    employeeId: number;
    currentShiftCode: string | undefined;
    changeShiftCode: string | undefined;
    year: number;
    month: number;
    dateWork: string | undefined;
    description: string | undefined;
    statusCde: string | undefined;
    wfDataCde: string | undefined;
    modifiedBy: string | undefined;
    rowVersion: string | undefined;
    content: string | undefined;
}

export class UpdateWorkingProcessDto implements IUpdateWorkingProcessDto {
    id: number;
    employeeId: number;
    partner: string | undefined;
    partnerAddress: string | undefined;
    partnerPhone: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment | undefined;
    description: string | undefined;
    modifiedBy: string | undefined;
    rowVersion: string | undefined;

    constructor(data?: IUpdateWorkingProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.partner = _data['partner'];
            this.partnerAddress = _data['partnerAddress'];
            this.partnerPhone = _data['partnerPhone'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.description = _data['description'];
            this.modifiedBy = _data['modifiedBy'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): UpdateWorkingProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkingProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['partner'] = this.partner;
        data['partnerAddress'] = this.partnerAddress;
        data['partnerPhone'] = this.partnerPhone;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['description'] = this.description;
        data['modifiedBy'] = this.modifiedBy;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): UpdateWorkingProcessDto {
        const json = this.toJSON();
        let result = new UpdateWorkingProcessDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateWorkingProcessDto {
    id: number;
    employeeId: number;
    partner: string | undefined;
    partnerAddress: string | undefined;
    partnerPhone: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment | undefined;
    description: string | undefined;
    modifiedBy: string | undefined;
    rowVersion: string | undefined;
}

export class UpdateWorkingShiftDto implements IUpdateWorkingShiftDto {
    id: number;
    employeeId: number;
    shiftCode: string | undefined;
    year: number;
    month: number;
    dateWork: string | undefined;
    modifiedBy: string | undefined;
    rowVersion: string | undefined;

    constructor(data?: IUpdateWorkingShiftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.shiftCode = _data['shiftCode'];
            this.year = _data['year'];
            this.month = _data['month'];
            this.dateWork = _data['dateWork'];
            this.modifiedBy = _data['modifiedBy'];
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): UpdateWorkingShiftDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkingShiftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['shiftCode'] = this.shiftCode;
        data['year'] = this.year;
        data['month'] = this.month;
        data['dateWork'] = this.dateWork;
        data['modifiedBy'] = this.modifiedBy;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): UpdateWorkingShiftDto {
        const json = this.toJSON();
        let result = new UpdateWorkingShiftDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateWorkingShiftDto {
    id: number;
    employeeId: number;
    shiftCode: string | undefined;
    year: number;
    month: number;
    dateWork: string | undefined;
    modifiedBy: string | undefined;
    rowVersion: string | undefined;
}

export class UserDto implements IUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
    phoneNumber: string | undefined;
    gender: string | undefined;
    birthday: moment.Moment | undefined;
    identityCard: string | undefined;
    identityCardDate: string | undefined;
    identityCardPlace: string | undefined;
    permanentAddress: string | undefined;
    temporaryAddress: string | undefined;
    avatar: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.userName = _data['userName'];
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.emailAddress = _data['emailAddress'];
            this.isActive = _data['isActive'];
            this.fullName = _data['fullName'];
            this.lastLoginTime = _data['lastLoginTime'] ? moment(_data['lastLoginTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            if (Array.isArray(_data['roleNames'])) {
                this.roleNames = [] as any;
                for (let item of _data['roleNames']) this.roleNames.push(item);
            }
            this.phoneNumber = _data['phoneNumber'];
            this.gender = _data['gender'];
            this.birthday = _data['birthday'] ? moment(_data['birthday'].toString()) : <any>undefined;
            this.identityCard = _data['identityCard'];
            this.identityCardDate = _data['identityCardDate'];
            this.identityCardPlace = _data['identityCardPlace'];
            this.permanentAddress = _data['permanentAddress'];
            this.temporaryAddress = _data['temporaryAddress'];
            this.avatar = _data['avatar'];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['userName'] = this.userName;
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['emailAddress'] = this.emailAddress;
        data['isActive'] = this.isActive;
        data['fullName'] = this.fullName;
        data['lastLoginTime'] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data['roleNames'] = [];
            for (let item of this.roleNames) data['roleNames'].push(item);
        }
        data['phoneNumber'] = this.phoneNumber;
        data['gender'] = this.gender;
        data['birthday'] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data['identityCard'] = this.identityCard;
        data['identityCardDate'] = this.identityCardDate;
        data['identityCardPlace'] = this.identityCardPlace;
        data['permanentAddress'] = this.permanentAddress;
        data['temporaryAddress'] = this.temporaryAddress;
        data['avatar'] = this.avatar;
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
    phoneNumber: string | undefined;
    gender: string | undefined;
    birthday: moment.Moment | undefined;
    identityCard: string | undefined;
    identityCardDate: string | undefined;
    identityCardPlace: string | undefined;
    permanentAddress: string | undefined;
    temporaryAddress: string | undefined;
    avatar: string | undefined;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(UserDto.fromJS(item));
            }
            this.totalCount = _data['totalCount'];
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        data['totalCount'] = this.totalCount;
        return data;
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.userName = _data['userName'];
            this.emailAddress = _data['emailAddress'];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['userName'] = this.userName;
        data['emailAddress'] = this.emailAddress;
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
}

export class WardModel implements IWardModel {
    id: number;
    provinceCde: string | undefined;
    districtCde: string | undefined;
    code: string | undefined;
    name: string | undefined;
    wardType: string | undefined;
    isDeleted: boolean;
    rowVersion: string | undefined;
    createdBy: string | undefined;
    createdDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    tenantId: number;

    constructor(data?: IWardModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.provinceCde = _data['provinceCde'];
            this.districtCde = _data['districtCde'];
            this.code = _data['code'];
            this.name = _data['name'];
            this.wardType = _data['wardType'];
            this.isDeleted = _data['isDeleted'];
            this.rowVersion = _data['rowVersion'];
            this.createdBy = _data['createdBy'];
            this.createdDate = _data['createdDate'] ? moment(_data['createdDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
            this.tenantId = _data['tenantId'];
        }
    }

    static fromJS(data: any): WardModel {
        data = typeof data === 'object' ? data : {};
        let result = new WardModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['provinceCde'] = this.provinceCde;
        data['districtCde'] = this.districtCde;
        data['code'] = this.code;
        data['name'] = this.name;
        data['wardType'] = this.wardType;
        data['isDeleted'] = this.isDeleted;
        data['rowVersion'] = this.rowVersion;
        data['createdBy'] = this.createdBy;
        data['createdDate'] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data['tenantId'] = this.tenantId;
        return data;
    }

    clone(): WardModel {
        const json = this.toJSON();
        let result = new WardModel();
        result.init(json);
        return result;
    }
}

export interface IWardModel {
    id: number;
    provinceCde: string | undefined;
    districtCde: string | undefined;
    code: string | undefined;
    name: string | undefined;
    wardType: string | undefined;
    isDeleted: boolean;
    rowVersion: string | undefined;
    createdBy: string | undefined;
    createdDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    tenantId: number;
}

export class WorkShiftChangeDto implements IWorkShiftChangeDto {
    id: number;
    employeeId: number;
    fullname: string | undefined;
    employeeCode: string | undefined;
    currentShiftCode: string | undefined;
    currentShift: string | undefined;
    changeShiftCode: string | undefined;
    changeShift: string | undefined;
    year: number;
    month: number;
    dateWork: string | undefined;
    description: string | undefined;
    statusCde: string | undefined;
    wfDataCde: string | undefined;
    isDelete: boolean;
    createBy: string | undefined;
    createDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    rowVersion: string | undefined;
    content: string | undefined;

    constructor(data?: IWorkShiftChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.fullname = _data['fullname'];
            this.employeeCode = _data['employeeCode'];
            this.currentShiftCode = _data['currentShiftCode'];
            this.currentShift = _data['currentShift'];
            this.changeShiftCode = _data['changeShiftCode'];
            this.changeShift = _data['changeShift'];
            this.year = _data['year'];
            this.month = _data['month'];
            this.dateWork = _data['dateWork'];
            this.description = _data['description'];
            this.statusCde = _data['statusCde'];
            this.wfDataCde = _data['wfDataCde'];
            this.isDelete = _data['isDelete'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
            this.rowVersion = _data['rowVersion'];
            this.content = _data['content'];
        }
    }

    static fromJS(data: any): WorkShiftChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkShiftChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['fullname'] = this.fullname;
        data['employeeCode'] = this.employeeCode;
        data['currentShiftCode'] = this.currentShiftCode;
        data['currentShift'] = this.currentShift;
        data['changeShiftCode'] = this.changeShiftCode;
        data['changeShift'] = this.changeShift;
        data['year'] = this.year;
        data['month'] = this.month;
        data['dateWork'] = this.dateWork;
        data['description'] = this.description;
        data['statusCde'] = this.statusCde;
        data['wfDataCde'] = this.wfDataCde;
        data['isDelete'] = this.isDelete;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data['rowVersion'] = this.rowVersion;
        data['content'] = this.content;
        return data;
    }

    clone(): WorkShiftChangeDto {
        const json = this.toJSON();
        let result = new WorkShiftChangeDto();
        result.init(json);
        return result;
    }
}

export interface IWorkShiftChangeDto {
    id: number;
    employeeId: number;
    fullname: string | undefined;
    employeeCode: string | undefined;
    currentShiftCode: string | undefined;
    currentShift: string | undefined;
    changeShiftCode: string | undefined;
    changeShift: string | undefined;
    year: number;
    month: number;
    dateWork: string | undefined;
    description: string | undefined;
    statusCde: string | undefined;
    wfDataCde: string | undefined;
    isDelete: boolean;
    createBy: string | undefined;
    createDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    rowVersion: string | undefined;
    content: string | undefined;
}

export class WorkingProcessDto implements IWorkingProcessDto {
    id: number;
    employeeId: number;
    employeeCode: string | undefined;
    fullName: string | undefined;
    partner: string | undefined;
    partnerAddress: string | undefined;
    partnerPhone: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    description: string | undefined;
    rowVersion: string | undefined;
    createBy: string | undefined;

    constructor(data?: IWorkingProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.employeeCode = _data['employeeCode'];
            this.fullName = _data['fullName'];
            this.partner = _data['partner'];
            this.partnerAddress = _data['partnerAddress'];
            this.partnerPhone = _data['partnerPhone'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
            this.description = _data['description'];
            this.rowVersion = _data['rowVersion'];
            this.createBy = _data['createBy'];
        }
    }

    static fromJS(data: any): WorkingProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['employeeCode'] = this.employeeCode;
        data['fullName'] = this.fullName;
        data['partner'] = this.partner;
        data['partnerAddress'] = this.partnerAddress;
        data['partnerPhone'] = this.partnerPhone;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data['description'] = this.description;
        data['rowVersion'] = this.rowVersion;
        data['createBy'] = this.createBy;
        return data;
    }

    clone(): WorkingProcessDto {
        const json = this.toJSON();
        let result = new WorkingProcessDto();
        result.init(json);
        return result;
    }
}

export interface IWorkingProcessDto {
    id: number;
    employeeId: number;
    employeeCode: string | undefined;
    fullName: string | undefined;
    partner: string | undefined;
    partnerAddress: string | undefined;
    partnerPhone: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    description: string | undefined;
    rowVersion: string | undefined;
    createBy: string | undefined;
}

export class WorkingShiftDto implements IWorkingShiftDto {
    id: number;
    employeeId: number;
    fullname: string | undefined;
    employeeCode: string | undefined;
    shiftCode: string | undefined;
    workingShift: string | undefined;
    year: number;
    month: number;
    dateWork: string | undefined;
    isDelete: boolean;
    createBy: string | undefined;
    createDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    rowVersion: string | undefined;

    constructor(data?: IWorkingShiftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.employeeId = _data['employeeId'];
            this.fullname = _data['fullname'];
            this.employeeCode = _data['employeeCode'];
            this.shiftCode = _data['shiftCode'];
            this.workingShift = _data['workingShift'];
            this.year = _data['year'];
            this.month = _data['month'];
            this.dateWork = _data['dateWork'];
            this.isDelete = _data['isDelete'];
            this.createBy = _data['createBy'];
            this.createDate = _data['createDate'] ? moment(_data['createDate'].toString()) : <any>undefined;
            this.modifiedBy = _data['modifiedBy'];
            this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
            this.rowVersion = _data['rowVersion'];
        }
    }

    static fromJS(data: any): WorkingShiftDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingShiftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['employeeId'] = this.employeeId;
        data['fullname'] = this.fullname;
        data['employeeCode'] = this.employeeCode;
        data['shiftCode'] = this.shiftCode;
        data['workingShift'] = this.workingShift;
        data['year'] = this.year;
        data['month'] = this.month;
        data['dateWork'] = this.dateWork;
        data['isDelete'] = this.isDelete;
        data['createBy'] = this.createBy;
        data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data['modifiedBy'] = this.modifiedBy;
        data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data['rowVersion'] = this.rowVersion;
        return data;
    }

    clone(): WorkingShiftDto {
        const json = this.toJSON();
        let result = new WorkingShiftDto();
        result.init(json);
        return result;
    }
}

export interface IWorkingShiftDto {
    id: number;
    employeeId: number;
    fullname: string | undefined;
    employeeCode: string | undefined;
    shiftCode: string | undefined;
    workingShift: string | undefined;
    year: number;
    month: number;
    dateWork: string | undefined;
    isDelete: boolean;
    createBy: string | undefined;
    createDate: moment.Moment;
    modifiedBy: string | undefined;
    modifiedDate: moment.Moment;
    rowVersion: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any }, result?: any): Observable<any> {
    if (result !== null && result !== undefined) return _observableThrow(result);
    else return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next('');
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = (event) => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
